let AgentUserInfo;
let AgentUserApproveType;
let AgentApprovalOptions = 3;
let AgentUserPermissions = [];
let AgentPermissionTypeToggles = new Set(["View", "Edit", "Delete", "Custom"]);
let IsSyncingPermissionsSelectAll = false;
let AgentMandatoryPermissions = ["Everyone", "IsEmployee", "TableTraverse"];
let AgentCanOverrideEvalModel = false;
const AUTO_ROUTING_WELCOME_MESSAGE = "<div style='color:var(--text-secondary)'>Start by asking your question and I'll automatically route it to the best AI agent.</div>";
// EC-31005: Only offer agents the user is allowed to use; @PermissionCodesArr is resolved server-side from the session
const AGENT_REQUIRED_PERMISSION_FILTER = "(AIAgents.RequiredPermission IS NULL OR AIAgents.RequiredPermission IN (@PermissionCodesArr))";

const AGENT_UI_TEMPLATE = `
<div class=page-content>
<div class=sidebar-overlay id=sidebarOverlay></div>
<div class=content-left id=contentLeft>
 <div class=sidebar-header>
  <ecp-btn id=newChat size=large icon=ews-icon-add>New chat</ecp-btn>
  <ecp-btn id=settingsBtn size=large icon=ews-icon-settings>Settings</ecp-btn>
  <ecp-btn id=closeSidebarBtn class=close-sidebar-btn type=ghost icon=ews-icon-close></ecp-btn>
 </div>
 <ecp-divider></ecp-divider>
 <div class=aiagent-section>
  <div class="category-label ecp-bodysm">AI agent</div>
  <div class="aiagent-input-container">
   <ecp-auto-complete id=aiagentInput name=aiagent reftable=AIAgents reffield=AIAgentID reffielddisplay=AgentName datatype="ECP.DataType._Integer" reffieldfilter="${AGENT_REQUIRED_PERMISSION_FILTER}"></ecp-auto-complete>
  </div>
 </div>
 <ecp-divider></ecp-divider>
 <div class=chat-history-section>
     <div class=sidebar-history-tabs-wrap>
      <div style="display:flex;align-items:center;gap:4px">
       <ecp-tabs id=sidebarHistoryTabs style="flex:1;min-width:0">
        <ecp-tab-item id=sidebarChatHistoryTab selected>Chat History</ecp-tab-item>
        <ecp-tab-item id=sidebarScheduledPromptsTab>Scheduled Prompts</ecp-tab-item>
       </ecp-tabs>
       <ecp-btn id=manageScheduledPromptsBtn type=ghost icon=ews-icon-settings aria-label="Manage scheduled prompts"></ecp-btn>
      </div>
     </div>
    <div id=chatHistoryPane>
     <ecp-subtabs vertical=""id=chatGroup></ecp-subtabs>
    </div>
    <div id=scheduledPromptHistoryPane class=hidden>
     <ecp-subtabs vertical=""id=scheduledPromptsGroup></ecp-subtabs>
    </div>
 </div>
</div>
<div class=chat-content>
 <div class=mobile-header>
  <ecp-btn id=openSidebarBtn type=ghost icon=ews-icon-overflow></ecp-btn>
  <span class=mobile-title>AI Agent</span>
  <div class=mobile-header-actions>
   <ecp-btn id=mobileSettingsBtn type=ghost icon=ews-icon-settings></ecp-btn>
   <ecp-tooltip for=mobileSettingsBtn placement=bottom delayms=500>Settings</ecp-tooltip>
   <ecp-btn id=closePanelBtn class=close-panel-btn type=ghost icon=ews-icon-tablegriddeletecolumn></ecp-btn>
   <ecp-tooltip for=closePanelBtn placement=bottom delayms=200>Close Side Panel</ecp-tooltip>
  </div>
 </div>
 <div id=normalChatPane class=chat-pane>
  <div class=chat-his></div>
  <div class=chat-tips>
   <div class=chat-tips-content>
    <ecp-sectionmessage type=information>
     <span id=autoApprovalTips>Auto-approval is enabled for this session.</span>
     <a style=margin-left:6px href="javascript:void(0);"id=cancelAutoApprovalBtn>End session auto-approval</a>
    </ecp-sectionmessage>
   </div>
  </div>
  <div class=search-box-wrapper>
   <div id=fileStagingArea class="file-staging-area hidden"></div>
   <div id=chatDropOverlay class="chat-drop-overlay hidden">
    <div class=chat-drop-overlay-content>
     <i class="ews-icon-arrowdown"></i>
     <span>Drop files to attach</span>
    </div>
   </div>
   <div id=activeSkillBar class="active-skill-bar hidden"></div>
   <div class=search-box>
     <ecp-btn id=inputActionsBtn class=input-actions-btn type=ghost icon=ews-icon-overflow aria-label="More actions"></ecp-btn>
      <div class=chat-input-wrap>
        <textarea id=chatInput class="message-box ecp-body" placeholder="What can we accomplish today?"></textarea>
       <ecp-btn id=voiceInputBtn class=voice-input-btn type=ghost icon=ews-icon-emvoice aria-label="Toggle voice input"></ecp-btn>
       <div id=skillCommandMenu class="skill-command-menu hidden"></div>
      </div>
      <div class=send-col>
       <div class=send-actions>
        <ecp-btn id=sendBtn class=send-btn type=primary icon=ews-icon-arrowup>Send</ecp-btn>
        <ecp-btn id=stopBtn class="stop-btn hidden" type=permanent-destructive icon=ews-icon-close>Stop</ecp-btn>
       </div>
       <div id=individualTokenUsageWrapper class="token-usage hidden">
        <ecp-progressbar id=individualTokenUsageProgressBar type="solid" bg-color="bg-object">
         <ecp-progressbar-item id=individualTokenUsageProgressItem progress="0" bg-color="bg-success" class="left-radius" type="solid" style="width:0%"></ecp-progressbar-item>
         <ecp-progressbar-item class="spare-item right-radius" bg-color="bg-object"></ecp-progressbar-item>
        </ecp-progressbar>
        <ecp-tooltip id=individualTokenUsageTooltip for=individualTokenUsageProgressBar placement="Left" delayms="300">0% personal usage</ecp-tooltip>
       </div>
       <div id=tokenUsageWrapper class="token-usage">
        <ecp-progressbar id=tokenUsageProgressBar type="solid" bg-color="bg-object" helper-text="Usage reset: --">
         <ecp-progressbar-item id=tokenUsageProgressItem progress="0" bg-color="bg-success" class="left-radius" type="solid" style="width:0%"></ecp-progressbar-item>
         <ecp-progressbar-item class="spare-item right-radius" bg-color="bg-object"></ecp-progressbar-item>
        </ecp-progressbar>
        <ecp-tooltip id=tokenUsageTooltip for=tokenUsageProgressBar placement="Left" delayms="300">0% organization usage</ecp-tooltip>
       </div>
      </div>
   </div>
   <!-- Kept out of .search-box, where every extra child spent one more composer gap -->
   <div class=composer-anchors>
     <ecp-tooltip for=inputActionsBtn placement=top>More actions</ecp-tooltip>
     <ecp-tooltip for=voiceInputBtn placement=top>Voice input</ecp-tooltip>
     <ecp-menu id=inputActionsMenu>
      <ecp-list type=clickable>
       <ecp-list-item data-input-action=upload>
        <ecp-list-item-content>
         <ecp-list-item-title><b>Attach files</b></ecp-list-item-title>
         <ecp-list-item-subtitle>.txt, .pdf, .docx, .xml, .json, .csv, .xls, .xlsx, .jpg, .jpeg, .png</ecp-list-item-subtitle>
        </ecp-list-item-content>
       </ecp-list-item>
       <ecp-list-item id=saveAsSkillItem data-input-action=save-skill>
        <ecp-list-item-content>
         <ecp-list-item-title><b>Save as Skill</b></ecp-list-item-title>
         <ecp-list-item-subtitle>Extract reusable skills from this conversation</ecp-list-item-subtitle>
        </ecp-list-item-content>
       </ecp-list-item>
        <ecp-list-item id=planFirstToggleItem data-input-action=toggle-plan-first>
         <ecp-list-item-content>
          <ecp-list-item-title><b>Plan First</b></ecp-list-item-title>
          <ecp-list-item-subtitle id=planFirstStateText>Currently <b>off</b></ecp-list-item-subtitle>
         </ecp-list-item-content>
        </ecp-list-item>
        <ecp-list-item id=runEvalsItem data-input-action=evals>
         <ecp-list-item-content>
          <ecp-list-item-title><b>Evals</b></ecp-list-item-title>
          <ecp-list-item-subtitle>Run saved evaluations for this agent</ecp-list-item-subtitle>
         </ecp-list-item-content>
        </ecp-list-item>
        <ecp-list-item id=googleSearchToggleItem class=hidden data-input-action=toggle-google-search>
         <ecp-list-item-content>
          <ecp-list-item-title><b>Google Search</b></ecp-list-item-title>
          <ecp-list-item-subtitle id=googleSearchStateText>Currently <b>on</b></ecp-list-item-subtitle>
         </ecp-list-item-content>
        </ecp-list-item>
        <ecp-list-item id=mcpConnectorsItem class=hidden data-input-action=mcp-connectors>
         <ecp-list-item-content>
          <ecp-list-item-title><b>Connectors</b></ecp-list-item-title>
          <ecp-list-item-subtitle id=mcpConnectorsStateText>External tools for this chat</ecp-list-item-subtitle>
         </ecp-list-item-content>
        </ecp-list-item>
       </ecp-list>
      </ecp-menu>
     <ecp-tooltip id=runEvalsTooltip for=runEvalsItem placement=right>Please select an agent to run evaluations</ecp-tooltip>
     <input type=file id=fileInputHidden class=hidden multiple accept=".txt,.pdf,.docx,.xml,.json,.csv,.xls,.xlsx,.jpg,.jpeg,.png">
   </div>
  </div>
 <div class=ai-disclaimer>
  <a class=ai-disclaimer-link href="/Home?DashboardID=184447&HelpResourcesID=1935"target=_blank>AI-generated content may be inaccurate or incomplete.<span class=ai-disclaimer-verify> Always verify data.</span> <span class=ews-icon-info></span></a>
 </div>
 </div>
</div>
<div id=promptPanel class="prompt-panel hidden">
 <div class=prompt-panel-header>
  <span id=promptPanelTitle class="prompt-panel-title ecp-bodysm">Recommended prompts</span>
  <ecp-btn id=promptPanelAddBtn class="prompt-panel-add hidden" type=ghost icon=ews-icon-add aria-label="Add a recommended prompt"></ecp-btn>
  <ecp-btn id=promptPanelToggleBtn class=prompt-panel-toggle type=ghost aria-label="Hide recommended prompts" aria-expanded=true aria-controls=promptPanelList>
   <span class="prompt-panel-toggle-icon ews-icon-caretright"></span>
  </ecp-btn>
 </div>
 <ecp-tooltip id=promptPanelAddTooltip for=promptPanelAddBtn placement=bottom delayms=300>Add a recommended prompt</ecp-tooltip>
 <ecp-tooltip id=promptPanelToggleTooltip for=promptPanelToggleBtn placement=left delayms=300>Hide recommended prompts</ecp-tooltip>
 <div id=promptPanelList class=prompt-panel-list></div>
</div>
</div>`;

const AgentUIContext = {
    mode: "standalone",
    root: null,
    onClosePanel: null,
    initialized: false,
    initPromise: null,
    settingsDialog: null
};

const MarkdownTableCalculatorState = {
    instances: [],
    loadPromise: null
};

const AgentSettings = {
    enableLogging: false,
    planFirst: false,
    includePageContext: true,
    googleSearch: true,
    tabNotifications: true,
    matchMyVoice: false
};

const ScheduledPromptsState = {
    activeSidebarTab: "chat-history",
    selectedExecutionIndex: -1,
    loadedForAIAgentID: 0,
    isLoading: false,
    prompts: [],
    agents: [],
    executions: [],
    notificationPreferences: {
        email: true,
        eChat: true
    }
};

const PROMPT_PLACEHOLDER_REGEX = /\[[^\]\r\n]+\]/;

const PendingEvalRequest = {
    aiAgentID: "",
    aiAgentEvalID: 0,
    evalAIModelID: 0,
    startNewConversation: false
};

const RELIABILITY_RUN_COUNT = 3;

let reliabilityModeEnabled = false;
let reliabilitySession = null;
let reliabilitySessionCounter = 0;

window.WaitingForApprovePlanFirst = false;

// Tracks the URL at the time page context was last sent to the backend.
// Context is re-sent only when navigation changes the URL (JS history updates included).
let lastSentPageContextUrl = null;

const AI_PANEL_MIN_WIDTH = 280;
const AI_PANEL_DEFAULT_WIDTH = 420;
const AI_PANEL_MAX_WIDTH_PERCENT = 70;

const FileUploadState = {
    stagedFiles: [],
    maxFileSize: 5 * 1024 * 1024, // 5MB
    // EC-31283: Admin-controlled (setting 3508), delivered by AIAgent_GetPanelBootstrap; this placeholder only sizes the gate until that call answers.
    maxTotalTokens: 50000,
    charsPerToken: 4,
    allowedExtensions: [".txt", ".pdf", ".docx", ".xml", ".json", ".csv", ".xls", ".xlsx", ".jpg", ".jpeg", ".png"],
    imageExtensions: [".jpg", ".jpeg", ".png"],
    // Images are sent to the model as image blocks, not text, so their byte size is not a
    // meaningful token count. Use a fixed upper-bound estimate so large images aren't rejected
    // by the text-oriented total-token gate.
    imageTokenEstimate: 1600,
    isUploading: false,
    dragDepth: 0
};

function AI_PANEL_LS_KEY() {
    return `${Distributor}_${UserID}_ecp_ai_panel_open`;
}

function AI_PANEL_WIDTH_LS_KEY() {
    return `${Distributor}_${UserID}_ecp_ai_panel_width_pct`;
}

// ---------------------------------------------------------------------------
// EC-31344: Session-stamped client cache.
// The side panel remounts on every page navigation, so hydrating it used to
// re-fire a burst of API calls each time. We cache the session-stable parts in
// localStorage, stamped with the SessionStamp global. That stamp changes
// on login (so permissions can't go stale across a re-login) and is scoped to
// the session (so this-session approval state can't leak into a later session),
// giving us a zero-round-trip validity check available at page load.
// Volatile entries additionally carry a short TTL so rapid navigation reuses
// them but they never drift far from the server.
// ---------------------------------------------------------------------------

// Reused across navigations while the panel is left open; conversation-list and
// token-usage staleness from other tabs/sessions is bounded to this window.
const AGENT_CACHE_TTL_MS = 60000;

function getAgentSessionStamp() {
    // EC-31813: EncompassSessionID became HttpOnly, so use the stamp derived from it instead. It
    // turns over with the session exactly the same way, which is all this cache key needs, and it
    // cannot be replayed as a credential if script on this page is ever compromised.
    return SessionStamp;
}

function agentCacheKey(name) {
    return `${Distributor}_${UserID}_aiagent_cache_${name}`;
}

// Returns the cached payload only when it was written under the current session
// (and, for TTL entries, has not expired); otherwise null so the caller fetches.
function readAgentCache(name) {
    const stamp = getAgentSessionStamp();
    if (EC_Fmt.isNull(stamp)) {
        return null;
    }
    try {
        const raw = localStorage.getItem(agentCacheKey(name));
        if (!raw) {
            return null;
        }
        const entry = JSON.parse(raw);
        if (!entry || entry.stamp !== stamp) {
            return null;
        }
        if (entry.expires && Date.now() > entry.expires) {
            return null;
        }
        return entry.data;
    } catch {
        return null;
    }
}

function writeAgentCache(name, data, ttlMs = 0) {
    const stamp = getAgentSessionStamp();
    if (EC_Fmt.isNull(stamp)) {
        return;
    }
    try {
        const entry = { stamp, data };
        if (ttlMs > 0) {
            entry.expires = Date.now() + ttlMs;
        }
        localStorage.setItem(agentCacheKey(name), JSON.stringify(entry));
    } catch {
        // localStorage may be unavailable (private mode, quota) — run uncached.
    }
}

function clearAgentCache(name) {
    try {
        localStorage.removeItem(agentCacheKey(name));
    } catch {
        // ignore
    }
}

function GetAIPanelMaxWidth() {
    return Math.round(window.innerWidth * (AI_PANEL_MAX_WIDTH_PERCENT / 100));
}

function ClampAIPanelWidth(width) {
    const normalizedWidth = Number(width);
    const maxWidth = GetAIPanelMaxWidth();

    if (!Number.isFinite(normalizedWidth)) {
        return Math.min(AI_PANEL_DEFAULT_WIDTH, maxWidth);
    }

    return Math.min(Math.max(Math.round(normalizedWidth), AI_PANEL_MIN_WIDTH), maxWidth);
}

function GetSavedAIPanelWidthPercent() {
    const savedWidthPercent = Number(EC_Fmt.GetLocalStorageValue(AI_PANEL_WIDTH_LS_KEY()));

    if (!Number.isFinite(savedWidthPercent) || savedWidthPercent <= 0) {
        return null;
    }

    return savedWidthPercent;
}

function GetPersistedAIPanelWidth() {
    const savedWidthPercent = GetSavedAIPanelWidthPercent();

    if (savedWidthPercent !== null) {
        return ClampAIPanelWidth((savedWidthPercent / 100) * window.innerWidth);
    }

    return ClampAIPanelWidth(AI_PANEL_DEFAULT_WIDTH);
}

function SaveAIPanelWidthPercent(width) {
    const viewportWidth = Math.max(window.innerWidth, 1);
    const normalizedWidth = ClampAIPanelWidth(width);
    const widthPercent = Math.round((normalizedWidth / viewportWidth) * 10000) / 100;

    EC_Fmt.SetLocalStorageValue(AI_PANEL_WIDTH_LS_KEY(), widthPercent);
}

function ApplyAIPanelWidth(panel, width = null) {
    if (!panel) {
        return;
    }

    const resolvedWidth = width === null ? GetPersistedAIPanelWidth() : ClampAIPanelWidth(width);
    panel._width = resolvedWidth;
    panel.style.width = `${resolvedWidth}px`;

    if (panel._open) {
        const bodyWrap = document.querySelector(".body-wrap");
        if (bodyWrap) {
            bodyWrap.style.marginRight = `${resolvedWidth}px`;
        }
    }
}

function GetSavedConversationID() {
    return EC_Fmt.GetLocalStorageValue(`${Distributor}_${UserID}_conversationid`);
}

function GetResumeConversationIDFromURL() {
    return new URLSearchParams(window.location.search).get("ResumeConversation");
}

function GetAgentSelectorMarkup(aiAgentID = "") {
    const normalizedAgentID = EC_Fmt.Null2ZeroInt(aiAgentID);
    const valueAttr = normalizedAgentID > 0 ? `value="${normalizedAgentID}"` : "";
    return `<ecp-auto-complete id=aiagentInput name=aiagent reftable=AIAgents reffield=AIAgentID reffielddisplay=AgentName datatype="ECP.DataType._Integer" reffieldfilter="${AGENT_REQUIRED_PERMISSION_FILTER}" ${valueAttr}></ecp-auto-complete>`;
}

function SetSelectedAgent(aiAgentID = "") {
    if (reliabilitySession) {
        const nextAgentID = String(EC_Fmt.Null2ZeroInt(aiAgentID));
        const activeReliabilityAgentID = String(EC_Fmt.Null2ZeroInt(reliabilitySession.aiAgentID));
        if (nextAgentID !== activeReliabilityAgentID) {
            resetReliabilityUI();
        }
    }

    const container = document.querySelector(".aiagent-input-container");
    if (!container) {
        return null;
    }

    // Active skill belongs to the previously selected agent
    clearActiveSkill();
    closeSkillCommandMenu();

    // Rebuilding the auto-complete wipes the display name the user just picked, so leave it alone when the selection is unchanged
    const existingInputEl = document.getElementById("aiagentInput");
    if (existingInputEl && EC_Fmt.Null2ZeroInt(existingInputEl.value) === EC_Fmt.Null2ZeroInt(aiAgentID)) {
        return existingInputEl;
    }

    container.innerHTML = GetAgentSelectorMarkup(aiAgentID);
    const aiAgentInputEl = document.getElementById("aiagentInput");
    if (aiAgentInputEl) {
        aiAgentInputEl.addEventListener("change", onAgentSelectionChanged);
    }
    return aiAgentInputEl;
}

function allowsAlwaysApproval() {
    return AgentApprovalOptions >= 3;
}

function isApproveOptionAllowed(approveOption) {
    switch (String(approveOption)) {
        case "0":
            return true;
        case "1":
            return AgentApprovalOptions >= 2;
        case "2":
            return allowsAlwaysApproval();
        default:
            return false;
    }
}

function applyApproveButtonOption(approveBtn, approveOption) {
    if (!approveBtn) {
        return;
    }

    const normalizedOption = isApproveOptionAllowed(approveOption) ? String(approveOption) : "0";
    approveBtn.setAttribute("approve-option", normalizedOption);

    switch (normalizedOption) {
        case "1":
            approveBtn.textContent = "Approve for this session";
            break;
        case "2":
            approveBtn.textContent = "Approve always";
            break;
        default:
            approveBtn.textContent = "Approve";
            break;
    }
}

function formatToolApprovalName(toolName) {
    const normalizedToolName = EC_Fmt.Null2EmptyStr(toolName).trim();
    if (EC_Fmt.isNull(normalizedToolName)) {
        return "";
    }

    return normalizedToolName
        .replace(/[._]+/g, " ")
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/\s+/g, " ")
        .trim();
}

function updateApprovalOptionsUI() {
    const toolApprovalsTab = AI_DOM.settingsTabs ? AI_DOM.settingsTabs.querySelector('[data-tab="tool-approvals"]') : null;
    if (toolApprovalsTab) {
        if (allowsAlwaysApproval()) {
            toolApprovalsTab.style.display = "";
        } else {
            toolApprovalsTab.style.display = "none";
            if (toolApprovalsTab.hasAttribute("selected")) {
                SwitchSettingsTab("general");
            }
        }
    }

    if (!allowsAlwaysApproval() && AgentUserApproveType === 2) {
        AgentUserApproveType = 0;
        updateUserApproveTips();
    }

    if (toolPermissionsViewInstance && AI_DOM.toolApprovalsTabContent && !AI_DOM.toolApprovalsTabContent.classList.contains("hidden")) {
        toolPermissionsViewInstance.render();
    }
}

function getEnableLoggingEnabled() {
    return AI_DOM.enableLoggingItem ? AI_DOM.enableLoggingItem.checked : AgentSettings.enableLogging;
}

function getPlanFirstEnabled() {
    return AI_DOM.planFirstCheckbox ? AI_DOM.planFirstCheckbox.checked : AgentSettings.planFirst;
}

function getIncludePageContextEnabled() {
    return AI_DOM.includePageContextCheckbox ? AI_DOM.includePageContextCheckbox.checked : AgentSettings.includePageContext;
}

function RenderAgentUIHost(host, mode) {
    host.innerHTML = AGENT_UI_TEMPLATE;
    host.classList.add("ai-agent");
    host.classList.toggle("ai-agent-standalone", mode !== "sidepanel");
    host.classList.toggle("ai-agent-sidepanel", mode === "sidepanel");
    host.dataset.ecpAiAgentMounted = "true";
}

async function MountAgentUI(host, options = {}) {
    if (!host) {
        return;
    }

    AgentUIContext.root = host;
    AgentUIContext.mode = options.mode || "standalone";
    AgentUIContext.onClosePanel = options.onClosePanel || null;

    if (host.dataset.ecpAiAgentMounted !== "true") {
        RenderAgentUIHost(host, AgentUIContext.mode);
    }

    if (!AgentUIContext.initPromise) {
        AgentUIContext.initPromise = Init();
    }

    await AgentUIContext.initPromise;

    if (!EC_Fmt.isNull(options.resumeConversationId)) {
        await ResumeConversationIfNeeded(options.resumeConversationId);
    }
}

const THINKING_MESSAGES = [
    "Accomplishing", "Actioning", "Actualizing", "Aerating", "Ale-gorithming", "Analyzing", "Architecting",
    "Baking", "Barrel-rolling", "Barrel-browsing", "Beaming", "Beboppin'", "Befuddling", "Billowing", "Bottle-necking", "Boogieing", "Boondoggling", "Booping", "Bootstrapping", "Brewing", "Breathing", "Bubble-counting", "Burrowing",
    "Calculating", "Canoodling", "Caffeinating", "Carbonating", "Caramelizing", "Canning", "Casing", "Catapulting", "Can-templating", "Cerebrating", "Channeling", "Cheersing", "Choreographing", "Churning", "Clarifying", "Coalescing", "Cogitating", "Combobulating", "Computing", "Composing", "Condensing", "Conjuring", "Concocting", "Considering", "Cooking", "Cork-popping", "Crafting", "Creating", "Crunching", "Crushing", "Crystallizing", "Cultivating",
    "Deciphering", "Deliberating", "Determining", "Dilly-dallying", "Discombobulating", "Distilling", "Doodling", "Doing", "Drinking",
    "Ebbing", "Elucidating", "Embellishing", "Enchanting", "Encompassing", "Envisioning", "Evaporating", "Evaluating",
    "Fermenting", "Fiddle-faddling", "Finagling", "Flavor-profiling", "Flibbertigibbeting", "Flummoxing", "Frothing", "Frolicking", "Forging", "Forklifting", "Forming",
    "Gallivanting", "Galloping", "Garnishing", "Generating", "Germinating", "Grain-grading", "Grooving",
    "Harmonizing", "Hatching", "Hauling", "Herding", "Honking", "Hoptimizing", "Hullaballooing", "Hustling",
    "Ideating", "Imagining", "Incubating", "Inferring", "Inventorying",
    "Jitterbugging", "Jiving",
    "Keg-splaining", "Kneading",
    "Lagering", "Levitating", "Logistifying", "Lollygagging",
    "Manifesting", "Marinating", "Mashing", "Meandering", "Moonwalking", "Moseying", "Mulling", "Mustering", "Musing",
    "Nesting", "Noodling",
    "Orbiting", "Orchestrating",
    "Percolating", "Perusing", "Philosophizing", "Pondering", "Pontificating", "Pouncing", "Pouring", "Precipitating", "Processing", "Proofing", "Proof-reading", "Puttering", "Puzzling",
    "Quenching",
    "Razzmatazzing", "Recombobulating", "Reticulating", "Rick-rolling", "Roosting", "Ruminating",
    "Sautéing", "Scampering", "Schlepping", "Scurrying", "Shenaniganing", "Shimmying", "Shucking", "Skedaddling", "Sketching", "Simmering", "Sipping", "Slithering", "SKU-sleuthing", "Smooshing", "Sommelier-ing", "Spelunking", "Spinning", "Stewing", "Sublimating", "Sussing", "Swirling", "Supply-studying", "Synthesizing",
    "Tailgating", "Tapping", "Tasting", "Tempering", "Thinking", "Thundering", "Tinkering", "Toasting", "Tomfoolering", "Transfiguring", "Transmuting", "Truck-tetrising", "Twisting",
    "Undulating", "Unfurling", "Unpacking", "Unravelling",
    "Vibing", "Viscositizing",
    "Warehousing", "Waddling", "Wandering", "Warping", "Whatchamacalliting", "Wheel-greasing", "Whirling", "Whirlpooling", "Whirring", "Whisking", "Working", "Wrangling",
    "Yeast-herding",
    "Zesting", "Zigzagging"
];

// Hard cap on plan text sent to the execution engine
const PLAN_EDITOR_MAX_LENGTH = 5000;

const ECPChatMessageDefinition = {
    name: "cur-chatmessage",
    attributes: [
        { property: "role", mode: "string" },
        { property: "avatar", mode: "string" },
        { property: "time", mode: "string" },
        { property: "markdown", mode: "boolean" }
    ],
    template: `
<div class=msg-root>
<div class=avatar-wrap>
 <ecp-chip class="ans-icon avatar-img"color=teal icon=ews-icon-spark>AI</ecp-chip>
</div>
<div class=content>
 <div class=meta><span class=h4>Agent</span><label class=cut-off-dot>&bull;</label><span class=time></span><i class="ews-icon-emvolume speak-btn hidden"title="Listen to response"></i><span class="feedback-btns hidden"><span class="feedback-btn thumbs-up"title="Good response">&#x1F44D;</span><span class="feedback-btn thumbs-down"title="Bad response">&#x1F44E;</span><i class="feedback-btn copy-response-btn ews-icon-copy" title="Copy response"></i><i class="feedback-btn share-response-btn ews-icon-share" title="Share response"></i></span></div>
 <tools-timeline class=tools-timeline></tools-timeline>
 <div class=bubble><slot></slot></div>
</div>
</div>
    `,

    styles: `
:host { display: block; }
.hidden { display: none; }
.msg-root { display: flex; align-items: flex-start; gap: 12px; max-width: 100%; animation: fadeIn 180ms ease; }
.avatar-wrap { width: 40px; height: 40px; flex-shrink: 0; }
/* Queries the agent's width across the shadow boundary */
@container agent (max-width: 560px) { .msg-root { gap: 8px; } }
.content { flex: 1; display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.bubble { padding: 12px; border-radius: 8px; word-break: break-word; font-size: var(--body-font-size); line-height: var(--body-line-height); }
.bubble ecp-section { margin-top: 8px; white-space: normal; }
.bubble p { margin-block: 5px; }
.bubble ol { padding-left: 30px; }
.section-btns { display: flex; justify-content: flex-end; margin-top: 16px;}
/* Wraps: byline, timestamp and five icons do not fit one line in a 280px side panel */
.meta { display: flex; flex-wrap: wrap; align-items: center; gap: 2px 8px; }
.h4 { font-size: var(--body-font-size); line-height: var(--body-line-height); font-weight: var(--semibold-weight); }
.time { color: var(--text-secondary); font-size: var(--bodysm-font-size); line-height: var(--bodysm-font-size); }
.cut-off-dot { font-size: var(--bodysm-font-size); color: var(--text-secondary); }
.speak-btn { color: var(--text-secondary); font-size: 14px; cursor: pointer; transition: color 0.15s ease; }
.speak-btn:hover { color: var(--primary-110); }
.speak-btn.speaking { color: var(--primary-110); }
.speak-btn.hidden { display: none; }
.feedback-btns { display: inline-flex; gap: 6px; margin-left: 4px; }
.feedback-btns.hidden { display: none; }
.feedback-btn { cursor: pointer; font-size: 14px; filter: grayscale(1); opacity: 0.6; transition: opacity 0.15s ease, transform 0.15s ease, filter 0.15s ease; user-select: none; border-radius: 10px; padding: 1px 4px; }
.feedback-btn:hover { opacity: 0.9; }
.feedback-btn.selected { opacity: 1; filter: none; transform: scale(1.08); }
.feedback-btn.disabled { pointer-events: none; opacity: 0.3; }
.feedback-btns.feedback-positive .thumbs-up { background: color-mix(in srgb, var(--green-70) 22%, transparent); }
.feedback-btns.feedback-negative .thumbs-down { background: color-mix(in srgb, var(--red-70) 22%, transparent); }
.feedback-btns.feedback-locked .feedback-btn:not(.selected) { opacity: 0.2; }
.copy-response-btn { color: var(--text-secondary); padding-top: 5px; }
.copy-response-btn:hover { color: var(--primary-110); opacity: 1; }
.share-response-btn { color: var(--text-secondary); padding-top: 5px; }
.share-response-btn:hover { color: var(--primary-110); opacity: 1; }
:host([role="assistant"]) { margin-bottom: 24px; }
:host([role="assistant"]) .msg-root { flex-direction: row; align-self: flex-start; }
:host([role="assistant"]) .bubble { background: transparent; padding: 0; }
:host([role="user"]) .msg-root { flex-direction: row-reverse; align-self: flex-end; justify-self: end; }
/* A share of the already-capped reading column, rather than four viewport steps */
:host([role="user"]) .bubble { background: var(--bg-object); max-width: min(84%, 760px); }
:host([role="user"]) .meta { flex-direction: row-reverse;}

@keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }

.dots { display: inline-block;}

.dots span { opacity: 0; animation: blink 1.5s infinite; }

.dots span:nth-child(1) { animation-delay: 0s; }
.dots span:nth-child(2) { animation-delay: 0.3s; }
.dots span:nth-child(3) { animation-delay: 0.6s; }

.thinking-word { font-family: 'Inconsolata', monospace; margin-right: 2px; }
.thinking-cursor { display: inline-block; width: 0.6em; height: 1.2em; background-color: black; vertical-align: text-bottom; opacity: 0.7; }

@keyframes blink { 0%, 20% { opacity: 0; } 30%, 100% { opacity: 1; }}

::slotted(textarea.plan-editor) { display: block; width: 100%; box-sizing: border-box; min-height: 140px; padding: 10px 12px; border: 1px solid var(--border); border-radius: 8px; background: var(--bg-object); font: inherit; color: inherit; line-height: var(--body-line-height); resize: vertical; overflow: hidden; }
::slotted(textarea.plan-editor:focus) { outline: 2px solid var(--primary-80); outline-offset: -1px; }

.file-attachments { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }
.file-attachment-chip { display: inline-flex; align-items: center; gap: 4px; padding: 3px 8px; border-radius: 12px; background: var(--bg); border: 1px solid var(--border); font-size: 11px; line-height: 16px; color: var(--text-secondary); max-width: 180px; }
.file-attachment-chip .fa-icon { flex-shrink: 0; font-size: 11px; }
.file-attachment-chip .fa-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* EC-25393: queued mid-run, before the agent picked it up */
:host(.queued-interjection) .bubble { background: transparent; border: 1px dashed var(--border); }
.queued-note { display: flex; align-items: center; gap: 6px; margin-top: 8px; color: var(--text-secondary); font-size: var(--bodysm-font-size); line-height: var(--bodysm-font-size); }
.queued-note .queued-note-icon { font-size: 12px; }
    `,
    enableIcon: true
};
class ECPChatMessage extends ECP.Component {
    created() {
        this.showPlanApprovalRequest = false;
        this._feedbackSubmitting = false;
        this.img = this.shadowRoot.querySelector(".avatar-img");
        this.timeEl = this.shadowRoot.querySelector(".time");

        if (this.time) {
            this.timeEl.textContent = this.time;
        }

        const nameEl = this.shadowRoot.querySelector(".h4");
        const role = this.getAttribute("role");
        if (role === "user") {
            if (AgentUserInfo.UserAvatar) {
                const avatarImg = document.createElement("img");
                avatarImg.src = AgentUserInfo.UserAvatar;
                avatarImg.className = "avatar-img";
                avatarImg.style.width = "40px";
                avatarImg.style.height = "40px";
                avatarImg.style.borderRadius = "50%";
                avatarImg.style.objectFit = "cover";

                const wrap = this.shadowRoot.querySelector(".avatar-wrap");
                wrap.innerHTML = "";
                wrap.appendChild(avatarImg);
            } else {
                const userAvatarHTML = `<ecp-illustration illustration="ews-icon-user-avatar" size="m"></ecp-illustration>`;
                this.shadowRoot.querySelector(".avatar-wrap").innerHTML = userAvatarHTML;
            }
            if (AgentUserInfo.UserName) {
                nameEl.textContent = AgentUserInfo.UserName;
            }
        } else {
            nameEl.textContent = "Agent";
            // Show speak button for assistant messages if Web Speech API is supported
            if ("speechSynthesis" in window) {
                const speakBtn = this.shadowRoot.querySelector(".speak-btn");
                if (speakBtn) {
                    speakBtn.classList.remove("hidden");
                    speakBtn.addEventListener("click", () => this._toggleSpeech());
                }
            }
            // Show feedback buttons for assistant messages
            const feedbackBtns = this.shadowRoot.querySelector(".feedback-btns");
            if (feedbackBtns) {
                feedbackBtns.classList.remove("hidden");
                const thumbsUp = feedbackBtns.querySelector(".thumbs-up");
                const thumbsDown = feedbackBtns.querySelector(".thumbs-down");
                const copyBtn = feedbackBtns.querySelector(".copy-response-btn");
                const shareBtn = feedbackBtns.querySelector(".share-response-btn");
                thumbsUp.addEventListener("click", () => this._submitFeedback("positive"));
                thumbsDown.addEventListener("click", () => this._submitFeedback("negative"));
                if (copyBtn) {
                    copyBtn.addEventListener("click", () => this._copyResponse());
                }
                if (shareBtn) {
                    shareBtn.addEventListener("click", () => this._shareResponse());
                }
            }
        }
    }

    _toggleSpeech() {
        try {
            const synth = window._testSpeechSynth || window.speechSynthesis;
            const speakBtn = this.shadowRoot.querySelector(".speak-btn");

            // If currently speaking this message, stop it
            if (this._isSpeaking) {
                synth.cancel();
                this._isSpeaking = false;
                if (speakBtn) {
                    speakBtn.classList.remove("speaking");
                    speakBtn.title = "Listen to response";
                }
                return;
            }

            // Stop any other speech first
            synth.cancel();

            // Get the text content and strip markdown for speech
            const rawText = this.rawContent || this.textContent || "";
            const textToSpeak = ECPChatMessage._stripMarkdownForSpeech(rawText);
            if (!textToSpeak.trim()) return;

            const UtteranceClass = window._TestUtteranceClass || SpeechSynthesisUtterance;
            const utterance = new UtteranceClass(textToSpeak);
            utterance.lang = "en-US";
            utterance.rate = 1.0; // Speed: 0.1 to 10 (1 = normal)
            utterance.pitch = 1.0; // Pitch: 0 to 2 (1 = normal)
            utterance.volume = 1.0; // Volume: 0 to 1

            // Try to select a higher quality voice if available
            const voices = synth.getVoices();
            if (voices.length > 0) {
            // Prefer enhanced/natural voices (naming varies by OS)
            // Chrome/Edge on Windows: "Microsoft ... Online (Natural)"
            // macOS: voices with "Premium" or specific names like "Samantha"
            // iOS: "Samantha (Enhanced)"
                const preferredVoice = voices.find(v => v.lang.startsWith("en") && (
                    v.name.includes("Natural")
                || v.name.includes("Enhanced")
                || v.name.includes("Premium")
                || v.name.includes("Samantha")
                || v.name.includes("Google US English")
                )) || voices.find(v => v.lang.startsWith("en-US") && v.localService)
                || voices.find(v => v.lang.startsWith("en"));

                if (preferredVoice) {
                    utterance.voice = preferredVoice;
                }
            }

            utterance.onend = () => {
                this._isSpeaking = false;
                if (speakBtn) {
                    speakBtn.classList.remove("speaking");
                    speakBtn.title = "Listen to response";
                }
            };

            utterance.onerror = () => {
                this._isSpeaking = false;
                if (speakBtn) {
                    speakBtn.classList.remove("speaking");
                    speakBtn.title = "Listen to response";
                }
            };

            // Set speaking state immediately so toggle responds without waiting for async onstart
            this._isSpeaking = true;
            if (speakBtn) {
                speakBtn.classList.add("speaking");
                speakBtn.title = "Stop listening";
            }

            synth.speak(utterance);
        } catch (e) {
            this._speechError = e.message;
        }
    }

    _copyResponse() {
        const rawText = this.rawContent;
        const textToCopy = typeof rawText === "string" && rawText.length > 0 ? rawText : (this.textContent || "");
        EC_Fmt.CopyTextToClipboard(textToCopy);
        ECP.HTML.Snackbar("Contents copied to clipboard.", "Success");
    }

    // EC-32546: hand the response's markdown to the share picker, which re-renders it as
    // mail/eChat-safe HTML. The raw markdown -- not the rendered DOM -- is the source, so charts,
    // table toolbars and plan editors never ride along.
    _shareResponse() {
        const rawText = this.rawContent;
        const textToShare = typeof rawText === "string" && rawText.length > 0 ? rawText : (this.textContent || "");
        showShareResponseDialog(textToShare);
    }

    _getFeedbackButtons() {
        const feedbackBtns = this.shadowRoot.querySelector(".feedback-btns");
        if (!feedbackBtns) {
            return null;
        }
        return {
            feedbackBtns,
            thumbsUp: feedbackBtns.querySelector(".thumbs-up"),
            thumbsDown: feedbackBtns.querySelector(".thumbs-down")
        };
    }

    _setFeedbackButtonsDisabled(disabled) {
        const buttons = this._getFeedbackButtons();
        if (!buttons) {
            return;
        }
        const { feedbackBtns, thumbsUp, thumbsDown } = buttons;
        if (disabled) {
            thumbsUp.classList.add("disabled");
            thumbsDown.classList.add("disabled");
            feedbackBtns.classList.add("feedback-locked");
            return;
        }
        thumbsUp.classList.remove("disabled");
        thumbsDown.classList.remove("disabled");
        feedbackBtns.classList.remove("feedback-locked");
    }

    _clearFeedbackSelection() {
        const buttons = this._getFeedbackButtons();
        if (!buttons) {
            return;
        }
        const { feedbackBtns, thumbsUp, thumbsDown } = buttons;
        feedbackBtns.classList.remove("feedback-positive", "feedback-negative", "feedback-locked");
        thumbsUp.classList.remove("selected", "disabled");
        thumbsDown.classList.remove("selected", "disabled");
        this._feedbackSentiment = null;
    }

    _applyFeedbackSelection(sentiment) {
        const buttons = this._getFeedbackButtons();
        if (!buttons) {
            return;
        }
        const { feedbackBtns, thumbsUp, thumbsDown } = buttons;

        feedbackBtns.classList.remove("feedback-positive", "feedback-negative");

        thumbsUp.classList.remove("selected", "disabled");
        thumbsDown.classList.remove("selected", "disabled");

        if (sentiment === "positive") {
            feedbackBtns.classList.add("feedback-positive");
            thumbsUp.classList.add("selected");
            this._feedbackSentiment = "positive";
            return;
        }

        if (sentiment === "negative") {
            feedbackBtns.classList.add("feedback-negative");
            thumbsDown.classList.add("selected");
            this._feedbackSentiment = "negative";
            return;
        }

        this._feedbackSentiment = null;
    }

    static async _showFeedbackDialog(sentiment, existingText) {
        const isNegative = sentiment === "negative";
        const title = isNegative ? "Why?" : "What did you like?";
        const prompt = isNegative
            ? "What went wrong? Your feedback helps improve future responses."
            : "What worked well? Your feedback helps reinforce good responses.";
        const placeholder = isNegative
            ? "Tell us why this response was not helpful..."
            : "Tell us what was helpful about this response (optional)...";
        const existingValue = EC_Fmt.Null2EmptyStr(existingText);

        return new Promise((resolve) => {
            const dialogHtml = `
                <div class=agent-feedback-dialog>
                    <div class=ecp-body style="margin-bottom:8px">${prompt}</div>
                    <textarea id=agentFeedbackInput maxlength=2000 placeholder="${placeholder}" style="width:100%;min-height:120px;resize:vertical">${EC_Fmt.HTMLEncode(existingValue)}</textarea>
                </div>`;

            ECP.Dialog.ShowDialog(title, dialogHtml, {
                confirmButtonTitle: "Submit",
                cancelButtonTitle: "Cancel",
                width: 520,
                confirmButtonAction: (container) => {
                    const input = container.querySelector("#agentFeedbackInput");
                    const feedbackText = EC_Fmt.Null2EmptyStr(input ? input.value : "").trim();
                    container.remove();
                    resolve(feedbackText);
                },
                cancelButtonAction: () => resolve(null)
            });
        });
    }

    async _submitFeedback(sentiment) {
        if (this._feedbackSubmitting) {
            return;
        }

        if (!this.aiAgentMessageID) {
            ECP.HTML.Snackbar("Feedback is not available for this message yet.", "Warning");
            return;
        }

        this._feedbackSubmitting = true;

        try {
            const existingText = this._feedbackSentiment === sentiment ? this._feedbackText : "";
            const feedbackText = await ECPChatMessage._showFeedbackDialog(sentiment, existingText);
            if (feedbackText == null) {
                return;
            }

            this._applyFeedbackSelection(sentiment);
            const result = await submitResponseFeedback({
                AIAgentMessageFeedbackID: this.aiAgentMessageFeedbackID,
                AIAgentMessageID: this.aiAgentMessageID,
                Sentiment: sentiment === "negative" ? 0 : 1,
                FeedbackText: feedbackText
            });
            this._feedbackText = feedbackText;
            if (result && result.AIAgentMessageFeedbackID) {
                this.aiAgentMessageFeedbackID = result.AIAgentMessageFeedbackID;
            }
        } catch (error) {
            this._clearFeedbackSelection();
            ECP.HTML.Snackbar(error && error.message ? error.message : "Could not save feedback.", "Error");
        } finally {
            this._feedbackSubmitting = false;
        }
    }

    _restoreFeedback(sentimentValue, feedbackText, aiAgentMessageFeedbackID) {
        const buttons = this._getFeedbackButtons();
        this._feedbackText = EC_Fmt.Null2EmptyStr(feedbackText);
        this.aiAgentMessageFeedbackID = EC_Fmt.Null2ZeroInt(aiAgentMessageFeedbackID);
        if (!buttons) return;
        const { thumbsUp, thumbsDown } = buttons;

        if (sentimentValue === 1) {
            this._feedbackSentiment = "positive";
            thumbsUp.classList.add("selected");
        } else if (sentimentValue === 0) {
            this._feedbackSentiment = "negative";
            thumbsDown.classList.add("selected");
        }
    }

    static _stripMarkdownForSpeech(text) {
        let result = text;

        // Remove code blocks (```...```)
        result = result.replace(/```[\s\S]*?```/g, "");

        // Remove inline code (`...`)
        result = result.replace(/`([^`]+)`/g, "$1");

        // Remove images ![alt](url)
        result = result.replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1");

        // Convert links [text](url) to just text
        result = result.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");

        // Remove headers (# ## ### etc.) but keep the text
        result = result.replace(/^#{1,6}\s+/gm, "");

        // Remove bold/italic markers (**text**, *text*, __text__, _text_)
        result = result.replace(/\*\*([^*]+)\*\*/g, "$1");
        result = result.replace(/\*([^*]+)\*/g, "$1");
        result = result.replace(/__([^_]+)__/g, "$1");
        result = result.replace(/_([^_]+)_/g, "$1");

        // Remove strikethrough (~~text~~)
        result = result.replace(/~~([^~]+)~~/g, "$1");

        // Remove horizontal rules (---, ***, ___)
        result = result.replace(/^[-*_]{3,}\s*$/gm, "");

        // Remove table separator rows (|---|---|)
        result = result.replace(/^\|[-:\s|]+\|\s*$/gm, "");

        // Convert table rows to readable text (remove pipes, clean up cells)
        result = result.replace(/^\|(.+)\|\s*$/gm, (match, content) => content.split("|").map(cell => cell.trim()).filter(cell => cell).join(", "));

        // Remove blockquote markers (>)
        result = result.replace(/^>\s*/gm, "");

        // Remove unordered list markers (-, *, +)
        result = result.replace(/^[\s]*[-*+]\s+/gm, "");

        // Remove ordered list markers (1., 2., etc.)
        result = result.replace(/^[\s]*\d+\.\s+/gm, "");

        // Remove HTML tags
        result = result.replace(/<[^>]+>/g, "");

        // Remove extra whitespace and normalize line breaks
        result = result.replace(/\n{3,}/g, "\n\n");
        result = result.replace(/[ \t]+/g, " ");

        return result.trim();
    }

    updateContent(text, streaming = false) {
        this.stopThinking();
        this.stopEvaluating();
        this._planEditorTextarea = null; // Content replacement destroys any active plan editor
        this.rawContent = text;

        if (!streaming) {
            this._cancelPendingStreamRender();
            this._renderContent(text, false);
            return;
        }

        // Streaming chunks can arrive faster than the display refreshes, and each render re-parses
        // the whole (growing) markdown document. Coalesce streaming renders to one per animation
        // frame; the scheduled render picks up whatever rawContent holds when the frame fires.
        if (!this._streamRenderHandle) {
            this._streamRenderHandle = requestAnimationFrame(() => {
                this._streamRenderHandle = null;
                this._renderContent(this.rawContent, true);
            });
        }
    }

    _cancelPendingStreamRender() {
        if (this._streamRenderHandle) {
            cancelAnimationFrame(this._streamRenderHandle);
            this._streamRenderHandle = null;
        }
    }

    // Paint any not-yet-rendered streaming content now, before DOM readers (chart hydration) run
    _flushPendingStreamRender() {
        if (this._streamRenderHandle) {
            this._cancelPendingStreamRender();
            this._renderContent(this.rawContent, true);
        }
    }

    _renderContent(text, streaming) {
        const bubble = this.shadowRoot.querySelector(".bubble");
        if (!bubble) {
            return;
        }

        // Ensure bubble is visible and restore the slot if it was removed by startThinking()
        bubble.style.display = "";
        if (!bubble.querySelector("slot")) {
            bubble.innerHTML = "<slot></slot>";
        }
        const markedLibrary = typeof globalThis.marked === "undefined" ? null : globalThis.marked;
        if (this.markdown && markedLibrary) {
            // While an ```ecp-chart fence is still streaming, its code is invisible (it shows as a
            // loader). Re-rendering every chunk would re-parse the growing code and detach/re-attach
            // the loader, restarting its spin animation. So render once when the fence opens, then
            // skip until it closes — the single loader stays put and keeps spinning. Only the live
            // streaming path opts in; terminal renders (cancel/error/history) always render.
            const fenceOpen = streaming && hasOpenChartFence(text);
            if (fenceOpen && this._chartFenceOpen) {
                return;
            }
            this._chartFenceOpen = fenceOpen;
            const html = markedLibrary.parse(text, { breaks: true, gfm: true });
            this.innerHTML = html;
            this._syncChartLoaders();
        } else {
            this.innerHTML = ECPChatPanel._escapeHtml(text).replace(/\n/g, "<br>");
        }
    }

    // Keep a stable wrapper per ```ecp-chart while its snippet streams in, with the standard SDK
    // loader (ECP.Dialog.ShowLoading) over it. updateContent() rebuilds this.innerHTML on every chunk,
    // which would wipe an inline loader — so we preserve one wrapper div per chart (a plain node, safe
    // to re-parent without reloading) and move it back into the freshly rendered placeholder each chunk.
    // hydrateD3Charts() later swaps the loader for the chart iframe. Charts are keyed by DOM order, which
    // is stable while streaming (fences only ever open, in order).
    _syncChartLoaders() {
        const placeholders = this.querySelectorAll(".ai-d3-chart");
        if (placeholders.length === 0) {
            return;
        }
        if (!this._chartWraps) {
            this._chartWraps = [];
        }
        for (let i = 0; i < placeholders.length; i++) {
            const placeholder = placeholders[i];
            let wrap = this._chartWraps[i];
            if (!wrap) {
                wrap = document.createElement("div");
                wrap.className = "ai-d3-wrap";
                const host = document.createElement("div");
                host.className = "ai-d3-host";
                wrap.appendChild(host);
                wrap._loadingMask = ECP.Dialog.ShowLoading("Building chart...", host);
                this._chartWraps[i] = wrap;
            }
            // Re-attach the preserved loader wrapper into the freshly rendered placeholder. A rendered
            // chart is left where it is — re-parenting an <iframe> would reload it.
            if (!wrap._rendered && wrap.parentElement !== placeholder) {
                placeholder.insertBefore(wrap, placeholder.firstChild);
            }
        }
    }

    // Swap each chart's loader for the rendered chart. Called at stream finalize and on history load.
    // Idempotent: a wrapper already rendered (_rendered) is kept as-is. Each snippet runs in a sandboxed iframe.
    hydrateD3Charts() {
        this._flushPendingStreamRender();
        // If the stream ended while a fence was still open, updateContent() skipped the last render —
        // render the final content now so placeholders reflect the complete code before hydrating.
        if (this._chartFenceOpen) {
            this._chartFenceOpen = false;
            const markedLibrary = typeof globalThis.marked === "undefined" ? null : globalThis.marked;
            if (this.markdown && markedLibrary && this.rawContent != null) {
                this.innerHTML = markedLibrary.parse(this.rawContent, { breaks: true, gfm: true });
                this._syncChartLoaders();
            }
        }
        const placeholders = this.querySelectorAll(".ai-d3-chart");
        if (placeholders.length === 0) {
            return;
        }
        if (!this._chartWraps) {
            this._chartWraps = [];
        }
        for (let i = 0; i < placeholders.length; i++) {
            const placeholder = placeholders[i];
            let wrap = this._chartWraps[i];
            if (!wrap) {
                // History/one-shot path: no streaming happened, so create the wrapper now.
                wrap = document.createElement("div");
                wrap.className = "ai-d3-wrap";
                this._chartWraps[i] = wrap;
            }
            if (wrap.parentElement !== placeholder) {
                placeholder.insertBefore(wrap, placeholder.firstChild);
            }
            placeholder.setAttribute("data-state", "rendered");
            if (wrap._rendered) {
                continue;
            }
            const srcEl = placeholder.querySelector("script.ai-d3-src");
            const snippet = srcEl ? srcEl.textContent : "";
            if (!snippet || !snippet.trim()) {
                continue;
            }
            if (wrap._loadingMask) {
                ECP.Dialog.HideLoading(wrap._loadingMask);
                wrap._loadingMask = null;
            }
            // Collapse (don't remove) the loader host: a ShowLoading position timer may still
            // reference it, and the SDK dereferences cover.parentElement without guarding.
            const loaderHost = wrap.querySelector(".ai-d3-host");
            if (loaderHost) {
                loaderHost.style.display = "none";
            }
            const chartId = `ecpchart_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
            wrap._rendered = true;
            // D3 is inlined into the srcdoc, so wait for the (cached, same-origin) fetch before
            // building. loadAgentD3Source() never rejects — on failure it yields "" and the
            // harness renders "Chart library unavailable" inside the iframe.
            loadAgentD3Source().then((d3Source) => {
                wrap.appendChild(buildChartIframe(chartId, snippet, d3Source));
            });
        }
    }

    // Load each artifact's page into its sandboxed iframe. Called at stream finalize and on history
    // load, after hydrateD3Charts() (which may re-render the content). Idempotent per shell.
    hydrateArtifacts() {
        this._flushPendingStreamRender();
        const shells = this.querySelectorAll(".ai-artifact");
        for (let i = 0; i < shells.length; i++) {
            const host = shells[i].querySelector(".ai-artifact-host");
            const spec = host && !host.querySelector("iframe") ? readAgentArtifactSpec(shells[i]) : null;
            if (!spec) {
                continue;
            }
            host.innerHTML = "";
            host.appendChild(buildArtifactIframe(spec));
        }
    }

    // Replace the rendered plan with a multi-line plain-text editor so the user can
    // adjust the plan before executing. The textarea holds the working copy; the
    // original text is kept so editing can be reverted.
    enablePlanEditing() {
        if (this._planEditorTextarea) {
            return;
        }
        this._cancelPendingStreamRender(); // The editor replaces the rendered content
        this._planOriginalText = this.rawContent || "";
        const textarea = document.createElement("textarea");
        textarea.className = "plan-editor";
        textarea.maxLength = PLAN_EDITOR_MAX_LENGTH;
        textarea.value = this._planOriginalText;
        textarea.setAttribute("aria-label", "Edit plan before executing");
        textarea.addEventListener("input", () => {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        });
        this.innerHTML = "";
        this.appendChild(textarea);
        this._planEditorTextarea = textarea;
        textarea.style.height = `${textarea.scrollHeight}px`;
    }

    // Current plan text: live editor value while editing, otherwise the rendered content
    getPlanEditorText() {
        if (this._planEditorTextarea) {
            return this._planEditorTextarea.value;
        }
        return this.rawContent || "";
    }

    disablePlanEditing(keepEdits = true) {
        if (!this._planEditorTextarea) {
            return;
        }
        const finalText = keepEdits ? this._planEditorTextarea.value : this._planOriginalText;
        this._planEditorTextarea = null;
        this.updateContent(finalText);
    }

    showFileAttachments(files) {
        if (!files || files.length === 0) {
            return;
        }
        this._attachedFiles = files;
        const bubble = this.shadowRoot.querySelector(".bubble");
        const container = document.createElement("div");
        container.className = "file-attachments";
        files.forEach((f) => {
            const chip = document.createElement("span");
            chip.className = "file-attachment-chip";
            chip.innerHTML = `<i class="fa-icon ews-icon-document"></i><span class="fa-name">${EC_Fmt.HTMLEncode(f.fileName || f.FileName || "")}</span>`;
            container.appendChild(chip);
        });
        bubble.insertBefore(container, bubble.firstChild);
    }

    // EC-25393: fallback rendering when there is no live assistant message to attach a timeline row to
    markQueuedInterjection(sequence, noteText) {
        this.interjectionSequence = sequence;
        this.classList.add("queued-interjection");

        const bubble = this.shadowRoot.querySelector(".bubble");
        let note = bubble.querySelector(".queued-note");
        if (!note) {
            note = document.createElement("div");
            note.className = "queued-note";
            bubble.appendChild(note);
        }
        note.innerHTML = `<i class="queued-note-icon ews-icon-circlehalfdashed"></i><span>${EC_Fmt.HTMLEncode(noteText)}</span>`;
    }

    clearQueuedInterjection() {
        this.interjectionSequence = null;
        this.classList.remove("queued-interjection");

        const note = this.shadowRoot.querySelector(".queued-note");
        if (note) {
            note.remove();
        }
    }

    startThinking() {
        this.stopThinking();
        this._cancelPendingStreamRender(); // A late streamed render would clobber the thinking UI
        let currentIndex = Math.floor(Math.random() * THINKING_MESSAGES.length);
        let currentWord = THINKING_MESSAGES[currentIndex];

        // Helper to get random pause between 4 and 6 seconds
        const getRandomPause = () => 4000 + Math.random() * 2000;

        // Get the bubble element from shadow DOM - styles only apply inside shadow DOM
        const bubble = this.shadowRoot.querySelector(".bubble");

        // Ensure bubble is visible
        bubble.style.display = "";

        // Initial setup - place content directly in shadow DOM bubble for styles to apply
        // We use a separate span for the word so we don't re-render the dots
        bubble.innerHTML = `<span class="thinking-word">${currentWord}</span><span class="dots"><span>.</span><span>.</span><span>.</span></span>`;

        // Cache the element to avoid querySelector in the loop
        const wordSpan = bubble.querySelector(".thinking-word");

        const update = () => {
            let nextIndex = Math.floor(Math.random() * THINKING_MESSAGES.length);
            // Ensure we pick a different word
            if (nextIndex === currentIndex) {
                nextIndex = (nextIndex + 1) % THINKING_MESSAGES.length;
            }

            const nextWord = THINKING_MESSAGES[nextIndex];
            const oldWord = currentWord;

            const maxLen = Math.max(oldWord.length, nextWord.length);
            // Transition takes 800ms total
            const stepTime = 800 / maxLen;

            let i = 0;
            const animateStep = () => {
                if (i <= maxLen) {
                    const prefix = nextWord.slice(0, i);
                    const suffix = oldWord.slice(i);

                    // Show cursor at the current position being typed
                    // The cursor visually represents the "typing head" replacing characters
                    let cursorHtml = "";
                    if (i < maxLen) {
                        cursorHtml = `<span class=thinking-cursor></span>`;
                    }

                    // Build the display: new characters + cursor + remaining old characters
                    // The cursor sits between what's been typed and what remains
                    wordSpan.innerHTML = `${prefix}${cursorHtml}${suffix.slice(1)}`;

                    i++;
                    this.thinkingAnimationRequest = setTimeout(animateStep, stepTime);
                } else {
                    // Animation complete, ensure clean state
                    wordSpan.textContent = nextWord;
                    currentWord = nextWord;
                    currentIndex = nextIndex;
                    // Random pause between 1.5 and 3.5 seconds before next word
                    this.thinkingInterval = setTimeout(update, getRandomPause());
                }
            };

            // Start the animation
            animateStep();
        };

        // Start the first update cycle after a random pause
        this.thinkingInterval = setTimeout(update, getRandomPause());
    }

    stopThinking() {
        if (this.thinkingInterval) {
            clearTimeout(this.thinkingInterval);
            this.thinkingInterval = null;
        }
        if (this.thinkingAnimationRequest) {
            clearTimeout(this.thinkingAnimationRequest);
            this.thinkingAnimationRequest = null;
        }

        // Clear content and hide bubble if it was thinking
        const bubble = this.shadowRoot.querySelector(".bubble");
        if (bubble && bubble.querySelector(".thinking-word")) {
            bubble.innerHTML = "";
            bubble.style.display = "none";
        }
    }

    startEvaluating() {
        this.stopThinking();
        this.stopEvaluating();

        const bubble = this.shadowRoot.querySelector(".bubble");
        if (!bubble) {
            return;
        }

        bubble.style.display = "";
        if (!bubble.querySelector("slot")) {
            bubble.innerHTML = "<slot></slot>";
        }

        this.evaluatingLoadingMask = ECP.Dialog.ShowLoading("Evaluating...", bubble);
    }

    stopEvaluating() {
        if (this.evaluatingLoadingMask) {
            ECP.Dialog.HideLoading(this.evaluatingLoadingMask);
            this.evaluatingLoadingMask = null;
        }
    }

    // Get the tools timeline component
    getToolsTimeline() {
        return this.shadowRoot.querySelector("tools-timeline");
    }

    // Move pre-tool thinking text into the timeline as a collapsible box and clear the bubble
    addPreToolThinking(text) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.addThinkingText(text);
        }
        this.updateContent("", true);
    }

    // EC-25393: queued user messages live in the run timeline, not as a trailing chat bubble
    addInterjection(text, stateText) {
        const timeline = this.getToolsTimeline();
        return timeline ? timeline.addInterjection(text, stateText) : null;
    }

    setInterjectionState(item, stateText, pending = false) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.setInterjectionState(item, stateText, pending);
        }
    }

    removeInterjection(item) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.removeInterjection(item);
        }
    }

    // Add tool calls to the timeline (replaces updateTools for running state)
    addToolCalls(toolNames, isComplete = false, metadata = null) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.addToolCalls(toolNames, isComplete, metadata);
        }
    }

    // Mark the timeline as complete
    markToolsComplete() {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.markComplete();
        }
    }

    // Mark the currently-spinning tool in the main timeline as completed
    markCurrentToolCompleted() {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.markCurrentToolCompleted();
        }
    }

    // Mark the currently-spinning tool in a sub-agent as completed
    markSubAgentCurrentToolCompleted(subAgentId) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.markSubAgentCurrentToolCompleted(subAgentId);
        }
    }

    // Create a sub-agent in the timeline
    createSubAgent(subAgentId, subAgentName, parentSubAgentId = null) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            return timeline.createSubAgent(subAgentId, subAgentName, parentSubAgentId);
        }
        return null;
    }

    // Add tool calls to a sub-agent
    addSubAgentToolCalls(subAgentId, toolNames, metadata = null) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.addSubAgentToolCalls(subAgentId, toolNames, metadata);
        }
    }

    // Append response to a sub-agent
    appendSubAgentResponse(subAgentId, text) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.appendSubAgentResponse(subAgentId, text);
        }
    }

    // Set response for a sub-agent
    setSubAgentResponse(subAgentId, text) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.setSubAgentResponse(subAgentId, text);
        }
    }

    // Mark a sub-agent as completed
    markSubAgentCompleted(subAgentId) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.markSubAgentCompleted(subAgentId);
        }
    }

    // Show tool approval request in the timeline
    showToolApproval(data, callback) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.addApprovalRequest(data, callback);
        }
    }

    // EC-32435: drop any approval box still waiting in this message's timeline
    dismissApprovalRequests(onlyToolApprovals = false) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.dismissApprovalRequests(onlyToolApprovals);
        }
        if (!onlyToolApprovals) {
            this.showPlanApprovalRequest = false;
        }
    }

    // Show clarification request (A/B/C options + free-text) in the timeline
    showClarificationRequest(data, callback) {
        const timeline = this.getToolsTimeline();
        if (timeline) {
            timeline.addClarificationRequest(data, callback);
        }
    }

    showPlanFirstApproval(callback) {
        const timeline = this.getToolsTimeline();
        if (timeline && !this.showPlanApprovalRequest) {
            const bubble = this.shadowRoot.querySelector(".bubble");
            bubble.insertAdjacentElement("afterend", timeline);
            this.showPlanApprovalRequest = true;
            timeline.addPlanApprovalRequest(callback);
        }
    }
}
ECP.Component.define(ECPChatMessage, ECPChatMessageDefinition);

const ECPChatPanelDefinition = {
    name: "ecp-chatpanel",
    template: `
<div class=panel-root>
 <slot class=chat-messages></slot>
 <div class="chat-typing hidden">Working...</div>
</div>
    `,
    styles: `
:host { display: block; height: 100%; box-sizing: border-box; }
.panel-root { display: flex; flex-direction: column; height: 100%; background: transparent; }
/* --agent-inset is what the composer pads with, and custom properties inherit through the shadow
   boundary, so the transcript and the prompt box share both edges at every width. */
.chat-messages { flex: 1; padding: clamp(14px, 1.6cqi, 28px) var(--agent-inset, 20px) 4px; width: 100%; display: flex; flex-direction: column; gap: 12px; box-sizing: border-box; }
.chat-typing { padding: 12px var(--agent-inset, 20px); color: rgba(0,0,0,0.6); border-top: 1px solid rgba(0,0,0,0.05); }
:host(.agent-reliability-chat-panel) { min-height: 0; }
:host(.agent-reliability-chat-panel) .chat-messages { margin: 0; padding: 16px 0 0; }
:host(.agent-reliability-chat-panel) .chat-typing { padding: 8px 0 0; border-top: none; }
.hidden { display: none; }
    `,
    enableIcon: true
};
const CHAT_AUTOSCROLL_THRESHOLD_PX = 50;
class ECPChatPanel extends ECP.Component {
    created() {
        this.msgBox = this.shadowRoot.querySelector(".chat-messages");
        this.typingEl = this.shadowRoot.querySelector(".chat-typing");
        this._scrollContainer = null;
        this._autoScrollEnabled = true;
        this._boundHandleScroll = () => {
            this._updateAutoScrollState();
        };
    }

    addMessage(role, text, timestamp, useMarkdown = true) {
        const time = timestamp ? this.constructor._formatTime(new Date(timestamp)) : this.constructor._formatTime(new Date());
        const msg = document.createElement("cur-chatmessage");
        msg.setAttribute("role", role);
        msg.setAttribute("time", time);
        if (useMarkdown) {
            msg.setAttribute("markdown", "true");
            msg.classList.add("markdown");
        }
        msg.innerHTML = "";
        this.appendChild(msg);

        msg.updateContent(text);
        msg.hydrateD3Charts();
        msg.hydrateArtifacts();

        this._scrollToBottom();
        return msg;
    }

    showTyping(show = true) {
        this.typingEl.classList.toggle("hidden", !show);
        this._scrollToBottom();
    }

    _getScrollContainer() {
        const container = this.parentNode;
        if (!container) {
            return null;
        }

        if (this._scrollContainer !== container) {
            if (this._scrollContainer && this._boundHandleScroll) {
                this._scrollContainer.removeEventListener("scroll", this._boundHandleScroll);
            }
            this._scrollContainer = container;
            if (this._boundHandleScroll) {
                this._scrollContainer.addEventListener("scroll", this._boundHandleScroll, { passive: true });
            }
        }
        return this._scrollContainer;
    }

    static _isWithinAutoScrollThreshold(container) {
        return (container.scrollHeight - container.scrollTop) <= (container.clientHeight + CHAT_AUTOSCROLL_THRESHOLD_PX);
    }

    _updateAutoScrollState() {
        const container = this._scrollContainer || this.parentNode;
        if (!container) {
            return;
        }
        this._autoScrollEnabled = ECPChatPanel._isWithinAutoScrollThreshold(container);
    }

    _scrollToBottom(force = false) {
        requestAnimationFrame(() => {
            const container = this._getScrollContainer();
            if (container && this.msgBox) {
                if (!force && !this._autoScrollEnabled) {
                    return;
                }
                container.scrollTop = this.msgBox.scrollHeight;
                this._autoScrollEnabled = true;
            }
        });
    }

    static _formatTime(date) {
        if (!date || !(date instanceof Date) || date.toString() === "Invalid Date") {
            return "";
        }

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        const inputDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const timeStr = `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

        if (inputDate.getTime() === today.getTime()) {
            return `Today ${timeStr}`;
        }
        if (inputDate.getTime() === yesterday.getTime()) {
            return `Yesterday ${timeStr}`;
        }

        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${date.getFullYear()}/${month}/${day} ${timeStr}`;
    }

    static _escapeHtml(unsafe) {
        if (!unsafe && unsafe !== "") return "";
        return String(unsafe);
    }
}
ECP.Component.define(ECPChatPanel, ECPChatPanelDefinition);

const ECPBtnGroupDefinition = {
    name: "ecp-btn-group",
    template: `
<div class=btn-group>
 <slot></slot>
</div>
    `,

    styles: `
:host {
 display:inline-block;
}
.btn-group {
 display: flex;
 flex-direction: row;
 align-items: center;
}
::slotted(ecp-btn) {
 margin: 0!important;
}
    `,
    enableIcon: true
};
class ECPBtnGroup extends ECP.Component {
    created() {
        requestAnimationFrame(() => {
            const btns = this.querySelectorAll("ecp-btn");
            for (let i = 0; i < btns.length; i++) {
                const btn = btns[i].shadowRoot.querySelector("button");
                if (btn) {
                    if (i !== btns.length - 1) {
                        btn.style["border-top-right-radius"] = "0";
                        btn.style["border-bottom-right-radius"] = "0";
                    }
                    if (i !== 0) {
                        btn.style["border-top-left-radius"] = "0";
                        btn.style["border-bottom-left-radius"] = "0";
                        btn.style["border-left"] = "0";
                    }
                }
            }
        });
    }
}
ECP.Component.define(ECPBtnGroup, ECPBtnGroupDefinition);

// Unified Tools Timeline Component - displays all tool calls (main agent and sub-agents) in a single collapsible view
const ToolsTimelineDefinition = {
    name: "tools-timeline",
    attributes: [
        { property: "collapsed", mode: "boolean" }
    ],
    template: `
<div class=timeline-root>
 <div class=timeline-header>
  <span class="timeline-icon ews-icon-run"></span>
  <span class=timeline-title>Tools</span>
  <span class=timeline-count></span>
  <span class="timeline-spinner ews-icon-circlehalfdashed"></span>
  <span class="timeline-toggle ews-icon-caretup"title=Collapse></span>
 </div>
 <div class=timeline-body>
  <div class=timeline-items></div>
 </div>
</div>
    `,
    styles: `
:host { display: block; margin-bottom: 8px; }
:host(.hidden) { display: none; }
.timeline-root {
 border: 1px solid var(--border);
 border-radius: 8px;
 background: var(--layer-1);
 overflow: hidden;
}
.timeline-header {
 display: flex;
 align-items: center;
 gap: 8px;
 padding: 12px 16px;
 background: var(--bg-object);
 border-bottom: 1px solid var(--border);
 cursor: pointer;
 user-select: none;
}
.timeline-header:hover {
 background: var(--bg-hover);
}
.timeline-icon {
 color: var(--primary-80);
 font-size: 16px;
}
.timeline-title {
 font-weight: var(--semibold-weight);
 color: var(--text);
 font-size: var(--body-font-size);
}
.timeline-count {
 flex: 1;
 color: var(--text-secondary);
 font-size: var(--bodysm-font-size);
}
.timeline-spinner {
 color: var(--primary-80);
 font-size: 16px;
 animation: spin 1s linear infinite;
}
.timeline-spinner.hidden { display: none; }
@keyframes spin {
 from { transform: rotate(0deg); }
 to { transform: rotate(360deg); }
}
.timeline-toggle {
 color: var(--text-secondary);
 font-size: 12px;
 transition: transform 200ms ease;
}
:host([collapsed]) .timeline-toggle {
 transform: rotate(180deg);
}
.timeline-body {
 padding: 12px 16px;
 display: flex;
 flex-direction: column;
 gap: 4px;
}
:host([collapsed]) .timeline-body {
 display: none;
}
.timeline-items {
 display: flex;
 flex-direction: column;
 gap: 4px;
}
.timeline-items:empty { display: none; }

.thinking-item {
 border: 1px solid var(--border);
 border-radius: 6px;
 background: var(--layer-2);
 overflow: hidden;
 animation: toolFadeIn 150ms ease;
}
.thinking-header {
 display: flex;
 align-items: center;
 gap: 8px;
 padding: 8px 12px;
 background: var(--bg-object);
 cursor: pointer;
 user-select: none;
}
.thinking-header:hover {
 background: var(--bg-hover);
}
.thinking-icon {
 color: var(--text-secondary);
 font-size: 14px;
}
.thinking-label {
 flex: 1;
 font-weight: var(--semibold-weight);
 color: var(--text-secondary);
 font-size: var(--bodysm-font-size);
}
.thinking-toggle {
 color: var(--text-secondary);
 font-size: 10px;
 transition: transform 200ms ease;
}
.thinking-item.collapsed .thinking-toggle {
 transform: rotate(180deg);
}
.thinking-body {
 padding: 8px 12px;
 border-top: 1px solid var(--border);
}
.thinking-item.collapsed .thinking-body {
 display: none;
}
.thinking-text {
 color: var(--text-secondary);
 font-size: var(--bodysm-font-size);
 line-height: 1.4;
 white-space: pre-wrap;
 word-break: break-word;
}
/* EC-25393: a message sent mid-run, shown where it was sent */
.interjection-item {
 border: 1px solid var(--border);
 border-left: 3px solid var(--primary-80);
 border-radius: 6px;
 background: var(--bg-object);
 padding: 8px 12px;
 animation: toolFadeIn 150ms ease;
}
.interjection-meta {
 display: flex;
 align-items: center;
 gap: 8px;
 margin-bottom: 4px;
}
.interjection-icon {
 color: var(--text-secondary);
 font-size: 13px;
}
.interjection-label {
 font-weight: var(--semibold-weight);
 color: var(--text-secondary);
 font-size: var(--bodysm-font-size);
}
.interjection-state {
 color: var(--text-secondary);
 font-size: var(--bodysm-font-size);
 font-style: italic;
}
.interjection-item.pending .interjection-state { color: var(--primary-110); }
.interjection-text {
 color: var(--text);
 font-size: var(--bodysm-font-size);
 line-height: 1.4;
 white-space: pre-wrap;
 word-break: break-word;
}
/* The user's own words are not tool noise: keep them visible once the timeline collapses. */
:host([collapsed].has-interjection) .timeline-body { display: block; }
:host([collapsed]) .timeline-items > *:not(.interjection-item) { display: none; }

.tool-item {
 display: flex;
 align-items: center;
 gap: 8px;
 padding: 6px 10px;
 background: var(--bg);
 border-radius: 4px;
 font-size: var(--bodysm-font-size);
 color: var(--text-secondary);
 animation: toolFadeIn 150ms ease;
}
@keyframes toolFadeIn {
 from { opacity: 0; transform: translateX(-4px); }
 to { opacity: 1; transform: translateX(0); }
}
.tool-item .tool-icon {
 color: var(--primary-80);
 font-size: 12px;
}
.tool-item .tool-name {
 flex: 1;
 overflow: hidden;
 text-overflow: ellipsis;
 white-space: nowrap;
}
.tool-item .tool-meta {
 color: var(--text-secondary);
 opacity: 0.8;
}
.tool-item .tool-spinner {
 animation: spin 1s linear infinite;
 font-size: 12px;
 color: var(--text-secondary);
}
.tool-item .tool-check {
 color: var(--green-70);
 font-size: 12px;
}
.tool-item.completed .tool-spinner { display: none; }
.tool-item:not(.completed) .tool-check { display: none; }
.tool-item.tool-detail { align-items: flex-start; }
.tool-item.tool-detail .tool-name { white-space: normal; }
.tool-item.tool-detail .tool-value {
 color: var(--text-secondary);
 display: block;
 margin-top: 2px;
 word-break: break-word;
 }

.subagent-item {
 border: 1px solid var(--border);
 border-radius: 6px;
 background: var(--layer-2);
 overflow: hidden;
 margin-top: 4px;
 animation: toolFadeIn 150ms ease;
}
.subagent-header {
 display: flex;
 align-items: center;
 gap: 8px;
 padding: 8px 12px;
 background: var(--bg-object);
 cursor: pointer;
 user-select: none;
}
.subagent-header:hover {
 background: var(--bg-hover);
}
.subagent-icon {
 color: var(--primary-80);
 font-size: 14px;
}
.subagent-name {
 flex: 1;
 font-weight: var(--semibold-weight);
 color: var(--text);
 font-size: var(--bodysm-font-size);
}
.subagent-spinner {
 color: var(--primary-80);
 font-size: 14px;
 animation: spin 1s linear infinite;
}
.subagent-spinner.hidden { display: none; }
.subagent-toggle {
 color: var(--text-secondary);
 font-size: 10px;
 transition: transform 200ms ease;
}
.subagent-item.collapsed .subagent-toggle {
 transform: rotate(180deg);
}
.subagent-body {
 padding: 8px 12px;
 display: flex;
 flex-direction: column;
 gap: 4px;
 border-top: 1px solid var(--border);
}
.subagent-item.collapsed .subagent-body {
 display: none;
}
.subagent-tools {
 display: flex;
 flex-direction: column;
 gap: 4px;
}
.subagent-tools:empty { display: none; }
.subagent-response {
 color: var(--text);
 font-size: var(--bodysm-font-size);
 line-height: 1.4;
 white-space: pre-wrap;
 word-break: break-word;
 padding: 4px 0;
}
.subagent-response:empty { display: none; }
.subagent-children {
 display: flex;
 flex-direction: column;
 gap: 4px;
 margin-left: 8px;
 padding-left: 8px;
 border-left: 2px solid var(--border);
}
.subagent-children:empty { display: none; }

.approval-item {
 padding: 12px;
 background: var(--bg);
 border-radius: 8px;
 margin-top: 4px;
 border: 1px solid var(--border);
 animation: toolFadeIn 150ms ease;
}
.approval-item .approval-content {
 margin-bottom: 12px;
 font-size: var(--body-font-size);
 color: var(--text);
 overflow-x: auto;
}
.approval-item .approval-actions {
 display: flex;
 justify-content: flex-end;
 gap: 8px;
 align-items: center;
}
.approval-item .approval-actions.hidden { display: none; }
.approval-item .approval-status {
 display: flex;
 align-items: center;
 gap: 6px;
 font-weight: var(--semibold-weight);
 justify-content: flex-end;
 font-size: var(--bodysm-font-size);
}
.approval-item .approval-status.hidden { display: none; }
.approval-item .approval-status.approved { color: var(--green-70); }
.approval-item .approval-status.cancelled { color: var(--red-70); }

/* Clarification Item Styles */
.clarification-item {
 padding: 14px;
 background: var(--bg);
 border-radius: 8px;
 margin-top: 4px;
 border: 1px solid var(--border);
 animation: toolFadeIn 150ms ease;
}
.clarification-question {
 margin-bottom: 12px;
 font-size: var(--body-font-size);
 color: var(--text);
 font-weight: var(--semibold-weight);
 line-height: 1.5;
}
.clarification-options {
 display: flex;
 flex-direction: column;
 gap: 6px;
 margin-bottom: 12px;
}
.clarification-option {
 display: flex;
 align-items: flex-start;
 gap: 10px;
 padding: 8px 10px;
 background: var(--layer-1);
 border: 1px solid var(--border);
 border-radius: 6px;
 cursor: pointer;
 transition: background-color 150ms ease, border-color 150ms ease;
 text-align: left;
 font-size: var(--body-font-size);
 color: var(--text);
 width: 100%;
 box-sizing: border-box;
}
.clarification-option:hover {
 background: var(--bg-hover);
 border-color: var(--border-active);
}
.clarification-option.selected {
 background: var(--bg-selected);
 border-color: var(--border-selected);
}
.clarification-option-label {
 font-weight: var(--semibold-weight);
 color: var(--primary-80);
 min-width: 20px;
 flex-shrink: 0;
}
.clarification-option-text {
 flex: 1;
 line-height: 1.4;
}
.clarification-other {
 margin-top: 4px;
 margin-bottom: 12px;
}
.clarification-other-label {
 font-size: var(--bodysm-font-size);
 color: var(--text-secondary);
 margin-bottom: 4px;
 font-weight: var(--semibold-weight);
}
.clarification-other-textarea {
 width: 100%;
 box-sizing: border-box;
 resize: vertical;
 min-height: 54px;
 padding: 8px 10px;
 font-size: var(--body-font-size);
 font-family: inherit;
 color: var(--text);
 background: var(--bg);
 border: 1px solid var(--border);
 border-radius: 6px;
 line-height: 1.4;
 outline: none;
 transition: border-color 150ms ease;
}
.clarification-other-textarea:focus {
 border-color: var(--border-active);
}
.clarification-other-textarea::placeholder {
 color: var(--text-placeholder);
}
.clarification-actions {
 display: flex;
 justify-content: flex-end;
 gap: 8px;
 align-items: center;
}
.clarification-actions.hidden { display: none; }
    `,
    enableIcon: true
};

class ToolsTimeline extends ECP.Component {
    created() {
        this._toolCount = 0;
        this._isComplete = false;
        this._subAgents = new Map(); // Map<subAgentId, subAgentElement>

        // Toggle collapse on header click
        const header = this.shadowRoot.querySelector(".timeline-header");
        header.addEventListener("click", () => this.toggleCollapse());

        // Start hidden
        this.classList.add("hidden");
    }

    toggleCollapse() {
        if (this.hasAttribute("collapsed")) {
            this.removeAttribute("collapsed");
        } else {
            this.setAttribute("collapsed", "");
        }
    }

    show() {
        this.classList.remove("hidden");
    }

    hide() {
        this.classList.add("hidden");
    }

    // Format metadata object into a display string (e.g. "tableName: Customers, keyValue: 3")
    static _formatMetadata(meta) {
        if (!meta || typeof meta !== "object") return "";
        const parts = Object.entries(meta)
            .filter(([, v]) => v !== null && v !== undefined && v !== "")
            .map(([k, v]) => `${k}: ${v}`);
        return parts.join(", ");
    }

    static _escapeHtml(value) {
        if (value === null || value === undefined) {
            return "";
        }

        return String(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    static _getKnowledgeSources(meta) {
        if (!meta || typeof meta !== "object" || typeof meta.KnowledgeSources !== "string") {
            return "";
        }

        return meta.KnowledgeSources;
    }

    static _getDisplayMetadata(meta) {
        if (!meta || typeof meta !== "object") {
            return null;
        }

        const displayMeta = {};
        Object.entries(meta).forEach(([key, value]) => {
            if (key !== "KnowledgeSources") {
                displayMeta[key] = value;
            }
        });

        return Object.keys(displayMeta).length > 0 ? displayMeta : null;
    }

    static _createToolItem(toolName, isComplete, meta = null) {
        const toolItem = document.createElement("div");
        toolItem.className = `tool-item${isComplete ? " completed" : ""}`;
        toolItem.dataset.tool = toolName;

        const metaStr = ToolsTimeline._formatMetadata(meta);
        const escapedMetaStr = ToolsTimeline._escapeHtml(metaStr);
        const metaHtml = metaStr ? `<span class="tool-meta" title="${escapedMetaStr}"> | ${escapedMetaStr}</span>` : "";

        toolItem.innerHTML = `
 <span class="tool-icon ews-icon-run"></span>
 <span class=tool-name>${ToolsTimeline._escapeHtml(toolName)}${metaHtml}</span>
 <span class="tool-spinner ews-icon-circlehalfdashed"></span>
 <span class="tool-check ews-icon-check"></span>
            `;

        return toolItem;
    }

    static _createKnowledgeSourcesItem(knowledgeSources, isComplete) {
        const toolItem = document.createElement("div");
        toolItem.className = `tool-item tool-detail${isComplete ? " completed" : ""}`;
        toolItem.dataset.tool = "Knowledge Sources";
        toolItem.innerHTML = `
 <span class="tool-icon ews-icon-run"></span>
 <span class=tool-name><strong>Knowledge Sources</strong><span class=tool-value>${ToolsTimeline._escapeHtml(knowledgeSources)}</span></span>
 <span class="tool-spinner ews-icon-circlehalfdashed"></span>
 <span class="tool-check ews-icon-check"></span>
            `;
        return toolItem;
    }

    // Add a collapsible "thinking" box showing pre-tool model output
    addThinkingText(text) {
        this.show();
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (!container) return;

        const thinkingItem = document.createElement("div");
        thinkingItem.className = "thinking-item collapsed";
        thinkingItem.innerHTML = `
<div class=thinking-header>
 <span class="thinking-icon ews-icon-spark"></span>
 <span class=thinking-label>Thinking</span>
 <span class="thinking-toggle ews-icon-caretup"></span>
</div>
<div class=thinking-body>
 <span class=thinking-text>${ToolsTimeline._escapeHtml(text)}</span>
</div>
        `;

        const header = thinkingItem.querySelector(".thinking-header");
        header.addEventListener("click", (e) => {
            e.stopPropagation();
            thinkingItem.classList.toggle("collapsed");
        });

        container.appendChild(thinkingItem);
    }

    // EC-25393: a course correction belongs in the run, not trailing the answer it changed
    addInterjection(text, stateText) {
        this.show();
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (!container) return null;

        const item = document.createElement("div");
        item.className = "interjection-item pending";
        item.innerHTML = `
<div class=interjection-meta>
 <span class="interjection-icon ews-icon-chatting"></span>
 <span class=interjection-label>You said</span>
 <span class=interjection-state></span>
</div>
<div class=interjection-text></div>
        `;
        item.querySelector(".interjection-text").textContent = text;
        item.querySelector(".interjection-state").textContent = stateText;
        container.appendChild(item);
        this.classList.add("has-interjection");
        return item;
    }

    setInterjectionState(item, stateText, pending = false) {
        if (!item || !this.shadowRoot.contains(item)) return;
        item.classList.toggle("pending", !!pending);
        const state = item.querySelector(".interjection-state");
        if (state) {
            state.textContent = stateText;
        }
    }

    removeInterjection(item) {
        if (!item) return;
        item.remove();
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (container && !container.querySelector(".interjection-item")) {
            this.classList.remove("has-interjection");
        }
    }

    // Add main agent tool calls
    addToolCalls(toolNames, isComplete = false, metadata = null) {
        this.show();
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (!container) return;

        // Mark any previously-spinning tool calls as completed
        if (!isComplete) {
            container.querySelectorAll(".tool-item:not(.completed)").forEach((item) => {
                item.classList.add("completed");
            });
        }

        toolNames.forEach((toolName, index) => {
            const meta = metadata && metadata[index] ? metadata[index] : null;
            const toolItem = ToolsTimeline._createToolItem(toolName, isComplete, ToolsTimeline._getDisplayMetadata(meta));
            container.appendChild(toolItem);
            this._toolCount++;

            const knowledgeSources = ToolsTimeline._getKnowledgeSources(meta);
            if (knowledgeSources) {
                container.appendChild(ToolsTimeline._createKnowledgeSourcesItem(knowledgeSources, isComplete));
            }
        });

        this._updateCount();
    }

    // Mark all main agent tools as completed
    markToolsCompleted() {
        const toolItems = this.shadowRoot.querySelectorAll(".tool-item");
        toolItems.forEach(item => item.classList.add("completed"));
    }

    // Mark the oldest currently-spinning main agent tool item as completed
    markCurrentToolCompleted() {
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (!container) return;
        const item = container.querySelector(".tool-item:not(.completed)");
        if (item) item.classList.add("completed");
    }

    // Mark the oldest currently-spinning tool item in a sub-agent as completed
    markSubAgentCurrentToolCompleted(subAgentId) {
        const subAgentEl = this._subAgents.get(subAgentId);
        if (!subAgentEl) return;
        const item = subAgentEl.querySelector(".tool-item:not(.completed)");
        if (item) item.classList.add("completed");
    }

    // Create a sub-agent entry
    createSubAgent(subAgentId, subAgentName, parentSubAgentId = null) {
        this.show();

        // Find the correct container
        let container;
        if (parentSubAgentId && this._subAgents.has(parentSubAgentId)) {
            const parentEl = this._subAgents.get(parentSubAgentId);
            container = parentEl.querySelector(".subagent-children");
        } else {
            container = this.shadowRoot.querySelector(".timeline-items");
        }

        if (!container) return null;

        const subAgentEl = document.createElement("div");
        subAgentEl.className = "subagent-item";
        subAgentEl.dataset.subagentid = subAgentId;
        subAgentEl.innerHTML = `
<div class=subagent-header>
 <span class="subagent-icon ews-icon-spark"></span>
 <span class=subagent-name>${subAgentName}</span>
 <span class="subagent-spinner ews-icon-circlehalfdashed"></span>
 <span class="subagent-toggle ews-icon-caretup"></span>
</div>
<div class=subagent-body>
 <div class=subagent-tools></div>
 <div class=subagent-response></div>
 <div class=subagent-children></div>
</div>
        `;

        // Add collapse toggle
        const header = subAgentEl.querySelector(".subagent-header");
        header.addEventListener("click", (e) => {
            e.stopPropagation();
            subAgentEl.classList.toggle("collapsed");
        });

        container.appendChild(subAgentEl);
        this._subAgents.set(subAgentId, subAgentEl);

        return subAgentEl;
    }

    // Add tool calls to a sub-agent
    addSubAgentToolCalls(subAgentId, toolNames, metadata = null) {
        const subAgentEl = this._subAgents.get(subAgentId);
        if (!subAgentEl) return;

        const toolsContainer = subAgentEl.querySelector(".subagent-tools");
        if (!toolsContainer) return;

        toolNames.forEach((toolName, index) => {
            const meta = metadata && metadata[index] ? metadata[index] : null;
            const toolItem = ToolsTimeline._createToolItem(toolName, false, ToolsTimeline._getDisplayMetadata(meta));
            toolsContainer.appendChild(toolItem);
            this._toolCount++;

            const knowledgeSources = ToolsTimeline._getKnowledgeSources(meta);
            if (knowledgeSources) {
                toolsContainer.appendChild(ToolsTimeline._createKnowledgeSourcesItem(knowledgeSources, false));
            }
        });

        this._updateCount();
    }

    // Append response text to a sub-agent
    appendSubAgentResponse(subAgentId, text) {
        const subAgentEl = this._subAgents.get(subAgentId);
        if (!subAgentEl) return;

        const responseEl = subAgentEl.querySelector(".subagent-response");
        if (responseEl) {
            responseEl.textContent += text;
        }
    }

    // Set response text for a sub-agent
    setSubAgentResponse(subAgentId, text) {
        const subAgentEl = this._subAgents.get(subAgentId);
        if (!subAgentEl) return;

        const responseEl = subAgentEl.querySelector(".subagent-response");
        if (responseEl) {
            responseEl.textContent = text;
        }
    }

    // Mark a sub-agent as completed
    markSubAgentCompleted(subAgentId) {
        const subAgentEl = this._subAgents.get(subAgentId);
        if (!subAgentEl) return;

        // Hide spinner
        const spinner = subAgentEl.querySelector(".subagent-spinner");
        if (spinner) {
            spinner.classList.add("hidden");
        }

        // Mark all tools as completed
        const toolItems = subAgentEl.querySelectorAll(".tool-item");
        toolItems.forEach(item => item.classList.add("completed"));
    }

    // Mark timeline as complete (hide main spinner and collapse)
    markComplete() {
        this._isComplete = true;
        const spinner = this.shadowRoot.querySelector(".timeline-spinner");
        if (spinner) {
            spinner.classList.add("hidden");
        }
        // Mark all main tools as completed
        this.markToolsCompleted();
        this._updateCount();

        // Collapse the timeline when complete
        this.setAttribute("collapsed", "");
    }

    // Update the tool count display
    _updateCount() {
        const countEl = this.shadowRoot.querySelector(".timeline-count");
        if (countEl) {
            const label = this._toolCount === 1 ? "tool" : "tools";
            if (this._isComplete) {
                countEl.textContent = `— Ran ${this._toolCount} ${label}`;
            } else {
                countEl.textContent = `— Running ${this._toolCount} ${label}...`;
            }
        }
    }

    // Clear all state
    clear() {
        this._toolCount = 0;
        this._isComplete = false;
        this._subAgents.clear();
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (container) {
            container.innerHTML = "";
        }
        const spinner = this.shadowRoot.querySelector(".timeline-spinner");
        if (spinner) {
            spinner.classList.remove("hidden");
        }
        this.hide();
    }

    // Add approval request item to the timeline
    addApprovalRequest(data, callback) {
        this.show(); // Ensure timeline is visible
        this.removeAttribute("collapsed"); // Ensure timeline is expanded so user sees the request
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (!container) return;

        const approvalItem = document.createElement("div");
        approvalItem.className = "approval-item tool-approval";
        const isTableToolApproval = data.ToolName === "TableEdit" || data.ToolName === "TableAdd";
        const isWebGetApproval = data.ToolName === "WebGet";
        // EC-33036: an administrator pinned this action to always ask, so the session/always waivers are not offered
        const adminApprovalRequired = data.AdminApprovalRequired === true;
        const isTableScopedApproval = isTableToolApproval && !EC_Fmt.isNull(data.ApprovalTableName);
        // Only "Approve once" when the administrator pinned the tool, or when a table tool has no table to save the approval against
        const approveOnceOnly = adminApprovalRequired || (isTableToolApproval && !isTableScopedApproval);
        const sessionApprovalSubtitle = isTableScopedApproval
            ? `Allows ${data.ApprovalTableName} for this tool for the rest of this session.`
            : "Automatically allows tools usage for this session.";
        const namedToolApproval = !isTableScopedApproval && !EC_Fmt.isNull(data.ToolName) ? formatToolApprovalName(data.ToolName) : "";
        let alwaysApprovalSubtitle = "Always allows the agent to use tools without asking.";
        if (isTableScopedApproval) {
            alwaysApprovalSubtitle = `Adds ${data.ApprovalTableName} to your saved approvals for this tool.`;
        } else if (!EC_Fmt.isNull(namedToolApproval)) {
            alwaysApprovalSubtitle = `Adds ${namedToolApproval} to your saved approvals.`;
        }

        // Generate content
        let contentHtml;
        // EC-31437: render the field table for any table tool that supplied comparison data.
        // TableEdit/TableChangeRequest show a before/after diff; TableAdd/TableAddRequest show a
        // compact preview of the key values about to be added.
        const hasTableComparison = data.TableEditData && data.TableEditData.Changes && data.TableEditData.Changes.length > 0;
        if (hasTableComparison) {
            // Check if renderTableEditComparison is available globally
            if (typeof renderTableEditComparison === "function") {
                contentHtml = renderTableEditComparison(data.TableEditData);
            } else {
                contentHtml = "<div>Details not available</div>";
            }
        } else if (isWebGetApproval) {
            contentHtml = `
<div>${data.UserApprovalMessage || "Approval Required"}</div>
<div style="margin-top:8px">
 <label for=WebGetPatternInput style="display:block;margin-bottom:4px;font-size:var(--bodysm-font-size);color:var(--text-secondary)">Allowed URL pattern (use * as a wildcard):</label>
 <ecp-input id=WebGetPatternInput value="${ToolsTimeline._escapeHtml(data.ProposedURLPattern || "")}" style="width:100%"></ecp-input>
</div>`;
        } else {
            contentHtml = `<div>${data.UserApprovalMessage || "Approval Required"}</div>`;
        }
        if (adminApprovalRequired) {
            contentHtml += `<div class=approval-admin-note style="margin-top:8px;font-size:var(--bodysm-font-size);color:var(--text-secondary)">An administrator requires approval for this action every time.</div>`;
        }

        approvalItem.innerHTML = `
<div class=approval-header style="display:flex;align-items:center;gap:8px;margin-bottom:8px;font-weight:600;font-size:var(--bodysm-font-size);color:var(--text-secondary)">
 <span class=ews-icon-help style="color:var(--primary-80)"></span>
 <span>${data.UserApprovalTitle || "Approval Required"}</span>
</div>
<div class=approval-content>${contentHtml}</div>
<div class=approval-actions>
 <ecp-btn id=CancelBtn type=ghost size=small>Cancel</ecp-btn>
 <ecp-btn-group>
    <ecp-btn id=ApproveBtn type=primary size=small>${isWebGetApproval ? "Save" : "Approve"}</ecp-btn>
  <ecp-btn id=ApproveDropDownBtn type=primary icon=ews-icon-caretdown size=small></ecp-btn>
 </ecp-btn-group>
 <ecp-menu id=ApproveDropDownMenu>
  <ecp-list type=clickable>
   <ecp-list-item approve-option=0>
    <ecp-list-item-content>
     <ecp-list-item-title><b> Approve once </b></ecp-list-item-title>
     <ecp-list-item-subtitle> Allows the agent to use tools only for this request. </ecp-list-item-subtitle>
    </ecp-list-item-content>
   </ecp-list-item>
   <ecp-list-item approve-option=1>
    <ecp-list-item-content>
     <ecp-list-item-title><b> Approve for this session </b></ecp-list-item-title>
         <ecp-list-item-subtitle> ${sessionApprovalSubtitle} </ecp-list-item-subtitle>
    </ecp-list-item-content>
   </ecp-list-item>
   <ecp-list-item approve-option=2>
    <ecp-list-item-content>
     <ecp-list-item-title><b> Approve always </b></ecp-list-item-title>
         <ecp-list-item-subtitle> ${alwaysApprovalSubtitle} </ecp-list-item-subtitle>
    </ecp-list-item-content>
   </ecp-list-item>
  </ecp-list>
 </ecp-menu>
</div>
<div class="approval-status hidden"></div>
        `;

        container.appendChild(approvalItem);

        // Bind events
        const approveBtn = approvalItem.querySelector("#ApproveBtn");
        const cancelBtn = approvalItem.querySelector("#CancelBtn");
        const dropDownBtn = approvalItem.querySelector("#ApproveDropDownBtn");
        const dropDownMenu = approvalItem.querySelector("#ApproveDropDownMenu");
        const actionsDiv = approvalItem.querySelector(".approval-actions");
        const statusDiv = approvalItem.querySelector(".approval-status");
        const dropDownOptions = approvalItem.querySelectorAll("[approve-option]");

        dropDownOptions.forEach((item) => {
            const approveOption = item.getAttribute("approve-option");
            if (isWebGetApproval || (approveOnceOnly && approveOption !== "0") || !isApproveOptionAllowed(approveOption)) {
                item.remove();
            }
        });

        applyApproveButtonOption(approveBtn, "0");

        const hasAlternateApprovalOption = approvalItem.querySelector('[approve-option="1"], [approve-option="2"]');
        if (!hasAlternateApprovalOption) {
            dropDownBtn.style.display = "none";
        }

        const handleResponse = async (approved) => {
            // Update UI
            actionsDiv.classList.add("hidden");
            statusDiv.classList.remove("hidden");

            let patternValue = null;
            if (isWebGetApproval) {
                const patternInput = approvalItem.querySelector("#WebGetPatternInput");
                patternValue = patternInput ? patternInput.value : null;
            }

            if (approved) {
                statusDiv.innerHTML = `<span class=ews-icon-check></span> ${isWebGetApproval ? "Saved" : "Approved"}`;
                statusDiv.className = "approval-status approved";

                // Handle approve option
                const approveOption = approveBtn.getAttribute("approve-option");
                if (approveOption && approveOption !== "0") {
                    try {
                        if (isTableScopedApproval && typeof setAgentTableToolApproveType === "function") {
                            await setAgentTableToolApproveType(data.ToolName, data.ApprovalTableName, approveOption);
                        } else if (typeof setAgentUserApproveType === "function") {
                            await setAgentUserApproveType(approveOption, approveOption === "2" ? data.ToolName : "");
                        }
                    } catch (error) {
                        ECP.HTML.Snackbar("Failed to save approval preference", "Error");
                    }
                }
            } else {
                statusDiv.innerHTML = `<span class=ews-icon-error></span> Cancelled`;
                statusDiv.className = "approval-status cancelled";
            }

            // Call callback
            if (callback) callback(approved, patternValue);
        };

        approveBtn.addEventListener("click", () => handleResponse(true));
        cancelBtn.addEventListener("click", () => handleResponse(false));

        if (dropDownBtn) {
            dropDownBtn.addEventListener("click", () => dropDownMenu.ShowMenu(dropDownBtn));
            dropDownMenu.addEventListener("click", (e) => {
                const item = e.target.closest("[approve-option]");
                if (item) {
                    const approveOption = item.getAttribute("approve-option");
                    if (approveOption && isApproveOptionAllowed(approveOption)) {
                        applyApproveButtonOption(approveBtn, approveOption);
                    }
                    dropDownMenu.CloseMenu();
                }
            });
        }
    }

    addPlanApprovalRequest(callback) {
        this.show(); // Ensure timeline is visible
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (!container) return;

        const header = this.shadowRoot.querySelector(".timeline-header");
        header.style.display = "none";

        const approvalItem = document.createElement("div");
        approvalItem.className = "approval-item plan-approval";
        approvalItem.innerHTML = `
<div class=approval-header style="display:flex;align-items:center;gap:8px;margin-bottom:8px;font-weight:600;font-size:var(--bodysm-font-size);color:var(--text-secondary)">
 <span class=ews-icon-help style="color:var(--primary-80)"></span>
 <span>Confirm Plan Execution</span>
</div>
<div class=approval-content>
 Planning complete.<br>
 Review the proposed plan above &mdash; you can edit the text directly before executing.
</div>
<div class=approval-actions>
 <ecp-btn id=CancelBtn type=ghost size=small>Cancel</ecp-btn>
 <ecp-btn id=ExecuteBtn type=primary size=small>Execute Plan</ecp-btn>
</div>
        `;

        container.appendChild(approvalItem);

        // Bind events
        const executeBtn = approvalItem.querySelector("#ExecuteBtn");
        const cancelBtn = approvalItem.querySelector("#CancelBtn");

        const handleResponse = async (approved) => {
            this.hide();
            // Call callback
            if (callback) callback(approved);
        };

        executeBtn.addEventListener("click", () => handleResponse(true));
        cancelBtn.addEventListener("click", () => handleResponse(false));

        this.removeAttribute("collapsed"); // Ensure timeline is expanded so user sees the request
    }

    // EC-32435: shared by the plan prompt and by an abandoned tool approval. onlyToolApprovals keeps
    // the plan box, which the "Execute the plan" path deliberately leaves standing.
    dismissApprovalRequests(onlyToolApprovals = false) {
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (!container) return;

        container.querySelectorAll(onlyToolApprovals ? ".approval-item.tool-approval" : ".approval-item").forEach(item => item.remove());

        // The plan box hides the header while it is up, so only restore it once that box is gone
        const header = this.shadowRoot.querySelector(".timeline-header");
        if (header && !container.querySelector(".approval-item.plan-approval")) {
            header.style.display = "";
        }

        const hasRemainingItems = container.querySelector(".tool-item, .subagent-item, .approval-item");
        if (!hasRemainingItems) {
            this.hide();
        }
    }

    addClarificationRequest(data, callback) {
        this.show();
        this.removeAttribute("collapsed");
        const container = this.shadowRoot.querySelector(".timeline-items");
        if (!container) return;

        const header = this.shadowRoot.querySelector(".timeline-header");
        if (header) header.style.display = "none";

        const options = data.Options || [];
        const question = data.Question || "Clarification needed";
        const escHtml = ToolsTimeline._escapeHtml;

        const optionsHtml = options.map(opt => `
<button class=clarification-option data-value="${escHtml(opt.Label || opt.Text)}">
 <span class=clarification-option-label>${escHtml(opt.Label)}</span>
 <span class=clarification-option-text>${escHtml(opt.Text)}</span>
</button>
        `).join("");

        const clarificationItem = document.createElement("div");
        clarificationItem.className = "clarification-item";
        clarificationItem.innerHTML = `
<div class=approval-header style="display:flex;align-items:center;gap:8px;margin-bottom:8px;font-weight:600;font-size:var(--bodysm-font-size);color:var(--text-secondary)">
 <span class=ews-icon-help style="color:var(--primary-80)"></span>
 <span>Clarification Needed</span>
</div>
<div class=clarification-question>${escHtml(question)}</div>
<div class=clarification-options>${optionsHtml}</div>
<div class=clarification-other>
 <div class=clarification-other-label>Other (type your own answer)</div>
 <textarea class=clarification-other-textarea placeholder="Enter a custom response..."rows=2></textarea>
</div>
<div class=clarification-actions>
 <ecp-btn id=ClarificationSubmitBtn type=primary size=small disabled>Submit</ecp-btn>
</div>
        `;

        container.appendChild(clarificationItem);

        const optionBtns = clarificationItem.querySelectorAll(".clarification-option");
        const otherTextarea = clarificationItem.querySelector(".clarification-other-textarea");
        const submitBtn = clarificationItem.querySelector("#ClarificationSubmitBtn");

        let selectedValue = null;

        const updateSubmitState = () => {
            const otherVal = otherTextarea ? otherTextarea.value.trim() : "";
            const canSubmit = selectedValue !== null || otherVal.length > 0;
            if (canSubmit) {
                submitBtn.removeAttribute("disabled");
            } else {
                submitBtn.setAttribute("disabled", "true");
            }
        };

        optionBtns.forEach((btn) => {
            btn.addEventListener("click", () => {
                optionBtns.forEach(b => b.classList.remove("selected"));
                btn.classList.add("selected");
                selectedValue = btn.getAttribute("data-value");
                if (otherTextarea) otherTextarea.value = "";
                updateSubmitState();
            });
        });

        if (otherTextarea) {
            otherTextarea.addEventListener("input", () => {
                if (otherTextarea.value.trim().length > 0) {
                    optionBtns.forEach(b => b.classList.remove("selected"));
                    selectedValue = null;
                }
                updateSubmitState();
            });

            otherTextarea.addEventListener("keydown", (e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    if (!submitBtn.hasAttribute("disabled")) submitBtn.click();
                }
            });
        }

        submitBtn.addEventListener("click", () => {
            const otherVal = otherTextarea ? otherTextarea.value.trim() : "";
            const answer = otherVal.length > 0 ? otherVal : selectedValue;
            if (!answer) return;

            // Fix 1: Collapse the clarification item to a compact summary line showing
            // just the question and the user's chosen answer.
            clarificationItem.style.padding = "8px 10px";
            clarificationItem.innerHTML = `
<div style="display:flex;align-items:center;gap:8px;font-size:var(--bodysm-font-size)">
 <span class=ews-icon-check style="color:var(--green-70);flex-shrink:0;font-size:12px"></span>
 <span style="color:var(--text-secondary);flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"title="${escHtml(question)}">${escHtml(question)}</span>
 <span style="color:var(--text-secondary);flex-shrink:0;margin:0 4px">→</span>
 <span style="font-weight:var(--semibold-weight);color:var(--text);flex-shrink:0;max-width:45%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"title="${escHtml(answer)}">${escHtml(answer)}</span>
</div>
            `;

            // Fix 2: Restore the timeline header so the second SSE pass (after clarification)
            // can add new tool calls to a properly collapsible timeline section.
            if (header) header.style.display = "";

            if (callback) callback(answer);
        });
    }
}

ECP.Component.define(ToolsTimeline, ToolsTimelineDefinition);

class ConversationTabManager {
    static get MaxTitleLength() {
        return 255;
    }

    static getTempTab() {
        return AI_DOM.chatGroup.querySelector("ecp-subtab-item:not([ConversationID])");
    }

    static getTab(conversationId) {
        return AI_DOM.chatGroup.querySelector(`ecp-subtab-item[ConversationID="${conversationId}"]`);
    }

    static createTemporaryTab(text, aiAgentId) {
        this.clearSelection();

        const tempTitle = this._generateTempTitle(text);
        const tempTabItem = this._createTabElement(aiAgentId, tempTitle, null, true);
        AI_DOM.chatGroup.prepend(tempTabItem);

        return tempTabItem;
    }

    static updateTabWithConversationInfo(conversationId, aiAgentId, conversationTitle) {
        const currentTab = this.getTempTab() || this.getTab(conversationId);

        if (currentTab) {
            this._applyConversationInfo(currentTab, aiAgentId, conversationId, conversationTitle);
        } else {
            const newTab = this._createTabElement(aiAgentId, conversationTitle, conversationId, true);
            AI_DOM.chatGroup.prepend(newTab);
        }
    }

    static clearSelection() {
        const selectedTab = AI_DOM.chatGroup.querySelector("ecp-subtab-item[selected]");
        if (selectedTab) {
            selectedTab.removeAttribute("selected");
        }
    }

    static _generateTempTitle(text) {
        const maxLength = 20;
        return text.substring(0, maxLength) + (text.length > maxLength ? "..." : "");
    }

    static _applyConversationInfo(tab, aiAgentId, conversationId, conversationTitle) {
        if (conversationId) {
            tab.setAttribute("ConversationID", conversationId);
        }

        if (aiAgentId) {
            tab.setAttribute("AIAgentID", aiAgentId);
        }

        this._setTabTitle(tab, conversationTitle, !EC_Fmt.isNull(conversationTitle));
    }

    static _setTabTitle(tab, conversationTitle, isInitialized) {
        const titleEl = tab.querySelector(".chat-title");
        if (!titleEl) {
            return;
        }

        const safeTitle = EC_Fmt.isNull(conversationTitle) ? "New conversation" : conversationTitle;
        titleEl.textContent = safeTitle;
        titleEl.title = safeTitle;
        tab.setAttribute("title", safeTitle);

        if (isInitialized) {
            tab.dataset.titleReady = "true";
        } else {
            delete tab.dataset.titleReady;
        }

        this._toggleEditIcon(tab, false);
    }

    static _toggleEditIcon(tab, shouldShow) {
        const editIcon = tab.querySelector(".chat-title-edit");
        if (!editIcon) {
            return;
        }

        const canEdit = tab.dataset.titleReady === "true"
            && tab.dataset.editingTitle !== "true"
            && tab.dataset.savingTitle !== "true";
        editIcon.style.visibility = shouldShow && canEdit ? "visible" : "hidden";
    }

    static _cancelTitleEdit(tab) {
        if (tab.dataset.editingTitle !== "true") {
            return;
        }

        const titleEl = tab.querySelector(".chat-title");
        const inputEl = tab.querySelector(".chat-title-input");
        const originalTitle = tab.dataset.originalTitle || titleEl.textContent;

        titleEl.textContent = originalTitle;
        titleEl.style.display = "block";
        inputEl.value = originalTitle;
        inputEl.style.display = "none";
        inputEl.disabled = false;

        delete tab.dataset.editingTitle;
        delete tab.dataset.finishingTitle;
        delete tab.dataset.originalTitle;

        this._toggleEditIcon(tab, false);
    }

    static async _finishTitleEdit(tab, shouldSave) {
        if (tab.dataset.editingTitle !== "true" || tab.dataset.finishingTitle === "true") {
            return;
        }

        tab.dataset.finishingTitle = "true";

        const titleEl = tab.querySelector(".chat-title");
        const inputEl = tab.querySelector(".chat-title-input");
        const originalTitle = tab.dataset.originalTitle || titleEl.textContent;
        const updatedTitle = inputEl.value.trim();

        if (!shouldSave) {
            this._cancelTitleEdit(tab);
            return;
        }

        if (updatedTitle === originalTitle) {
            this._cancelTitleEdit(tab);
            return;
        }

        if (EC_Fmt.isNull(updatedTitle)) {
            this._cancelTitleEdit(tab);
            ECP.Dialog.Alert("Conversation title cannot be empty.");
            return;
        }

        tab.dataset.savingTitle = "true";
        inputEl.disabled = true;

        try {
            const savedTitle = await RenameConversationTitle(
                tab.getAttribute("ConversationID"),
                tab.getAttribute("AIAgentID"),
                updatedTitle
            );

            this._setTabTitle(tab, savedTitle, true);
        } catch (error) {
            this._setTabTitle(tab, originalTitle, true);
            ECP.Dialog.Alert(error.message || "Unable to rename conversation.");
        } finally {
            titleEl.style.display = "block";
            inputEl.style.display = "none";
            inputEl.disabled = false;

            delete tab.dataset.editingTitle;
            delete tab.dataset.finishingTitle;
            delete tab.dataset.originalTitle;
            delete tab.dataset.savingTitle;

            this._toggleEditIcon(tab, false);
        }
    }

    static _startTitleEdit(tab) {
        if (tab.dataset.titleReady !== "true" || tab.dataset.editingTitle === "true" || tab.dataset.savingTitle === "true") {
            return;
        }

        const titleEl = tab.querySelector(".chat-title");
        const inputEl = tab.querySelector(".chat-title-input");

        if (!titleEl || !inputEl) {
            return;
        }

        tab.dataset.editingTitle = "true";
        tab.dataset.originalTitle = titleEl.textContent;

        inputEl.value = titleEl.textContent;
        titleEl.style.display = "none";
        inputEl.style.display = "block";

        this._toggleEditIcon(tab, false);

        requestAnimationFrame(() => {
            inputEl.focus();
            inputEl.select();
        });
    }

    static _createTabElement(aiAgentId, title, conversationId = null, selected = false) {
        const chatEle = document.createElement("ecp-subtab-item");
        chatEle.classList.add("chatGroup");

        if (aiAgentId) {
            chatEle.setAttribute("AIAgentID", aiAgentId);
        }
        if (conversationId) {
            chatEle.setAttribute("ConversationID", conversationId);
        }
        if (selected) {
            chatEle.setAttribute("selected", "");
        }

        const contentWrap = document.createElement("span");
        contentWrap.className = "chat-title-wrap";

        const titleEl = document.createElement("span");
        titleEl.className = "chat-title";

        const inputEl = document.createElement("input");
        inputEl.className = "chat-title-input";
        inputEl.type = "text";
        inputEl.maxLength = this.MaxTitleLength;

        const editIcon = document.createElement("span");
        editIcon.className = "chat-title-edit ews-icon-edit";
        editIcon.style.visibility = "hidden";

        contentWrap.appendChild(titleEl);
        contentWrap.appendChild(inputEl);
        contentWrap.appendChild(editIcon);
        chatEle.appendChild(contentWrap);

        this._setTabTitle(chatEle, title, !EC_Fmt.isNull(title));

        chatEle.addEventListener("mouseenter", () => {
            this._toggleEditIcon(chatEle, true);
        });
        chatEle.addEventListener("mouseleave", () => {
            this._toggleEditIcon(chatEle, false);
        });

        editIcon.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            this._startTitleEdit(chatEle);
        });

        inputEl.addEventListener("click", (event) => {
            event.stopPropagation();
        });
        inputEl.addEventListener("keydown", async (event) => {
            if (event.key === "Enter") {
                event.preventDefault();
                event.stopPropagation();
                await this._finishTitleEdit(chatEle, true);
            } else if (event.key === "Escape") {
                event.preventDefault();
                event.stopPropagation();
                this._cancelTitleEdit(chatEle);
            }
        });
        inputEl.addEventListener("blur", async () => {
            await this._finishTitleEdit(chatEle, true);
        });

        chatEle.addEventListener("click", HandleChatGroupClick);
        return chatEle;
    }
}

class ChatPanel {
    constructor(conversationId, options = {}) {
        this.id = conversationId;
        this.options = options;
        this.element = this.getOrCreatePanel();
    }

    getOrCreatePanel() {
        const isTemporary = EC_Fmt.isNull(this.id);
        const hostElement = this.options.hostElement || AI_DOM.pageContainer;

        if (!hostElement) {
            return null;
        }

        let panel;

        if (!isTemporary) {
            panel = hostElement.querySelector(`ecp-chatpanel[ConversationID="${this.id}"]`) || document.querySelector(`ecp-chatpanel[ConversationID="${this.id}"]`);
        } else if (!EC_Fmt.isNull(this.options.temporaryKey)) {
            panel = hostElement.querySelector(`ecp-chatpanel[data-temporary-key="${this.options.temporaryKey}"]`);
        } else {
            panel = hostElement.querySelector("ecp-chatpanel[temporary]:not([data-temporary-key])");
        }

        if (!panel) {
            panel = document.createElement("ecp-chatpanel");
            panel.classList.add("chat-panel");
            if (!isTemporary) {
                panel.setAttribute("ConversationID", this.id);
            } else {
                panel.setAttribute("temporary", "");
                if (!EC_Fmt.isNull(this.options.temporaryKey)) {
                    panel.setAttribute("data-temporary-key", this.options.temporaryKey);
                }
            }
            if (this.options.isReliabilityPanel) {
                panel.setAttribute("data-reliability-panel", "true");
            }
            hostElement.prepend(panel);
        } else if (panel.parentNode !== hostElement) {
            hostElement.prepend(panel);
        }

        if (this.options.isReliabilityPanel) {
            panel.setAttribute("data-reliability-panel", "true");
        }

        return panel;
    }

    show() {
        if (!this.element) {
            return;
        }

        if (this.options.hideOthers !== false) {
            ChatPanel.hideAllPanels();
        }

        if (AI_DOM.pageContainer && !AI_DOM.pageContainer.contains(this.element) && !this.options.hostElement) {
            AI_DOM.pageContainer.insertBefore(this.element, AI_DOM.pageContainer.firstChild);
        }

        this.element.style.display = "block";
    }

    addMessage(role, content, timestamp = null) {
        return this.element.addMessage(role, content, timestamp);
    }

    scrollToBottom() {
        if (this.element._scrollToBottom) this.element._scrollToBottom();
    }

    forceScrollToBottom() {
        if (this.element._scrollToBottom) this.element._scrollToBottom(true);
    }

    clear() {
        // Messages are slotted content (light DOM children of the host element),
        // not inside the shadow DOM, so we need to clear the element's children directly
        this.element.innerHTML = "";
    }

    remove() {
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
        }
    }

    isNewConversation() {
        return !!this.element && this.element.hasAttribute("temporary");
    }

    static hideAllPanels(root = document) {
        const panels = root.querySelectorAll("ecp-chatpanel");
        for (let i = 0; i < panels.length; i++) {
            panels[i].style.display = "none";
        }
    }

    static getCurrentPanel() {
        const visiblePanel = Array.from(document.querySelectorAll("ecp-chatpanel"))
            .find(panel => panel.style.display !== "none" && panel.getAttribute("data-reliability-panel") !== "true");

        if (visiblePanel) {
            const conversationId = visiblePanel.getAttribute("ConversationID");
            return new ChatPanel(conversationId);
        }
        return null;
    }

    static removePanelById(conversationId) {
        const panel = document.querySelector(`ecp-chatpanel[ConversationID="${conversationId}"]`);
        if (panel) {
            panel.remove();
        }
    }
}

// Active request state management for cancellation
const activeAIRequestState = {
    isProcessing: false,
    isReliabilityMode: false,
    isAggregateResultOpen: false,
    abortController: null, // For fetch requests
    thinkingMsg: null, // Current thinking message element
    chatPanel: null, // Current chat panel
    reliabilityRuns: [], // Active reliability run states
    conversationID: null, // EC-25393: known from run_started, so interjections can be queued mid-run
    queuedInterjections: [], // EC-25393: [{ sequence, text, messageEl, delivered }] for the running turn
    deliveredInterjectionSequences: new Set() // EC-25393: slots the agent reported picking up
};

let activePlanApprovalMessage = null;

// EC-32435: live tool-approval prompts, so a new turn can dismiss them and resolve the promise
// handleMultipleApprovalRequests is parked on instead of leaking that async frame forever.
const pendingToolApprovals = new Set();

const AI_AGENT_STREAM_REQUEST_TIMEOUT_MS = 15 * 60 * 1000;

const AI_DOM = {
    get chatInput() {
        return document.getElementById("chatInput");
    },
    get sendBtn() {
        return document.getElementById("sendBtn");
    },
    get stopBtn() {
        return document.getElementById("stopBtn");
    },
    get tokenUsageWrapper() {
        return document.getElementById("tokenUsageWrapper");
    },
    get tokenUsageProgressBar() {
        return document.getElementById("tokenUsageProgressBar");
    },
    get tokenUsageProgressItem() {
        return document.getElementById("tokenUsageProgressItem");
    },
    get individualTokenUsageWrapper() {
        return document.getElementById("individualTokenUsageWrapper");
    },
    get individualTokenUsageProgressBar() {
        return document.getElementById("individualTokenUsageProgressBar");
    },
    get individualTokenUsageProgressItem() {
        return document.getElementById("individualTokenUsageProgressItem");
    },
    get voiceInputBtn() {
        return document.getElementById("voiceInputBtn");
    },
    get inputActionsBtn() {
        return document.getElementById("inputActionsBtn");
    },
    get inputActionsMenu() {
        return document.getElementById("inputActionsMenu");
    },
    get fileInputHidden() {
        return document.getElementById("fileInputHidden");
    },
    get fileStagingArea() {
        return document.getElementById("fileStagingArea");
    },
    get chatDropOverlay() {
        return document.getElementById("chatDropOverlay");
    },
    get skillCommandMenu() {
        return document.getElementById("skillCommandMenu");
    },
    get activeSkillBar() {
        return document.getElementById("activeSkillBar");
    },
    get searchBoxWrapper() {
        return document.querySelector(".search-box-wrapper");
    },
    get pageContainer() {
        return this._pageContainer || document.querySelector(".chat-his");
    },
    get sidebarHistoryTabs() {
        return document.getElementById("sidebarHistoryTabs");
    },
    get chatHistoryPane() {
        return document.getElementById("chatHistoryPane");
    },
    get scheduledPromptHistoryPane() {
        return document.getElementById("scheduledPromptHistoryPane");
    },
    get normalChatPane() {
        return document.getElementById("normalChatPane");
    },
    get chatGroup() {
        return this._chatGroup || document.getElementById("chatGroup");
    },
    get scheduledPromptsGroup() {
        return document.getElementById("scheduledPromptsGroup");
    },
    get newChatBtn() {
        return this._newChatBtn || document.getElementById("newChat");
    },
    get planFirstCheckbox() {
        return document.getElementById("planFirst");
    },
    get includePageContextCheckbox() {
        return document.getElementById("includePageContext");
    },
    get tabNotificationsCheckbox() {
        return document.getElementById("tabNotifications");
    },
    get matchMyVoiceCheckbox() {
        return document.getElementById("matchMyVoice");
    },
    get matchMyVoiceProfileState() {
        return document.getElementById("matchMyVoiceProfileState");
    },
    get permissionsList() {
        return this._permissionsList || document.getElementById("permissionsList");
    },
    get manageScheduledPromptsBtn() {
        return document.getElementById("manageScheduledPromptsBtn");
    },
    get scheduledPromptEmailPref() {
        return document.getElementById("scheduledPromptEmailPref");
    },
    get scheduledPromptEChatPref() {
        return document.getElementById("scheduledPromptEChatPref");
    },
    // Settings dialog elements
    get settingsBtn() {
        return document.getElementById("settingsBtn");
    },
    get mobileSettingsBtn() {
        return document.getElementById("mobileSettingsBtn");
    },
    get settingsDialogContainer() {
        return document.getElementById("settingsDialogContainer");
    },
    get closeSettingsBtn() {
        return document.getElementById("closeSettingsBtn");
    },
    get cancelSettingsBtn() {
        return document.getElementById("cancelSettingsBtn");
    },
    get saveSettingsBtn() {
        return document.getElementById("saveSettingsBtn");
    },
    get settingsTabs() {
        return document.getElementById("settingsTabs");
    },
    get generalTabContent() {
        return document.getElementById("generalTabContent");
    },
    get permissionsTabContent() {
        return document.getElementById("permissionsTabContent");
    },
    get permissionsSearch() {
        return document.getElementById("permissionsSearch");
    },
    get permissionsTypeToggles() {
        return document.getElementById("permissionsTypeToggles");
    },
    get enableLoggingItem() {
        return document.getElementById("enableLogging");
    },
    get toolApprovalsTabContent() {
        return document.getElementById("toolApprovalsTabContent");
    },
    // Mobile sidebar elements
    get contentLeft() {
        return document.getElementById("contentLeft");
    },
    get sidebarOverlay() {
        return document.getElementById("sidebarOverlay");
    },
    get openSidebarBtn() {
        return document.getElementById("openSidebarBtn");
    },
    get closeSidebarBtn() {
        return document.getElementById("closeSidebarBtn");
    },
    get chatContent() {
        return document.querySelector(".chat-content");
    },
    get saveAsSkillItem() {
        return document.getElementById("saveAsSkillItem");
    },
    get planFirstToggleItem() {
        return document.getElementById("planFirstToggleItem");
    },
    get planFirstStateText() {
        return document.getElementById("planFirstStateText");
    },
    get runEvalsItem() {
        return document.getElementById("runEvalsItem");
    },
    get runEvalsTooltip() {
        return document.getElementById("runEvalsTooltip");
    },
    get googleSearchToggleItem() {
        return document.getElementById("googleSearchToggleItem");
    },
    get googleSearchStateText() {
        return document.getElementById("googleSearchStateText");
    },
    get mcpConnectorsItem() {
        return document.getElementById("mcpConnectorsItem");
    },
    get mcpConnectorsStateText() {
        return document.getElementById("mcpConnectorsStateText");
    },
    get promptPanel() {
        return document.getElementById("promptPanel");
    },
    get promptPanelList() {
        return document.getElementById("promptPanelList");
    },
    get promptPanelTitle() {
        return document.getElementById("promptPanelTitle");
    },
    get promptPanelAddBtn() {
        return document.getElementById("promptPanelAddBtn");
    },
    get promptPanelToggleBtn() {
        return document.getElementById("promptPanelToggleBtn");
    },
    get promptPanelToggleTooltip() {
        return document.getElementById("promptPanelToggleTooltip");
    }
};

// Fetch user permissions from the backend
// EC-31344: permissions now arrive with the panel bootstrap (and its session-stamped
// cache) instead of a dedicated call; this applies whichever payload we hold to the UI.
function applyUserPermissions(response) {
    if (response && response.Permissions) {
        AgentUserPermissions = response.Permissions.map(p => ({
            Code: p.Code,
            Description: p.Description,
            Type: p.Type,
            IsMandatory: p.IsMandatory || AgentMandatoryPermissions.includes(p.Code),
            IsSelected: true // All selected by default
        }));
        AgentCanOverrideEvalModel = response.CanOverrideEvalModel === true;

        // Update mandatory permissions list from backend if provided
        if (response.MandatoryPermissions) {
            AgentMandatoryPermissions = response.MandatoryPermissions;
        }

        RenderPermissionsList();
    }
}

// Render the permissions list UI
function RenderPermissionsList() {
    const permissionsListEl = AI_DOM.permissionsList;
    if (!permissionsListEl) return;

    permissionsListEl.innerHTML = "";

    // Add Select All / Unselect All checkbox
    const selectAllItem = document.createElement("ecp-list-item");
    selectAllItem.className = "permissions-select-all-item";

    const selectAllCheckbox = CreatePermissionCheckbox();
    selectAllCheckbox.id = "selectAllPermissions";
    selectAllCheckbox.setAttribute("label", "Select all");
    selectAllCheckbox.checked = AreAllNonMandatorySelected();

    selectAllCheckbox.addEventListener("change", () => {
        if (IsSyncingPermissionsSelectAll) {
            return;
        }
        ToggleAllPermissions(selectAllCheckbox.checked);
        RenderPermissionsList();
    });

    selectAllItem.appendChild(selectAllCheckbox);
    permissionsListEl.appendChild(selectAllItem);

    // Render individual permissions
    AgentUserPermissions.forEach((permission, index) => {
        const listItem = document.createElement("ecp-list-item");
        listItem.className = "permission-item";
        if (permission.IsMandatory) {
            listItem.classList.add("mandatory");
        }

        const checkbox = CreatePermissionCheckbox();
        checkbox.className = "permission-checkbox";
        checkbox.checked = permission.IsSelected;
        checkbox.disabled = permission.IsMandatory;
        checkbox.id = `permission-${index}`;
        checkbox.name = "agent-permissions";
        checkbox.index = index;
        checkbox.dataset.permissionCode = permission.Code;
        checkbox.setAttribute("aria-label", permission.Code);

        const label = document.createElement("div");
        label.className = "permission-label";
        label.style.cursor = permission.IsMandatory ? "not-allowed" : "pointer";

        const codeSpan = document.createElement("span");
        codeSpan.className = "permission-code";
        codeSpan.textContent = permission.Code;

        const descSpan = document.createElement("span");
        descSpan.className = "permission-description";
        descSpan.textContent = permission.Description;

        label.appendChild(codeSpan);
        label.appendChild(descSpan);

        listItem.appendChild(checkbox);
        listItem.appendChild(label);

        // Add lock icon for mandatory permissions
        if (permission.IsMandatory) {
            const lockIcon = document.createElement("i");
            lockIcon.className = "ews-icon-lock permission-lock-icon";
            listItem.appendChild(lockIcon);
        }

        // Add click handler to toggle checkbox (except for mandatory)
        if (!permission.IsMandatory) {
            checkbox.addEventListener("change", () => {
                permission.IsSelected = checkbox.checked;
                UpdateSelectAllCheckbox();
            });

            label.addEventListener("click", (e) => {
                e.preventDefault();
                checkbox.checked = !checkbox.checked;
                permission.IsSelected = checkbox.checked;
                UpdateSelectAllCheckbox();
            });
        }

        permissionsListEl.appendChild(listItem);
    });

    ApplyPermissionsFilter();
}

// EC-31094: ecp-checkbox reflects attributes during construction, so
// document.createElement("ecp-checkbox") throws "The result must not have attributes".
// Building it through the HTML parser sidesteps that strict check.
function CreatePermissionCheckbox() {
    const holder = document.createElement("div");
    holder.innerHTML = "<ecp-checkbox></ecp-checkbox>";
    return holder.firstElementChild;
}

// Get the selected permissions as a ^-delimited string
function GetSelectedPermissions() {
    return AgentUserPermissions
        .filter(p => p.IsSelected)
        .map(p => p.Code)
        .join("^");
}

// Check if all non-mandatory permissions are selected
function AreAllNonMandatorySelected() {
    const nonMandatoryPerms = AgentUserPermissions.filter(p => !p.IsMandatory);
    if (nonMandatoryPerms.length === 0) return true;
    return nonMandatoryPerms.every(p => p.IsSelected);
}

// Toggle all non-mandatory permissions
function ToggleAllPermissions(selectAll) {
    AgentUserPermissions.forEach((permission) => {
        if (!permission.IsMandatory) {
            permission.IsSelected = selectAll;
        }
    });
}

// Update the select all checkbox state based on individual permissions
function UpdateSelectAllCheckbox() {
    const selectAllCheckbox = document.getElementById("selectAllPermissions");
    if (selectAllCheckbox) {
        IsSyncingPermissionsSelectAll = true;
        selectAllCheckbox.checked = AreAllNonMandatorySelected();
        IsSyncingPermissionsSelectAll = false;
    }
}

// Show only the permissions matching the search text
function ApplyPermissionsFilter() {
    if (!AI_DOM.permissionsList) {
        return;
    }

    // ecp-input reports undefined for .value until the component initializes
    const searchLower = (AI_DOM.permissionsSearch?.value || "").toLowerCase();
    const permissionItems = AI_DOM.permissionsList.querySelectorAll(".permission-item");

    permissionItems.forEach((item) => {
        const permissionCode = item.querySelector(".permission-code");
        const code = permissionCode ? permissionCode.textContent.toLowerCase() : "";
        const permissionDescription = item.querySelector(".permission-description");
        const description = permissionDescription ? permissionDescription.textContent.toLowerCase() : "";

        item.style.display = code.includes(searchLower) || description.includes(searchLower) ? "" : "none";
    });

    // Select all toggles every permission, so hide it while the search narrows the list
    const selectAllItem = AI_DOM.permissionsList.querySelector(".permissions-select-all-item");
    if (selectAllItem) {
        selectAllItem.style.display = searchLower ? "none" : "";
    }
}

// EC-27291: Type toggle buttons check/uncheck every non-mandatory permission of that type
function SetPermissionsSelectedByType(permissionType, isSelected) {
    AgentUserPermissions.forEach((permission) => {
        if (!permission.IsMandatory && permission.Type === permissionType) {
            permission.IsSelected = isSelected;
        }
    });
}

function getSelectedAgentID() {
    const aiAgentInput = document.getElementById("aiagentInput");
    return EC_Fmt.Null2ZeroInt(aiAgentInput ? aiAgentInput.value : "");
}

function canRunAgentEvals() {
    return getSelectedAgentID() > 0;
}

function getScheduledPromptPreferenceStorageKey() {
    return `${Distributor}_${UserID}_aiagent_scheduled_prompt_notification_prefs`;
}

function loadScheduledPromptNotificationPreferences() {
    try {
        const raw = localStorage.getItem(getScheduledPromptPreferenceStorageKey());
        if (EC_Fmt.isNull(raw)) {
            return;
        }

        const parsed = JSON.parse(raw);
        ScheduledPromptsState.notificationPreferences.email = !(parsed && parsed.email === false);
        ScheduledPromptsState.notificationPreferences.eChat = !(parsed && parsed.eChat === false);
    } catch {
        ScheduledPromptsState.notificationPreferences.email = true;
        ScheduledPromptsState.notificationPreferences.eChat = true;
    }
}

function saveScheduledPromptNotificationPreferences() {
    try {
        localStorage.setItem(
            getScheduledPromptPreferenceStorageKey(),
            JSON.stringify(ScheduledPromptsState.notificationPreferences)
        );
    } catch {
        // Keep the preference state in memory if localStorage is unavailable.
    }
}

function syncScheduledPromptNotificationPreferencesUI() {
    const emailPref = AI_DOM.scheduledPromptEmailPref;
    const eChatPref = AI_DOM.scheduledPromptEChatPref;

    if (emailPref) {
        emailPref.checked = ScheduledPromptsState.notificationPreferences.email;
    }

    if (eChatPref) {
        eChatPref.checked = ScheduledPromptsState.notificationPreferences.eChat;
    }
}

function setSidebarHistoryTab(tabName) {
    ScheduledPromptsState.activeSidebarTab = tabName === "scheduled-prompts" ? "scheduled-prompts" : "chat-history";

    const chatHistoryPane = AI_DOM.chatHistoryPane;
    const scheduledPromptHistoryPane = AI_DOM.scheduledPromptHistoryPane;
    const sidebarChatHistoryTab = document.getElementById("sidebarChatHistoryTab");
    const sidebarScheduledPromptsTab = document.getElementById("sidebarScheduledPromptsTab");

    if (chatHistoryPane) {
        chatHistoryPane.classList.toggle("hidden", ScheduledPromptsState.activeSidebarTab !== "chat-history");
    }

    if (scheduledPromptHistoryPane) {
        scheduledPromptHistoryPane.classList.toggle("hidden", ScheduledPromptsState.activeSidebarTab !== "scheduled-prompts");
    }

    if (sidebarChatHistoryTab) {
        if (ScheduledPromptsState.activeSidebarTab === "chat-history") {
            sidebarChatHistoryTab.setAttribute("selected", "");
        } else {
            sidebarChatHistoryTab.removeAttribute("selected");
        }
    }

    if (sidebarScheduledPromptsTab) {
        if (ScheduledPromptsState.activeSidebarTab === "scheduled-prompts") {
            sidebarScheduledPromptsTab.setAttribute("selected", "");
        } else {
            sidebarScheduledPromptsTab.removeAttribute("selected");
        }
    }

    if (ScheduledPromptsState.activeSidebarTab === "scheduled-prompts") {
        loadScheduledPromptExecutions(true);
    }
}

function formatScheduledPromptTime(value) {
    if (EC_Fmt.isNull(value)) {
        return "";
    }

    const trimmed = String(value).trim();
    if (trimmed.length === 0) {
        return "";
    }

    const parsedDate = new Date(trimmed);
    if (!Number.isNaN(parsedDate.getTime())) {
        return EC_Fmt.ScreenFmt(parsedDate, ECP.DataType._DateTime);
    }

    return trimmed;
}

function formatScheduledPromptTimeOfDay(value) {
    if (EC_Fmt.isNull(value)) {
        return "";
    }

    const trimmed = String(value).trim();
    if (trimmed.length === 0) {
        return "";
    }

    if (trimmed.indexOf(":") >= 0) {
        const parts = trimmed.split(":");
        if (parts.length >= 2) {
            return `${String(parts[0] || "").trim().padStart(2, "0").slice(-2)}:${String(parts[1] || "").trim().padStart(2, "0").slice(-2)}`;
        }
    }

    return trimmed;
}

function formatScheduledPromptFrequency(prompt) {
    if (!prompt) {
        return "";
    }

    const frequency = EC_Fmt.Null2ZeroInt(prompt.Frequency);
    const timeOfDay = formatScheduledPromptTimeOfDay(prompt.TimeOfDay);

    if (frequency === 1) {
        return `Daily${timeOfDay ? ` @ ${timeOfDay}` : ""}`;
    }

    if (frequency === 2) {
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const dayIndex = EC_Fmt.Null2ZeroInt(prompt.DayOfWeek) - 1;
        const dayName = dayIndex >= 0 && dayIndex < dayNames.length ? dayNames[dayIndex] : "Weekly";
        return `${dayName}${timeOfDay ? ` @ ${timeOfDay}` : ""}`;
    }

    if (frequency === 3) {
        return `Monthly${prompt.DayOfMonth ? ` day ${prompt.DayOfMonth}` : ""}${timeOfDay ? ` @ ${timeOfDay}` : ""}`;
    }

    if (frequency === 4) {
        return "Every hour on the hour";
    }

    if (frequency === 5) {
        return "At :00, :15, :30 and :45";
    }

    return "Unknown";
}

// Hourly and every-15-minute prompts run on clock boundaries, so they have no time of day
function scheduledPromptFrequencyUsesTimeOfDay(frequency) {
    return frequency !== 4 && frequency !== 5;
}

function buildDayOfMonthSelect(id, value) {
    const selectedDay = EC_Fmt.Null2ZeroInt(value) > 0 ? EC_Fmt.Null2ZeroInt(value) : 1;
    let options = "";

    for (let day = 1; day <= 31; day++) {
        const selectedAttr = day === selectedDay ? " selected" : "";
        const dayLabel = day === 31 ? "Last day" : String(day);
        options += `<ecp-select-option value="${day}"${selectedAttr}>${dayLabel}</ecp-select-option>`;
    }

    return `<ecp-select id="${id}" style="width:100%">${options}</ecp-select>`;
}

function formatScheduledPromptExecutionStatus(execution) {
    if (!execution) {
        return "";
    }

    if (typeof execution.HasResponse === "boolean") {
        return execution.HasResponse ? "Completed" : "No response";
    }

    const responseText = typeof execution.Response === "string" ? execution.Response.trim() : "";
    return responseText.length > 0 ? "Completed" : "No response";
}

function isNoScheduledPromptExecutionsError(error) {
    const statusCode = Number(error && error.status ? error.status : error);
    if (!Number.isNaN(statusCode) && statusCode === 400) {
        return true;
    }

    const message = String(error && error.message ? error.message : error || "").toLowerCase();
    if (message.length === 0) {
        return false;
    }

    return message.includes("no scheduled prompt")
        || message.includes("no execution")
        || message.includes("no message")
        || message.includes("not found");
}

function getScheduledPromptHistoryTitle(execution) {
    const promptText = EC_Fmt.NullChk(execution && execution.PromptPreview, "").trim();
    if (!EC_Fmt.isNull(promptText)) {
        const maxLength = 42;
        return promptText.length > maxLength ? `${promptText.slice(0, maxLength)}...` : promptText;
    }

    return formatScheduledPromptTime(execution && execution.TimeCreated);
}

function getScheduledPromptHistorySubtitle(execution) {
    const timeText = formatScheduledPromptTime(execution && execution.TimeCreated);
    const agentName = EC_Fmt.NullChk(execution && execution.AgentName, "").trim();
    const statusText = formatScheduledPromptExecutionStatus(execution);
    if (!EC_Fmt.isNull(agentName) && !EC_Fmt.isNull(timeText)) {
        return `${agentName} • ${timeText}${EC_Fmt.isNull(statusText) ? "" : ` • ${statusText}`}`;
    }

    if (!EC_Fmt.isNull(agentName)) {
        return EC_Fmt.isNull(statusText) ? agentName : `${agentName} • ${statusText}`;
    }

    if (!EC_Fmt.isNull(timeText)) {
        return EC_Fmt.isNull(statusText) ? timeText : `${timeText} • ${statusText}`;
    }

    return "Scheduled prompt execution";
}

function createScheduledPromptHistoryItem(execution, index) {
    const item = document.createElement("ecp-subtab-item");
    item.classList.add("scheduled-prompts-history-item");
    item.setAttribute("ScheduledPromptExecutionIndex", String(index));

    const wrap = document.createElement("span");
    wrap.className = "scheduled-prompt-history-wrap";

    const title = document.createElement("span");
    title.className = "scheduled-prompt-history-title";
    title.textContent = getScheduledPromptHistoryTitle(execution);

    const subtitle = document.createElement("span");
    subtitle.className = "scheduled-prompt-history-subtitle";
    subtitle.textContent = getScheduledPromptHistorySubtitle(execution);

    wrap.appendChild(title);
    wrap.appendChild(subtitle);
    item.appendChild(wrap);

    return item;
}

function clearScheduledPromptsHistorySelection() {
    if (!AI_DOM.scheduledPromptsGroup) {
        return;
    }

    const selected = AI_DOM.scheduledPromptsGroup.querySelector("ecp-subtab-item[selected]");
    if (selected) {
        selected.removeAttribute("selected");
    }
}

async function showScheduledPromptExecutionHistory(execution) {
    if (!execution || EC_Fmt.isNull(execution.ConversationID)) {
        return;
    }

    const historyPanel = new ChatPanel("", { temporaryKey: "scheduled-prompts-history" });
    historyPanel.show();
    historyPanel.clear();
    await GetConversationHistory(execution.ConversationID, historyPanel);
}

async function renderScheduledPromptExecutions() {
    const group = AI_DOM.scheduledPromptsGroup;
    if (!group) {
        return;
    }

    group.innerHTML = "";

    const executions = Array.isArray(ScheduledPromptsState.executions) ? ScheduledPromptsState.executions : [];
    if (executions.length === 0) {
        ScheduledPromptsState.selectedExecutionIndex = -1;
        return;
    }

    for (let i = 0; i < executions.length; i++) {
        const item = createScheduledPromptHistoryItem(executions[i], i);
        if (i === ScheduledPromptsState.selectedExecutionIndex) {
            item.setAttribute("selected", "");
        }
        group.appendChild(item);
    }
}

async function HandleScheduledPromptsGroupClick(event) {
    const target = event.target.closest("ecp-subtab-item");
    if (!target) {
        return;
    }

    const index = EC_Fmt.Null2ZeroInt(target.getAttribute("ScheduledPromptExecutionIndex"));
    const executions = Array.isArray(ScheduledPromptsState.executions) ? ScheduledPromptsState.executions : [];
    if (index < 0 || index >= executions.length) {
        return;
    }

    ScheduledPromptsState.selectedExecutionIndex = index;
    clearScheduledPromptsHistorySelection();
    target.setAttribute("selected", "");
    ConversationTabManager.clearSelection();
    await showScheduledPromptExecutionHistory(executions[index]);
}

async function loadScheduledPromptExecutions(forceReload = false) {
    const scheduledHistoryLoadKey = -1;
    if (!forceReload && ScheduledPromptsState.loadedForAIAgentID === scheduledHistoryLoadKey) {
        await renderScheduledPromptExecutions();
        return;
    }

    ScheduledPromptsState.isLoading = true;
    await renderScheduledPromptExecutions();

    try {
        const req = new ECP.EC_Request("AIAgent_GetScheduledPromptExecutions");
        req.SetReturnType(ECP.EC_ReturnType.Json);

        const result = await req.Submit();

        if (!Array.isArray(result) && result && typeof result === "object") {
            const errorMessage = result.ErrorMessage || result.Error || "";
            if (!EC_Fmt.isNull(errorMessage)) {
                throw new Error(String(errorMessage));
            }

            if (result.success === false) {
                ScheduledPromptsState.executions = [];
                ScheduledPromptsState.selectedExecutionIndex = -1;
                ScheduledPromptsState.loadedForAIAgentID = scheduledHistoryLoadKey;
                return;
            }

            if (result.Status === "Error") {
                throw new Error("Unable to load scheduled prompt executions.");
            }
        }

        ScheduledPromptsState.executions = Array.isArray(result) ? result : [];
        if (ScheduledPromptsState.executions.length === 0) {
            ScheduledPromptsState.selectedExecutionIndex = -1;
        } else if (ScheduledPromptsState.selectedExecutionIndex < 0 || ScheduledPromptsState.selectedExecutionIndex >= ScheduledPromptsState.executions.length) {
            ScheduledPromptsState.selectedExecutionIndex = -1;
        }
        ScheduledPromptsState.loadedForAIAgentID = scheduledHistoryLoadKey;
    } catch (error) {
        ScheduledPromptsState.executions = [];
        ScheduledPromptsState.selectedExecutionIndex = -1;
        ScheduledPromptsState.loadedForAIAgentID = scheduledHistoryLoadKey;

        if (!isNoScheduledPromptExecutionsError(error)) {
            const errorMessage = String(error && error.message ? error.message : "").trim();
            ECP.HTML.Snackbar(errorMessage.length > 0 ? errorMessage : "Unable to load scheduled prompt executions.", "Warning");
        }
    } finally {
        ScheduledPromptsState.isLoading = false;
        ECP.Dialog.HideLoading();
        await renderScheduledPromptExecutions();

        if (ScheduledPromptsState.activeSidebarTab === "scheduled-prompts"
            && ScheduledPromptsState.selectedExecutionIndex >= 0
            && ScheduledPromptsState.selectedExecutionIndex < ScheduledPromptsState.executions.length) {
            await showScheduledPromptExecutionHistory(ScheduledPromptsState.executions[ScheduledPromptsState.selectedExecutionIndex]);
        }
    }
}

function syncEvalMenuState() {
    const runEvalsItem = AI_DOM.runEvalsItem;
    if (!runEvalsItem) {
        return;
    }

    const canRun = canRunAgentEvals();
    runEvalsItem.style.opacity = canRun ? "" : "0.5";
    runEvalsItem.style.pointerEvents = canRun ? "" : "auto";
    runEvalsItem.setAttribute("aria-disabled", canRun ? "false" : "true");

    const runEvalsTooltip = AI_DOM.runEvalsTooltip;
    if (runEvalsTooltip) {
        runEvalsTooltip.hidden = canRun;
        runEvalsTooltip.style.display = canRun ? "none" : "";
    }
}

function getReliabilityRootContainer() {
    return AgentUIContext.root || document.querySelector(".ai-agent");
}

function toggleReliabilityModeClasses(enabled) {
    const pageContainer = AI_DOM.pageContainer;
    if (pageContainer) {
        pageContainer.classList.toggle("agent-reliability-mode", enabled);
    }

    const rootContainer = getReliabilityRootContainer();
    if (rootContainer) {
        rootContainer.classList.toggle("agent-reliability-mode", enabled);
    }
}

function getCurrentReliabilityMode() {
    return !!reliabilityModeEnabled;
}

function setReliabilityModeEnabled(enabled) {
    const nextState = !!enabled;
    if (reliabilityModeEnabled === nextState) {
        return;
    }

    reliabilityModeEnabled = nextState;
    if (!reliabilityModeEnabled) {
        resetReliabilityUI();
    }
}

function getReliabilitySession() {
    return reliabilitySession;
}

function normalizeReliabilityPrompt(promptText) {
    return EC_Fmt.Null2EmptyStr(promptText).trim().replace(/\s+/g, " ");
}

function buildReliabilityRunState(runId, promptText) {
    return {
        runId,
        prompt: promptText,
        hasEdited: false,
        isUnique: false,
        isRunning: false,
        score: null,
        explanation: "",
        scoreSaveErrorMessage: "",
        evalResultReceived: false,
        hasError: false,
        done: false,
        completionHandled: false,
        containerId: `agentReliabilityRunPanel${runId}`,
        streamController: null,
        thinkingMsg: null,
        chatPanel: null,
        panelId: `agentReliabilityChatPanel${runId}`,
        promptEditorId: `agentReliabilityRunPrompt${runId}`,
        promptHintId: `agentReliabilityRunPromptHint${runId}`,
        statusId: `agentReliabilityRunStatus${runId}`,
        startedAtMs: null,
        chunkCompletedAtMs: null,
        durationMs: null,
        inputTokens: null,
        outputTokens: null,
        cachedTokens: null,
        errorMessage: "",
        userMessageElement: null
    };
}

function getReliabilityPageContainer() {
    return AI_DOM.pageContainer;
}

function getReliabilityMainInputElement() {
    return AI_DOM.chatInput;
}

function setReliabilityMainInputLocked(locked) {
    const input = getReliabilityMainInputElement();
    if (!input) {
        return;
    }

    input.disabled = !!locked;
    if (locked) {
        input.blur();
    }
}

function getReliabilityRunHintElement(runState) {
    if (!runState) {
        return null;
    }

    const pageContainer = getReliabilityPageContainer();
    return pageContainer ? pageContainer.querySelector(`#${runState.promptHintId}`) : null;
}

function getReliabilityRunStatusElement(runState) {
    if (!runState) {
        return null;
    }

    const pageContainer = getReliabilityPageContainer();
    return pageContainer ? pageContainer.querySelector(`#${runState.statusId}`) : null;
}

function getReliabilityRunCard(runState) {
    if (!runState) {
        return null;
    }

    const pageContainer = getReliabilityPageContainer();
    return pageContainer ? pageContainer.querySelector(`#${runState.containerId}`) : null;
}

function formatReliabilityDurationSeconds(durationMs) {
    if (!Number.isFinite(durationMs)) {
        return "Unavailable";
    }

    return `${EC_Fmt.ScreenFmt(Math.max(0, Number(durationMs)) / 1000, "Decimal", 2)}s`;
}

function isReliabilityRunEdited(runState, basePrompt) {
    return normalizeReliabilityPrompt(runState.prompt) !== normalizeReliabilityPrompt(basePrompt);
}

function doesReliabilityRunHavePlaceholders(runState) {
    return !!runState && hasPromptPlaceholders(runState.prompt || "");
}

function isReliabilityRunUnique(runState) {
    if (!reliabilitySession || !runState) {
        return false;
    }

    const normalizedPrompt = normalizeReliabilityPrompt(runState.prompt);
    if (EC_Fmt.isNull(normalizedPrompt)) {
        return false;
    }

    let matchCount = 0;
    for (let i = 0; i < reliabilitySession.runs.length; i++) {
        if (normalizeReliabilityPrompt(reliabilitySession.runs[i].prompt) === normalizedPrompt) {
            matchCount++;
        }
    }

    return matchCount === 1;
}

function isReliabilityRunReadyToSend(runState) {
    return !EC_Fmt.isNull(runState.prompt) && isReliabilityRunUnique(runState) && !doesReliabilityRunHavePlaceholders(runState);
}

function areReliabilityRunsReadyForSend() {
    if (!reliabilitySession) {
        return false;
    }

    return reliabilitySession.runs.every(runState => isReliabilityRunReadyToSend(runState));
}

function hideStandardChatPanels() {
    const pageContainer = getReliabilityPageContainer();
    if (!pageContainer) {
        return;
    }

    pageContainer.querySelectorAll("ecp-chatpanel:not([data-reliability-panel=\"true\"])").forEach((panel) => {
        panel.style.display = "none";
    });
}

function restoreStandardChatPanel(sourceConversationID = "", hadTemporarySourcePanel = false) {
    const pageContainer = getReliabilityPageContainer();
    if (!pageContainer) {
        return;
    }

    const standardPanels = Array.from(pageContainer.querySelectorAll("ecp-chatpanel:not([data-reliability-panel=\"true\"])"));
    if (standardPanels.length === 0) {
        return;
    }

    let panelToShow = null;

    if (!EC_Fmt.isNull(sourceConversationID)) {
        panelToShow = pageContainer.querySelector(`ecp-chatpanel[ConversationID="${sourceConversationID}"]`);
    }

    if (!panelToShow && hadTemporarySourcePanel) {
        panelToShow = pageContainer.querySelector("ecp-chatpanel[temporary]:not([data-reliability-panel=\"true\"])");
    }

    if (!panelToShow) {
        panelToShow = standardPanels[0];
    }

    standardPanels.forEach((panel) => {
        panel.style.display = panel === panelToShow ? "block" : "none";
    });
}

function renderReliabilityRunPanel(runState, runCard = null) {
    const targetCard = runCard || getReliabilityRunCard(runState);
    if (!targetCard) {
        return null;
    }

    const existingPanelHost = targetCard.querySelector(".agent-reliability-chat-host");
    if (existingPanelHost) {
        existingPanelHost.remove();
    }

    const panelWrap = document.createElement("div");
    panelWrap.className = "agent-reliability-chat-host";
    panelWrap.setAttribute("data-run-panel-id", runState.panelId);
    targetCard.appendChild(panelWrap);

    const chatPanel = new ChatPanel("", {
        temporaryKey: runState.panelId,
        hostElement: panelWrap,
        hideOthers: false,
        isReliabilityPanel: true
    });

    if (!chatPanel.element) {
        return null;
    }

    chatPanel.element.classList.add("agent-reliability-chat-panel");
    chatPanel.element.setAttribute("data-reliability-run-id", String(runState.runId));
    runState.chatPanel = chatPanel;
    return chatPanel;
}

function mountReliabilityRunsUI() {
    const pageContainer = getReliabilityPageContainer();
    if (!pageContainer || !reliabilitySession) {
        return;
    }

    const existingLayout = pageContainer.querySelector(".agent-reliability-layout");
    if (existingLayout) {
        existingLayout.remove();
    }

    hideStandardChatPanels();

    const layout = document.createElement("div");
    layout.className = "agent-reliability-layout";
    pageContainer.appendChild(layout);

    for (let i = 0; i < reliabilitySession.runs.length; i++) {
        const runState = reliabilitySession.runs[i];
        const runSection = document.createElement("section");
        runSection.className = "agent-reliability-run";
        runSection.id = runState.containerId;
        runSection.innerHTML = `
            <div class=agent-reliability-run-label>Run ${runState.runId + 1}</div>
            <textarea id="${runState.promptEditorId}" class="agent-reliability-run-prompt" rows="6"></textarea>
            <div id="${runState.promptHintId}" class="agent-reliability-run-hint">Edit this run before sending (small changes are fine).</div>
            <div id="${runState.statusId}" class="agent-reliability-run-status">Awaiting unique edits</div>
        `;
        layout.appendChild(runSection);

        // Run states arrive freshly built by buildReliabilityRunState() with prompt = basePrompt
        renderReliabilityRunPanel(runState, runSection);

        const promptEditor = runSection.querySelector(`#${runState.promptEditorId}`);
        if (promptEditor) {
            promptEditor.value = reliabilitySession.basePrompt;
            promptEditor.addEventListener("input", () => {
                runState.prompt = promptEditor.value;
                updateReliabilityRunPromptHints(runState);
                updateReliabilitySessionSendState();
            });
        }
    }

    toggleReliabilityModeClasses(true);
    for (let i = 0; i < reliabilitySession.runs.length; i++) {
        updateReliabilityRunPromptHints(reliabilitySession.runs[i]);
    }
    updateReliabilitySessionSendState();
}

function enterReliabilityModeForEval(evalObj, evalPrompt, evalModelOptions) {
    const aiAgentInput = document.getElementById("aiagentInput");
    let aiAgentID = "";
    if (evalModelOptions && evalModelOptions.aiAgentID) {
        aiAgentID = String(evalModelOptions.aiAgentID);
    } else if (aiAgentInput) {
        aiAgentID = aiAgentInput.value;
    }
    if (EC_Fmt.isNull(aiAgentID)) {
        ECP.HTML.Snackbar("Select an agent to run evaluations", "Warning");
        return;
    }

    const currentPanel = ChatPanel.getCurrentPanel();
    cancelActiveRequest();
    resetReliabilityUI();
    setReliabilityModeEnabled(true);

    reliabilitySession = {
        id: ++reliabilitySessionCounter,
        aiAgentID,
        evalObj,
        basePrompt: evalPrompt || "",
        aiAgentEvalID: evalModelOptions ? EC_Fmt.Null2ZeroInt(evalModelOptions.AIAgentEvalID) : 0,
        evalAIModelID: evalModelOptions ? EC_Fmt.Null2ZeroInt(evalModelOptions.EvalAIModelID) : 0,
        sourceConversationID: currentPanel && currentPanel.element ? currentPanel.element.getAttribute("ConversationID") || "" : "",
        hadTemporarySourcePanel: !!(currentPanel && currentPanel.element && currentPanel.element.hasAttribute("temporary")),
        hasSent: false,
        hasShownSaveWarning: false,
        runs: []
    };

    for (let i = 0; i < RELIABILITY_RUN_COUNT; i++) {
        reliabilitySession.runs.push(buildReliabilityRunState(i, evalPrompt || ""));
    }

    mountReliabilityRunsUI();
}

function updateReliabilityRunPromptHints(runState) {
    if (!runState || !reliabilitySession) {
        return;
    }

    const hasEdit = isReliabilityRunEdited(runState, reliabilitySession.basePrompt);
    const isUnique = isReliabilityRunUnique(runState);
    const normalizedPrompt = normalizeReliabilityPrompt(runState.prompt);
    const hasPlaceholders = doesReliabilityRunHavePlaceholders(runState);
    runState.hasEdited = hasEdit;
    runState.isUnique = isUnique;

    const hint = getReliabilityRunHintElement(runState);
    const status = getReliabilityRunStatusElement(runState);

    if (hint) {
        if (runState.isRunning || runState.done) {
            hint.textContent = "";
            hint.classList.add("hidden");
        } else if (EC_Fmt.isNull(normalizedPrompt)) {
            hint.textContent = "Each run needs a prompt before sending.";
            hint.classList.remove("hidden");
        } else if (hasPlaceholders) {
            hint.textContent = "Replace any [placeholders] before sending this run.";
            hint.classList.remove("hidden");
        } else if (!isUnique) {
            hint.textContent = hasEdit
                ? "Make this prompt different from the other runs."
                : "One run can keep the original prompt, but all 3 prompts must be slightly different from each other.";
            hint.classList.remove("hidden");
        } else if (!hasEdit) {
            hint.textContent = "Original prompt kept. Make sure the other runs stay unique.";
            hint.classList.remove("hidden");
        } else {
            hint.textContent = "";
            hint.classList.add("hidden");
        }
    }

    if (!status) {
        return;
    }

    if (runState.hasError) {
        status.textContent = runState.errorMessage || "Run failed.";
        status.className = "agent-reliability-run-status agent-reliability-run-error";
        return;
    }

    if (runState.isRunning) {
        status.textContent = "Running";
        status.className = "agent-reliability-run-status agent-reliability-run-running";
        return;
    }

    if (runState.done) {
        const scoreText = Number.isFinite(runState.score) ? `Run complete - Score ${EC_Fmt.ScreenFmt(runState.score, "Integer")}` : "Run complete";
        const durationText = Number.isFinite(runState.durationMs) ? ` - Time ${formatReliabilityDurationSeconds(runState.durationMs)}` : "";
        // Token fields are either null or an already-clamped integer (set by handleEvalResult)
        let tokenText = "";
        if (runState.inputTokens !== null || runState.outputTokens !== null || runState.cachedTokens !== null) {
            tokenText = ` - Tokens ${EC_Fmt.ScreenFmt(runState.inputTokens || 0, "Integer")}/${EC_Fmt.ScreenFmt(runState.outputTokens || 0, "Integer")}/${EC_Fmt.ScreenFmt(runState.cachedTokens || 0, "Integer")}`;
        }
        const saveWarningText = EC_Fmt.isNull(runState.scoreSaveErrorMessage) ? "" : " - Score not saved";
        status.textContent = `${scoreText}${durationText}${tokenText}${saveWarningText}`;
        status.className = "agent-reliability-run-status agent-reliability-run-complete";
        return;
    }

    if (hasPlaceholders) {
        status.textContent = "Awaiting placeholder values";
    } else if (!isUnique) {
        status.textContent = "Awaiting unique prompts";
    } else if (hasEdit) {
        status.textContent = "Ready to send";
    } else {
        status.textContent = "Ready to send (original prompt)";
    }
    status.className = "agent-reliability-run-status";
}

function updateReliabilitySessionSendState() {
    const sendBtn = AI_DOM.sendBtn;
    if (!sendBtn) {
        return;
    }

    if (!getCurrentReliabilityMode() || !reliabilitySession) {
        if (!activeAIRequestState.isProcessing) {
            sendBtn.disabled = false;
        }
        return;
    }

    if (activeAIRequestState.isReliabilityMode || reliabilitySession.hasSent) {
        sendBtn.disabled = true;
        return;
    }

    sendBtn.disabled = !areReliabilityRunsReadyForSend();
}

function finalizeReliabilitySession() {
    if (!reliabilitySession || activeAIRequestState.isAggregateResultOpen) {
        return;
    }

    const allDone = reliabilitySession.runs.every(run => run.done);
    if (!allDone) {
        return;
    }

    activeAIRequestState.isAggregateResultOpen = true;

    const rows = reliabilitySession.runs.map((run) => {
        const scoreText = Number.isFinite(run.score) ? EC_Fmt.ScreenFmt(run.score, "Integer") : "No score";
        const durationText = Number.isFinite(run.durationMs) ? formatReliabilityDurationSeconds(run.durationMs) : "Unavailable";
        const tokenUsageText = formatTokenUsageText(run.inputTokens, run.outputTokens, run.cachedTokens) || "Unavailable";
        const explanationText = EC_Fmt.isNull(run.explanation) ? "" : `<div class=agent-reliability-result-explanation>${EC_Fmt.HTMLEncode(run.explanation)}</div>`;
        const saveWarningText = EC_Fmt.isNull(run.scoreSaveErrorMessage) ? "" : `<div class=agent-reliability-result-explanation>Score save failed: ${EC_Fmt.HTMLEncode(run.scoreSaveErrorMessage)}</div>`;
        return `<div class=agent-reliability-result-row><div class=agent-reliability-result-label>Run ${run.runId + 1}</div><div class=agent-reliability-result-prompt>${EC_Fmt.HTMLEncode(run.prompt || "")}</div><div class=agent-reliability-result-score>Score: ${scoreText}</div><div class=agent-reliability-result-score>Time: ${durationText}</div><div class=agent-reliability-result-score>Tokens: ${EC_Fmt.HTMLEncode(tokenUsageText)}</div>${explanationText}${saveWarningText}</div>`;
    }).join("");

    const missingScore = reliabilitySession.runs.some(run => !Number.isFinite(run.score));
    const missingDuration = reliabilitySession.runs.some(run => !Number.isFinite(run.durationMs));
    let averageText = "Average score: unavailable until all 3 runs have numeric scores.";
    let averageDurationText = "Average time: unavailable until all 3 runs reach chunk_completed.";
    if (!missingScore) {
        const totalScore = reliabilitySession.runs.reduce((sum, run) => sum + run.score, 0);
        averageText = `Average score: ${EC_Fmt.ScreenFmt(totalScore / RELIABILITY_RUN_COUNT, "Decimal", 2)}`;
    }
    if (!missingDuration) {
        const totalDuration = reliabilitySession.runs.reduce((sum, run) => sum + run.durationMs, 0);
        averageDurationText = `Average time: ${formatReliabilityDurationSeconds(totalDuration / RELIABILITY_RUN_COUNT)}`;
    }

    ECP.Dialog.ShowDialog("Reliability eval results", `<div class=agent-reliability-result-dialog>${rows}<div class=agent-reliability-result-average><div>${averageText}</div><div>${averageDurationText}</div></div></div>`, {
        cancelButtonTitle: "Close",
        width: 820
    });

    activeAIRequestState.isAggregateResultOpen = false;
}

// Clear the shared request-state fields after a request ends or is cancelled
function clearActiveAIRequestState() {
    activeAIRequestState.isReliabilityMode = false;
    activeAIRequestState.isAggregateResultOpen = false;
    activeAIRequestState.isProcessing = false;
    activeAIRequestState.abortController = null;
    activeAIRequestState.thinkingMsg = null;
    activeAIRequestState.chatPanel = null;
    activeAIRequestState.reliabilityRuns = [];
}

function markReliabilityRunComplete(runState, options = {}) {
    if (!runState || runState.completionHandled) {
        return;
    }

    runState.completionHandled = true;
    runState.isRunning = false;
    runState.done = true;
    runState.streamController = null;

    if (runState.thinkingMsg) {
        finalizeToolsDisplay(runState.thinkingMsg);
    }

    updateReliabilityRunPromptHints(runState);

    if (Array.isArray(activeAIRequestState.reliabilityRuns) && activeAIRequestState.reliabilityRuns.length > 0) {
        activeAIRequestState.reliabilityRuns = activeAIRequestState.reliabilityRuns.filter(run => run.runId !== runState.runId);
    }

    if (activeAIRequestState.reliabilityRuns.length === 0) {
        clearActiveAIRequestState();
        updateButtonVisibility(false);
        if (reliabilitySession && reliabilitySession.hasSent) {
            setReliabilityMainInputLocked(true);
            setInputState(false);
        } else {
            setReliabilityMainInputLocked(false);
            setInputState(true);
        }
        if (options.skipFinalize !== true) {
            finalizeReliabilitySession();
        }
        updateReliabilitySessionSendState();
    }
}

function markReliabilityRunFailure(runState, message, options = {}) {
    if (!runState || runState.completionHandled) {
        return;
    }

    runState.hasError = true;
    runState.errorMessage = message;
    runState.streamController = null;
    runState.isRunning = false;

    if (runState.thinkingMsg) {
        runState.thinkingMsg.stopThinking();
        runState.thinkingMsg.updateContent(message);
        runState.thinkingMsg.markToolsComplete();
    }

    markReliabilityRunComplete(runState, options);
}

function stopReliabilitySessionRuns(options = {}) {
    const runningRuns = Array.isArray(activeAIRequestState.reliabilityRuns) && activeAIRequestState.reliabilityRuns.length > 0
        ? activeAIRequestState.reliabilityRuns.slice()
        : [];

    for (let i = 0; i < runningRuns.length; i++) {
        const runState = runningRuns[i];
        if (runState.streamController) {
            try {
                runState.streamController.abort();
            } catch {
                /* ignore cancellation cleanup errors */
            }
        }

        markReliabilityRunFailure(runState, "Run cancelled.", options);
    }
}

function teardownReliabilityChatPanels() {
    if (!reliabilitySession) {
        return;
    }

    for (let i = 0; i < reliabilitySession.runs.length; i++) {
        const runState = reliabilitySession.runs[i];
        if (runState.chatPanel) {
            runState.chatPanel.remove();
            runState.chatPanel = null;
        }
        runState.thinkingMsg = null;
    }
}

function resetReliabilityUI() {
    const sourceConversationID = reliabilitySession ? reliabilitySession.sourceConversationID : "";
    const hadTemporarySourcePanel = reliabilitySession ? reliabilitySession.hadTemporarySourcePanel === true : false;

    stopReliabilitySessionRuns({ skipFinalize: true });
    teardownReliabilityChatPanels();

    const pageContainer = getReliabilityPageContainer();
    if (pageContainer) {
        const reliabilityLayout = pageContainer.querySelector(".agent-reliability-layout");
        if (reliabilityLayout) {
            reliabilityLayout.remove();
        }
    }

    toggleReliabilityModeClasses(false);
    restoreStandardChatPanel(sourceConversationID, hadTemporarySourcePanel);

    clearActiveAIRequestState();

    reliabilityModeEnabled = false;
    reliabilitySession = null;
    updateButtonVisibility(false);
    setReliabilityMainInputLocked(false);
    setInputState(true);
    updateSaveSkillBarVisibility();
}

function buildReliabilityRunRequestContext(runState) {
    const session = getReliabilitySession();
    if (!session || !runState) {
        return null;
    }

    return {
        runId: runState.runId,
        runState,
        sessionAiAgentID: session.aiAgentID,
        sessionEvalID: session.aiAgentEvalID,
        sessionModelID: session.evalAIModelID
    };
}

async function sendReliabilityRuns() {
    const session = getReliabilitySession();
    if (!session) {
        return;
    }

    if (session.hasSent) {
        setReliabilityMainInputLocked(true);
        setInputState(false);
        updateReliabilitySessionSendState();
        ECP.HTML.Snackbar("Start a new chat before sending another prompt.", "Warning");
        return;
    }

    if (!areReliabilityRunsReadyForSend()) {
        ECP.HTML.Snackbar("Make all 3 run prompts unique and replace any [placeholders] before sending.", "Warning");
        updateReliabilitySessionSendState();
        return;
    }

    const aiAgentID = session.aiAgentID || getSelectedAgentID();
    if (EC_Fmt.isNull(aiAgentID)) {
        ECP.HTML.Snackbar("Select an agent to continue", "Warning");
        return;
    }

    const runStates = session.runs.slice();
    if (runStates.length === 0) {
        return;
    }

    activeAIRequestState.isReliabilityMode = true;
    activeAIRequestState.isProcessing = true;
    activeAIRequestState.reliabilityRuns = runStates.slice();
    activeAIRequestState.thinkingMsg = null;
    activeAIRequestState.chatPanel = null;
    activeAIRequestState.abortController = null;
    activeAIRequestState.isAggregateResultOpen = false;
    session.hasSent = true;
    updateButtonVisibility(true);
    setReliabilityMainInputLocked(true);
    setInputState(false);
    updateReliabilitySessionSendState();

    const runPromises = [];

    for (let i = 0; i < runStates.length; i++) {
        const runState = runStates[i];
        const promptText = (runState.prompt || "").trim();

        if (EC_Fmt.isNull(promptText) || !isReliabilityRunReadyToSend(runState)) {
            markReliabilityRunFailure(runState, "Each run prompt must be non-empty and different from the other runs.");
            continue;
        }

        const context = buildReliabilityRunRequestContext(runState);
        if (!context) {
            markReliabilityRunFailure(runState, "Run context could not be initialized.");
            continue;
        }

        runState.isRunning = true;
        runState.done = false;
        runState.completionHandled = false;
        runState.hasError = false;
        runState.errorMessage = "";
        runState.score = null;
        runState.explanation = "";
        runState.scoreSaveErrorMessage = "";
        runState.evalResultReceived = false;
        runState.streamController = null;
        runState.userMessageElement = null;
        runState.startedAtMs = Date.now();
        runState.chunkCompletedAtMs = null;
        runState.durationMs = null;

        if (!runState.chatPanel) {
            runState.chatPanel = renderReliabilityRunPanel(runState);
        }

        if (!runState.chatPanel || !runState.chatPanel.element) {
            markReliabilityRunFailure(runState, "Run panel could not be created.");
            continue;
        }

        runState.chatPanel.element.setAttribute("AIAgentID", String(aiAgentID));
        runState.chatPanel.show();
        runState.chatPanel.clear();

        runState.userMessageElement = runState.chatPanel.addMessage("user", promptText, new Date().toISOString());
        const thinkingMsg = runState.chatPanel.addMessage("assistant", "", new Date().toISOString());
        thinkingMsg.aiAgentEvalID = context.sessionEvalID || 0;
        thinkingMsg.evalAIModelID = context.sessionModelID || 0;
        thinkingMsg.startThinking();
        runState.thinkingMsg = thinkingMsg;
        updateReliabilityRunPromptHints(runState);

        const messagePayload = {
            content: promptText,
            forcePlanFirst: WaitingForApprovePlanFirst,
            executePlan: false,
            AIAgentEvalID: context.sessionEvalID,
            EvalAIModelID: context.sessionModelID,
            FileDocumentIDArr: []
        };

        runPromises.push((async () => {
            try {
                await ReceiveServerSentEvents(thinkingMsg, messagePayload, runState.chatPanel, context);
                if (!runState.completionHandled) {
                    markReliabilityRunFailure(runState, "Run stream ended unexpectedly before completion.");
                }
            } catch (error) {
                if (!runState.completionHandled) {
                    markReliabilityRunFailure(runState, error && error.message ? error.message : "Run request failed.");
                }
            }
        })());
    }

    if (runPromises.length === 0) {
        activeAIRequestState.isReliabilityMode = false;
        activeAIRequestState.isProcessing = false;
        updateButtonVisibility(false);
        setReliabilityMainInputLocked(true);
        setInputState(false);
        updateReliabilitySessionSendState();
        return;
    }

    await Promise.allSettled(runPromises);
}

// ===========================================
// Settings Dialog Functions
// ===========================================

function OpenSettingsDialog() {
    CloseSidebar();

    if (AgentUIContext.settingsDialog) {
        CloseSettingsDialog();
    }

    const content = document.createElement("div");
    content.className = "ai-agent settings-dialog-content-root";
    content.innerHTML = `
<div class=settings-dialog-body>
 <div class=settings-sidebar>
  <ecp-subtabs vertical="" id=settingsTabs>
   <ecp-subtab-item selected data-tab=general>General</ecp-subtab-item>
   <ecp-subtab-item data-tab=permissions>Permissions</ecp-subtab-item>
   <ecp-subtab-item data-tab=tool-approvals>Tool approvals</ecp-subtab-item>
  </ecp-subtabs>
 </div>
 <div class=settings-content>
  <div class=settings-tab-content id=generalTabContent>
   <ecp-list class=settings-list>
    <ecp-list-item class=settings-item id=enableLoggingRow>
     <div class=settings-item-text>
      <div class=h4>Enable logging</div>
     </div>
     <ecp-switch id=enableLogging size=small${AgentSettings.enableLogging ? " checked" : ""}></ecp-switch>
    </ecp-list-item>
    <ecp-list-item class=settings-item id=enablePlanFirst>
     <div class=settings-item-text>
      <div class=h4>Plan first</div>
     </div>
     <ecp-switch id=planFirst size=small${AgentSettings.planFirst ? " checked" : ""}></ecp-switch>
    </ecp-list-item>
    <ecp-list-item class=settings-item >
     <div class=settings-item-text>
      <div class=h4>Include page context</div>
     </div>
     <ecp-switch id=includePageContext size=small${AgentSettings.includePageContext ? " checked" : ""}></ecp-switch>
    </ecp-list-item>
    <ecp-list-item class=settings-item id=tabNotificationsRow>
     <div class=settings-item-text>
      <div class=h4>Tab notifications</div>
      <div class=settings-item-subtext>Show an indicator in the browser tab title when an agent finishes while I'm looking elsewhere.</div>
     </div>
     <ecp-switch id=tabNotifications size=small${AgentSettings.tabNotifications ? " checked" : ""}></ecp-switch>
    </ecp-list-item>
    <ecp-list-item class=settings-item id=matchMyVoiceRow>
     <div class=settings-item-text>
      <div class=h4>Match my voice</div>
      <div class=settings-item-subtext>Write in my own tone, length and formatting. Only used when writing emails and other external communications — not for replies in this chat.</div>
      <div class=settings-item-subtext id=matchMyVoiceProfileState></div>
     </div>
     <ecp-switch id=matchMyVoice size=small${AgentSettings.matchMyVoice ? " checked" : ""}></ecp-switch>
    </ecp-list-item>
   </ecp-list>
  </div>
  <div class="settings-tab-content hidden" id=permissionsTabContent>
   <div class=permissions-search>
    <ecp-input id=permissionsSearch type=text placeholder="Search permissions" icon=ews-icon-search></ecp-input>
   </div>
   <div class=permissions-type-toggles id=permissionsTypeToggles>
    <button type=button class="permission-type-btn selected" data-type=View>View</button>
    <button type=button class="permission-type-btn selected" data-type=Edit>Edit</button>
    <button type=button class="permission-type-btn selected" data-type=Delete>Delete</button>
    <button type=button class="permission-type-btn selected" data-type=Custom>Custom</button>
   </div>
   <div class=permissions-container>
    <ecp-list id=permissionsList class=permissions-list></ecp-list>
   </div>
  </div>
  <div class="settings-tab-content hidden" id=toolApprovalsTabContent></div>
 </div>
</div>`;

    AgentUIContext.settingsDialog = ECP.Dialog.ShowDialog("AI agent settings", content, {
        width: 760,
        height: 520,
        cancelButtonTitle: "Cancel",
        confirmButtonTitle: "Save settings",
        cancelButtonAction: () => CloseSettingsDialog(),
        confirmButtonAction: async () => {
            try {
                await SyncAgentSettingsFromDialog();
                CloseSettingsDialog();
                ECP.HTML.Snackbar("Settings saved", "Success");
            } catch (error) {
                ECP.HTML.Snackbar("Failed to save settings", "Error");
            }
        }
    });

    const dialogContent = AgentUIContext.settingsDialog.querySelector(".ecp-dialog-content");
    if (dialogContent) {
        dialogContent.style.padding = "0";
        dialogContent.style.overflow = "hidden";
        dialogContent.style.display = "flex";
        dialogContent.style.flexDirection = "column";
    }

    toolPermissionsViewInstance = null;
    AgentPermissionTypeToggles = new Set(["View", "Edit", "Delete", "Custom"]); // Toggle buttons are recreated selected
    InitializeSettingsDialogContent();
    RenderPermissionsList();
    SwitchSettingsTab("general");
    updateApprovalOptionsUI();
}

function CloseSettingsDialog() {
    if (AgentUIContext.settingsDialog) {
        const currentDialog = AgentUIContext.settingsDialog;

        AgentUIContext.settingsDialog = null;
        toolPermissionsViewInstance = null;
        ECP.Dialog.CloseDialog(currentDialog);
    }
}

async function SyncAgentSettingsFromDialog() {
    if (AI_DOM.enableLoggingItem) {
        AgentSettings.enableLogging = AI_DOM.enableLoggingItem.checked;
    }

    if (AI_DOM.planFirstCheckbox) {
        setAgentPlanFirst(AI_DOM.planFirstCheckbox.checked);
    }

    if (AI_DOM.includePageContextCheckbox) {
        AgentSettings.includePageContext = AI_DOM.includePageContextCheckbox.checked;
    }

    if (AI_DOM.tabNotificationsCheckbox) {
        setTabNotificationsEnabled(AI_DOM.tabNotificationsCheckbox.checked);
    }

    if (AI_DOM.matchMyVoiceCheckbox && AI_DOM.matchMyVoiceCheckbox.checked !== AgentSettings.matchMyVoice) {
        await setAgentMatchMyVoice(AI_DOM.matchMyVoiceCheckbox.checked);
    }

    if (toolPermissionsViewInstance) {
        await toolPermissionsViewInstance.save();
    }
}

function BindSwitchSetting(element, onUpdate) {
    if (!element) {
        return;
    }

    const syncValue = () => onUpdate(element.checked);
    element.addEventListener("click", syncValue);
    element.addEventListener("change", syncValue);
}

function InitializeSettingsDialogContent() {
    if (AI_DOM.settingsTabs) {
        AI_DOM.settingsTabs.addEventListener("click", (e) => {
            const tabItem = e.target.closest("ecp-subtab-item");
            if (tabItem) {
                const tabName = tabItem.getAttribute("data-tab");
                if (tabName) {
                    SwitchSettingsTab(tabName);
                }
            }
        });
    }

    if (AI_DOM.permissionsSearch) {
        AI_DOM.permissionsSearch.addEventListener("input", () => {
            ApplyPermissionsFilter();
        });
    }

    if (AI_DOM.permissionsTypeToggles) {
        AI_DOM.permissionsTypeToggles.addEventListener("click", (e) => {
            const typeBtn = e.target.closest(".permission-type-btn");
            if (!typeBtn) {
                return;
            }
            const permissionType = typeBtn.dataset.type;
            const enabled = !AgentPermissionTypeToggles.has(permissionType);
            if (enabled) {
                AgentPermissionTypeToggles.add(permissionType);
            } else {
                AgentPermissionTypeToggles.delete(permissionType);
            }
            typeBtn.classList.toggle("selected", enabled);
            SetPermissionsSelectedByType(permissionType, enabled);
            RenderPermissionsList();
        });
    }

    BindSwitchSetting(AI_DOM.enableLoggingItem, (checked) => {
        AgentSettings.enableLogging = checked;
    });

    BindSwitchSetting(AI_DOM.planFirstCheckbox, (checked) => {
        setAgentPlanFirst(checked);
    });

    BindSwitchSetting(AI_DOM.includePageContextCheckbox, (checked) => {
        AgentSettings.includePageContext = checked;
    });

    BindSwitchSetting(AI_DOM.tabNotificationsCheckbox, (checked) => {
        setTabNotificationsEnabled(checked);
    });

    refreshMatchMyVoiceProfileState();
}

class ToolPermissionsView {
    constructor(container) {
        this.container = container;
        this.toolApprovals = [];
        this.otherApprovedTools = [];
    }

    async load() {
        this.renderLoading();
        try {
            const [currentType, approvalSettings] = await Promise.all([getAgentUserApproveType(), getAgentToolApprovalSettings()]);
            AgentUserApproveType = EC_Fmt.Null2ZeroInt(currentType);
            this.toolApprovals = approvalSettings && approvalSettings.ToolApprovals ? approvalSettings.ToolApprovals : [];
            this.otherApprovedTools = approvalSettings && Array.isArray(approvalSettings.OtherApprovedTools) ? approvalSettings.OtherApprovedTools : [];
            this.render();
        } catch (error) {
            this.renderEmptyState(); // Fallback
        }
    }

    render() {
        this.container.innerHTML = "";

        if (!allowsAlwaysApproval()) {
            this.renderDisabledState();
            return;
        }

        if (!Array.isArray(this.toolApprovals) || this.toolApprovals.length === 0) {
            this.renderEmptyState();
            return;
        }

        const wrapper = document.createElement("div");
        wrapper.style.display = "flex";
        wrapper.style.flexDirection = "column";
        wrapper.style.gap = "12px";
        wrapper.style.padding = "12px";
        wrapper.style.height = "100%";
        wrapper.style.overflow = "auto";

        wrapper.appendChild(this.createOtherToolApprovalSection());

        this.toolApprovals.forEach((toolApproval) => {
            wrapper.appendChild(this.createTableToolSection(toolApproval));
        });

        this.container.appendChild(wrapper);
    }

    createOtherToolApprovalSection() {
        const section = document.createElement("div");
        section.style.border = "1px solid var(--border)";
        section.style.borderRadius = "10px";
        section.style.background = "var(--bg)";
        section.style.padding = "12px";
        section.style.display = "flex";
        section.style.flexDirection = "column";
        section.style.gap = "10px";

        const header = document.createElement("div");
        header.innerHTML = `
<div style="font-weight:600">Other AI Agent Tools</div>
<div style="font-size:var(--bodysm-font-size);color:var(--text-secondary)">Always allow the AI agent to use only the saved tools below.</div>
        `;
        section.appendChild(header);

        const approvedTools = this.getApprovedOtherTools();
        const countLabel = document.createElement("div");
        countLabel.style.fontSize = "var(--bodysm-font-size)";
        countLabel.style.color = "var(--text-secondary)";
        countLabel.textContent = `${approvedTools.length} tool${approvedTools.length === 1 ? "" : "s"} selected`;
        section.appendChild(countLabel);

        section.appendChild(this.createOtherToolSearch());

        const listHost = document.createElement("div");
        listHost.style.maxHeight = "240px";
        listHost.style.overflow = "auto";
        listHost.style.border = "1px solid var(--border)";
        listHost.style.borderRadius = "8px";
        if (approvedTools.length === 0) {
            const empty = document.createElement("div");
            empty.style.padding = "16px";
            empty.style.fontSize = "var(--bodysm-font-size)";
            empty.style.color = "var(--text-secondary)";
            empty.textContent = "No tools are currently pre-approved. Use the search above to add one.";
            listHost.appendChild(empty);
        } else {
            const list = document.createElement("ecp-list");
            list.className = "permissions-list";

            approvedTools.forEach((toolInfo) => {
                const listItem = document.createElement("ecp-list-item");
                listItem.className = "tool-permission-item";

                const label = document.createElement("div");
                label.textContent = EC_Fmt.Null2EmptyStr(toolInfo && toolInfo.Title) || formatToolApprovalName(toolInfo && toolInfo.ToolName);

                const revokeBtn = EC_Fmt.HtmlStrToElement(`<ecp-btn type=permanent-destructive icon=ews-icon-delete>Revoke</ecp-btn>`);
                revokeBtn.addEventListener("click", () => {
                    this.removeApprovedTool(toolInfo && toolInfo.ToolName);
                    this.render();
                });

                ToolPermissionsView.configureApprovalListItem(listItem, label, revokeBtn);
                listItem.appendChild(label);
                listItem.appendChild(revokeBtn);
                list.appendChild(listItem);
            });

            listHost.appendChild(list);
        }
        section.appendChild(listHost);

        return section;
    }

    static configureApprovalListItem(listItem, label, actionButton) {
        listItem.style.display = "flex";
        listItem.style.alignItems = "center";
        listItem.style.gap = "12px";
        listItem.style.width = "100%";
        listItem.style.boxSizing = "border-box";

        if (label) {
            label.style.flex = "1";
            label.style.minWidth = "0";
        }

        if (actionButton) {
            actionButton.style.flexShrink = "0";
        }
    }

    createTableToolSection(toolApproval) {
        const section = document.createElement("div");
        section.style.border = "1px solid var(--border)";
        section.style.borderRadius = "10px";
        section.style.background = "var(--bg)";
        section.style.padding = "12px";
        section.style.display = "flex";
        section.style.flexDirection = "column";
        section.style.gap = "10px";

        const header = document.createElement("div");
        header.innerHTML = `
<div style="font-weight:600">${toolApproval.Title || toolApproval.ToolName}</div>
<div style="font-size:var(--bodysm-font-size);color:var(--text-secondary)">${toolApproval.Description || ""}</div>
        `;
        section.appendChild(header);

        const approvedTableDetails = this.getApprovedTableDetails(toolApproval.ToolName);
        const selectedCount = approvedTableDetails.length;
        const countLabel = document.createElement("div");
        countLabel.style.fontSize = "var(--bodysm-font-size)";
        countLabel.style.color = "var(--text-secondary)";
        countLabel.textContent = `${selectedCount} table${selectedCount === 1 ? "" : "s"} selected`;
        section.appendChild(countLabel);

        section.appendChild(this.createTableToolSearch(toolApproval));

        const listHost = document.createElement("div");
        listHost.style.maxHeight = "240px";
        listHost.style.overflow = "auto";
        listHost.style.border = "1px solid var(--border)";
        listHost.style.borderRadius = "8px";

        if (approvedTableDetails.length === 0) {
            const empty = document.createElement("div");
            empty.style.padding = "16px";
            empty.style.fontSize = "var(--bodysm-font-size)";
            empty.style.color = "var(--text-secondary)";
            empty.textContent = "No tables are currently always approved. Use the search above to add one.";
            listHost.appendChild(empty);
        } else {
            const list = document.createElement("ecp-list");
            list.className = "permissions-list";

            approvedTableDetails.forEach((tableInfo) => {
                const listItem = document.createElement("ecp-list-item");
                listItem.className = "tool-permission-item";

                const label = document.createElement("div");
                label.style.display = "flex";
                label.style.flexDirection = "column";
                label.style.minWidth = "0";

                const tableName = EC_Fmt.Null2EmptyStr(tableInfo && tableInfo.TableName);
                const alias = EC_Fmt.Null2EmptyStr(tableInfo && tableInfo.Alias);

                const nameLabel = document.createElement("span");
                nameLabel.textContent = tableName;
                label.appendChild(nameLabel);

                if (!EC_Fmt.isNull(alias) && alias !== tableName) {
                    const aliasLabel = document.createElement("span");
                    aliasLabel.style.fontSize = "var(--bodysm-font-size)";
                    aliasLabel.style.color = "var(--text-secondary)";
                    aliasLabel.textContent = alias;
                    label.appendChild(aliasLabel);
                }

                const revokeBtn = EC_Fmt.HtmlStrToElement(`<ecp-btn type=permanent-destructive icon=ews-icon-delete>Revoke</ecp-btn>`);
                revokeBtn.addEventListener("click", () => {
                    this.removeApprovedTable(toolApproval.ToolName, tableName);
                    this.render();
                });

                ToolPermissionsView.configureApprovalListItem(listItem, label, revokeBtn);
                listItem.appendChild(label);
                listItem.appendChild(revokeBtn);
                list.appendChild(listItem);
            });

            listHost.appendChild(list);
        }

        section.appendChild(listHost);
        return section;
    }

    createTableToolSearch(toolApproval) {
        const searchInput = document.createElement("ecp-auto-complete");
        const inputName = `${toolApproval.ToolName}ApprovalTableSearch`;

        searchInput.setAttribute("name", inputName);
        searchInput.setAttribute("inputName", inputName);
        searchInput.setAttribute("refTable", "Tables");
        searchInput.setAttribute("refField", "Table");
        searchInput.setAttribute("dataType", "ECP.DataType._Text");
        searchInput.setAttribute("refFieldDisplay", "Table");
        searchInput.setAttribute("refFieldDisplayDataType", "ECP.DataType._Text");
        searchInput.setAttribute("limitToRefList", "true");
        searchInput.setAttribute("placeholder", `Search ${toolApproval.Title || toolApproval.ToolName} tables`);

        searchInput.addEventListener("change", () => {
            const tableName = EC_Fmt.Null2EmptyStr(searchInput.value || searchInput.curValue).trim();
            if (EC_Fmt.isNull(tableName)) {
                return;
            }

            this.addApprovedTable(toolApproval.ToolName, tableName, searchInput.curDisplayValue || tableName);
            searchInput.value = "";
            searchInput.curDisplayValue = "";
            this.render();
        });

        return searchInput;
    }

    createOtherToolSearch() {
        const searchInput = document.createElement("ecp-auto-complete");
        const inputName = "OtherToolApprovalSearch";

        searchInput.setAttribute("name", inputName);
        searchInput.setAttribute("inputName", inputName);
        searchInput.setAttribute("refTable", "AIAgentsAPICommands");
        searchInput.setAttribute("refField", "APICommand");
        searchInput.setAttribute("dataType", "ECP.DataType._Text");
        searchInput.setAttribute("refFieldDisplay", "UserApprovalTitle");
        searchInput.setAttribute("refFieldDisplayDataType", "ECP.DataType._Text");
        searchInput.setAttribute("refFieldFilter", "AIAgentsAPICommands.Active = 1 AND AIAgentsAPICommands.UserApprovalMessage IS NOT NULL");
        searchInput.setAttribute("limitToRefList", "true");
        searchInput.setAttribute("placeholder", "Search pre-approvable AI agent tools");

        searchInput.addEventListener("change", () => {
            const toolName = EC_Fmt.Null2EmptyStr(searchInput.curValue || searchInput.value).trim();
            if (EC_Fmt.isNull(toolName)) {
                return;
            }

            this.addApprovedTool(toolName, searchInput.curDisplayValue || toolName);
            searchInput.value = "";
            searchInput.curValue = "";
            searchInput.curDisplayValue = "";
            this.render();
        });

        return searchInput;
    }

    getToolApproval(toolName) {
        return Array.isArray(this.toolApprovals)
            ? this.toolApprovals.find(item => item.ToolName === toolName)
            : null;
    }

    getApprovedTables(toolName) {
        const toolApproval = this.getToolApproval(toolName);
        return toolApproval && Array.isArray(toolApproval.ApprovedTables) ? toolApproval.ApprovedTables : [];
    }

    getApprovedTableDetails(toolName) {
        const toolApproval = this.getToolApproval(toolName);
        if (!toolApproval) {
            return [];
        }

        if (Array.isArray(toolApproval.ApprovedTableDetails)) {
            return toolApproval.ApprovedTableDetails;
        }

        return this.getApprovedTables(toolName).map(tableName => ({ TableName: tableName, Alias: tableName }));
    }

    getApprovedOtherTools() {
        return Array.isArray(this.otherApprovedTools) ? this.otherApprovedTools : [];
    }

    addApprovedTool(toolName, title) {
        const normalizedToolName = EC_Fmt.Null2EmptyStr(toolName).trim();
        if (EC_Fmt.isNull(normalizedToolName)) {
            return;
        }

        const approvedTools = Array.isArray(this.otherApprovedTools) ? [...this.otherApprovedTools] : [];
        const existingTool = approvedTools.find(item => item && String(item.ToolName).toLowerCase() === normalizedToolName.toLowerCase());
        if (existingTool) {
            if (EC_Fmt.isNull(existingTool.Title) && !EC_Fmt.isNull(title)) {
                existingTool.Title = title;
            }
            this.otherApprovedTools = approvedTools;
            return;
        }

        approvedTools.push({
            ToolName: normalizedToolName,
            Title: EC_Fmt.Null2EmptyStr(title) || formatToolApprovalName(normalizedToolName)
        });
        this.otherApprovedTools = approvedTools;
    }

    addApprovedTable(toolName, tableName, alias) {
        const toolApproval = this.getToolApproval(toolName);
        const normalizedTableName = EC_Fmt.Null2EmptyStr(tableName).trim();
        if (!toolApproval || EC_Fmt.isNull(normalizedTableName)) {
            return;
        }

        const approvedTables = Array.isArray(toolApproval.ApprovedTables) ? [...toolApproval.ApprovedTables] : [];
        if (!approvedTables.some(item => String(item).toLowerCase() === normalizedTableName.toLowerCase())) {
            approvedTables.push(normalizedTableName);
        }
        toolApproval.ApprovedTables = approvedTables;

        const approvedTableDetails = Array.isArray(toolApproval.ApprovedTableDetails) ? [...toolApproval.ApprovedTableDetails] : [];
        const existingDetail = approvedTableDetails.find(item => item && String(item.TableName).toLowerCase() === normalizedTableName.toLowerCase());
        if (!existingDetail) {
            approvedTableDetails.push({ TableName: normalizedTableName, Alias: EC_Fmt.Null2EmptyStr(alias) || normalizedTableName });
        }
        toolApproval.ApprovedTableDetails = approvedTableDetails;
    }

    removeApprovedTable(toolName, tableName) {
        const toolApproval = this.getToolApproval(toolName);
        const normalizedTableName = EC_Fmt.Null2EmptyStr(tableName).trim();
        if (!toolApproval || EC_Fmt.isNull(normalizedTableName)) {
            return;
        }

        toolApproval.ApprovedTables = this.getApprovedTables(toolName).filter(item => String(item).toLowerCase() !== normalizedTableName.toLowerCase());
        toolApproval.ApprovedTableDetails = this.getApprovedTableDetails(toolName).filter(item => !item || String(item.TableName).toLowerCase() !== normalizedTableName.toLowerCase());
    }

    removeApprovedTool(toolName) {
        const normalizedToolName = EC_Fmt.Null2EmptyStr(toolName).trim();
        if (EC_Fmt.isNull(normalizedToolName)) {
            return;
        }

        this.otherApprovedTools = this.getApprovedOtherTools().filter(item => !item || String(item.ToolName).toLowerCase() !== normalizedToolName.toLowerCase());
    }

    renderDisabledState() {
        this.container.innerHTML = `
<div class=tool-permissions-empty>
 <ecp-empty illustration=warning>
  <ecp-empty-title>Always allow is disabled</ecp-empty-title>
  <ecp-empty-body>Your administrator has disabled always-allow approvals.</ecp-empty-body>
 </ecp-empty>
</div>
        `;
    }

    renderEmptyState() {
        this.container.innerHTML = `
<div class=tool-permissions-empty>
 <ecp-empty illustration=empty>
    <ecp-empty-title>Unable to load tool approvals</ecp-empty-title>
        <ecp-empty-body>Try reopening the settings dialog.</ecp-empty-body>
 </ecp-empty>
</div>
        `;
    }

    renderLoading() {
        this.container.innerHTML = `
<div class=tool-permissions-empty>
 <span class="ews-icon-circlehalfdashed spin"style="font-size:24px;color:var(--primary-80);animation: spin 1s linear infinite"></span>
 <div class=empty-text>Loading permissions...</div>
</div>
        `;
    }

    async save() {
        if (!allowsAlwaysApproval()) {
            return;
        }

        const tableEditTables = this.getApprovedTables("TableEdit").join("^");
        const tableAddTables = this.getApprovedTables("TableAdd").join("^");
        const tableChangeRequestTables = this.getApprovedTables("TableChangeRequest").join("^");
        const tableAddRequestTables = this.getApprovedTables("TableAddRequest").join("^");
        const approvedTools = this.getApprovedOtherTools().map(item => item && item.ToolName).filter(item => !EC_Fmt.isNull(item)).join("^");
        await saveAgentToolApprovalSettings(tableEditTables, tableAddTables, tableChangeRequestTables, tableAddRequestTables, approvedTools);
    }
}

let toolPermissionsViewInstance = null;

function SwitchSettingsTab(tabName) {
    if (!AI_DOM.settingsTabs || !AI_DOM.generalTabContent || !AI_DOM.permissionsTabContent) {
        return;
    }

    // Update tab selection
    const tabs = AI_DOM.settingsTabs.querySelectorAll("ecp-subtab-item");
    tabs.forEach((tab) => {
        if (tab.getAttribute("data-tab") === tabName) {
            tab.setAttribute("selected", "");
        } else {
            tab.removeAttribute("selected");
        }
    });

    // Show/hide content
    AI_DOM.generalTabContent.classList.add("hidden");
    AI_DOM.permissionsTabContent.classList.add("hidden");
    const toolApprovalsTab = AI_DOM.toolApprovalsTabContent;
    if (toolApprovalsTab) toolApprovalsTab.classList.add("hidden");

    if (tabName === "general") {
        AI_DOM.generalTabContent.classList.remove("hidden");
    } else if (tabName === "permissions") {
        AI_DOM.permissionsTabContent.classList.remove("hidden");
    } else if (tabName === "tool-approvals") {
        if (toolApprovalsTab) toolApprovalsTab.classList.remove("hidden");

        // Initialize or refresh view
        if (!toolPermissionsViewInstance && toolApprovalsTab) {
            toolPermissionsViewInstance = new ToolPermissionsView(toolApprovalsTab);
        }
        if (toolPermissionsViewInstance) {
            toolPermissionsViewInstance.load();
        }
    }
}

function InitializeSettingsDialog() {
    // Open settings button (sidebar)
    if (AI_DOM.settingsBtn) {
        AI_DOM.settingsBtn.addEventListener("click", OpenSettingsDialog);
    }

    // Open settings button (mobile header)
    if (AI_DOM.mobileSettingsBtn) {
        AI_DOM.mobileSettingsBtn.addEventListener("click", OpenSettingsDialog);
    }
}

// ===========================================
// Mobile Sidebar Functions
// ===========================================

function OpenSidebar() {
    if (AI_DOM.contentLeft) {
        AI_DOM.contentLeft.classList.add("open");
    }
    if (AI_DOM.sidebarOverlay) {
        AI_DOM.sidebarOverlay.classList.add("visible");
    }
}

function CloseSidebar() {
    if (AI_DOM.contentLeft) {
        AI_DOM.contentLeft.classList.remove("open");
    }
    if (AI_DOM.sidebarOverlay) {
        AI_DOM.sidebarOverlay.classList.remove("visible");
    }
}

function InitializeMobileSidebar() {
    // Open sidebar button
    if (AI_DOM.openSidebarBtn) {
        AI_DOM.openSidebarBtn.addEventListener("click", OpenSidebar);
    }

    // Close sidebar button
    if (AI_DOM.closeSidebarBtn) {
        AI_DOM.closeSidebarBtn.addEventListener("click", CloseSidebar);
    }

    // Close sidebar when clicking overlay
    if (AI_DOM.sidebarOverlay) {
        AI_DOM.sidebarOverlay.addEventListener("click", CloseSidebar);
    }

    // Close sidebar when selecting a chat on mobile
    if (AI_DOM.chatGroup) {
        AI_DOM.chatGroup.addEventListener("click", () => {
            if (isDrawerAgentLayout()) {
                CloseSidebar();
            }
        });
    }

    if (AI_DOM.scheduledPromptsGroup) {
        AI_DOM.scheduledPromptsGroup.addEventListener("click", () => {
            if (isDrawerAgentLayout()) {
                CloseSidebar();
            }
        });
    }
}

// Tracks the active microphone session so interim and finalized speech can be merged into the prompt.
const DEFAULT_VOICE_INPUT_LANG = "en-US";
const VOICE_TRANSCRIPT_ALTERNATIVE_INDEX = 0;
const VoiceInputState = {
    recognition: null,
    isListening: false,
    baseText: "",
    finalTranscript: "",
    lastRenderedValue: "",
    allowPendingResults: true,
    pendingStopPromise: null,
    pendingStopResolve: null
};

function getSpeechRecognitionConstructor() {
    if (typeof window === "undefined") {
        return null;
    }

    return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}

function buildVoiceInputValue(baseText, transcriptText) {
    if (EC_Fmt.isNull(transcriptText)) {
        return baseText;
    }

    if (EC_Fmt.isNull(baseText)) {
        return transcriptText;
    }

    if (/\s$/.test(baseText)) {
        return `${baseText}${transcriptText}`;
    }

    return `${baseText} ${transcriptText}`;
}

function buildVoiceTranscriptText(finalTranscript, interimTranscript) {
    const transcriptParts = [];
    if (!EC_Fmt.isNull(finalTranscript)) {
        transcriptParts.push(finalTranscript.trim());
    }
    if (!EC_Fmt.isNull(interimTranscript)) {
        transcriptParts.push(interimTranscript.trim());
    }
    return transcriptParts.join(" ");
}

function isCurrentVoiceRecognition(recognition) {
    return !!recognition && VoiceInputState.recognition === recognition;
}

function resolvePendingVoiceStop() {
    const pendingStopResolve = VoiceInputState.pendingStopResolve;
    VoiceInputState.pendingStopPromise = null;
    VoiceInputState.pendingStopResolve = null;
    if (pendingStopResolve) {
        pendingStopResolve();
    }
}

function createPendingVoiceStopPromise() {
    if (VoiceInputState.pendingStopPromise) {
        return VoiceInputState.pendingStopPromise;
    }

    VoiceInputState.pendingStopPromise = new Promise((resolve) => {
        VoiceInputState.pendingStopResolve = resolve;
    });

    return VoiceInputState.pendingStopPromise;
}

function applyVoiceInputValue(input, transcriptText) {
    const nextValue = buildVoiceInputValue(VoiceInputState.baseText, transcriptText);
    input.value = nextValue;
    VoiceInputState.lastRenderedValue = nextValue;
    autoResizeChatInput();
}

function syncVoiceInputButtonState() {
    const voiceInputBtn = AI_DOM.voiceInputBtn;
    const sendBtn = AI_DOM.sendBtn;
    if (!voiceInputBtn) {
        return;
    }

    const isSupported = !!getSpeechRecognitionConstructor();
    const isDisabled = !isSupported || !!(sendBtn && sendBtn.disabled && sendBtn.dataset.queueEmpty !== "true");
    let voiceInputTitle = "Voice input is not available in this browser.";
    if (isSupported) {
        voiceInputTitle = VoiceInputState.isListening ? "Stop voice input" : "Start voice input";
    }

    voiceInputBtn.disabled = isDisabled;
    voiceInputBtn.classList.toggle("recording", VoiceInputState.isListening);
    voiceInputBtn.setAttribute("aria-pressed", VoiceInputState.isListening ? "true" : "false");
    voiceInputBtn.setAttribute("title", voiceInputTitle);
}

function clearVoiceInputState(recognition = null) {
    if (recognition && !isCurrentVoiceRecognition(recognition)) {
        return;
    }

    VoiceInputState.recognition = null;
    VoiceInputState.isListening = false;
    VoiceInputState.baseText = "";
    VoiceInputState.finalTranscript = "";
    VoiceInputState.lastRenderedValue = "";
    VoiceInputState.allowPendingResults = true;
    resolvePendingVoiceStop();
    syncVoiceInputButtonState();
}

function stopVoiceInput(options = {}) {
    const recognition = VoiceInputState.recognition;
    const waitForFinalResult = !!options.waitForFinalResult;
    const discardPendingResults = !!options.discardPendingResults;

    if (!recognition) {
        VoiceInputState.isListening = false;
        syncVoiceInputButtonState();
        resolvePendingVoiceStop();
        return Promise.resolve();
    }

    if (discardPendingResults) {
        VoiceInputState.allowPendingResults = false;
    }

    VoiceInputState.isListening = false;
    syncVoiceInputButtonState();

    const stopPromise = waitForFinalResult ? createPendingVoiceStopPromise() : Promise.resolve();

    try {
        recognition.stop();
    } catch {
        clearVoiceInputState(recognition);
    }

    return stopPromise;
}

function handleVoiceInputManualEdit() {
    const input = AI_DOM.chatInput;
    if (!input || !VoiceInputState.isListening) {
        return;
    }

    if (input.value === VoiceInputState.lastRenderedValue) {
        return;
    }

    stopVoiceInput({ discardPendingResults: true });
}

function startVoiceInput() {
    const input = AI_DOM.chatInput;
    const SpeechRecognition = getSpeechRecognitionConstructor();
    if (!input || !SpeechRecognition) {
        ECP.HTML.Snackbar("Voice input is not available in this browser.", "Warning");
        syncVoiceInputButtonState();
        return;
    }

    if (VoiceInputState.isListening) {
        return;
    }

    const recognition = new SpeechRecognition();
    VoiceInputState.recognition = recognition;
    VoiceInputState.isListening = true;
    VoiceInputState.baseText = input.value;
    VoiceInputState.finalTranscript = "";
    VoiceInputState.lastRenderedValue = input.value;
    VoiceInputState.allowPendingResults = true;

    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = navigator.language || DEFAULT_VOICE_INPUT_LANG;

    recognition.onresult = (event) => {
        if (!isCurrentVoiceRecognition(recognition) || !VoiceInputState.allowPendingResults) {
            return;
        }

        const finalTranscriptParts = [];
        const interimTranscriptParts = [];
        for (let i = event.resultIndex; i < event.results.length; i++) {
            const transcriptResult = event.results[i][VOICE_TRANSCRIPT_ALTERNATIVE_INDEX];
            const transcript = transcriptResult ? transcriptResult.transcript.trim() : "";
            if (EC_Fmt.isNull(transcript)) {
                continue;
            }

            if (event.results[i].isFinal) {
                finalTranscriptParts.push(transcript);
            } else {
                interimTranscriptParts.push(transcript);
            }
        }

        const finalTranscript = finalTranscriptParts.join(" ");
        const interimTranscript = interimTranscriptParts.join(" ");
        if (!EC_Fmt.isNull(finalTranscript)) {
            VoiceInputState.finalTranscript = buildVoiceTranscriptText(VoiceInputState.finalTranscript, finalTranscript);
        }

        const transcriptText = buildVoiceTranscriptText(VoiceInputState.finalTranscript, interimTranscript);
        applyVoiceInputValue(input, transcriptText);
    };

    recognition.onerror = (event) => {
        if (!isCurrentVoiceRecognition(recognition)) {
            return;
        }

        if (event.error === "aborted" || event.error === "no-speech") {
            return;
        }

        if (event.error === "not-allowed" || event.error === "service-not-allowed") {
            ECP.HTML.Snackbar("Please allow microphone access to use voice input.", "Warning");
        } else if (event.error === "audio-capture") {
            ECP.HTML.Snackbar("No microphone was detected for voice input.", "Warning");
        } else {
            ECP.HTML.Snackbar("Voice input stopped unexpectedly.", "Warning");
        }
    };

    recognition.onend = () => {
        clearVoiceInputState(recognition);
    };

    syncVoiceInputButtonState();
    input.focus();

    try {
        recognition.start();
    } catch {
        clearVoiceInputState(recognition);
        ECP.HTML.Snackbar("Voice input could not be started.", "Warning");
    }
}

function toggleVoiceInput() {
    if (VoiceInputState.isListening) {
        stopVoiceInput();
        return;
    }

    startVoiceInput();
}

function processSelectedFiles(files) {
    if (!files || files.length === 0) {
        return;
    }

    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const validation = validateFile(file);
        if (!validation.valid) {
            ECP.HTML.Snackbar(validation.error, "Error");
            continue;
        }
        if (!validateTotalTokens(file)) {
            ECP.HTML.Snackbar(`Adding "${file.name}" would exceed the ${formatMaxTotalTokensLabel()} token limit.`, "Error");
            continue;
        }
        addFileToStaging(file);
    }
}

function isDragEventWithFiles(event) {
    if (!event || !event.dataTransfer) {
        return false;
    }
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
        return true;
    }
    if (!event.dataTransfer.types) {
        return false;
    }
    return Array.from(event.dataTransfer.types).includes("Files");
}

function setDropOverlayVisible(isVisible) {
    const overlay = AI_DOM.chatDropOverlay;
    const wrapper = AI_DOM.searchBoxWrapper;
    if (overlay) {
        overlay.classList.toggle("hidden", !isVisible);
    }
    if (wrapper) {
        wrapper.classList.toggle("drag-over", isVisible);
    }
}

function initializeChatFileDropZone() {
    const wrapper = AI_DOM.searchBoxWrapper;
    if (!wrapper) {
        return;
    }

    wrapper.addEventListener("dragenter", (event) => {
        if (!isDragEventWithFiles(event)) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        FileUploadState.dragDepth += 1;
        setDropOverlayVisible(true);
    });

    wrapper.addEventListener("dragover", (event) => {
        if (!isDragEventWithFiles(event)) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = "copy";
        setDropOverlayVisible(true);
    });

    wrapper.addEventListener("dragleave", (event) => {
        event.preventDefault();
        event.stopPropagation();
        FileUploadState.dragDepth = Math.max(0, FileUploadState.dragDepth - 1);
        if (FileUploadState.dragDepth === 0) {
            setDropOverlayVisible(false);
        }
    });

    wrapper.addEventListener("drop", (event) => {
        if (!isDragEventWithFiles(event)) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        FileUploadState.dragDepth = 0;
        setDropOverlayVisible(false);
        processSelectedFiles(event.dataTransfer.files);
    });
}

// EC-31344: GetSessionSettings only feeds the user's name/avatar here, which is
// session-stable, so cache it and skip the call on subsequent navigations.
async function LoadAgentUserInfo() {
    const cached = readAgentCache("userinfo");
    if (cached) {
        return cached;
    }
    const info = await new ECP.EC_Request("GetSessionSettings").Submit();
    writeAgentCache("userinfo", info);
    return info;
}

// EC-31344: One request hydrates the whole panel. Session-stable data (approval
// preference + permissions) is served from the session-stamped cache and only
// re-requested when the session changes; volatile data (conversation list + token
// usage) is reused within a short TTL so back-to-back navigations stay call-free.
async function LoadPanelBootstrap() {
    const cachedStatic = readAgentCache("static");
    const cachedVolatile = readAgentCache("volatile");

    // Fully warm: nothing to fetch.
    if (cachedStatic && cachedVolatile) {
        applyBootstrapStatic(cachedStatic);
        applyBootstrapVolatile(cachedVolatile);
        return;
    }

    const req = new ECP.EC_Request("AIAgent_GetPanelBootstrap");
    req.SetReturnType(ECP.EC_ReturnType.Json);
    if (cachedStatic) {
        // Prove we already hold session-stable data so the server can omit it.
        req.AddRequestVariable("KnownSessionID", getAgentSessionStamp());
    }

    let data;
    try {
        data = await req.Submit();
    } catch (error) {
        ECP.HTML.Snackbar("Failed to load the agent panel");
        return;
    }

    let staticData = cachedStatic;
    if (data.StaticIncluded) {
        staticData = { UserApproveType: data.UserApproveType, Permissions: data.Permissions, MatchMyVoice: data.MatchMyVoice };
        writeAgentCache("static", staticData);
    }
    if (staticData) {
        applyBootstrapStatic(staticData);
    }

    const volatileData = {
        Conversations: data.Conversations,
        AgentApprovalOptions: data.AgentApprovalOptions,
        TokenUsage: data.TokenUsage,
        MaxFileUploadTokens: data.MaxFileUploadTokens,
        IsAIAgentAdmin: data.IsAIAgentAdmin
    };
    writeAgentCache("volatile", volatileData, AGENT_CACHE_TTL_MS);
    applyBootstrapVolatile(volatileData);
}

function applyBootstrapStatic(staticData) {
    if (!staticData) {
        return;
    }
    AgentUserApproveType = EC_Fmt.Null2ZeroInt(staticData.UserApproveType);
    updateUserApproveTips();
    applyUserPermissions(staticData.Permissions);
    // EC-29677: a cache entry written before this shipped has no MatchMyVoice, which reads as off until the next session.
    AgentSettings.matchMyVoice = !!staticData.MatchMyVoice;
}

function applyBootstrapVolatile(volatileData) {
    if (!volatileData) {
        return;
    }
    AgentApprovalOptions = EC_Fmt.Null2ZeroInt(volatileData.AgentApprovalOptions) || 3;
    applyMaxFileUploadTokens(volatileData.MaxFileUploadTokens);
    // EC-32371: volatile rather than static so a session open across the deploy picks the flag up on the next
    // cache expiry, instead of replaying a cached static payload without it until the user logs in again.
    setPromptPanelCanManage(!!volatileData.IsAIAgentAdmin);
    // EC-32546: volatile for the same reason -- a session open across the deploy would otherwise
    // replay a cached static payload without the flag and never offer eChat sharing.
    setAgentCanShareEChat(!!volatileData.CanShareEChat);
    renderConversationTabs(volatileData.Conversations);
    applyTokenUsageMetrics(volatileData.TokenUsage);
}

// EC-31283: A cache entry written before this shipped has no MaxFileUploadTokens, so keep the placeholder until a bootstrap carrying the setting arrives.
function applyMaxFileUploadTokens(maxFileUploadTokens) {
    const limit = EC_Fmt.Null2ZeroInt(maxFileUploadTokens);
    if (limit <= 0) {
        return;
    }

    FileUploadState.maxTotalTokens = limit;
    renderStagingArea();
}

const CHAT_INPUT_VIEWPORT_MAX_RATIO = 0.4;

// Grows the prompt box with its content. CSS owns the clamping through min-height/max-height, so
// past the cap the textarea scrolls internally instead of pushing the send control off screen.
function autoResizeChatInput() {
    const input = AI_DOM.chatInput;
    if (!input) {
        return;
    }

    input.style.height = "auto";
    const borderHeight = input.offsetHeight - input.clientHeight;
    input.style.height = `${input.scrollHeight + borderHeight}px`;
}

// The on-screen keyboard shrinks the visual viewport without changing the layout height, so the
// cap is recomputed from it -- otherwise a grown input can hide the send control behind the keyboard.
function syncChatInputViewportCap() {
    const wrapper = AI_DOM.searchBoxWrapper;
    if (!wrapper) {
        return;
    }

    const viewport = window.visualViewport;
    const viewportHeight = viewport ? viewport.height : window.innerHeight;
    wrapper.style.setProperty("--chat-input-viewport-cap", `${Math.round(viewportHeight * CHAT_INPUT_VIEWPORT_MAX_RATIO)}px`);
    autoResizeChatInput();
}

async function Init() {
    if (AgentUIContext.initialized) {
        return;
    }

    const input = AI_DOM.chatInput;
    const sendBtn = AI_DOM.sendBtn;
    const stopBtn = AI_DOM.stopBtn;

    if (!input || !sendBtn || !stopBtn || !AI_DOM.newChatBtn || !AI_DOM.chatGroup || !AI_DOM.pageContainer) {
        return;
    }

    AgentUIContext.initialized = true;

    sendBtn.addEventListener("click", async () => {
        if (getCurrentReliabilityMode() && reliabilitySession) {
            await sendReliabilityRuns();
            return;
        }

        await sendMessage();
    });
    stopBtn.addEventListener("click", () => cancelActiveRequest());
    const voiceInputBtn = AI_DOM.voiceInputBtn;
    if (voiceInputBtn) {
        voiceInputBtn.addEventListener("click", () => toggleVoiceInput());
    }
    window.addEventListener("beforeunload", (e) => {
        if (activeAIRequestState.isProcessing) {
            e.preventDefault();
        }
    });
    window.addEventListener("pagehide", () => {
        stopVoiceInput();
        cancelActiveRequest();
    });
    input.addEventListener("keydown", (event) => {
        if (handleSlashCommandKeydown(event)) {
            return;
        }
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            sendBtn.click();
        }
    });
    input.addEventListener("input", () => handleVoiceInputManualEdit());
    input.addEventListener("input", () => handleSlashCommandInput());
    input.addEventListener("input", () => autoResizeChatInput());
    input.addEventListener("input", () => syncQueueButtonEnabled());

    // EC-32301
    EC_Fmt.AfterInput(input, PROMPT_FILTER_MIN_QUERY_LENGTH, PROMPT_FILTER_DEBOUNCE_MS, (_, value) => filterPromptPanelForQuery(value), true);
    input.addEventListener("input", () => {
        if (input.value.trim().length < PROMPT_FILTER_MIN_QUERY_LENGTH) {
            clearPromptPanelFilter();
        }
    });
    input.addEventListener("blur", () => closeSkillCommandMenu());

    window.addEventListener("resize", () => syncChatInputViewportCap());
    if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", () => syncChatInputViewportCap());
    }
    syncChatInputViewportCap();

    const inputActionsBtn = AI_DOM.inputActionsBtn;
    const inputActionsMenu = AI_DOM.inputActionsMenu;
    const fileInputHidden = AI_DOM.fileInputHidden;
    initializeChatFileDropZone();
    if (inputActionsBtn && inputActionsMenu && fileInputHidden) {
        inputActionsBtn.addEventListener("click", () => {
            syncInputActionsMenuState();
            inputActionsMenu.ShowMenu(inputActionsBtn);
        });

        inputActionsMenu.addEventListener("click", async (e) => {
            const item = e.target.closest("[data-input-action]");
            if (!item) {
                return;
            }

            const action = item.getAttribute("data-input-action");
            switch (action) {
                case "upload":
                    fileInputHidden.click();
                    break;
                case "save-skill":
                    if (!canSaveConversationAsSkill()) {
                        ECP.HTML.Snackbar("This conversation cannot be saved as a skill yet.", "Information");
                        break;
                    }
                    saveWorkflowAsSkill();
                    break;
                case "toggle-plan-first":
                    setAgentPlanFirst(!AgentSettings.planFirst, {
                        syncSettingsDialog: true,
                        showToast: true
                    });
                    break;
                case "evals":
                    if (!canRunAgentEvals()) {
                        ECP.HTML.Snackbar("Select an agent to run evaluations.", "Information");
                        break;
                    }
                    await showAgentEvalsDialog();
                    break;
                case "toggle-google-search": {
                    const aiAgentID = document.getElementById("aiagentInput") ? document.getElementById("aiagentInput").value : "";
                    setGoogleSearchEnabled(aiAgentID, !AgentSettings.googleSearch, { showToast: true });
                    break;
                }
                case "mcp-connectors": {
                    const aiAgentID = document.getElementById("aiagentInput") ? document.getElementById("aiagentInput").value : "";
                    showMCPConnectorsDialog(aiAgentID);
                    break;
                }
                default:
                    break;
            }

            inputActionsMenu.CloseMenu();
        });

        fileInputHidden.addEventListener("change", () => {
            processSelectedFiles(fileInputHidden.files);
            fileInputHidden.value = "";
        });
    }

    syncInputActionsMenuState();
    loadScheduledPromptNotificationPreferences();
    syncScheduledPromptNotificationPreferencesUI();

    const sidebarHistoryTabs = AI_DOM.sidebarHistoryTabs;
    if (sidebarHistoryTabs) {
        sidebarHistoryTabs.addEventListener("change", (event) => {
            const activeTabItem = event && event.detail ? event.detail.activeTabItem : null;
            if (activeTabItem && activeTabItem.id === "sidebarScheduledPromptsTab") {
                setSidebarHistoryTab("scheduled-prompts");
                return;
            }

            setSidebarHistoryTab("chat-history");
        });
    }

    if (AI_DOM.scheduledPromptsGroup) {
        AI_DOM.scheduledPromptsGroup.addEventListener("click", HandleScheduledPromptsGroupClick);
    }

    const scheduledPromptEmailPref = AI_DOM.scheduledPromptEmailPref;
    if (scheduledPromptEmailPref) {
        scheduledPromptEmailPref.addEventListener("change", () => {
            ScheduledPromptsState.notificationPreferences.email = scheduledPromptEmailPref.checked;
            saveScheduledPromptNotificationPreferences();
        });
    }

    const scheduledPromptEChatPref = AI_DOM.scheduledPromptEChatPref;
    if (scheduledPromptEChatPref) {
        scheduledPromptEChatPref.addEventListener("change", () => {
            ScheduledPromptsState.notificationPreferences.eChat = scheduledPromptEChatPref.checked;
            saveScheduledPromptNotificationPreferences();
        });
    }

    const manageScheduledPromptsBtn = AI_DOM.manageScheduledPromptsBtn;
    if (manageScheduledPromptsBtn) {
        manageScheduledPromptsBtn.addEventListener("click", async () => {
            await showScheduledPromptsDialog();
        });
    }

    setSidebarHistoryTab("chat-history");

    AgentUserInfo = await LoadAgentUserInfo();

    // EC-31344: one round trip (backed by a session-stamped client cache) hydrates the
    // approval preference, permissions, conversation list, and token usage together.
    await LoadPanelBootstrap();

    // Initialize settings dialog
    InitializeSettingsDialog();

    // Initialize mobile sidebar
    InitializeMobileSidebar();
    syncVoiceInputButtonState();

    if (AgentUIContext.mode === "sidepanel") {
        const closePanelBtn = document.getElementById("closePanelBtn");
        if (closePanelBtn && typeof AgentUIContext.onClosePanel === "function") {
            closePanelBtn.addEventListener("click", () => {
                AgentUIContext.onClosePanel();
            });
        }
    }

    // Conversation list and token usage were already applied by LoadPanelBootstrap above.
    updateApprovalOptionsUI();

    const promptPanelToggleBtn = AI_DOM.promptPanelToggleBtn;
    if (promptPanelToggleBtn) {
        promptPanelToggleBtn.addEventListener("click", () => setPromptPanelCollapsed(!PromptPanelState.collapsed));
    }
    const promptPanelAddBtn = AI_DOM.promptPanelAddBtn;
    if (promptPanelAddBtn) {
        promptPanelAddBtn.addEventListener("click", () => addRecommendedPromptForCurrentAgent());
    }
    observeAgentLayoutWidth();

    AI_DOM.newChatBtn.addEventListener("click", () => newChat());
    await newChat();

    const aiAgentInputEl = document.getElementById("aiagentInput");
    aiAgentInputEl.addEventListener("change", onAgentSelectionChanged);
    document.getElementById("cancelAutoApprovalBtn").addEventListener("click", () => setAgentUserApproveType("0"));

    try {
        // Load Marked.js
        await EC_Fmt.LoadScript("https://cdn.e8.co/GlobalDocs/c059942b7332ed5ab496fedf80ed5ec5.js");
        const markedLibrary = typeof globalThis.marked === "undefined" ? null : globalThis.marked;
        if (!markedLibrary) {
            throw new Error("Marked unavailable after script load");
        }
        const baseRenderer = typeof markedLibrary.Renderer === "function" ? new markedLibrary.Renderer() : null;
        const renderer = {
            table(header, body) {
                return `
<div class="md-table-wrap">
 <div class="md-table-actions">
  <ecp-btn class="md-table-calc-btn" type="ghost" icon="ews-icon-calculator" title="Toggle calculator" aria-label="Toggle calculator"></ecp-btn>
  <ecp-btn class="md-table-dl-btn" type="ghost" icon="ews-icon-download" title="Download as CSV" aria-label="Download as CSV">CSV</ecp-btn>
 </div>
 <table class="Table NoPadding">
  <thead>${header}</thead>
  <tbody>${body}</tbody>
 </table>
</div>
    `;
            },
            tablerow(content) {
                return `<tr>${content}</tr>`;
            },
            tablecell(content, flags) {
                const tag = flags.header ? "th" : "td";
                const cls = flags.header ? "Parent" : "";
                return `<${tag} class="${cls}">${content}</${tag}>`;
            },
            link(...args) {
                const html = baseRenderer && typeof baseRenderer.link === "function" ? baseRenderer.link.apply(this, args) : "";
                if (AgentUIContext.mode === "sidepanel" || !html || html.includes(" target=")) {
                    return html;
                }

                return html.replace("<a ", '<a target="_blank" rel="noopener noreferrer" ');
            },
            code(code, infostring) {
                const lang = (infostring || "").trim().toLowerCase();
                if (lang === "ecp-artifact") {
                    // Falls through to a plain code block when the fence is not the artifact tool's JSON.
                    const artifactHtml = renderAgentArtifactPlaceholder(code);
                    if (artifactHtml) {
                        return artifactHtml;
                    }
                }
                if (lang !== "ecp-chart") {
                    return baseRenderer && typeof baseRenderer.code === "function"
                        ? baseRenderer.code(code, infostring)
                        : `<pre><code>${ECPChatPanel._escapeHtml(code)}</code></pre>`;
                }
                // Capture only — never execute here. updateContent() replaces innerHTML on every
                // streaming chunk, so a partial snippet would run repeatedly. The raw code rides
                // along in an inert <script type="text/plain"> (not executed by the browser, and it
                // survives the innerHTML replacement). Escaping "<" stops it breaking out of the tag.
                // hydrateD3Charts() runs it later, once, inside a sandboxed iframe.
                const safe = code.replace(/</g, "\\u003c");
                // Just an anchor carrying the (streaming) code. _syncChartLoaders() drops a stable
                // loader wrapper in here each chunk; hydrateD3Charts() swaps it for the chart iframe.
                return `<div class="ai-d3-chart" data-state="pending"><script type="text/plain" class="ai-d3-src">${safe}</script></div>`;
            }
        };

        markedLibrary.use({ renderer });
        setupMarkdownTableExport();
        setupAgentChartRendering();
        setupAgentArtifactRendering();
    } catch (e) {
        ECP.HTML.Snackbar("Failed to load Marked");
    }
}

// ---------------------------------------------------------------------------
// D3 chart rendering for agent responses
// The model emits ```ecp-chart fenced blocks containing self-contained D3 v5
// snippets. The marked code renderer turns each into an inert .ai-d3-chart
// placeholder; hydrateD3Charts() (called at stream finalize / history load) runs
// each snippet inside a sandboxed iframe so generated code is isolated from the
// page, session, and cookies. Charts redraw on resize for responsiveness from
// mobile to widescreen.
// ---------------------------------------------------------------------------

// Absolute URL so the parent page can fetch our D3 same-origin (authenticated, cookies sent).
const AGENT_D3_URL = new URL("includes/d3_INC.js", document.baseURI).href;

// The chart iframe is sandboxed with allow-scripts only, so it has an opaque origin. A
// <script src> from there is a cross-site subresource request that the SameSite=Lax session
// cookie is withheld from, and the auth gate answers with an HTML app-shell instead of the
// script (SyntaxError "Unexpected token '<'"). So fetch D3 once here — same-origin, cookies
// intact — cache the source text, and inline it into each iframe's srcdoc. Never rejects; a
// failed fetch resolves to "" so the iframe renders the harness's "Chart library unavailable".
let _agentD3SourcePromise = null;
function loadAgentD3Source() {
    if (!_agentD3SourcePromise) {
        _agentD3SourcePromise = fetch(AGENT_D3_URL, { credentials: "same-origin" })
            .then(resp => (resp.ok ? resp.text() : ""))
            .catch(() => "");
    }
    return _agentD3SourcePromise;
}

// True while text ends inside an unclosed ```ecp-chart fence (opener line finished, no closing ```
// yet) — i.e. the chart code is still streaming in, so the rendered placeholder shouldn't be rebuilt.
function hasOpenChartFence(text) {
    if (!text) {
        return false;
    }
    const marker = "```ecp-chart";
    const open = text.lastIndexOf(marker);
    if (open < 0) {
        return false;
    }
    const lineEnd = text.indexOf("\n", open + marker.length);
    if (lineEnd < 0) {
        return false;
    }
    return text.indexOf("```", lineEnd + 1) < 0;
}

// Harness that runs inside each chart iframe. Kept free of backticks / ${} so it
// stays a literal here. Fence bodies come in two dialects: a compact Chart.js-style JSON spec
// ({type,data:{labels,datasets},options}) rendered by the built-in templates below, or a
// self-contained D3 v5 snippet invoked with (d3, container, width, height, theme). Both paths
// report their rendered height to the parent and redraw on width change.
const CHART_HARNESS_JS = `
function __ecpReadText(value) {
    if (typeof value === "string") { return value; }
    if (value && typeof value === "object" && typeof value.text === "string") { return value.text; }
    return "";
}

function __ecpReadAxisLabel(axis) {
    if (!axis) { return ""; }
    if (typeof axis === "string") { return axis; }
    if (typeof axis.label === "string") { return axis.label; }
    if (axis.scaleLabel && typeof axis.scaleLabel.labelString === "string") { return axis.scaleLabel.labelString; }
    return __ecpReadText(axis.title);
}

// Axis options drift between our schema (options.xAxis) and Chart.js v3 (options.scales.x) / v2 (options.scales.xAxes[0])
function __ecpFindAxis(options, ownKey, v3Key, v2Key) {
    if (options[ownKey] != null) { return options[ownKey]; }
    var scales = options.scales;
    if (scales && typeof scales === "object") {
        if (scales[v3Key] != null) { return scales[v3Key]; }
        if (Array.isArray(scales[v2Key]) && scales[v2Key].length > 0) { return scales[v2Key][0]; }
    }
    return null;
}

// Returns a normalized spec for JSON chart payloads, null when the code is not JSON (a D3
// snippet), and throws when it is JSON but has no renderable numeric datasets.
function __ecpParseChartSpec(code) {
    var text = String(code || "").trim();
    if (text.charAt(0) !== "{") { return null; }
    var raw;
    try { raw = JSON.parse(text); } catch (e) { return null; }
    if (!raw || typeof raw !== "object") { return null; }

    var data = raw.data && typeof raw.data === "object" ? raw.data : raw;
    var rawSets = Array.isArray(data.datasets) ? data.datasets : [];
    var datasets = [];
    for (var i = 0; i < rawSets.length; i++) {
        var ds = rawSets[i] || {};
        var values = Array.isArray(ds.data) ? ds.data : (Array.isArray(ds.values) ? ds.values : null);
        if (!values || values.length === 0) { continue; }
        var nums = [];
        for (var j = 0; j < values.length; j++) {
            var v = Number(values[j]);
            if (!isFinite(v)) { nums = null; break; }
            nums.push(v);
        }
        if (nums) { datasets.push({ label: ds.label == null ? "" : String(ds.label), values: nums }); }
    }
    if (datasets.length === 0) { throw new Error("ecp-chart JSON spec has no numeric datasets"); }

    var labels = Array.isArray(data.labels) ? data.labels.map(String) : [];
    if (labels.length === 0) {
        for (var k = 0; k < datasets[0].values.length; k++) { labels.push(String(k + 1)); }
    }

    var typeText = String(raw.type == null ? "bar" : raw.type).toLowerCase();
    var type = "bar";
    if (typeText.indexOf("line") >= 0 || typeText.indexOf("area") >= 0) { type = "line"; }
    if (typeText.indexOf("pie") >= 0 || typeText.indexOf("dough") >= 0 || typeText.indexOf("donut") >= 0) { type = "pie"; }

    var options = raw.options && typeof raw.options === "object" ? raw.options : {};
    return {
        type: type,
        donut: typeText.indexOf("dough") >= 0 || typeText.indexOf("donut") >= 0,
        labels: labels,
        datasets: datasets,
        title: __ecpReadText(options.title),
        xLabel: __ecpReadAxisLabel(__ecpFindAxis(options, "xAxis", "x", "xAxes")),
        yLabel: __ecpReadAxisLabel(__ecpFindAxis(options, "yAxis", "y", "yAxes"))
    };
}

function __ecpRenderChartSpec(spec, container, width, height, theme) {
    var d3v = window.d3;
    var colors = theme && Array.isArray(theme.series) && theme.series.length > 0 ? theme.series : ["#2f6fed"];
    var textColor = theme && theme.text ? theme.text : "#1a1a1a";
    var gridColor = theme && theme.grid ? theme.grid : "#d0d0d0";
    var fmt = d3v.format(",");
    function seriesColor(i) { return colors[i % colors.length]; }

    var host = d3v.select(container);

    if (spec.title) {
        host.append("div")
            .style("font", "600 13px system-ui, sans-serif")
            .style("color", textColor)
            .style("margin", "0 0 6px")
            .style("text-align", "center")
            .text(spec.title);
    }

    if (spec.type === "pie" || spec.datasets.length > 1) {
        var legend = host.append("div")
            .style("display", "flex").style("flex-wrap", "wrap")
            .style("gap", "4px 14px").style("justify-content", "center")
            .style("font", "12px system-ui, sans-serif")
            .style("color", textColor).style("margin", "0 0 6px");
        var legendItems = spec.type === "pie"
            ? spec.labels
            : spec.datasets.map(function (ds) { return ds.label; });
        legendItems.forEach(function (label, i) {
            var item = legend.append("span")
                .style("display", "inline-flex").style("align-items", "center").style("gap", "5px");
            item.append("span")
                .style("width", "10px").style("height", "10px").style("border-radius", "2px")
                .style("background", seriesColor(i)).style("display", "inline-block");
            item.append("span").text(label || ("Series " + (i + 1)));
        });
    }

    // Title + legend spend part of the height budget so the whole assembly fits it.
    height = Math.max(120, height - Math.ceil(container.getBoundingClientRect().height));

    var svg = host.append("svg")
        .attr("viewBox", "0 0 " + width + " " + height)
        .attr("preserveAspectRatio", "xMidYMid meet")
        .style("width", "100%").style("height", "auto").style("display", "block");

    if (spec.type === "pie") {
        var values = spec.datasets[0].values;
        var total = 0;
        values.forEach(function (v) { total += Math.max(0, v); });
        var radius = Math.min(width, height) / 2 - 10;
        var pieG = svg.append("g").attr("transform", "translate(" + (width / 2) + "," + (height / 2) + ")");
        var arcs = d3v.pie().sort(null).value(function (v) { return Math.max(0, v); })(values);
        var arcGen = d3v.arc().outerRadius(radius).innerRadius(spec.donut ? radius * 0.55 : 0);
        pieG.selectAll("path").data(arcs).enter().append("path")
            .attr("d", arcGen)
            .attr("fill", function (d, i) { return seriesColor(i); })
            .attr("stroke", gridColor).attr("stroke-width", 1)
            .append("title").text(function (d, i) {
                var pct = total > 0 ? (100 * Math.max(0, values[i]) / total).toFixed(1) : "0.0";
                return (spec.labels[i] || "") + ": " + fmt(values[i]) + " (" + pct + "%)";
            });
        return;
    }

    var labels = spec.labels;
    var margin = { top: 8, right: 14, bottom: spec.xLabel ? 48 : 30, left: spec.yLabel ? 60 : 48 };
    var longest = 0;
    labels.forEach(function (l) { if (l.length > longest) { longest = l.length; } });
    var rotateTicks = longest * 6.5 > (width - margin.left - margin.right) / Math.max(1, labels.length);
    if (rotateTicks) { margin.bottom += Math.min(70, Math.round(longest * 4.2)); }
    var innerW = width - margin.left - margin.right;
    var innerH = Math.max(60, height - margin.top - margin.bottom);
    var plot = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var yMin = 0, yMax = 0;
    spec.datasets.forEach(function (ds) {
        ds.values.forEach(function (v) { if (v < yMin) { yMin = v; } if (v > yMax) { yMax = v; } });
    });
    if (yMax === yMin) { yMax = yMin + 1; }
    var y = d3v.scaleLinear().domain([yMin, yMax]).nice().range([innerH, 0]);

    var yAxisG = plot.append("g").call(d3v.axisLeft(y).ticks(5).tickSize(-innerW).tickFormat(d3v.format(".3~s")));
    yAxisG.select(".domain").remove();
    yAxisG.selectAll("line").attr("stroke", gridColor).attr("stroke-opacity", 0.6);
    yAxisG.selectAll("text").attr("fill", textColor).style("font", "11px system-ui, sans-serif");

    var x0 = d3v.scaleBand().domain(labels).range([0, innerW]).paddingInner(0.2).paddingOuter(0.1);
    var xAxisG = plot.append("g").attr("transform", "translate(0," + innerH + ")").call(d3v.axisBottom(x0).tickSizeOuter(0));
    xAxisG.select(".domain").attr("stroke", gridColor);
    xAxisG.selectAll("line").attr("stroke", gridColor);
    var xTicks = xAxisG.selectAll("text").attr("fill", textColor).style("font", "11px system-ui, sans-serif");
    if (rotateTicks) {
        xTicks.attr("transform", "rotate(-35)").attr("text-anchor", "end").attr("dx", "-6").attr("dy", "4");
    }

    if (spec.type === "bar") {
        var x1 = d3v.scaleBand()
            .domain(spec.datasets.map(function (ds, i) { return String(i); }))
            .range([0, x0.bandwidth()])
            .padding(spec.datasets.length > 1 ? 0.08 : 0);
        spec.datasets.forEach(function (ds, di) {
            var barG = plot.append("g").attr("fill", seriesColor(di));
            labels.forEach(function (label, li) {
                var v = ds.values[li];
                if (v == null || !isFinite(v)) { return; }
                barG.append("rect")
                    .attr("x", x0(label) + x1(String(di)))
                    .attr("y", y(Math.max(0, v)))
                    .attr("width", Math.max(1, x1.bandwidth()))
                    .attr("height", Math.max(1, Math.abs(y(v) - y(0))))
                    .attr("rx", 2)
                    .append("title").text(label + (ds.label ? " - " + ds.label : "") + ": " + fmt(v));
            });
        });
    } else {
        spec.datasets.forEach(function (ds, di) {
            var pts = [];
            labels.forEach(function (label, li) {
                var v = ds.values[li];
                if (v == null || !isFinite(v)) { return; }
                pts.push([x0(label) + x0.bandwidth() / 2, y(v), label, v]);
            });
            var lineGen = d3v.line().x(function (p) { return p[0]; }).y(function (p) { return p[1]; });
            plot.append("path").attr("d", lineGen(pts))
                .attr("fill", "none").attr("stroke", seriesColor(di)).attr("stroke-width", 2);
            var dotG = plot.append("g").attr("fill", seriesColor(di));
            pts.forEach(function (p) {
                dotG.append("circle").attr("cx", p[0]).attr("cy", p[1]).attr("r", 3)
                    .append("title").text(p[2] + (ds.label ? " - " + ds.label : "") + ": " + fmt(p[3]));
            });
        });
    }

    if (spec.yLabel) {
        svg.append("text").attr("transform", "rotate(-90)")
            .attr("x", -(margin.top + innerH / 2)).attr("y", 14)
            .attr("text-anchor", "middle").attr("fill", textColor)
            .style("font", "11px system-ui, sans-serif").text(spec.yLabel);
    }
    if (spec.xLabel) {
        svg.append("text").attr("x", margin.left + innerW / 2).attr("y", height - 6)
            .attr("text-anchor", "middle").attr("fill", textColor)
            .style("font", "11px system-ui, sans-serif").text(spec.xLabel);
    }
}

window.__ecpRunChart = function (id, code, theme) {
    var container = document.getElementById("c");
    var lastW = -1, t;
    var MIN_H = 100, MAX_H = 400;
    // Content taller than MAX_H is scaled down uniformly (transforms don't affect layout,
    // so the documentElement rect always measures the natural height). The posted height is
    // the visual height, so the parent iframe always lands within [MIN_H, MAX_H] uncropped.
    function post(msg) { try { parent.postMessage(msg, "*"); } catch (e) {} }
    function size() {
        var natural = Math.ceil(document.documentElement.getBoundingClientRect().height);
        var visual = natural;
        container.style.transform = "";
        container.style.transformOrigin = "";
        if (natural > MAX_H) {
            container.style.transformOrigin = "top center";
            container.style.transform = "scale(" + (MAX_H / natural) + ")";
            visual = MAX_H;
        }
        post({ type: "ecp-chart-size", id: id, height: Math.max(MIN_H, visual) });
    }
    function draw() {
        var width = window.innerWidth || container.clientWidth || 600;
        lastW = width;
        var height = Math.max(180, Math.min(MAX_H, Math.round(width * 0.5625)));
        container.style.transform = "";
        container.style.transformOrigin = "";
        container.innerHTML = "";
        try {
            var spec = __ecpParseChartSpec(code);
            if (spec) {
                __ecpRenderChartSpec(spec, container, width, height, theme);
            } else {
                (new Function("d3", "container", "width", "height", "theme", code))(window.d3, container, width, height, theme);
            }
        } catch (err) {
            container.innerHTML = '<div class="ecp-chart-err">\\u26A0 Chart failed to render</div>';
            post({ type: "ecp-chart-error", id: id, message: String((err && err.message) || err) });
        }
        size();
    }
    if (!window.d3) {
        container.innerHTML = '<div class="ecp-chart-err">\\u26A0 Chart library unavailable</div>';
        post({ type: "ecp-chart-error", id: id, message: "d3 missing" });
        size();
        return;
    }
    draw();
    window.addEventListener("resize", function () {
        clearTimeout(t);
        t = setTimeout(function () { if (window.innerWidth !== lastW) { draw(); } }, 150);
    });
};
`;

// Resolve the agent's theme colors to concrete values (the sandboxed iframe has no
// access to the page's CSS custom properties, so we pass resolved colors in).
function getAgentChartTheme() {
    const cs = getComputedStyle(document.body);
    const readVar = (name, fallback) => {
        const val = cs.getPropertyValue(name);
        return val && val.trim() ? val.trim() : fallback;
    };
    return {
        text: readVar("--text", "#1a1a1a"),
        grid: readVar("--border", "#d0d0d0"),
        series: [
            readVar("--text-accent-blue-bold", "#2f6fed"),
            readVar("--text-accent-green-bold", "#19a974"),
            readVar("--text-accent-orange-bold", "#d35400"),
            readVar("--text-accent-purple-bold", "#8e44ad"),
            readVar("--text-accent-teal-bold", "#16a2b8"),
            readVar("--text-accent-red-bold", "#e0245e"),
            readVar("--text-accent-yellow-bold", "#f5a623"),
            readVar("--text-accent-magenta-bold", "#c2185b"),
            readVar("--text-accent-navy-bold", "#34495e"),
            readVar("--text-accent-gray-bold", "#6b7280")
        ]
    };
}

function buildChartIframe(chartId, snippet, d3Source) {
    const theme = getAgentChartTheme();
    // Escape "<" so neither the snippet nor the theme JSON can terminate the inline <script>.
    const codeLiteral = JSON.stringify(snippet).replace(/</g, "\\u003c");
    const themeLiteral = JSON.stringify(theme).replace(/</g, "\\u003c");
    const idLiteral = JSON.stringify(chartId).replace(/</g, "\\u003c");
    // D3 is inlined below (see loadAgentD3Source), so every script is inline — no external
    // origin needed. connect-src 'none' blocks all network egress so a snippet cannot exfiltrate.
    const csp = `default-src 'none'; script-src 'unsafe-inline' 'unsafe-eval'; style-src 'unsafe-inline'; img-src data:; connect-src 'none'`;
    const srcdoc = "<!doctype html><html><head><meta charset=\"utf-8\">"
        + `<meta http-equiv="Content-Security-Policy" content="${csp}">`
        + "<style>html,body{margin:0;padding:0;overflow:hidden}"
        + "svg{max-width:100%;height:auto;display:block}"
        + ".ecp-chart-err{font:13px system-ui,sans-serif;color:#b00020;padding:8px}</style>"
        + "</head><body><div id=\"c\"></div>"
        + `<script>${d3Source || ""}</script>`
        + `<script>${CHART_HARNESS_JS}</script>`
        + `<script>window.__ecpRunChart(${idLiteral}, ${codeLiteral}, ${themeLiteral});</script>`
        + "</body></html>";

    const iframe = document.createElement("iframe");
    iframe.className = "ai-d3-frame";
    iframe.setAttribute("sandbox", "allow-scripts");
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("title", "Chart");
    iframe.dataset.chartId = chartId;
    iframe.style.height = "240px";
    iframe.srcdoc = srcdoc;
    return iframe;
}

let _agentChartRenderingSetup = false;
function setupAgentChartRendering() {
    if (_agentChartRenderingSetup) { return; }
    _agentChartRenderingSetup = true;

    const style = document.createElement("style");
    style.id = "ai-d3-chart-styles";
    style.textContent = `
.ai-d3-chart {display:block;margin:10px 0;width:100%;max-width:100%}
.ai-d3-chart[data-state="pending"] {min-height:180px}
.ai-d3-wrap {position:relative;width:100%;min-height:100px}
.ai-d3-chart[data-state="pending"] .ai-d3-wrap {min-height:180px}
.ai-d3-host {width:100%;min-height:180px}
.ai-d3-chart iframe.ai-d3-frame {width:100%;border:0;display:block;background:transparent;min-height:100px;max-height:400px}
`;
    document.head.appendChild(style);

    // Size each chart iframe to its content. Sandboxed frames post origin "null", so
    // route by matching the message source to a known iframe (prevents spoofing).
    window.addEventListener("message", (e) => {
        const data = e && e.data;
        if (!data || data.type !== "ecp-chart-size" || typeof data.id !== "string") { return; }
        // Validate the id format before using it in a selector — a spoofed message must
        // not be able to inject selector syntax.
        if (!/^ecpchart_[a-z0-9]+$/i.test(data.id)) { return; }
        const frame = document.querySelector(`iframe.ai-d3-frame[data-chart-id="${data.id}"]`);
        if (!frame || frame.contentWindow !== e.source) { return; }
        // The harness scales content taller than 400px down to fit, so the posted visual
        // height is authoritative — clamp only as a backstop against rogue snippet posts.
        const h = Math.max(100, Math.min(400, parseInt(data.height, 10) || 0));
        frame.style.height = `${h}px`;
    });
}

// ---------------------------------------------------------------------------
// HTML artifacts in agent responses
// Basic_SaveArtifact stores a self-contained HTML page in S3 and hands the model a
// ```ecp-artifact fence holding {artifactID, title, url, v}. The marked code renderer
// turns the fence into an .ai-artifact shell (title bar, copy link, open in new tab);
// hydrateArtifacts() then loads the page in an iframe sandboxed with allow-scripts
// only, so it runs in an opaque origin with no reach into this page, its cookies or
// its session. The page posts its own height so the frame fits the content.
// ---------------------------------------------------------------------------

// Only pages the artifact tool wrote: the users CDN bucket, the artifact SubDir, an MD5 key.
const AGENT_ARTIFACT_URL_PATTERN = /^https:\/\/cdn\.e8\.co\/[A-Za-z0-9_-]+\/S3AgentArtifact\/[a-f0-9]{32}\.html$/;
const AGENT_ARTIFACT_VERSION_PATTERN = /^[a-f0-9]{1,32}$/;
const AGENT_ARTIFACT_MIN_HEIGHT = 200;
const AGENT_ARTIFACT_MAX_HEIGHT = 900;

// The fence body is model output: unless it is the tool's own JSON pointing at an artifact URL,
// the caller renders an ordinary code block instead of a frame.
function parseAgentArtifactSpec(code) {
    let spec;
    try {
        spec = JSON.parse(code);
    } catch (e) {
        return null;
    }
    if (!spec || typeof spec.url !== "string" || !AGENT_ARTIFACT_URL_PATTERN.test(spec.url)) {
        return null;
    }
    return {
        url: spec.url,
        version: typeof spec.v === "string" && AGENT_ARTIFACT_VERSION_PATTERN.test(spec.v) ? spec.v : "",
        title: typeof spec.title === "string" && spec.title.trim() ? spec.title.trim() : "Artifact"
    };
}

// The same validation for a shell already in the DOM: the model can write raw HTML into a response,
// so a .ai-artifact it typed by hand must never get a frame pointed at an arbitrary URL.
function readAgentArtifactSpec(shell) {
    const url = shell.dataset.url || "";
    if (!AGENT_ARTIFACT_URL_PATTERN.test(url)) {
        return null;
    }
    const version = shell.dataset.version || "";
    return {
        url,
        version: AGENT_ARTIFACT_VERSION_PATTERN.test(version) ? version : "",
        title: shell.dataset.title || "Artifact"
    };
}

// Returns "" when the fence is not a valid artifact spec, so the renderer falls back to a code block.
function renderAgentArtifactPlaceholder(code) {
    const spec = parseAgentArtifactSpec(code);
    if (!spec) {
        return "";
    }
    const title = EC_Fmt.HTMLEncode(spec.title);
    return `<div class="ai-artifact" data-url="${spec.url}" data-version="${spec.version}" data-title="${title}">`
        + `<div class="ai-artifact-bar"><span class="ai-artifact-title" title="${title}">${title}</span>`
        + `<span class="ai-artifact-actions">`
        + `<ecp-btn class="ai-artifact-copy-btn" type="ghost" icon="ews-icon-link" title="Copy a link to this artifact" aria-label="Copy link">Copy link</ecp-btn>`
        + `<ecp-btn class="ai-artifact-toggle-btn" type="ghost" icon="ews-icon-caretup" title="Collapse artifact" aria-label="Collapse artifact" aria-expanded="true"></ecp-btn>`
        + `<a class="ai-artifact-open" href="${spec.url}" target="_blank" rel="noopener noreferrer" title="Open in a new tab" aria-label="Open in a new tab"><i class="ews-icon-externallink"></i></a>`
        + `</span></div>`
        + `<div class="ai-artifact-host"><div class="ai-artifact-pending">Loading artifact...</div></div></div>`;
}

function buildArtifactIframe(spec) {
    const iframe = document.createElement("iframe");
    iframe.className = "ai-artifact-frame";
    // allow-scripts only — no allow-same-origin, top-navigation, popups or forms: the page runs in an
    // opaque origin with no access to the parent window, its cookies or its storage.
    iframe.setAttribute("sandbox", "allow-scripts");
    iframe.setAttribute("referrerpolicy", "no-referrer");
    iframe.setAttribute("loading", "lazy");
    iframe.setAttribute("title", spec.title);
    iframe.style.height = `${AGENT_ARTIFACT_MIN_HEIGHT}px`;
    // v is the stored page's hash: an edit keeps the URL, so this is what defeats a cached copy.
    iframe.src = spec.version ? `${spec.url}?v=${spec.version}` : spec.url;
    return iframe;
}

// Collapsing hides the frame rather than removing it, so expanding again does not reload the page. Always
// expanded to start; this only exists so a long artifact can be tucked away without scrolling past it.
function setAgentArtifactCollapsed(shell, collapsed) {
    shell.classList.toggle("ai-artifact-collapsed", collapsed);
    const toggleBtn = shell.querySelector(".ai-artifact-toggle-btn");
    if (!toggleBtn) {
        return;
    }
    const label = collapsed ? "Expand artifact" : "Collapse artifact";
    toggleBtn.setAttribute("icon", collapsed ? "ews-icon-caretdown" : "ews-icon-caretup");
    toggleBtn.setAttribute("title", label);
    toggleBtn.setAttribute("aria-label", label);
    toggleBtn.setAttribute("aria-expanded", collapsed ? "false" : "true");
}

let _agentArtifactRenderingSetup = false;
function setupAgentArtifactRendering() {
    if (_agentArtifactRenderingSetup) { return; }
    _agentArtifactRenderingSetup = true;

    const style = document.createElement("style");
    style.id = "ai-artifact-styles";
    style.textContent = `
.ai-artifact {display:block;margin:10px 0;border:1px solid var(--border);border-radius:8px;overflow:hidden}
.ai-artifact-bar {display:flex;align-items:center;justify-content:space-between;gap:8px;padding:4px 6px 4px 12px;background:var(--layer-1);border-bottom:1px solid var(--border)}
.ai-artifact-title {font-size:var(--bodysm-font-size);font-weight:var(--semibold-weight);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.ai-artifact-actions {display:inline-flex;align-items:center;gap:4px;flex-shrink:0}
.ai-artifact-open {display:inline-flex;align-items:center;padding:6px;color:var(--text-secondary);text-decoration:none}
.ai-artifact-pending {padding:14px 12px;font-size:var(--bodysm-font-size);color:var(--text-secondary)}
.ai-artifact iframe.ai-artifact-frame {width:100%;border:0;display:block;background:#fff}
.ai-artifact.ai-artifact-collapsed .ai-artifact-bar {border-bottom:0}
.ai-artifact.ai-artifact-collapsed .ai-artifact-host {display:none}
`;
    document.head.appendChild(style);

    document.addEventListener("click", (e) => {
        const target = e.target instanceof Element ? e.target : null;
        const toggleBtn = target ? target.closest(".ai-artifact-toggle-btn") : null;
        const toggleShell = toggleBtn ? toggleBtn.closest(".ai-artifact") : null;
        if (toggleShell) {
            e.preventDefault();
            setAgentArtifactCollapsed(toggleShell, !toggleShell.classList.contains("ai-artifact-collapsed"));
            return;
        }
        const copyBtn = target ? target.closest(".ai-artifact-copy-btn") : null;
        const shell = copyBtn ? copyBtn.closest(".ai-artifact") : null;
        const spec = shell ? readAgentArtifactSpec(shell) : null;
        if (!spec) {
            return;
        }
        e.preventDefault();
        EC_Fmt.CopyTextToClipboard(spec.url);
        ECP.HTML.Snackbar("Artifact link copied to clipboard.", "Success");
    }, true);

    // Size each frame to its page. Sandboxed frames post origin "null", so route by matching the
    // message source to a known artifact frame — nothing else can resize one.
    window.addEventListener("message", (e) => {
        const data = e && e.data;
        if (!data || data.type !== "ecp-artifact-size") { return; }
        const frames = document.querySelectorAll("iframe.ai-artifact-frame");
        for (let i = 0; i < frames.length; i++) {
            if (frames[i].contentWindow === e.source) {
                const h = Math.max(AGENT_ARTIFACT_MIN_HEIGHT, Math.min(AGENT_ARTIFACT_MAX_HEIGHT, parseInt(data.height, 10) || 0));
                frames[i].style.height = `${h}px`;
                return;
            }
        }
    });
}

function setupMarkdownTableExport() {
    if (document.getElementById("md-table-export-styles")) return;
    const style = document.createElement("style");
    style.id = "md-table-export-styles";
    style.textContent = `
.md-table-wrap {position:relative;display:block;margin:8px 0}
.md-table-actions {position:absolute;top:6px;right:6px;display:none;align-items:center;gap:6px;z-index:2}
.md-table-wrap:hover .md-table-actions {display:inline-flex}
    `;
    document.head.appendChild(style);
    document.addEventListener("click", async (e) => {
        const target = e.target instanceof Element ? e.target : null;
        if (!target) {
            return;
        }
        const calcBtn = target.closest(".md-table-calc-btn");
        if (calcBtn) {
            const tableWrap = calcBtn.closest(".md-table-wrap");
            const existingCalculator = getMarkdownTableCalculator(tableWrap);
            closeMarkdownTableCalculators(existingCalculator);
            if (!existingCalculator && tableWrap && !tableWrap._tableCalculatorPendingOpen) {
                tableWrap._tableCalculatorPendingOpen = true;
                e.preventDefault();
                e.stopImmediatePropagation();
                try {
                    const calculator = await ensureMarkdownTableCalculator(tableWrap);
                    if (calculator && calcBtn.isConnected && !calculator.Enabled) {
                        calcBtn.dispatchEvent(new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true
                        }));
                    }
                } catch (error) {
                    ECP.HTML.Snackbar("Failed to load calculator", "Error");
                } finally {
                    tableWrap._tableCalculatorPendingOpen = false;
                }
            }
            return;
        }
        const btn = target.closest(".md-table-dl-btn");
        if (!btn) return;
        const tableEl = btn.closest(".md-table-wrap")?.querySelector("table");
        if (tableEl) exportMarkdownTableToCSV(tableEl);
    }, true);
}

async function ensureMarkdownTableCalculator(tableWrap) {
    if (!tableWrap) {
        return null;
    }
    if (tableWrap._tableCalculator) {
        return tableWrap._tableCalculator;
    }
    if (tableWrap._tableCalculatorInitPromise) {
        return tableWrap._tableCalculatorInitPromise;
    }
    if (!MarkdownTableCalculatorState.loadPromise) {
        MarkdownTableCalculatorState.loadPromise = EC_Fmt.LoadScript("BI/TableCalculator.js").catch((error) => {
            MarkdownTableCalculatorState.loadPromise = null;
            throw error;
        });
    }
    tableWrap._tableCalculatorInitPromise = (async () => {
        await MarkdownTableCalculatorState.loadPromise;
        const tableEl = tableWrap.querySelector("table");
        const enableButton = tableWrap.querySelector(".md-table-calc-btn");
        if (!tableEl || !enableButton || typeof TableCalculator === "undefined") {
            return null;
        }
        const calculator = new TableCalculator(
            tableEl,
            enableButton,
            "thead > tr > th",
            "tbody > tr > td",
            []
        );
        tableWrap._tableCalculator = calculator;
        MarkdownTableCalculatorState.instances.push(calculator);
        return calculator;
    })();
    try {
        return await tableWrap._tableCalculatorInitPromise;
    } finally {
        tableWrap._tableCalculatorInitPromise = null;
    }
}

function getMarkdownTableCalculator(tableWrap) {
    if (!tableWrap) {
        return null;
    }
    return tableWrap._tableCalculator || null;
}

function closeMarkdownTableCalculators(excludeCalculator = null) {
    const retainedCalculators = [];
    for (let i = 0; i < MarkdownTableCalculatorState.instances.length; i++) {
        const calculator = MarkdownTableCalculatorState.instances[i];
        if (!calculator) {
            continue;
        }
        const tableEl = calculator.Tables && calculator.Tables.length > 0 ? calculator.Tables[0] : null;
        if (calculator !== excludeCalculator && calculator.Enabled) {
            TableCalculator.EnableDisable(calculator);
        }
        // Keep calculators that still belong to a live table, or are still open while the UI finishes closing.
        if ((tableEl && tableEl.isConnected) || calculator.Enabled) {
            retainedCalculators.push(calculator);
        }
    }
    MarkdownTableCalculatorState.instances = retainedCalculators;
}

function exportMarkdownTableToCSV(tableEl) {
    const rows = [];
    tableEl.querySelectorAll("thead tr, tbody tr").forEach((tr) => {
        const cells = [];
        tr.querySelectorAll("th, td").forEach((cell) => {
            const text = normalizeCSVCellText(cell.innerText);
            cells.push(`"${text}"`);
        });
        rows.push(cells.join(","));
    });
    const csv = `\uFEFF${rows.join("\r\n")}`;
    const now = new Date();
    const dateStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}`;
    const filename = `table_data_${dateStr}.csv`;
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

function normalizeCSVCellText(text) {
    const normalizedText = text.trim().replace(/\r?\n/g, " ");
    const safeText = /^[=+\-@]/.test(normalizedText) ? `'${normalizedText}` : normalizedText;
    return safeText.replace(/"/g, '""');
}

const AgentInfoCache = {};

async function GetAgentInfo(aiAgentID) {
    if (!aiAgentID) return null;
    if (AgentInfoCache[aiAgentID]) {
        return AgentInfoCache[aiAgentID];
    }

    // EC-31344: agent config (intro, prompt templates, web-search flag) is session-stable,
    // so a page reload with the panel open reuses it instead of re-fetching.
    const cached = readAgentCache(`agentinfo_${aiAgentID}`);
    if (cached) {
        AgentInfoCache[aiAgentID] = cached;
        return cached;
    }

    const req = new ECP.EC_Request("AIAgent_GetInfo");
    req.AddRequestVariable("AIAgentID", aiAgentID);
    req.SetReturnType(ECP.EC_ReturnType.Json);
    const agentData = await req.Submit();

    AgentInfoCache[aiAgentID] = agentData;
    writeAgentCache(`agentinfo_${aiAgentID}`, agentData);
    return agentData;
}

// EC-32371: both layers of the client cache have to go, or an added or removed recommended prompt
// only shows up in the next session.
function invalidateAgentInfoCache(aiAgentID) {
    delete AgentInfoCache[aiAgentID];
    clearAgentCache(`agentinfo_${aiAgentID}`);
}

function getTokenUsageProgressColor(usagePercent) {
    if (usagePercent <= 70) {
        return "bg-success";
    }
    if (usagePercent <= 85) {
        return "bg-warning";
    }
    return "bg-error";
}

// Usage payloads may use PascalCase or camelCase keys depending on the source
function readUsageMetric(metrics, pascalKey, camelKey) {
    if (metrics && !EC_Fmt.isNull(metrics[pascalKey])) {
        return metrics[pascalKey];
    }
    if (metrics && !EC_Fmt.isNull(metrics[camelKey])) {
        return metrics[camelKey];
    }
    return null;
}

// Kept so a width change can re-render the meter's label without waiting for the next run
const TokenUsageState = {
    usagePercent: 0,
    resetTimeRemaining: "--"
};

function applyTokenUsageMetrics(metrics) {
    const tokenUsageWrapper = AI_DOM.tokenUsageWrapper;
    const tokenUsageProgressBar = AI_DOM.tokenUsageProgressBar;
    const tokenUsageProgressItem = AI_DOM.tokenUsageProgressItem;
    if (!tokenUsageWrapper || !tokenUsageProgressBar || !tokenUsageProgressItem) {
        return;
    }

    const rawPercent = Number(readUsageMetric(metrics, "TokenUsagePercent", "tokenUsagePercent"));
    const usagePercent = Number.isFinite(rawPercent) ? Math.max(0, Math.min(100, Math.round(rawPercent))) : 0;
    const resetTimeRemaining = Number.isFinite(rawPercent)
        ? EC_Fmt.NullChk(readUsageMetric(metrics, "TokenUsageResetTimeRemaining", "tokenUsageResetTimeRemaining"), "--")
        : "--";

    TokenUsageState.usagePercent = usagePercent;
    TokenUsageState.resetTimeRemaining = resetTimeRemaining;

    tokenUsageWrapper.classList.remove("hidden");
    tokenUsageProgressItem.setAttribute("progress", String(usagePercent));
    tokenUsageProgressItem.setAttribute("bg-color", getTokenUsageProgressColor(usagePercent));
    tokenUsageProgressItem.style.width = `${usagePercent}%`;
    syncTokenUsageLabel();

    applyIndividualTokenUsageMetrics(metrics);
}

/**
 * The meter sits under the send controls, so it is only ever as wide as they are. At the compact
 * step that is two icon buttons, where "Usage reset: 3 hours, 47 minutes" wrapped into a six-line
 * tower taller than the prompt box -- so at that size the reset time moves into the tooltip, which
 * already carries the percentage, and the meter shows just its bar.
 */
function syncTokenUsageLabel() {
    const progressBar = AI_DOM.tokenUsageProgressBar;
    const tooltip = document.getElementById("tokenUsageTooltip");
    if (!progressBar || !tooltip) {
        return;
    }

    const compact = agentLayoutWidth() <= COMPACT_COMPOSER_MAX_WIDTH;
    const usage = `${TokenUsageState.usagePercent}% organization usage`;

    if (compact) {
        progressBar.removeAttribute("helper-text");
        tooltip.textContent = `${usage} \u2014 resets in ${TokenUsageState.resetTimeRemaining}`;
        return;
    }

    progressBar.setAttribute("helper-text", `Usage reset: ${TokenUsageState.resetTimeRemaining}`);
    tooltip.textContent = usage;
}

// Per-user "Cowork Usage Limit" bar, shown just above the company-wide usage bar.
// Hidden entirely when the user's role is High/unlimited (the payload omits IndividualTokenUsagePercent).
// No reset-time helper text here: the reset window is identical to the company bar's, so we avoid
// showing it twice (the tooltip still reports this user's own usage percentage).
function applyIndividualTokenUsageMetrics(metrics) {
    const wrapper = AI_DOM.individualTokenUsageWrapper;
    const progressBar = AI_DOM.individualTokenUsageProgressBar;
    const progressItem = AI_DOM.individualTokenUsageProgressItem;
    if (!wrapper || !progressBar || !progressItem) {
        return;
    }

    const individualPercent = readUsageMetric(metrics, "IndividualTokenUsagePercent", "individualTokenUsagePercent");

    // High/unlimited roles omit IndividualTokenUsagePercent, so individualPercent stays null here.
    // Number(null) is 0 (not NaN), so check for null explicitly -> hide the bar rather than show it at 0%.
    const rawPercent = Number(individualPercent);
    if (individualPercent === null || !Number.isFinite(rawPercent)) {
        // No individual limit for this user's role (High/unlimited) -> hide the per-user bar.
        wrapper.classList.add("hidden");
        return;
    }

    const usagePercent = Math.max(0, Math.min(100, Math.round(rawPercent)));
    wrapper.classList.remove("hidden");
    progressItem.setAttribute("progress", String(usagePercent));
    progressItem.setAttribute("bg-color", getTokenUsageProgressColor(usagePercent));
    progressItem.style.width = `${usagePercent}%`;
    document.getElementById("individualTokenUsageTooltip").textContent = `${usagePercent}% personal usage`;
}

async function GetPromptMessage() {
    const aiAgentID = document.getElementById("aiagentInput").value;
    const agentData = await GetAgentInfo(aiAgentID);

    if (!agentData) return "";

    let welcomeMsg = agentData.IntroductionMessage;
    if (EC_Fmt.isNull(welcomeMsg)) {
        welcomeMsg = "Introduction not set";
    }
    return welcomeMsg;
}

// EC-32349: the recommended prompts live in a collapsible right-hand panel. It opens with each new
// conversation (collapsed on narrow layouts) and folds away once the conversation's first message is sent.
const PromptPanelState = {
    collapsed: false,
    // Scored against the chat input by the EC-32301 filter, rebuilt when the agent changes
    entries: [],
    query: "",
    // EC-32371: AIAgentAdmin, from the panel bootstrap. Shows the add and remove controls; the writes
    // behind them re-check the permission server-side, so this only decides what is on screen.
    canManage: false
};

// The filter runs off the keystroke path through EC_Fmt.AfterInput, which waits out a pause and
// stays quiet until there is enough text to tell prompts apart. Under that, the whole library shows.
const PROMPT_FILTER_DEBOUNCE_MS = 50;
const PROMPT_FILTER_MIN_QUERY_LENGTH = 5;
const PROMPT_FILTER_MIN_PARTIAL_LENGTH = 4;
const PROMPT_FILTER_MIN_SCORE = 2;
const PROMPT_FILTER_STOP_WORDS = new Set(("a an the and or but if then of to in on at by for from with within into onto as is are was were be been being do does did done have has had "
    + "it its this that these those i me my we our us you your he she they them their not no so than too very can could will would should may might must please need want "
    + "all any each some more most new also just only up out over under again about after before when where which who whom what how why there here").split(" "));

// Two characters is the floor because the acronyms carry real meaning here (PO, AR, SO); one-letter
// fragments do not. Duplicates are dropped: a prompt is no more relevant for saying "invoice" twice.
function promptFilterTokens(text) {
    const tokens = [];
    const parts = String(text).toLowerCase().split(/[^a-z0-9]+/);

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        if (part.length >= 2 && !PROMPT_FILTER_STOP_WORDS.has(part) && tokens.indexOf(part) === -1) {
            tokens.push(part);
        }
    }

    return tokens;
}

// A typo or a stem difference leaves the typed token as a subsequence of the library token
// ("invoce" inside "invoice"). Two characters of slack is what separates a near miss from an
// unrelated word that happens to share letters.
function isNearPromptToken(token, candidate) {
    if (candidate.length < token.length || candidate.length - token.length > 2) {
        return false;
    }

    let matched = 0;
    for (let i = 0; matched < token.length && i < candidate.length; i++) {
        if (candidate[i] === token[matched]) {
            matched++;
        }
    }

    return matched === token.length;
}

// Scores one typed word against one side of a prompt, best hit wins: the whole word, a partial word, or a near miss.
function scorePromptToken(token, tokens, exactScore, partialScore, nearScore) {
    if (tokens.indexOf(token) !== -1) {
        return exactScore;
    }
    if (token.length < PROMPT_FILTER_MIN_PARTIAL_LENGTH) {
        return 0;
    }

    let nearHit = 0;
    for (let i = 0; i < tokens.length; i++) {
        const candidate = tokens[i];

        // Both directions, because the query is a prompt in progress: "invoic" on the way to
        // "invoice", and "invoices" against a library that says "invoice".
        if (candidate.startsWith(token) || (candidate.length >= PROMPT_FILTER_MIN_PARTIAL_LENGTH && token.startsWith(candidate))) {
            return partialScore;
        }
        if (nearHit === 0 && isNearPromptToken(token, candidate)) {
            nearHit = nearScore;
        }
    }

    return nearHit;
}

// A hit in the title says what the prompt is for; the same word buried in the prompt body is far weaker evidence.
function scorePromptEntry(entry, queryTokens) {
    let score = 0;

    for (let i = 0; i < queryTokens.length; i++) {
        const titleScore = scorePromptToken(queryTokens[i], entry.nameTokens, 6, 5, 3);
        score += titleScore > 0 ? titleScore : scorePromptToken(queryTokens[i], entry.promptTokens, 2, 2, 1);
    }

    return score;
}

// Returns what the panel should show, and whether that is a filtered set. Filtering never empties
// the panel -- too little text, no usable words, or nothing scoring at all each leave the whole library up.
function visiblePromptEntries() {
    const query = PromptPanelState.query.trim();

    // A leading slash belongs to the skill picker, which is already reacting to these keystrokes
    if (query.length < PROMPT_FILTER_MIN_QUERY_LENGTH || query.startsWith("/")) {
        return { entries: PromptPanelState.entries, filtered: false };
    }

    const queryTokens = promptFilterTokens(query);
    if (queryTokens.length === 0) {
        return { entries: PromptPanelState.entries, filtered: false };
    }

    const matches = [];
    for (let i = 0; i < PromptPanelState.entries.length; i++) {
        const score = scorePromptEntry(PromptPanelState.entries[i], queryTokens);
        if (score >= PROMPT_FILTER_MIN_SCORE) {
            matches.push({ entry: PromptPanelState.entries[i], score });
        }
    }

    if (matches.length === 0) {
        return { entries: PromptPanelState.entries, filtered: false };
    }

    // Array.sort is stable, so equally scored prompts keep the alphabetical order they were built in
    matches.sort((a, b) => b.score - a.score);

    return { entries: matches.map(match => match.entry), filtered: true };
}

// Below this the recommended-prompts panel cannot hold a rail and still leave the chat a usable
// column, so it leaves the flow. Matches the 1120px step in AgentUI.css.
const NARROW_AGENT_LAYOUT_MAX_WIDTH = 1120;

// The agent's own width, never the viewport's: a full-screen agent loses the site menu's 256px,
// and a side panel is 280px to 70% of the viewport whatever the screen behind it measures.
function agentLayoutWidth() {
    const root = AgentUIContext.root || document.querySelector(".ai-agent");
    const measured = root ? root.clientWidth : 0;
    return measured > 0 ? measured : window.innerWidth;
}

function isNarrowAgentLayout() {
    return agentLayoutWidth() <= NARROW_AGENT_LAYOUT_MAX_WIDTH;
}

// Matches the 900px step in AgentUI.css, which is what actually moves the sidebar
const DRAWER_AGENT_LAYOUT_MAX_WIDTH = 900;

function isDrawerAgentLayout() {
    return agentLayoutWidth() <= DRAWER_AGENT_LAYOUT_MAX_WIDTH;
}

// Labels are the first thing worth spending when the prompt box beside them still has to be
// typeable, so they come off by how much the visible controls actually cost. The Send/Stop pair
// costs ~160px, hence the 560px step matching AgentUI.css. A lone Send costs almost nothing: the
// usage meter under it already reserves two icon controls' width, so its label runs the column
// 4px wider and no more, and it keeps that label down to the narrowest agent worth labelling.
const COMPACT_COMPOSER_MAX_WIDTH = 560;
const COMPACT_SINGLE_CONTROL_MAX_WIDTH = 260;

const COMPOSER_BUTTON_LABELS = {
    sendBtn: { send: "Send", queue: "Queue" },
    stopBtn: { stop: "Stop" }
};

// ecp-btn picks labelled or square-icon while handling the icon attribute, so re-apply the icon
// after the label changes to make it re-measure.
function setComposerButtonLabel(btn, label, compact) {
    if (!btn) {
        return;
    }

    // Set either way, so the icon-only button still reads as Send, Queue or Stop
    btn.setAttribute("aria-label", label);

    const nextText = compact ? "" : label;
    if (btn.textContent === nextText) {
        return;
    }

    btn.textContent = nextText;

    const icon = btn.getAttribute("icon");
    if (icon) {
        btn.removeAttribute("icon");
        btn.setAttribute("icon", icon);
    }
}

function isCompactComposer() {
    const stopBtn = AI_DOM.stopBtn;
    const bothShowing = !!stopBtn && !stopBtn.classList.contains("hidden");
    const maxWidth = bothShowing ? COMPACT_COMPOSER_MAX_WIDTH : COMPACT_SINGLE_CONTROL_MAX_WIDTH;
    return agentLayoutWidth() <= maxWidth;
}

function syncComposerButtonLabels() {
    const compact = isCompactComposer();
    const sendBtn = AI_DOM.sendBtn;
    const queueMode = sendBtn && sendBtn.getAttribute("icon") === "ews-icon-circlehalfdashed";

    setComposerButtonLabel(sendBtn, queueMode ? COMPOSER_BUTTON_LABELS.sendBtn.queue : COMPOSER_BUTTON_LABELS.sendBtn.send, compact);
    setComposerButtonLabel(AI_DOM.stopBtn, COMPOSER_BUTTON_LABELS.stopBtn.stop, compact);
}

// One observer for everything that reacts to width in JS; CSS does the rest through @container
function observeAgentLayoutWidth() {
    const root = AgentUIContext.root || document.querySelector(".ai-agent");
    if (!root || typeof ResizeObserver === "undefined") {
        window.addEventListener("resize", () => onAgentLayoutWidthChanged());
        return;
    }

    new ResizeObserver(() => onAgentLayoutWidthChanged()).observe(root);
}

function onAgentLayoutWidthChanged() {
    syncPromptPanelLayout();
    syncComposerButtonLabels();
    syncTokenUsageLabel();
}

// Narrow layouts take the panel out of the flow: a drawer over the chat when open, just the
// toggle when closed. Either way the chat column keeps its full width.
function syncPromptPanelLayout() {
    const panel = AI_DOM.promptPanel;
    if (!panel) {
        return;
    }

    panel.classList.toggle("narrow", isNarrowAgentLayout());
}

function setPromptPanelCollapsed(collapsed) {
    PromptPanelState.collapsed = collapsed;

    const panel = AI_DOM.promptPanel;
    if (!panel) {
        return;
    }

    panel.classList.toggle("collapsed", collapsed);
    syncPromptPanelLayout();

    const label = collapsed ? "Show recommended prompts" : "Hide recommended prompts";
    const toggleBtn = AI_DOM.promptPanelToggleBtn;
    if (toggleBtn) {
        toggleBtn.setAttribute("aria-expanded", collapsed ? "false" : "true");
        toggleBtn.setAttribute("aria-label", label);
    }

    const toggleTooltip = AI_DOM.promptPanelToggleTooltip;
    if (toggleTooltip) {
        toggleTooltip.textContent = label;
    }
}

function resetPromptPanelForNewConversation() {
    clearPromptPanelFilter();
    setPromptPanelCollapsed(isNarrowAgentLayout());
}

function applyPromptTemplateToInput(prompt) {
    const chatInput = AI_DOM.chatInput;
    if (!chatInput) {
        return;
    }

    // The drawer covers the chat on narrow layouts, so it has to move aside to reveal what it filled in
    if (isNarrowAgentLayout()) {
        setPromptPanelCollapsed(true);
    }

    chatInput.value = prompt;
    autoResizeChatInput();
    chatInput.focus();

    // The input now holds the chosen prompt, so filtering on it would only ever re-find that one
    clearPromptPanelFilter();
}

// The tokens are precomputed once per agent load rather than per keystroke, so a filter pass is
// a handful of string comparisons over a list this size.
function buildPromptPanelEntry(template, index) {
    const name = String(template.Name);
    const prompt = String(template.Prompt);

    return {
        index,
        name,
        prompt,
        // 0 for a payload served from an agent cache written before EC-32371, which only costs that
        // entry its remove control until the cache turns over
        recommendedPromptID: Number(template.AIAgentsRecommendedPromptID) || 0,
        nameTokens: promptFilterTokens(name),
        promptTokens: promptFilterTokens(prompt)
    };
}

function buildPromptPanelItem(entry) {
    const item = document.createElement("div");
    item.className = "prompt-panel-item";
    // Keyed on the entry, not on render position, so an id survives the list being filtered
    item.id = `promptPanelItem${entry.index}`;
    item.setAttribute("role", "button");
    item.setAttribute("tabindex", "0");

    const label = document.createElement("span");
    label.className = "prompt-panel-item-label";
    label.textContent = entry.name;
    item.appendChild(label);

    // The tooltip resolves its target by id on connect, so it rides along inside the item
    const tooltip = document.createElement("ecp-tooltip");
    tooltip.setAttribute("for", item.id);
    tooltip.setAttribute("placement", "left");
    tooltip.setAttribute("delayms", "300");
    tooltip.textContent = entry.prompt.replace(/\s+/g, " ").trim();
    item.appendChild(tooltip);

    item.addEventListener("click", () => applyPromptTemplateToInput(entry.prompt));
    item.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            applyPromptTemplateToInput(entry.prompt);
        }
    });

    if (PromptPanelState.canManage && entry.recommendedPromptID > 0) {
        item.appendChild(buildPromptPanelRemoveButton(entry));
    }

    return item;
}

// The remove control sits inside the item, which is itself a button, so both handlers stop here
// rather than also filling the chat input with the prompt being removed.
function buildPromptPanelRemoveButton(entry) {
    const removeBtn = document.createElement("ecp-btn");
    removeBtn.className = "prompt-panel-item-remove";
    removeBtn.setAttribute("type", "ghost");
    removeBtn.setAttribute("icon", "ews-icon-close");
    removeBtn.setAttribute("aria-label", `Remove ${entry.name}`);

    removeBtn.addEventListener("click", (event) => {
        event.stopPropagation();
        confirmRemoveRecommendedPrompt(entry);
    });
    removeBtn.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.stopPropagation();
        }
    });

    return removeBtn;
}

function renderPromptPanelItems() {
    const container = AI_DOM.promptPanelList;
    if (!container) {
        return;
    }

    const visible = visiblePromptEntries();

    container.innerHTML = "";
    visible.entries.forEach(entry => container.appendChild(buildPromptPanelItem(entry)));

    // Only an admin gets this far with nothing to show: the panel stays hidden for everyone else, so
    // the empty state exists to point them at the add button rather than to explain an empty list.
    if (visible.entries.length === 0) {
        const empty = document.createElement("div");
        empty.className = "prompt-panel-empty ecp-bodysm";
        empty.textContent = "No recommended prompts for this agent yet.";
        container.appendChild(empty);
    }

    // The heading is the only cue that the panel is showing a subset rather than the whole library
    const title = AI_DOM.promptPanelTitle;
    if (title) {
        title.textContent = visible.filtered ? "Matching prompts" : "Recommended prompts";
    }
}

// EC-32371: the add button is the only way into the dialog, so an admin needs the panel on screen even
// for an agent with no prompts yet. Everyone else keeps the old behaviour of no panel at all.
function syncPromptPanelAddButton() {
    const addBtn = AI_DOM.promptPanelAddBtn;
    if (addBtn) {
        addBtn.classList.toggle("hidden", !PromptPanelState.canManage);
    }
}

function setPromptPanelCanManage(canManage) {
    if (PromptPanelState.canManage === canManage) {
        return;
    }

    PromptPanelState.canManage = canManage;
    syncPromptPanelAddButton();
    renderPromptPanelItems();
}

function filterPromptPanelForQuery(query) {
    if (query === PromptPanelState.query) {
        return;
    }

    PromptPanelState.query = query;
    renderPromptPanelItems();
}

function clearPromptPanelFilter() {
    filterPromptPanelForQuery("");
}

async function LoadPromptTemplates() {
    const panel = AI_DOM.promptPanel;
    const container = AI_DOM.promptPanelList;
    if (!panel || !container) {
        return;
    }

    container.innerHTML = "";
    PromptPanelState.entries = [];
    PromptPanelState.query = "";

    const aiAgentID = document.getElementById("aiagentInput").value;
    if (!aiAgentID) {
        panel.classList.add("hidden");
        return;
    }

    const agentData = await GetAgentInfo(aiAgentID);
    const templates = agentData && agentData.PromptTemplates ? agentData.PromptTemplates.slice() : [];

    if (templates.length === 0 && !PromptPanelState.canManage) {
        panel.classList.add("hidden");
        return;
    }

    templates.sort((a, b) => String(a.Name).localeCompare(String(b.Name), undefined, { sensitivity: "base" }));

    PromptPanelState.entries = templates.map((t, index) => buildPromptPanelEntry(t, index));

    panel.classList.remove("hidden");
    syncPromptPanelAddButton();
    renderPromptPanelItems();
}

// ===== EC-32371: adding and removing recommended prompts (AIAgentAdmin only) =====

const RECOMMENDED_PROMPT_MAX_TITLE_LENGTH = 100;
const RECOMMENDED_PROMPT_MAX_PROMPT_LENGTH = 4000;

// Resolves to {title, prompt} on Confirm, or null when the user backs out. ShowDialog hides the
// container before handing it to confirmButtonAction, so a failed check un-hides it and reports the
// problem in place instead of resolving with something the server would only reject.
function showRecommendedPromptDialog() {
    return new Promise((resolve) => {
        const dialogHtml = `
            <div class=recommended-prompt-dialog>
                <label class=ecp-bodysm for=recommendedPromptTitle>Title</label>
                <input id=recommendedPromptTitle type=text maxlength=${RECOMMENDED_PROMPT_MAX_TITLE_LENGTH} placeholder="Short name shown in the panel">
                <label class=ecp-bodysm for=recommendedPromptText>Prompt</label>
                <textarea id=recommendedPromptText maxlength=${RECOMMENDED_PROMPT_MAX_PROMPT_LENGTH} placeholder="What should the agent be asked to do?"></textarea>
                <div id=recommendedPromptError class="recommended-prompt-error hidden ecp-bodysm"></div>
            </div>`;

        ECP.Dialog.ShowDialog("Add a recommended prompt", dialogHtml, {
            confirmButtonTitle: "Add",
            cancelButtonTitle: "Cancel",
            width: 560,
            confirmButtonAction: (container) => {
                const title = EC_Fmt.Null2EmptyStr(container.querySelector("#recommendedPromptTitle").value).trim();
                const prompt = EC_Fmt.Null2EmptyStr(container.querySelector("#recommendedPromptText").value).trim();

                if (EC_Fmt.isNull(title) || EC_Fmt.isNull(prompt)) {
                    const error = container.querySelector("#recommendedPromptError");
                    error.textContent = EC_Fmt.isNull(title) ? "Enter a title for the prompt." : "Enter the prompt text.";
                    error.classList.remove("hidden");
                    container.style.display = "";
                    return;
                }

                container.remove();
                resolve({ title, prompt });
            },
            cancelButtonAction: () => resolve(null)
        });
    });
}

async function addRecommendedPromptForCurrentAgent() {
    const aiAgentID = getSelectedAgentID();
    if (aiAgentID <= 0) {
        ECP.HTML.Snackbar("Select an AI agent first.", "Warning");
        return;
    }

    const entered = await showRecommendedPromptDialog();
    if (entered === null) {
        return;
    }

    const req = new ECP.EC_Request("AIAgent_AddRecommendedPrompt");
    req.SetReturnType(ECP.EC_ReturnType.Json);
    req.AddRequestVariable("AIAgentID", String(aiAgentID), ECP.EC_Verb.Post);
    req.AddRequestVariable("Title", entered.title, ECP.EC_Verb.Post);
    req.AddRequestVariable("Prompt", entered.prompt, ECP.EC_Verb.Post);
    const result = await req.Submit();

    if (!result || !result.Success) {
        ECP.HTML.Snackbar(result && result.ErrorMessage ? result.ErrorMessage : "Could not add the recommended prompt.", "Error");
        return;
    }

    ECP.HTML.Snackbar("Recommended prompt added.", "Success");
    await reloadRecommendedPrompts(aiAgentID);
}

function confirmRemoveRecommendedPrompt(entry) {
    const dialog = ECP.Dialog.ShowDialog("Remove recommended prompt", `Remove <strong>${EC_Fmt.HTMLEncode(entry.name)}</strong> from this agent?`, {
        cancelButtonTitle: "Cancel",
        confirmButtonTitle: "Remove",
        cancelButtonAction: () => ECP.Dialog.CloseDialog(dialog),
        confirmButtonAction: async () => {
            ECP.Dialog.CloseDialog(dialog);
            await removeRecommendedPrompt(entry.recommendedPromptID);
        }
    });
}

async function removeRecommendedPrompt(recommendedPromptID) {
    const aiAgentID = getSelectedAgentID();

    const req = new ECP.EC_Request("AIAgent_RemoveRecommendedPrompt");
    req.SetReturnType(ECP.EC_ReturnType.Json);
    req.AddRequestVariable("AIAgentsRecommendedPromptID", String(recommendedPromptID), ECP.EC_Verb.Post);
    const result = await req.Submit();

    if (!result || !result.Success) {
        ECP.HTML.Snackbar(result && result.ErrorMessage ? result.ErrorMessage : "Could not remove the recommended prompt.", "Error");
        return;
    }

    ECP.HTML.Snackbar("Recommended prompt removed.", "Success");
    await reloadRecommendedPrompts(aiAgentID);
}

// The agent's prompt list is cached on both sides. The server side is cleared by the ClearAIAgentCache
// trigger on AIAgentsRecommendedPrompts; this drops the client copy so the reload sees the new list.
async function reloadRecommendedPrompts(aiAgentID) {
    invalidateAgentInfoCache(aiAgentID);
    await LoadPromptTemplates();
}

// ===== Slash command skill picker =====
// Typing "/" as the first character in the chat input opens a dropdown of the selected
// agent's skills. The chosen skill is forced into the agent's context server-side,
// bypassing the SearchKnowledge RAG lookup so only that skill drives the request.

const SlashCommandState = {
    skillsCache: {}, // aiAgentID -> [{id, name, slug}]
    skillsLoadPromises: {}, // aiAgentID -> in-flight load promise
    activeSkill: null, // {id, name, slug}
    visibleSkills: [],
    highlightedIndex: 0,
    isOpen: false,
    isLoading: false
};

function slugifySkillName(skillName) {
    return String(skillName || "").trim().replace(/\s+/g, "-");
}

async function loadAgentSkills(aiAgentID) {
    const agentKey = String(EC_Fmt.Null2ZeroInt(aiAgentID));
    if (agentKey === "0") {
        return [];
    }
    if (SlashCommandState.skillsCache[agentKey]) {
        return SlashCommandState.skillsCache[agentKey];
    }
    if (SlashCommandState.skillsLoadPromises[agentKey]) {
        return SlashCommandState.skillsLoadPromises[agentKey];
    }

    const fetchSkills = async (agentFilterValue) => {
        const myTableView = new ECP.EC_TableView("AIAgentsSkills");
        myTableView.SetFormat("json");
        myTableView.SetMaxRecords(500);
        myTableView.AddColumn("AIAgentSkillID");
        myTableView.AddColumn("SkillName");
        myTableView.AddFilter("AIAgentID", agentFilterValue, ECP.EC_Operator.Equals);
        myTableView.AddFilter("Active", "1", ECP.EC_Operator.Equals);
        myTableView.AddSelectSort("SkillName", ECP.EC_SortOrder.Asc);

        const data = await myTableView.GetResults();
        const myRecordSet = new ECP.EC_Recordset(data);
        const skills = [];
        while (!myRecordSet.EOF) {
            const name = myRecordSet.Item("SkillName");
            skills.push({
                id: myRecordSet.Item("AIAgentSkillID"),
                name,
                slug: slugifySkillName(name)
            });
            myRecordSet.MoveNext();
        }
        return skills;
    };

    const loadPromise = (async () => {
        let skills;
        try {
            // Agent-specific skills plus global skills (AIAgentID=0 applies to all agents)
            const [agentSkills, globalSkills] = await Promise.all([fetchSkills(agentKey), fetchSkills("0")]);
            skills = agentSkills.concat(globalSkills).sort((a, b) => a.slug.localeCompare(b.slug));
        } catch {
            skills = [];
        }

        SlashCommandState.skillsCache[agentKey] = skills;
        delete SlashCommandState.skillsLoadPromises[agentKey];
        return skills;
    })();

    SlashCommandState.skillsLoadPromises[agentKey] = loadPromise;
    return loadPromise;
}

function renderSkillCommandMenu() {
    const menu = AI_DOM.skillCommandMenu;
    if (!menu) {
        return;
    }

    if (!SlashCommandState.isOpen) {
        menu.innerHTML = "";
        menu.classList.add("hidden");
        return;
    }

    menu.classList.remove("hidden");

    if (SlashCommandState.isLoading) {
        menu.innerHTML = `<div class="skill-command-empty ecp-bodysm">Loading skills...</div>`;
        return;
    }

    if (SlashCommandState.visibleSkills.length === 0) {
        menu.innerHTML = `<div class="skill-command-empty ecp-bodysm">No matching skills</div>`;
        return;
    }

    let html = `<div class="skill-command-header ecp-bodysm">Skills</div>`;
    SlashCommandState.visibleSkills.forEach((skill, index) => {
        html += `<div class="skill-command-item${index === SlashCommandState.highlightedIndex ? " highlighted" : ""}" data-skill-index="${index}">`;
        html += `<i class="skill-command-icon ews-icon-spark"></i>`;
        html += `<span class="skill-command-slug">/${EC_Fmt.HTMLEncode(skill.slug)}</span>`;
        html += `<span class="skill-command-name ecp-bodysm">${EC_Fmt.HTMLEncode(skill.name)}</span>`;
        html += `</div>`;
    });
    menu.innerHTML = html;

    menu.querySelectorAll(".skill-command-item").forEach((item) => {
        // mousedown (not click) so the textarea keeps focus when picking a skill
        item.addEventListener("mousedown", (e) => {
            e.preventDefault();
            const skill = SlashCommandState.visibleSkills[Number(item.getAttribute("data-skill-index"))];
            if (skill) {
                activateSkill(skill);
            }
        });
    });

    const highlighted = menu.querySelector(".skill-command-item.highlighted");
    if (highlighted) {
        highlighted.scrollIntoView({ block: "nearest" });
    }
}

function closeSkillCommandMenu() {
    SlashCommandState.isOpen = false;
    SlashCommandState.isLoading = false;
    SlashCommandState.visibleSkills = [];
    SlashCommandState.highlightedIndex = 0;
    renderSkillCommandMenu();
}

async function handleSlashCommandInput() {
    const input = AI_DOM.chatInput;
    if (!input) {
        return;
    }

    // Slash commands only apply when "/" is the first character and no skill is active yet
    if (SlashCommandState.activeSkill || !input.value.startsWith("/")) {
        closeSkillCommandMenu();
        return;
    }

    // Skills require an explicitly selected agent
    const aiAgentID = getSelectedAgentID();
    if (aiAgentID <= 0) {
        closeSkillCommandMenu();
        return;
    }

    const agentKey = String(aiAgentID);
    if (!SlashCommandState.skillsCache[agentKey]) {
        SlashCommandState.isOpen = true;
        SlashCommandState.isLoading = true;
        renderSkillCommandMenu();
        await loadAgentSkills(agentKey);
        SlashCommandState.isLoading = false;
        // The input may have changed while skills were loading
        if (SlashCommandState.activeSkill || !input.value.startsWith("/") || getSelectedAgentID() !== aiAgentID) {
            closeSkillCommandMenu();
            return;
        }
    }

    const skills = SlashCommandState.skillsCache[agentKey] || [];
    const typed = input.value.slice(1);
    const token = typed.split(/\s/)[0].toLowerCase();

    // Typing whitespace after a complete skill slug activates it directly
    if (/\s/.test(typed)) {
        const exactSkill = skills.find(s => s.slug.toLowerCase() === token);
        if (exactSkill) {
            activateSkill(exactSkill);
        } else {
            closeSkillCommandMenu();
        }
        return;
    }

    SlashCommandState.visibleSkills = skills.filter(s => s.slug.toLowerCase().includes(token));
    SlashCommandState.highlightedIndex = 0;
    SlashCommandState.isOpen = true;
    renderSkillCommandMenu();
}

// Returns true when the keystroke was consumed by the skill dropdown
function handleSlashCommandKeydown(event) {
    if (!SlashCommandState.isOpen) {
        return false;
    }

    switch (event.key) {
        case "ArrowDown":
        case "ArrowUp": {
            const count = SlashCommandState.visibleSkills.length;
            if (count > 0) {
                const delta = event.key === "ArrowDown" ? 1 : -1;
                SlashCommandState.highlightedIndex = (SlashCommandState.highlightedIndex + delta + count) % count;
                renderSkillCommandMenu();
            }
            event.preventDefault();
            return true;
        }
        case "Enter":
        case "Tab": {
            event.preventDefault();
            const skill = SlashCommandState.visibleSkills[SlashCommandState.highlightedIndex];
            if (skill) {
                activateSkill(skill);
            } else {
                closeSkillCommandMenu();
            }
            return true;
        }
        case "Escape":
            event.preventDefault();
            closeSkillCommandMenu();
            return true;
        default:
            return false;
    }
}

function activateSkill(skill) {
    SlashCommandState.activeSkill = skill;
    closeSkillCommandMenu();

    const input = AI_DOM.chatInput;
    if (input && input.value.startsWith("/")) {
        // Strip the typed slash command, keep any text entered after it
        const typed = input.value.slice(1);
        const firstSpace = typed.search(/\s/);
        input.value = firstSpace === -1 ? "" : typed.slice(firstSpace + 1);
        autoResizeChatInput();
    }

    renderActiveSkillBar();
    if (input) {
        input.focus();
    }
}

function clearActiveSkill() {
    SlashCommandState.activeSkill = null;
    renderActiveSkillBar();
}

function renderActiveSkillBar() {
    const bar = AI_DOM.activeSkillBar;
    if (!bar) {
        return;
    }

    const skill = SlashCommandState.activeSkill;
    if (!skill) {
        bar.innerHTML = "";
        bar.classList.add("hidden");
        return;
    }

    bar.classList.remove("hidden");
    bar.innerHTML = `<span class="skill-chip" title="${EC_Fmt.HTMLEncode(skill.name)}">`
        + `<i class="skill-chip-icon ews-icon-spark"></i>`
        + `<span class="skill-chip-name">/${EC_Fmt.HTMLEncode(skill.slug)}</span>`
        + `<i class="skill-chip-remove ews-icon-close" title="Remove skill"></i>`
        + `</span>`;

    bar.querySelector(".skill-chip-remove").addEventListener("click", () => {
        clearActiveSkill();
        const input = AI_DOM.chatInput;
        if (input) {
            input.focus();
        }
    });
}

// Resolves the skill to send: either the chip the user picked, or a full "/skill-slug"
// typed directly into the input without selecting from the dropdown.
function resolveActiveSkillForSend(text, aiAgentValue) {
    if (SlashCommandState.activeSkill) {
        return { skill: SlashCommandState.activeSkill, text };
    }

    if (!EC_Fmt.isNull(text) && text.startsWith("/") && EC_Fmt.Null2ZeroInt(aiAgentValue) > 0) {
        const skills = SlashCommandState.skillsCache[String(EC_Fmt.Null2ZeroInt(aiAgentValue))] || [];
        const typed = text.slice(1);
        const firstSpace = typed.search(/\s/);
        const token = (firstSpace === -1 ? typed : typed.slice(0, firstSpace)).toLowerCase();
        const matchedSkill = skills.find(s => s.slug.toLowerCase() === token);
        if (matchedSkill) {
            return { skill: matchedSkill, text: firstSpace === -1 ? "" : typed.slice(firstSpace + 1).trim() };
        }
    }

    return { skill: null, text };
}

// EC-31344: rebuild the conversation tab list from a payload (bootstrap response or cache).
function renderConversationTabs(conversations) {
    const list = Array.isArray(conversations) ? conversations : [];
    AI_DOM.chatGroup.innerHTML = "";

    for (let i = 0; i < list.length; i++) {
        const chatInfo = list[i];
        const chatEle = ConversationTabManager._createTabElement(chatInfo.AIAgentID, chatInfo.Conversation, chatInfo.ConversationID);
        AI_DOM.chatGroup.appendChild(chatEle);
    }
}

async function AutoSelectAgentForPrompt(promptText) {
    const trimmedPrompt = promptText.trim();
    if (EC_Fmt.isNull(trimmedPrompt)) {
        throw new Error("Please enter a message before auto-selecting an agent.");
    }

    const req = new ECP.EC_Request("AIAgent_AutoSelect");
    req.SetReturnType(ECP.EC_ReturnType.Json);
    req.AddRequestVariable("Prompt", trimmedPrompt);

    let response;
    try {
        response = await req.Submit(12);
    } catch (error) {
        const errorMessage = String(error && error.message ? error.message : error || "").toLowerCase();
        const isTimeoutError = errorMessage.includes("request timed out") || errorMessage.includes("request timeout") || errorMessage.includes("timeout") || errorMessage.includes("exceeded the timeout limit");
        if (isTimeoutError) {
            return "";
        }

        throw new Error(error && error.message ? error.message : String(error));
    }

    function IsAutoSelectTimeoutResponse(autoSelectResponse) {
        if (!autoSelectResponse || !Array.isArray(autoSelectResponse.errors) || autoSelectResponse.errors.length === 0) {
            return false;
        }

        for (let i = 0; i < autoSelectResponse.errors.length; i++) {
            const errorItem = autoSelectResponse.errors[i] || {};
            const title = String(errorItem.title || "").toLowerCase();
            const detail = String(errorItem.detail || "").toLowerCase();
            if (title.includes("timeout") || detail.includes("timeout") || detail.includes("exceeded the timeout limit")) {
                return true;
            }
        }

        return false;
    }

    if (IsAutoSelectTimeoutResponse(response)) {
        return "";
    }

    if (response && response.Error) {
        throw new Error(response.Error);
    }

    if (response && Array.isArray(response.errors) && response.errors.length > 0) {
        const firstError = response.errors[0];
        throw new Error(firstError.detail || firstError.title || "Unable to auto-select an agent for this prompt.");
    }

    const aiAgentID = response ? String(response.AIAgentID || "") : "";
    if (EC_Fmt.Null2ZeroInt(aiAgentID) <= 0) {
        throw new Error("Unable to auto-select an agent for this prompt.");
    }

    SetSelectedAgent(aiAgentID);
    await showAgentPromptIfNeeded();
    return aiAgentID;
}

async function RenameConversationTitle(conversationId, aiAgentId, conversationTitle) {
    const trimmedTitle = conversationTitle.trim();
    if (EC_Fmt.isNull(trimmedTitle)) {
        throw new Error("Conversation title cannot be empty.");
    }

    const req = new ECP.EC_Request("AIAgent_RenameConversation");
    req.SetReturnType(ECP.EC_ReturnType.Text);
    req.AddRequestVariable("ConversationID", conversationId);
    req.AddRequestVariable("AIAgentID", aiAgentId || "");
    req.AddRequestVariable("ConversationTitle", trimmedTitle.substring(0, ConversationTabManager.MaxTitleLength));

    try {
        const responseText = await req.Submit();
        const data = typeof responseText === "string" ? JSON.parse(responseText) : responseText;

        if (data && data.Error) {
            throw new Error(data.Error);
        }

        // EC-31344: title changed server-side, so the cached conversation list is stale.
        clearAgentCache("volatile");

        return data && data.Conversation ? data.Conversation : trimmedTitle;
    } catch (error) {
        let errorMessage = "Unable to rename conversation.";

        if (error && error.message) {
            errorMessage = error.message;

            try {
                const errorData = JSON.parse(error.message);
                if (errorData && errorData.Error) {
                    errorMessage = errorData.Error;
                }
            } catch (parseError) {
                // Keep the original message when it is not JSON.
            }
        }

        throw new Error(errorMessage);
    }
}

async function HandleChatGroupClick(event) {
    if (event.target.closest(".chat-title-edit") || event.target.closest(".chat-title-input")) {
        return;
    }

    const target = event.target.closest("ecp-subtab-item");
    if (!target || target.dataset.editingTitle === "true") return;

    const conversationId = target.getAttribute("ConversationID");
    const aiAgentId = target.getAttribute("AIAgentID");
    if (!conversationId) return;

    setSidebarHistoryTab("chat-history");

    EC_Fmt.SetLocalStorageValue(`${Distributor}_${UserID}_conversationid`, conversationId);

    cancelActiveRequest();
    resetReliabilityUI();

    ConversationTabManager.clearSelection();
    target.setAttribute("selected", "");

    if (aiAgentId) {
        SetSelectedAgent(aiAgentId);
        await LoadPromptTemplates();
    }

    setPromptPanelCollapsed(true);

    const chatPanel = new ChatPanel(conversationId);
    chatPanel.element.setAttribute("AIAgentID", aiAgentId);
    chatPanel.show();

    chatPanel.element.innerHTML = "";
    await GetConversationHistory(conversationId, chatPanel);
}

async function ResumeConversationIfNeeded(conversationId) {
    if (EC_Fmt.isNull(conversationId)) {
        return;
    }

    const target = ConversationTabManager.getTab(conversationId);
    if (!target) {
        return;
    }

    await HandleChatGroupClick({ target });
}

function parseHistoricalToolMetadataJson(text, jsonStartIndex) {
    if (jsonStartIndex < 0 || jsonStartIndex >= text.length || text[jsonStartIndex] !== "{") {
        return null;
    }

    let depth = 0;
    let inString = false;
    let escaped = false;

    for (let i = jsonStartIndex; i < text.length; i++) {
        const char = text[i];

        if (escaped) {
            escaped = false;
            continue;
        }

        if (inString) {
            if (char === "\\") {
                escaped = true;
            } else if (char === '"') {
                inString = false;
            }
            continue;
        }

        if (char === '"') {
            inString = true;
            continue;
        }

        if (char === "{") {
            depth++;
        } else if (char === "}") {
            depth--;
            if (depth === 0) {
                return {
                    rawMetadata: text.slice(jsonStartIndex, i + 1),
                    nextIndex: i + 1
                };
            }
        }
    }

    return {
        rawMetadata: text.slice(jsonStartIndex).trim(),
        nextIndex: text.length
    };
}

function parseHistoricalToolMetadataString(text, startIndex) {
    if (startIndex < 0 || startIndex >= text.length) {
        return null;
    }

    const quoteChar = text[startIndex];
    if (quoteChar !== '"' && quoteChar !== "'") {
        return null;
    }

    let value = "";
    let escaped = false;

    for (let i = startIndex + 1; i < text.length; i++) {
        const char = text[i];
        if (escaped) {
            switch (char) {
                case "n":
                    value += "\n";
                    break;
                case "r":
                    value += "\r";
                    break;
                case "t":
                    value += "\t";
                    break;
                default:
                    value += char;
                    break;
            }
            escaped = false;
            continue;
        }

        if (char === "\\") {
            escaped = true;
            continue;
        }

        if (char === quoteChar) {
            return {
                value,
                nextIndex: i + 1
            };
        }

        value += char;
    }

    return {
        value,
        nextIndex: text.length
    };
}

function parseHistoricalToolMetadataObject(rawMetadata) {
    if (EC_Fmt.isNull(rawMetadata)) {
        return null;
    }

    const metadataText = String(rawMetadata).trim();
    const metadata = {};
    let cursor = metadataText.startsWith("{") ? 1 : 0;

    while (cursor < metadataText.length) {
        while (cursor < metadataText.length && (metadataText[cursor] === "," || /\s/.test(metadataText[cursor]))) {
            cursor++;
        }

        if (cursor >= metadataText.length || metadataText[cursor] === "}") {
            break;
        }

        const keyResult = parseHistoricalToolMetadataString(metadataText, cursor);
        if (!keyResult || EC_Fmt.isNull(keyResult.value)) {
            break;
        }

        cursor = keyResult.nextIndex;
        while (cursor < metadataText.length && /\s/.test(metadataText[cursor])) {
            cursor++;
        }

        if (cursor >= metadataText.length || metadataText[cursor] !== ":") {
            break;
        }

        cursor++;
        while (cursor < metadataText.length && /\s/.test(metadataText[cursor])) {
            cursor++;
        }

        let value;
        if (cursor < metadataText.length && (metadataText[cursor] === '"' || metadataText[cursor] === "'")) {
            const valueResult = parseHistoricalToolMetadataString(metadataText, cursor);
            if (!valueResult) {
                break;
            }

            value = valueResult.value;
            cursor = valueResult.nextIndex;
        } else {
            const valueStartIndex = cursor;
            while (cursor < metadataText.length && metadataText[cursor] !== "," && metadataText[cursor] !== "}") {
                cursor++;
            }
            value = metadataText.slice(valueStartIndex, cursor).trim();
        }

        metadata[keyResult.value] = value;

        while (cursor < metadataText.length && /\s/.test(metadataText[cursor])) {
            cursor++;
        }

        if (cursor < metadataText.length && metadataText[cursor] === ",") {
            cursor++;
        }
    }

    return Object.keys(metadata).length > 0 ? metadata : null;
}

function findHistoricalToolMetadataEntry(parameterText, toolNames, toolIndex, searchStartIndex) {
    const toolPrefix = `${toolNames[toolIndex]} `;
    const entryStartIndex = parameterText.indexOf(toolPrefix, searchStartIndex);
    if (entryStartIndex < 0) {
        return null;
    }

    const valueStartIndex = entryStartIndex + toolPrefix.length;
    let entryEndIndex = parameterText.length;
    for (let i = toolIndex + 1; i < toolNames.length; i++) {
        const nextEntryIndex = parameterText.indexOf(` | ${toolNames[i]} `, valueStartIndex);
        if (nextEntryIndex >= 0 && nextEntryIndex < entryEndIndex) {
            entryEndIndex = nextEntryIndex;
        }
    }

    return {
        rawMetadata: parameterText.slice(valueStartIndex, entryEndIndex).trim(),
        nextIndex: entryEndIndex < parameterText.length && parameterText.startsWith(" | ", entryEndIndex)
            ? entryEndIndex + 3
            : entryEndIndex
    };
}

function parseHistoricalToolMetadata(toolNames, serializedParameters) {
    const metadata = Array.isArray(toolNames) ? toolNames.map(() => null) : [];
    if (!Array.isArray(toolNames) || toolNames.length === 0 || EC_Fmt.isNull(serializedParameters)) {
        return metadata;
    }

    const parameterText = decodeFromDbValue(String(serializedParameters).trim());
    let cursor = 0;

    for (let i = 0; i < toolNames.length && cursor < parameterText.length; i++) {
        const entry = findHistoricalToolMetadataEntry(parameterText, toolNames, i, cursor);
        if (!entry || EC_Fmt.isNull(entry.rawMetadata)) {
            continue;
        }

        let parsedMetadata;

        const parsedJson = parseHistoricalToolMetadataJson(entry.rawMetadata, 0);
        if (parsedJson && parsedJson.rawMetadata === entry.rawMetadata) {
            try {
                parsedMetadata = JSON.parse(parsedJson.rawMetadata);
            } catch {
                parsedMetadata = parseHistoricalToolMetadataObject(entry.rawMetadata);
            }
        } else {
            parsedMetadata = parseHistoricalToolMetadataObject(entry.rawMetadata);
        }

        metadata[i] = parsedMetadata || {
            Parameters: entry.rawMetadata
        };

        cursor = entry.nextIndex;
    }

    return metadata;
}

async function GetConversationHistory(conversationId, chatPanel) {
    if (EC_Fmt.isNull(conversationId)) {
        ECP.Dialog.Alert("ConversationID is missing");
        return;
    }

    const req = new ECP.EC_Request("AIAgent_GetConversationHistory");
    req.SetReturnType(ECP.EC_ReturnType.Json);
    req.AddRequestVariable("ConversationID", conversationId);

    try {
        const history = await req.Submit();

        if (!Array.isArray(history) || history.length === 0) {
            chatPanel.addMessage("assistant", "No conversation history found.", new Date().toISOString());
            return;
        }

        // Build a lookup of sub-agent messages (ConversationType === 1) keyed by AIAgentID
        const subAgentMessages = new Map();
        history.forEach((item) => {
            if (item.ConversationType === 1 && item.AIAgentID) {
                if (!subAgentMessages.has(item.AIAgentID)) {
                    subAgentMessages.set(item.AIAgentID, []);
                }
                subAgentMessages.set(item.AIAgentID, subAgentMessages.get(item.AIAgentID).concat(item));
            }
        });

        // Render only parent messages (ConversationType === 0 or unset)
        // Approval pauses now keep the same turn row (tools tracked in AIAgentMessageTools), so the
        // consolidated message already carries the full tool history. Legacy conversations may still
        // contain separate approval-pending rows (ConversationType === 2): they are not displayed, but
        // any tool calls they report are merged into the next normal message's tool history, with the
        // overlapping tool deduplicated.
        let pendingApprovalTools = []; // tool names carried forward from approval messages
        let pendingApprovalMetadata = []; // tool metadata carried forward from approval messages

        history.forEach((item) => {
            // Skip sub-agent messages — they only contribute tool calls to the parent
            if (item.ConversationType === 1) return;

            // Approval messages: collect their tool calls but don't render as a visible message
            if (item.ConversationType === 2) {
                if (item.ToolsCalls && item.ToolsCalls.trim()) {
                    const tools = item.ToolsCalls.split(",").map(t => t.trim()).filter(t => t);
                    const metadata = parseHistoricalToolMetadata(tools, item.ToolCallParameters);
                    pendingApprovalTools = pendingApprovalTools.concat(tools);
                    pendingApprovalMetadata = pendingApprovalMetadata.concat(metadata);
                }
                return;
            }

            if (item.Prompt) {
                const userMsg = chatPanel.addMessage("user", decodeFromDbValue(item.Prompt), item.TimeCreated);
                if (item.FileAttachments && item.FileAttachments.length > 0) {
                    userMsg.showFileAttachments(item.FileAttachments);
                }
            }
            if (item.Response) {
                const msg = chatPanel.addMessage("assistant", decodeFromDbValue(item.Response), item.TimeCreated);
                if (item.AIAgentMessageID) {
                    msg.aiAgentMessageID = item.AIAgentMessageID;
                }
                if (item.Sentiment != null && item.Sentiment !== "") {
                    msg._restoreFeedback(parseInt(item.Sentiment, 10), item.FeedbackText, item.AIAgentMessageFeedbackID);
                }

                // Merge any pending approval tool calls with this message's tool calls
                let toolNames = [];
                let toolMetadata = [];
                if (pendingApprovalTools.length > 0) {
                    toolNames = toolNames.concat(pendingApprovalTools);
                    toolMetadata = toolMetadata.concat(pendingApprovalMetadata);
                    pendingApprovalTools = [];
                    pendingApprovalMetadata = [];
                }
                if (item.ToolsCalls && item.ToolsCalls.trim()) {
                    let msgTools = item.ToolsCalls.split(",").map(t => t.trim()).filter(t => t);
                    let msgMetadata = parseHistoricalToolMetadata(msgTools, item.ToolCallParameters);
                    // Deduplicate: if the last approval tool matches the first tool on this message, skip the duplicate
                    if (toolNames.length > 0 && msgTools.length > 0 && toolNames[toolNames.length - 1] === msgTools[0]) {
                        msgTools = msgTools.slice(1);
                        msgMetadata = msgMetadata.slice(1);
                    }
                    toolNames = toolNames.concat(msgTools);
                    toolMetadata = toolMetadata.concat(msgMetadata);
                }

                // Display tool calls for historical messages
                if (toolNames.length > 0) {
                    // Separate regular tools from sub-agent entries
                    const regularTools = [];
                    const regularMetadata = [];
                    const subAgentEntries = []; // { toolName, aiAgentId }
                    toolNames.forEach((name, index) => {
                        const metadata = toolMetadata[index] || null;
                        const subAgentMatch = name.match(/^SubAgent\.(.+?)_(\d+)$/);
                        if (subAgentMatch) {
                            subAgentEntries.push({
                                toolName: name,
                                displayName: subAgentMatch[1],
                                aiAgentId: parseInt(subAgentMatch[2], 10)
                            });
                        } else {
                            regularTools.push(name);
                            regularMetadata.push(metadata);
                        }
                    });

                    // Add regular tool calls
                    if (regularTools.length > 0) {
                        msg.addToolCalls(regularTools, true, regularMetadata);
                    }

                    // Add sub-agent entries with their nested tool calls
                    subAgentEntries.forEach((entry) => {
                        msg.createSubAgent(entry.aiAgentId, entry.displayName);
                        const subMsgs = subAgentMessages.get(entry.aiAgentId) || [];
                        subMsgs.forEach((subItem) => {
                            if (subItem.ToolsCalls && subItem.ToolsCalls.trim()) {
                                const subTools = subItem.ToolsCalls.split(",").map(t => t.trim()).filter(t => t);
                                const subMetadata = parseHistoricalToolMetadata(subTools, subItem.ToolCallParameters);
                                if (subTools.length > 0) {
                                    msg.addSubAgentToolCalls(entry.aiAgentId, subTools, subMetadata);
                                }
                            }
                        });
                        msg.markSubAgentCompleted(entry.aiAgentId);
                    });

                    msg.markToolsComplete();
                }
            }
        });

        chatPanel.scrollToBottom();
    } catch (err) {
        chatPanel.addMessage("assistant", `❌ Failed to load history: ${err.message}`, new Date().toISOString());
    }
}

function decodeFromDbValue(text) {
    let decoded = text;
    decoded = decoded.replace(/<br\s*\/?>/gi, "\n");
    decoded = decoded.replace(/&#94;/g, "^");
    decoded = decoded.replace(/&#124;/g, "|");
    decoded = decoded.replace(/&#126;/g, "~");
    decoded = decoded.replace(/&#96;/g, "`");
    return decoded;
}

function renderTableEditComparison(changeData) {
    if (!changeData || !changeData.Changes || changeData.Changes.length === 0) {
        return "";
    }

    const changes = changeData.Changes;
    const recordIdentifier = changeData.RecordIdentifier || "";
    // EC-31437: an add previews the values being written (After only); there is no saved record yet, so
    // there is no Before column and no record to link to.
    const isAdd = changeData.IsAdd === true;
    const moreFieldCount = changeData.MoreFieldCount || 0;
    const keyValue = changes[0].KeyValue;
    const hasRecordLink = !isAdd && !EC_Fmt.isNull(keyValue);
    const columnCount = isAdd ? 2 : 3;
    const cellStyle = "padding:12px 16px";
    const headerCellStyle = "padding:12px 16px;text-align:left;font-weight:var(--semibold-weight);color:var(--text-secondary);border-bottom:1px solid var(--divider)";

    let tableRows = "";
    changes.forEach((change) => {
        const fieldName = ToolsTimeline._escapeHtml(change.Field || "");
        const afterValue = formatComparisonValue(change.After);

        if (isAdd) {
            tableRows += `
<tr style="border-bottom:1px solid var(--divider)">
 <td style="${cellStyle};font-weight:var(--semibold-weight)">${fieldName}</td>
 <td style="${cellStyle}">${afterValue}</td>
</tr>
            `;
        } else {
            const beforeValue = formatComparisonValue(change.Before);
            tableRows += `
<tr style="border-bottom:1px solid var(--divider)">
 <td style="${cellStyle};font-weight:var(--semibold-weight)">${fieldName}</td>
 <td style="${cellStyle};color:var(--text-secondary)">${beforeValue}</td>
 <td style="${cellStyle};font-weight:var(--semibold-weight)">${afterValue}</td>
</tr>
            `;
        }
    });

    if (moreFieldCount > 0) {
        tableRows += `
<tr>
 <td colspan="${columnCount}" style="${cellStyle};color:var(--text-secondary);font-style:italic">+ ${moreFieldCount} more field${moreFieldCount === 1 ? "" : "s"}</td>
</tr>
        `;
    }

    let identifierHtml = "";
    if (recordIdentifier) {
        const escapedIdentifier = ToolsTimeline._escapeHtml(recordIdentifier);
        // Encode each query-string value separately (keeping the literal ~ separator) so a text primary
        // key or table/field name containing a quote or & can never break out of the href attribute.
        const recordHref = `Home?DashboardID=100100&TableName=${encodeURIComponent(changes[0].TableName)}&Search=${encodeURIComponent(changes[0].KeyField)}~${encodeURIComponent(keyValue)}`;
        const identifierBody = hasRecordLink
            ? `<a href="${recordHref}" style="color:var(--text-link);text-decoration:none">${escapedIdentifier}</a>`
            : escapedIdentifier;
        identifierHtml = `<div style="margin-bottom:12px;margin-left:20px;font-weight:600">${identifierBody}</div>`;
    }

    const valueHeaders = isAdd
        ? `<th style="${headerCellStyle}">Value</th>`
        : `<th style="${headerCellStyle}">Before</th>
    <th style="${headerCellStyle}">After</th>`;

    return `
<div style=margin-top:16px>
 ${identifierHtml}
 <table style="width:100%;border-collapse:collapse;border:1px solid var(--divider);border-radius:6px;overflow:hidden;background:var(--layer-2)">
  <thead>
   <tr style="background:var(--bg-object)">
    <th style="${headerCellStyle}">Field</th>
    ${valueHeaders}
   </tr>
  </thead>
  <tbody>
   ${tableRows}
  </tbody>
 </table>
</div>
    `;
}

function formatComparisonValue(value) {
    if (value === null || value === undefined || value === "") {
        return '<span class="empty-value">—</span>';
    }

    // Check if the value is a status badge (object with text and color)
    if (typeof value === "object" && value.text && value.color) {
        return `<ecp-chip color="${value.color}">${value.text}</ecp-chip>`;
    }

    // Check if value should be rendered as a chip/badge (contains color info)
    if (typeof value === "string" && value.includes("[chip:")) {
        const match = value.match(/\[chip:(\w+)\](.*?)\[\/chip\]/);
        if (match) {
            const color = match[1];
            const text = match[2];
            return `<ecp-chip color="${color}">${text}</ecp-chip>`;
        }
    }

    // Return plain text, escaped for security
    return String(value).replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

function capturePageContext() {
    const MAX_LENGTH = 30000;
    const parts = [];

    // Page parameters
    const pageParams = {};
    ["DashboardID", "TableName", "Search", "Parameters", "SelectSort"].forEach((key) => {
        const val = EC_Fmt.GetPageParameter(key);
        if (!EC_Fmt.isNull(val)) pageParams[key] = val;
    });
    if (Object.keys(pageParams).length > 0) {
        parts.push(`[Page] ${Object.entries(pageParams).map(([k, v]) => `${k}=${v}`).join(", ")}`);
    }

    // Page title — use document.title (browser tab) to avoid picking up injected buttons
    if (document.title) parts.push(`[Title] ${document.title.trim()}`);

    // Track which dashboard items have been fully handled to skip in the generic fallback
    const processedDashboardItems = new Set();

    // Dashboard-level filter bar (specific dashboards with ActionField/ActionLabel inputs)
    const dashboardFilterBar = document.querySelector(".dashboard-filter");
    if (dashboardFilterBar) {
        const filters = [];
        dashboardFilterBar.querySelectorAll(".ActionField").forEach((field) => {
            const label = field.querySelector(".ActionLabel")?.innerText?.trim() || "";
            const input = field.querySelector("input[name]:not([type=hidden]), select[name], ecp-auto-complete[name], ecp-input[name]");
            if (!input) return;
            const value = input.value || input.getAttribute("value") || "";
            if (!EC_Fmt.isNull(value)) filters.push(`${label || input.getAttribute("name")}=${value}`);
        });
        if (filters.length > 0) parts.push(`[DashboardFilters] ${filters.join(", ")}`);
    }

    // Table grid data (supports multiple ecp-tableview elements on the same page)
    document.querySelectorAll("ecp-tableview").forEach((ecpTableView) => {
        const tableEl = ecpTableView.querySelector("#TableView, #TableEdit");
        if (!tableEl) return;

        const tableName = tableEl.getAttribute("tableName") || "";
        const dashboardItem = ecpTableView.closest("[item-type]");

        if (tableEl.hasAttribute("singleRecord")) {
            // Single record detail view: emit a single [Record] tag so the agent knows
            // this is not a grid/list — omit the [Table] tag entirely to avoid confusion.
            const pageTitle = tableEl.querySelector(".tv_pageTitle")?.innerText?.trim() || "";
            parts.push(`[Record:${tableName}] ${pageTitle}`);
            tableEl.querySelectorAll("tr").forEach((tr) => {
                const titleCell = tr.querySelector("td.title");
                if (!titleCell) return;
                const tds = tr.querySelectorAll("td");
                if (tds.length < 2) return;
                const label = titleCell.innerText.trim();
                // Last td is the value (handles copy view which has an extra origin td)
                const value = tds[tds.length - 1].innerText.trim().replace(/\s+/g, " ");
                if (label && value) parts.push(`${label}: ${value}`);
            });
        } else {
            const tableKey = tableEl.getAttribute("TableKey") || "";
            const widgetTitle = dashboardItem?.querySelector(".header")?.innerText?.trim() || "";
            if (widgetTitle) {
                parts.push(`[Table] ${widgetTitle} (${tableName}${tableKey ? `, key: ${tableKey}` : ""})`);
            } else if (tableName) {
                parts.push(`[Table] ${tableName}${tableKey ? ` (key: ${tableKey})` : ""}`);
            }
            const headers = [];
            tableEl.querySelectorAll("thead th").forEach((th) => {
                const text = th.innerText.trim();
                if (text && !th.classList.contains("link-icon-column")) headers.push(text);
            });
            if (headers.length > 0) parts.push(`[Columns] ${headers.join(" | ")}`);

            const rows = tableEl.querySelectorAll("tbody > tr");
            let rowCount = 0;
            rows.forEach((tr) => {
                if (rowCount >= 50) return;
                const cells = [];
                tr.querySelectorAll("td:not(.link-icon-column)").forEach((td) => {
                    cells.push(td.innerText.trim().replace(/\s+/g, " "));
                });
                const rowText = cells.join(" | ");
                if (rowText) {
                    parts.push(`[Row] ${rowText}`);
                    rowCount++;
                }
            });
            if (rows.length > 50) parts.push(`[...${rows.length - 50} more rows]`);
        }

        if (dashboardItem) processedDashboardItems.add(dashboardItem);
    });

    // Report data (supports multiple FusionTables on the same page)
    document.querySelectorAll("table.FusionTable").forEach((fusionTable) => {
        const dashboardItem = fusionTable.closest("[item-type]");
        const container = dashboardItem || document;
        const widgetTitle = dashboardItem?.querySelector(".header")?.innerText?.trim() || "";

        const reportName = container.querySelector("#CheckReportName");
        const reportTable = container.querySelector("#ReportTableName");
        const label = widgetTitle || (reportName?.value) || "";
        if (label) parts.push(`[Report] ${label}`);
        if (reportTable?.value) parts.push(`[ReportTable] ${reportTable.value}`);

        const filterForm = container.querySelector("form.ecp-fusion-pinned-override");
        if (filterForm) {
            const filters = [];
            filterForm.querySelectorAll("input[name], select[name], ecp-input[name], ecp-auto-complete[name]").forEach((el) => {
                const name = el.getAttribute("name") || "";
                if (!name || el.type === "hidden") return;
                const value = el.value || el.getAttribute("value") || "";
                if (!EC_Fmt.isNull(value)) filters.push(`${name}=${value}`);
            });
            if (filters.length > 0) parts.push(`[Filters] ${filters.join(", ")}`);
        }

        const reportHeaders = [];
        fusionTable.querySelectorAll("thead tr:last-child th").forEach((th) => {
            const text = th.innerText.trim();
            if (text) reportHeaders.push(text);
        });
        if (reportHeaders.length > 0) parts.push(`[Columns] ${reportHeaders.join(" | ")}`);

        const reportRows = fusionTable.querySelectorAll("tbody > tr");
        let reportRowCount = 0;
        reportRows.forEach((tr) => {
            if (reportRowCount >= 50) return;
            const cells = [];
            tr.querySelectorAll("td").forEach((td) => {
                cells.push(td.innerText.trim().replace(/\s+/g, " "));
            });
            const rowText = cells.join(" | ");
            if (rowText) {
                parts.push(`[Row] ${rowText}`);
                reportRowCount++;
            }
        });
        if (reportRows.length > 50) parts.push(`[...${reportRows.length - 50} more rows]`);

        if (container.querySelector("svg.ews-chart")) {
            parts.push("[Chart] Report contains chart visualization");
        }

        if (dashboardItem) processedDashboardItems.add(dashboardItem);
    });

    // Other dashboard widgets — generic text extraction for anything not already handled above
    const dashboard = document.querySelector("div.ews-dashboard");
    if (dashboard) {
        dashboard.querySelectorAll("[item-type]").forEach((item) => {
            if (processedDashboardItems.has(item)) return;
            const itemType = item.getAttribute("item-type") || "";

            // Omni-Filters widget: capture active filter values using filter-alias labels
            if (itemType === "Omni-Filters") {
                const filters = [];
                item.querySelectorAll("[filter-alias]").forEach((el) => {
                    const alias = el.getAttribute("filter-alias") || "";
                    const value = el.value || el.getAttribute("value") || "";
                    if (alias && !EC_Fmt.isNull(value)) filters.push(`${alias}=${value}`);
                });
                if (filters.length > 0) parts.push(`[DashboardFilters] ${filters.join(", ")}`);
                return;
            }

            const widgetTitle = item.querySelector(".header")?.innerText?.trim() || "";
            const contentEl = item.querySelector(".content");
            const widgetText = contentEl ? contentEl.innerText.replace(/\s+/g, " ").trim().substring(0, 500) : "";
            if (widgetTitle || widgetText) {
                parts.push(`[Widget:${itemType}] ${widgetTitle}${widgetText ? `: ${widgetText}` : ""}`);
            }
        });
    }

    // Form fields (non-dashboard detail pages)
    const formFields = [];
    document.querySelectorAll("#Content ecp-input, #Content input[name], #Content select[name], #Content textarea[name]").forEach((el) => {
        const name = el.getAttribute("name") || el.getAttribute("reffield") || "";
        if (!name) return;
        const value = el.value || el.getAttribute("value") || "";
        if (!EC_Fmt.isNull(value)) formFields.push(`${name}=${value}`);
    });
    if (formFields.length > 0) parts.push(`[Fields] ${formFields.join(", ")}`);

    // Section headers
    const sections = [];
    document.querySelectorAll("#Content ecp-section").forEach((sec) => {
        const heading = sec.getAttribute("heading") || sec.getAttribute("title") || "";
        if (heading) sections.push(heading);
    });
    if (sections.length > 0) parts.push(`[Sections] ${sections.join(", ")}`);

    let result = parts.join("\n");
    if (result.length > MAX_LENGTH) {
        result = `${result.substring(0, MAX_LENGTH)}...`;
    }
    return result;
}

async function ReceiveServerSentEvents(thinkingMsg, userMessage, chatPanel, runContext = null) {
    const showSQL = getEnableLoggingEnabled() ? "&EnableLogging=true" : "";
    const usePlanFirst = getPlanFirstEnabled();
    const forcePlanFirst = userMessage && userMessage.forcePlanFirst === true;
    const executePlan = userMessage && userMessage.executePlan === true;
    const shouldUsePlanFirst = usePlanFirst || forcePlanFirst || WaitingForApprovePlanFirst || executePlan;
    const aiAgentInput = document.getElementById("aiagentInput");
    let aiAgentID = "";
    if (runContext && runContext.sessionAiAgentID) {
        aiAgentID = String(runContext.sessionAiAgentID);
    } else if (aiAgentInput) {
        aiAgentID = aiAgentInput.value;
    }
    const Prompt = userMessage.content;
    const conversationId = chatPanel.element.getAttribute("ConversationID");

    let requestUrl = `api?APICommand=AIAgent_Chat&AIAgentID=${aiAgentID}&Prompt=${encodeURIComponent(Prompt)}${showSQL}`;

    if (userMessage.FileDocumentIDArr && userMessage.FileDocumentIDArr.length > 0) {
        requestUrl += `&FileDocumentIDArr=${userMessage.FileDocumentIDArr.join("^")}`;
    }

    if (EC_Fmt.Null2ZeroInt(userMessage.AIAgentSkillID) > 0) {
        requestUrl += `&AIAgentSkillID=${encodeURIComponent(userMessage.AIAgentSkillID)}`;
    }

    if (!EC_Fmt.isNull(userMessage.FunctionCallApprovalRequestID)) {
        requestUrl += `&FunctionCallApprovalRequestID=${userMessage.FunctionCallApprovalRequestID}`;
    }

    if (userMessage.FunctionCallApprovalRequestIDs && userMessage.FunctionCallApprovalRequestIDs.length > 0) {
        const idList = userMessage.FunctionCallApprovalRequestIDs.join(",");
        requestUrl += `&FunctionCallApprovalRequestIDs=${encodeURIComponent(idList)}`;
    }

    if (!EC_Fmt.isNull(userMessage.ClarificationRequestID)) {
        requestUrl += `&ClarificationRequestID=${userMessage.ClarificationRequestID}`;
    }

    if (!EC_Fmt.isNull(userMessage.ClarificationAnswer)) {
        requestUrl += `&ClarificationAnswer=${encodeURIComponent(userMessage.ClarificationAnswer)}`;
    }

    if (!chatPanel.element.hasAttribute("isTemporary") && !EC_Fmt.isNull(conversationId)) {
        requestUrl += `&ConversationID=${conversationId}`;
    }

    if (shouldUsePlanFirst && EC_Fmt.isNull(userMessage.FunctionCallApprovalRequestID) && EC_Fmt.isNull(userMessage.ClarificationRequestID)) {
        requestUrl += `&PlanFirst=True&ExecutePlan=${executePlan}`;
    }

    // EC-29098: Pass user's session toggle to suppress web search when disabled
    if (currentAgentGoogleSearchPermitted && !getGoogleSearchEnabled()) {
        requestUrl += `&EnableGoogleSearch=false`;
    }

    // EC-24893: connectors switched off for this chat; this is the one URL builder, so approval and clarification
    // resumes carry the same list as the first send
    const disabledMCPServerIDs = getDisabledMCPServerIDs();
    if (disabledMCPServerIDs.length > 0) {
        requestUrl += `&DisabledAIAgentMCPServerIDs=${encodeURIComponent(disabledMCPServerIDs.join("^"))}`;
    }

    // Build POST body for large fields that should not be in the URL
    const postBody = new URLSearchParams();

    // Final plan text from the plan editor (may include manual user edits) — the
    // execution engine uses it as the authoritative plan when executing.
    if (executePlan && !EC_Fmt.isNull(userMessage.editedPlan)) {
        postBody.set("EditedPlan", userMessage.editedPlan);
    }

    // JSON map of {FunctionCallApprovalRequestID: editedURLPattern} for approved WebGet requests.
    if (!EC_Fmt.isNull(userMessage.ApprovedURLPatterns)) {
        postBody.set("ApprovedURLPatterns", userMessage.ApprovedURLPatterns);
    }

    const selectedPermissions = GetSelectedPermissions();
    if (selectedPermissions) postBody.set("PermissionList", selectedPermissions);
    const aiAgentEvalID = userMessage.AIAgentEvalID || thinkingMsg.aiAgentEvalID || 0;
    const evalAIModelID = userMessage.EvalAIModelID || thinkingMsg.evalAIModelID || 0;
    if (aiAgentEvalID) postBody.set("AIAgentEvalID", String(aiAgentEvalID));
    if (evalAIModelID) postBody.set("EvalAIModelID", String(evalAIModelID));

    // Capture page context when the URL has changed since last send (first message,
    // JS history updates like TableView single-record navigation, and browser back/forward).
    const usePageContext = getIncludePageContextEnabled();
    if (AgentUIContext.mode === "sidepanel" && usePageContext) {
        const currentUrl = window.location.href;
        if (currentUrl !== lastSentPageContextUrl) {
            const pageContext = capturePageContext();
            if (pageContext) {
                postBody.set("PageContext", pageContext);
                lastSentPageContextUrl = currentUrl;
            }
        }
    }

    await handleStreamingResponse(requestUrl, postBody, thinkingMsg, chatPanel, aiAgentID, runContext);
}

// Mark tools timeline as complete (called when response starts or done event)
function finalizeToolsDisplay(thinkingMsg) {
    thinkingMsg.stopThinking();
    thinkingMsg.markToolsComplete();
}

async function handleStreamingResponse(requestUrl, postBody, thinkingMsg, chatPanel, aiAgentID, runContext = null) {
    const controller = new AbortController();
    const runState = runContext && runContext.runState ? runContext.runState : null;
    const isReliabilityRun = !!runState;

    if (isReliabilityRun) {
        runState.streamController = controller;
    } else {
        activeAIRequestState.abortController = controller;
    }

    let requestTimedOut = false;
    const requestTimeoutHandle = setTimeout(() => {
        requestTimedOut = true;
        controller.abort();
    }, AI_AGENT_STREAM_REQUEST_TIMEOUT_MS);

    let displayed = "";
    let hasTools = false;
    let chunkCompleted = false;
    let planReadyReceived = false;
    // Accumulated approval events — processed after the stream ends so all boxes show at once
    const pendingApprovalRequests = [];
    let shouldStop = false;
    // EC-25393: a run ending on something the user must act on does not auto-send what they queued
    let approvalsShown = false;
    let clarificationShown = false;

    const afterChunkCompleted = async () => {
        finalizeToolsDisplay(thinkingMsg);
        if (Number.isFinite(thinkingMsg.responseStartedAtMs) && !Number.isFinite(thinkingMsg.responseDurationMs)) {
            thinkingMsg.responseDurationMs = Math.max(0, Date.now() - thinkingMsg.responseStartedAtMs);
        }
        if (isReliabilityRun && Number.isFinite(runState.startedAtMs) && !Number.isFinite(runState.durationMs)) {
            runState.chunkCompletedAtMs = Date.now();
            runState.durationMs = Math.max(0, runState.chunkCompletedAtMs - runState.startedAtMs);
        }
        if (thinkingMsg.aiAgentEvalID > 0 && !planReadyReceived) {
            thinkingMsg.startEvaluating();
        }
        if (!isReliabilityRun && !planReadyReceived) {
            setInputState(true);
        }
        await handlePlanFirstMessage(displayed, thinkingMsg, chatPanel, planReadyReceived);
        thinkingMsg.hydrateD3Charts();
        thinkingMsg.hydrateArtifacts();
        chunkCompleted = true;
    };

    const processEvent = async (data) => {
        if (data.Error) {
            const prefix = displayed ? `${displayed}\n\n` : "";
            const errorMessage = `${prefix}Error: ${data.Error}`;

            if (isReliabilityRun) {
                markReliabilityRunFailure(runState, errorMessage);
            } else {
                if (activeAIRequestState.abortController === controller) {
                    activeAIRequestState.abortController = null;
                    finalizeAgentActiveRequest();
                }
                thinkingMsg.stopEvaluating();
                thinkingMsg.updateContent(errorMessage);
                setInputState(true);
            }

            shouldStop = true;
            return;
        }

        switch (data.Event) {
            case "chunk":
                if (displayed === "" && hasTools) {
                    thinkingMsg.stopThinking();
                }
                displayed += data.Answer;
                thinkingMsg.updateContent(displayed, true);
                chatPanel.scrollToBottom();
                break;
            case "chunk_completed":
                if (!isReliabilityRun && data.ConversationID) {
                    handleConversationInfo(data, chatPanel, aiAgentID);
                }
                await afterChunkCompleted();
                chatPanel.scrollToBottom();
                break;
            case "plan_ready":
                planReadyReceived = true;
                thinkingMsg.stopEvaluating();
                WaitingForApprovePlanFirst = true;
                if (!isReliabilityRun) {
                    setInputState(true);
                }
                if (chunkCompleted) {
                    await handlePlanFirstMessage(displayed, thinkingMsg, chatPanel, true);
                    chatPanel.scrollToBottom();
                }
                break;
            case "function_call_approval_request":
                // Accumulate all approval groups emitted in this stream; they are shown
                // simultaneously after the stream ends so the user sees every approval box at once.
                pendingApprovalRequests.push(data);
                break;
            case "clarification_request":
                shouldStop = true;
                clarificationShown = true;
                thinkingMsg.stopEvaluating();
                finalizeToolsDisplay(thinkingMsg);
                await handleClarificationRequest(data, thinkingMsg, chatPanel, runContext);
                break;
            case "run_started":
                // EC-25393: the ID to queue against, available up front rather than only when the run finishes
                if (!isReliabilityRun && data.ConversationID) {
                    activeAIRequestState.conversationID = data.ConversationID;
                }
                break;
            case "interjection":
                markInterjectionsDelivered(data.InterjectionSequences);
                break;
            case "conversation_info":
                if (data.AIAgentMessageID) {
                    thinkingMsg.aiAgentMessageID = data.AIAgentMessageID;
                }
                if (!isReliabilityRun) {
                    handleConversationInfo(data, chatPanel, aiAgentID);
                }
                break;
            case "tool_start": {
                const toolNames = data.FunctionCallTraces || [];
                const toolMetadata = data.FunctionCallMetadata || null;
                if (displayed !== "") {
                    thinkingMsg.addPreToolThinking(displayed);
                    displayed = "";
                }
                thinkingMsg.addToolCalls(toolNames, false, toolMetadata);
                hasTools = true;
                chatPanel.scrollToBottom();
                break;
            }
            case "tool_finish":
                thinkingMsg.markCurrentToolCompleted();
                break;
            case "sub_agent_start":
                handleSubAgentStart(data, thinkingMsg, chatPanel);
                hasTools = true;
                break;
            case "sub_agent_tool_start":
                handleSubAgentToolStart(data, thinkingMsg);
                chatPanel.scrollToBottom();
                break;
            case "sub_agent_tool_finish":
                handleSubAgentToolFinish(data, thinkingMsg);
                break;
            case "sub_agent_chunk":
                handleSubAgentChunk(data, thinkingMsg);
                chatPanel.scrollToBottom();
                break;
            case "sub_agent_end":
                handleSubAgentEnd(data, thinkingMsg);
                chatPanel.scrollToBottom();
                break;
            case "done":
                thinkingMsg.stopEvaluating();
                if (!isReliabilityRun && activeAIRequestState.abortController === controller) {
                    activeAIRequestState.abortController = null;
                    finalizeAgentActiveRequest();
                }
                applyTokenUsageMetrics(data);
                // EC-31344: the run spent tokens and may have created/renamed a conversation,
                // so drop the cached volatile bootstrap to force a fresh pull on the next navigation.
                clearAgentCache("volatile");
                if (data.AIAgentMessageID) {
                    thinkingMsg.aiAgentMessageID = data.AIAgentMessageID;
                }
                if (!chunkCompleted) {
                    await afterChunkCompleted();
                }
                if (isReliabilityRun) {
                    if (thinkingMsg.aiAgentEvalID > 0 && !runState.evalResultReceived) {
                        markReliabilityRunFailure(runState, "Run completed without an eval score.");
                    } else if (!runState.completionHandled) {
                        markReliabilityRunComplete(runState);
                    }
                }
                shouldStop = true;
                break;
            case "eval_result":
                await handleEvalResult(data, thinkingMsg, runContext);
                chatPanel.scrollToBottom();
                break;
        }
    };

    try {
        const response = await fetch(requestUrl, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: postBody.toString(),
            signal: controller.signal
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = "";

        while (true) {
            const { done, value } = await reader.read();
            if (done || shouldStop || (isReliabilityRun ? runState.done : !activeAIRequestState.isProcessing)) {
                break;
            }

            buffer += decoder.decode(value, { stream: true });

            let boundary = buffer.indexOf("\n\n");
            while (boundary !== -1) {
                const eventText = buffer.substring(0, boundary);
                buffer = buffer.substring(boundary + 2);
                const dataLine = eventText.split("\n").find(line => line.startsWith("data: "));
                if (!dataLine) continue;
                try {
                    await processEvent(JSON.parse(dataLine.slice(6)));
                } catch (e) { /* ignore parse errors */ }
                if (shouldStop) break;
                boundary = buffer.indexOf("\n\n");
            }
        }

        // After the stream ends, present all accumulated approval boxes at once.
        if (pendingApprovalRequests.length > 0) {
            const requestsToHandle = pendingApprovalRequests.splice(0);
            approvalsShown = true;
            thinkingMsg.stopEvaluating();
            finalizeToolsDisplay(thinkingMsg);
            // Settle before the boxes go up: the approve round trip re-arms the request state.
            abandonQueuedInterjections();
            await handleMultipleApprovalRequests(requestsToHandle, thinkingMsg, chatPanel, runContext);
        }

        // EC-25393: nothing is waiting on the user, so anything the agent never reached becomes the next turn
        if (!isReliabilityRun) {
            if (approvalsShown || clarificationShown || planReadyReceived) {
                abandonQueuedInterjections();
            } else {
                await resendQueuedInterjections();
            }
        }
    } catch (error) {
        if (isReliabilityRun) {
            if (runState.completionHandled) {
                return;
            }
        } else if (!activeAIRequestState.isProcessing) {
            return;
        }

        if (!isReliabilityRun) {
            abandonQueuedInterjections();
        }

        clearTimeout(requestTimeoutHandle);

        if (requestTimedOut) {
            const prefix = displayed ? `${displayed}\n\n` : "";
            const timeoutMessage = `${prefix}Error: Request timed out after 15 minutes`;
            if (isReliabilityRun) {
                markReliabilityRunFailure(runState, timeoutMessage);
            } else {
                thinkingMsg.stopEvaluating();
                thinkingMsg.updateContent(timeoutMessage);
                finalizeAgentActiveRequest();
                setInputState(true);
            }
            return;
        }

        if (!displayed) {
            try {
                const errorResponse = await fetch(requestUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: postBody.toString()
                });
                const errorData = await errorResponse.json();
                if (errorData.Error) {
                    const validationMessage = `Error: ${errorData.Error}`;
                    if (isReliabilityRun) {
                        markReliabilityRunFailure(runState, validationMessage);
                    } else {
                        thinkingMsg.stopEvaluating();
                        thinkingMsg.updateContent(validationMessage);
                        finalizeAgentActiveRequest();
                        setInputState(true);
                    }
                    return;
                }
            } catch (e) { /* ignore – fall through to generic message */ }
        }

        const connectionMessage = `${displayed}${displayed ? "\n" : ""}Error: Connection failed`;
        if (isReliabilityRun) {
            markReliabilityRunFailure(runState, connectionMessage);
        } else {
            thinkingMsg.stopEvaluating();
            thinkingMsg.updateContent(connectionMessage);
            finalizeAgentActiveRequest();
            setInputState(true);
        }
    } finally {
        clearTimeout(requestTimeoutHandle);
        if (isReliabilityRun && runState.streamController === controller) {
            runState.streamController = null;
        }
    }
}

// Sub-agent event handlers - now use thinkingMsg's timeline methods
function handleSubAgentStart(data, thinkingMsg, chatPanel) {
    const subAgentId = data.SubAgentID;
    const subAgentName = data.SubAgentName || `Sub-Agent ${subAgentId}`;
    const parentSubAgentId = data.ParentSubAgentID || null;

    // Create the sub-agent in the timeline
    thinkingMsg.createSubAgent(subAgentId, subAgentName, parentSubAgentId);
    chatPanel.scrollToBottom();
}

function handleSubAgentToolStart(data, thinkingMsg) {
    const subAgentId = data.SubAgentID;
    const toolNames = data.FunctionCallTraces || [];
    const toolMetadata = data.FunctionCallMetadata || null;

    thinkingMsg.addSubAgentToolCalls(subAgentId, toolNames, toolMetadata);
}

function handleSubAgentToolFinish(data, thinkingMsg) {
    const subAgentId = data.SubAgentID;
    thinkingMsg.markSubAgentCurrentToolCompleted(subAgentId);
}

function handleSubAgentChunk(data, thinkingMsg) {
    const subAgentId = data.SubAgentID;
    const text = data.Answer || "";

    thinkingMsg.appendSubAgentResponse(subAgentId, text);
}

function handleSubAgentEnd(data, thinkingMsg) {
    const subAgentId = data.SubAgentID;
    const finalAnswer = data.Answer;

    // If a final answer is provided, update it
    if (finalAnswer !== undefined) {
        thinkingMsg.setSubAgentResponse(subAgentId, finalAnswer);
    }
    thinkingMsg.markSubAgentCompleted(subAgentId);
}

/**
 * Shows one approval box per item in approvalDataList simultaneously.
 * The user must interact with every box; when the last one is resolved the function
 * sends a single combined request to the backend (approve-all or cancel).
 * Cancelling any single box cancels the whole batch.
 *
 * EC-32435: the prompt can also be abandoned — the user starts a new turn or leaves instead of
 * answering. dismissPendingToolApprovals() takes the batch over in that case, so the waiter below
 * always ends and a late click on a removed box cannot re-arm activeAIRequestState under the turn
 * that replaced this one.
 */
async function handleMultipleApprovalRequests(approvalDataList, thinkingMsg, chatPanel, runContext = null) {
    thinkingMsg.stopThinking();

    await new Promise((resolve) => {
        let remaining = approvalDataList.length;
        let anyCancel = false;
        let settled = false;
        const editedPatternsByRequestID = {};

        // First caller wins: whoever claims the batch (the last box acted on, or the dismissal) owns it
        const claimBatch = () => {
            if (settled) return false;
            settled = true;
            pendingToolApprovals.delete(pendingApproval);
            return true;
        };

        const pendingApproval = {
            dismiss: () => {
                if (!claimBatch()) return;
                thinkingMsg.dismissApprovalRequests(true);
                resolve();
            }
        };
        pendingToolApprovals.add(pendingApproval);

        const createApprovalHandler = data => async (approved, patternValue) => {
            if (settled) return; // Batch already answered or abandoned
            if (!approved) anyCancel = true;
            if (approved && patternValue != null && !EC_Fmt.isNull(patternValue)) {
                editedPatternsByRequestID[data.FunctionCallApprovalRequestID] = patternValue;
            }
            remaining--;
            if (remaining > 0) return; // Wait for every box to be acted on

            claimBatch();

            // The first stream's `done` event calls finalizeAgentActiveRequest() which sets
            // isProcessing = false. Re-arm the active request state so Level 2's stream does
            // not immediately exit the reading loop on !isProcessing and so the stop button works.
            initializeAgentActiveRequest(thinkingMsg, chatPanel);
            thinkingMsg.startThinking();

            const allRequestIDs = approvalDataList.map(d => d.FunctionCallApprovalRequestID);
            const NewUserMessage = {
                content: anyCancel ? "Cancel" : "Approve",
                // Primary ID for cancel path or legacy backends
                FunctionCallApprovalRequestID: allRequestIDs[0],
                // Full list sent only on approve so backend can execute all groups
                FunctionCallApprovalRequestIDs: anyCancel ? null : allRequestIDs,
                // Edited WebGet URL patterns, keyed by request ID, sent only on approve
                ApprovedURLPatterns: (!anyCancel && Object.keys(editedPatternsByRequestID).length > 0) ? JSON.stringify(editedPatternsByRequestID) : null,
                AIAgentEvalID: thinkingMsg.aiAgentEvalID || 0,
                EvalAIModelID: thinkingMsg.evalAIModelID || 0
            };

            await ReceiveServerSentEvents(thinkingMsg, NewUserMessage, chatPanel, runContext);
            resolve();
        };

        approvalDataList.forEach((data) => {
            thinkingMsg.showToolApproval(data, createApprovalHandler(data));
        });

        if (chatPanel) {
            chatPanel.forceScrollToBottom();
        }
    });
}

async function handleClarificationRequest(data, thinkingMsg, chatPanel, runContext = null) {
    thinkingMsg.stopThinking();

    await new Promise((resolve) => {
        thinkingMsg.showClarificationRequest(data, async (answer) => {
            thinkingMsg.startThinking();

            const NewUserMessage = {
                content: answer,
                ClarificationRequestID: data.ClarificationRequestID,
                ClarificationAnswer: answer,
                AIAgentEvalID: thinkingMsg.aiAgentEvalID || 0,
                EvalAIModelID: thinkingMsg.evalAIModelID || 0
            };

            await ReceiveServerSentEvents(thinkingMsg, NewUserMessage, chatPanel, runContext);
            resolve();
        });
        if (chatPanel) {
            chatPanel.forceScrollToBottom();
        }
    });
}

async function handlePlanFirstMessage(answer, thinkingMsg, chatPanel, planReady = false) {
    const usePlanFirst = getPlanFirstEnabled();
    if (!usePlanFirst && !planReady && !WaitingForApprovePlanFirst) {
        return;
    }

    if (!planReady) {
        return;
    }

    WaitingForApprovePlanFirst = true;
    activePlanApprovalMessage = thinkingMsg;
    thinkingMsg.showPlanFirstApproval(async (approvalBool) => {
        if (approvalBool) {
            // The editor value (with any manual edits) is the final plan sent to the execution engine.
            // maxLength blocks typing past the cap, but a pre-filled plan can exceed it — truncate here.
            let finalPlanText = thinkingMsg.getPlanEditorText().trim();
            if (finalPlanText.length > PLAN_EDITOR_MAX_LENGTH) {
                finalPlanText = finalPlanText.substring(0, PLAN_EDITOR_MAX_LENGTH);
                ECP.HTML.Snackbar(`Plan exceeded ${PLAN_EDITOR_MAX_LENGTH} characters and was truncated.`, "Warning");
            }
            thinkingMsg.disablePlanEditing(true);
            const text = "Execute the plan";
            chatPanel.addMessage("user", text, new Date().toISOString());
            const newThinkingMsg = chatPanel.addMessage("assistant", "", new Date().toISOString());
            newThinkingMsg.startThinking();

            WaitingForApprovePlanFirst = false;
            activePlanApprovalMessage = null;
            setAgentPlanFirst(false, { syncSettingsDialog: true });
            initializeAgentActiveRequest(newThinkingMsg, chatPanel);
            await ReceiveServerSentEvents(newThinkingMsg, {
                content: text, forcePlanFirst: true, executePlan: true, editedPlan: finalPlanText
            }, chatPanel);
        } else {
            thinkingMsg.disablePlanEditing(true);
            WaitingForApprovePlanFirst = true;
            activePlanApprovalMessage = null;
        }
    });
    thinkingMsg.enablePlanEditing();
    chatPanel.scrollToBottom();
    updateButtonVisibility(false);
}

function dismissPendingPlanApproval() {
    const dismissFromMessage = (messageEl) => {
        if (!messageEl || typeof messageEl.getToolsTimeline !== "function") return;
        if (typeof messageEl.disablePlanEditing === "function") {
            messageEl.disablePlanEditing(true);
        }
        const timeline = messageEl.getToolsTimeline();
        if (timeline && typeof timeline.dismissApprovalRequests === "function") {
            timeline.dismissApprovalRequests();
        }
        messageEl.showPlanApprovalRequest = false;
    };

    if (activePlanApprovalMessage) {
        dismissFromMessage(activePlanApprovalMessage);
        activePlanApprovalMessage = null;
        return;
    }

    const currentPanel = ChatPanel.getCurrentPanel();
    if (!currentPanel || !currentPanel.element) return;

    const assistantMessages = currentPanel.element.querySelectorAll('cur-chatmessage[role="assistant"]');
    assistantMessages.forEach((messageEl) => {
        const timeline = typeof messageEl.getToolsTimeline === "function" ? messageEl.getToolsTimeline() : null;
        if (timeline && timeline.shadowRoot && timeline.shadowRoot.querySelector(".approval-item")) {
            dismissFromMessage(messageEl);
        }
    });
}

/**
 * EC-32435: Abandons every tool-approval prompt still waiting for an answer. Starting a new turn means
 * the user is never going to answer them, so each batch's waiter is resolved and its boxes removed.
 * The backend cancels the matching AIAgentMessageTools rows on that same turn.
 */
function dismissPendingToolApprovals() {
    // dismiss() removes itself from the set, so walk a snapshot
    Array.from(pendingToolApprovals).forEach(pendingApproval => pendingApproval.dismiss());

    // Boxes with no live waiter (the conversation was reopened, or a reload dropped the promise)
    const currentPanel = ChatPanel.getCurrentPanel();
    if (!currentPanel || !currentPanel.element) return;

    currentPanel.element.querySelectorAll('cur-chatmessage[role="assistant"]').forEach((messageEl) => {
        if (typeof messageEl.dismissApprovalRequests !== "function") return;
        const timeline = typeof messageEl.getToolsTimeline === "function" ? messageEl.getToolsTimeline() : null;
        if (timeline && timeline.shadowRoot && timeline.shadowRoot.querySelector(".approval-item.tool-approval")) {
            messageEl.dismissApprovalRequests(true);
        }
    });
}

/**
 * Submits user feedback (thumbs up/down) for an AI agent response.
 * Updates the feedback row for the message.
 * Payload: { AIAgentMessageID: string, Sentiment: number (1=positive, 0=negative) }
 */
async function submitResponseFeedback(payload) {
    if (!payload.AIAgentMessageID) return;

    const req = new ECP.EC_Request("AIAgent_SubmitResponseFeedback");
    req.AddRequestVariable("AIAgentMessageFeedbackID", EC_Fmt.Null2ZeroInt(payload.AIAgentMessageFeedbackID));
    req.AddRequestVariable("AIAgentMessageID", String(payload.AIAgentMessageID));
    req.AddRequestVariable("Sentiment", String(payload.Sentiment));
    req.AddRequestVariable("FeedbackText", EC_Fmt.Null2EmptyStr(payload.FeedbackText));
    req.SetReturnType(ECP.EC_ReturnType.Json);
    const result = await req.Submit();
    if (result && result.Error) {
        throw new Error(result.Error);
    }
    return result;
}

// ---------------------------------------------------------------------------
// EC-32546: share an agent response by Email or eChat.
// The response is re-rendered from its markdown into standalone HTML and handed to the
// same EWS.SendMessage dialogs that the report Share menu uses, so recipients get the
// formatting they see in the panel without a new API command on either channel.
// ---------------------------------------------------------------------------

// EChatMessages.Message is a 4000 character column, and the server caps writes at the column
// length, so anything longer would arrive silently cut in half.
const SHARE_ECHAT_MAX_BODY_LENGTH = 4000;
const SHARE_SUBJECT_MAX_LENGTH = 78;
const SHARE_DEFAULT_SUBJECT = "Encompass AI agent response";
const SHARE_CHART_PLACEHOLDER = "[Chart omitted - open the response in Encompass to view it]";

// Mail clients drop <style> blocks and class selectors, so table formatting has to be inline.
const SHARE_TABLE_STYLE = "border-collapse:collapse;border:1px solid #d0d0d0";
const SHARE_TABLE_CELL_STYLE = "border:1px solid #d0d0d0;padding:4px 8px;text-align:left";
const SHARE_TABLE_HEADER_STYLE = `${SHARE_TABLE_CELL_STYLE};background:#f4f4f4;font-weight:600`;

// Interactive or scriptable markup that has no meaning in an inbox or a chat bubble. The
// agent's own renderer contributes the chart <script type="text/plain"> and the table
// toolbar; the rest guards against raw HTML the model wrote into its answer.
const SHARE_STRIPPED_SELECTORS = "script,style,iframe,object,embed,link,meta,base,form,input,button,textarea,select,svg,math,video,audio,source,track,ecp-btn,.md-table-actions";

// An allow-list, not a block-list: a blocked-scheme check is only as good as the obfuscations it
// anticipates, and this HTML comes from the model. Anything not named here loses the attribute.
const SHARE_ALLOWED_URL_SCHEMES = ["http:", "https:", "mailto:", "tel:"];

// Attributes that carry a URL and so have to pass the scheme check.
const SHARE_URL_ATTRIBUTES = ["href", "src", "xlink:href"];

// srcset holds a comma-separated URL list that the scheme check does not parse, so it is dropped
// outright rather than validated -- responsive images earn nothing in an inbox.
const SHARE_DROPPED_URL_ATTRIBUTES = ["srcset", "imagesrcset", "formaction", "background", "poster", "action", "data", "ping"];

let AgentCanShareEChat = false;

function setAgentCanShareEChat(canShare) {
    AgentCanShareEChat = !!canShare;
}

// Turns the response markdown into HTML that survives an email or an eChat bubble:
// the agent's live widgets are removed, event handlers and javascript: URLs are dropped,
// relative links are absolutised (a recipient reads this outside the app), and tables get
// inline borders. Parsing happens in an inert DOMParser document, so nothing here loads a
// remote resource or runs a script while the share dialog is being built.
function buildShareResponseHTML(rawText) {
    const markedLibrary = typeof globalThis.marked === "undefined" ? null : globalThis.marked;
    const text = EC_Fmt.Null2EmptyStr(rawText);
    if (!markedLibrary) {
        // Marked failed to load; the plain text is still worth sharing.
        return `<div>${EC_Fmt.HTMLEncode(text).replace(/\n/g, "<br>")}</div>`;
    }

    const parsed = markedLibrary.parse(text, { breaks: true, gfm: true });
    const doc = new DOMParser().parseFromString(parsed, "text/html");

    doc.body.querySelectorAll(".ai-d3-chart").forEach((chart) => {
        const note = doc.createElement("p");
        const em = doc.createElement("em");
        em.textContent = SHARE_CHART_PLACEHOLDER;
        note.appendChild(em);
        chart.replaceWith(note);
    });

    // An artifact travels as its shareable link; the frame itself has no place in an inbox. The href
    // goes through the same scheme allow-list as every other URL below.
    doc.body.querySelectorAll(".ai-artifact").forEach((artifact) => {
        const link = doc.createElement("a");
        link.setAttribute("href", artifact.getAttribute("data-url") || "");
        link.textContent = artifact.getAttribute("data-title") || "Artifact";
        const note = doc.createElement("p");
        note.appendChild(link);
        note.appendChild(doc.createTextNode(" (interactive view)"));
        artifact.replaceWith(note);
    });

    doc.body.querySelectorAll(SHARE_STRIPPED_SELECTORS).forEach(node => node.remove());

    // The table renderer wraps every table in a toolbar shell; the toolbar is gone by now,
    // so lift the table out and drop the wrapper.
    doc.body.querySelectorAll(".md-table-wrap").forEach((wrap) => {
        const table = wrap.querySelector("table");
        if (table) {
            wrap.replaceWith(table);
        } else {
            wrap.remove();
        }
    });

    doc.body.querySelectorAll("table").forEach(table => table.setAttribute("style", SHARE_TABLE_STYLE));
    doc.body.querySelectorAll("th").forEach(cell => cell.setAttribute("style", SHARE_TABLE_HEADER_STYLE));
    doc.body.querySelectorAll("td").forEach(cell => cell.setAttribute("style", SHARE_TABLE_CELL_STYLE));

    doc.body.querySelectorAll("*").forEach((element) => {
        const attributes = [...element.attributes];
        for (let i = 0; i < attributes.length; i++) {
            const name = attributes[i].name;
            if (name.toLowerCase().startsWith("on")) {
                element.removeAttribute(name);
            }
        }
        element.removeAttribute("class");
        for (let i = 0; i < SHARE_DROPPED_URL_ATTRIBUTES.length; i++) {
            element.removeAttribute(SHARE_DROPPED_URL_ATTRIBUTES[i]);
        }
        for (let i = 0; i < SHARE_URL_ATTRIBUTES.length; i++) {
            absolutiseShareUrl(element, SHARE_URL_ATTRIBUTES[i]);
        }
    });

    return doc.body.innerHTML.trim();
}

// A recipient opens this outside the app, so a root-relative agent link has to carry the origin.
// Every URL is resolved against the page and then checked against the scheme allow-list, so an
// unsafe scheme costs the attribute. Resolving first is what closes the obfuscation gap: a browser
// strips tabs, newlines and other C0 control characters out of a URL before acting on it, so a
// scheme read off the raw attribute ("java\nscript:") is not the scheme that would actually run.
// URL applies the same stripping, leaving the scheme the browser would see.
function absolutiseShareUrl(element, attribute) {
    const value = EC_Fmt.Null2EmptyStr(element.getAttribute(attribute)).trim();
    if (!value) {
        return;
    }

    let resolved;
    try {
        resolved = new URL(value, window.location.href);
    } catch {
        // Not a URL the browser can resolve, so not one a recipient can follow.
        element.removeAttribute(attribute);
        return;
    }

    if (!SHARE_ALLOWED_URL_SCHEMES.includes(resolved.protocol)) {
        element.removeAttribute(attribute);
        return;
    }

    element.setAttribute(attribute, resolved.href);
}

// Subject line from the response itself: its first heading, or failing that its first line
// of prose, with the markdown markers taken off.
function buildShareResponseSubject(rawText) {
    const lines = EC_Fmt.Null2EmptyStr(rawText).split("\n");
    let firstLine = "";

    for (let i = 0; i < lines.length; i++) {
        const candidate = ECPChatMessage._stripMarkdownForSpeech(lines[i]).trim();
        if (candidate) {
            firstLine = candidate;
            break;
        }
    }

    if (!firstLine) {
        return SHARE_DEFAULT_SUBJECT;
    }

    if (firstLine.length <= SHARE_SUBJECT_MAX_LENGTH) {
        return firstLine;
    }

    return `${firstLine.slice(0, SHARE_SUBJECT_MAX_LENGTH - 3).trimEnd()}...`;
}

// EWS.SendMessage ships with the QuickLink/SendMessage controls, which the agent dashboard
// does not pull in. Load them on the first share instead of taxing every panel load with
// TinyMCE. SendMessage.js registers itself through EWS.Ready, which fires straight away on
// an already-ready EWS, so the control is in place once the script resolves.
async function ensureSendMessageControl() {
    if (EWS.SendMessage) {
        return true;
    }

    await EC_Fmt.LoadScript("Controls/SendMessage.css");
    await EC_Fmt.LoadScript("Controls/Tinymce/tinymce.js");
    await EC_Fmt.LoadScript("Controls/TinymceEdit.js");
    await EC_Fmt.LoadScript("Controls/SendMessage.js");

    return !!EWS.SendMessage;
}

async function shareAgentResponse(rawText, channel) {
    const body = buildShareResponseHTML(rawText);
    if (!body) {
        ECP.HTML.Snackbar("There is nothing in this response to share.", "Warning");
        return;
    }

    if (!await ensureSendMessageControl()) {
        ECP.HTML.Snackbar("Sharing is unavailable right now.", "Error");
        return;
    }

    if (channel === "echat") {
        if (body.length > SHARE_ECHAT_MAX_BODY_LENGTH) {
            ECP.HTML.Snackbar(`This response is too long for eChat and will be cut off after ${SHARE_ECHAT_MAX_BODY_LENGTH} characters. Share it by email to send all of it.`, "Warning");
        }
        EWS.SendMessage.Echat({ message: body });
        return;
    }

    EWS.SendMessage.Email({
        subject: buildShareResponseSubject(rawText),
        message: body
    });
}

// Email is open to every user; eChat follows the same gate the report Share menu uses, so
// the option is hidden unless the user holds EnableEChat and eChat is on for the system.
function showShareResponseDialog(rawText) {
    if (!EC_Fmt.Null2EmptyStr(rawText).trim()) {
        ECP.HTML.Snackbar("There is nothing in this response to share.", "Warning");
        return;
    }

    const echatOptionHTML = AgentCanShareEChat
        ? "<ecp-btn id=agentShareEchatBtn icon=ews-icon-echat><i>e</i>Chat</ecp-btn>"
        : "";

    const dialog = ECP.Dialog.ShowDialog("Share response", `
        <div class=agent-share-dialog>
            <div class=ecp-body style="margin-bottom:12px">Send this response with others.</div>
            <div style="display:flex;gap:8px;flex-wrap:wrap">
                <ecp-btn id=agentShareEmailBtn icon=ews-icon-email>Email</ecp-btn>
                ${echatOptionHTML}
            </div>
        </div>`, {
        width: 420,
        // The two channel buttons are the action; a footer Confirm would have nothing to confirm.
        disableButtons: true
    });

    dialog.querySelector("#agentShareEmailBtn").addEventListener("click", () => {
        ECP.Dialog.CloseDialog(dialog);
        shareAgentResponse(rawText, "email");
    });

    const echatBtn = dialog.querySelector("#agentShareEchatBtn");
    if (echatBtn) {
        echatBtn.addEventListener("click", () => {
            ECP.Dialog.CloseDialog(dialog);
            shareAgentResponse(rawText, "echat");
        });
    }
}

async function submitEvalScore(payload) {
    if (!payload.AIAgentMessageID) {
        return;
    }

    const req = new ECP.EC_Request("AIAgent_SubmitEvalScore");
    req.AddRequestVariable("AIAgentMessageID", String(payload.AIAgentMessageID));
    req.AddRequestVariable("EvalScore", String(payload.EvalScore));
    req.SetReturnType(ECP.EC_ReturnType.Json);
    const result = await req.Submit();
    if (result && result.Error) {
        throw new Error(result.Error);
    }
}

async function showEvalResultDialog(evalResult) {
    const explanation = EC_Fmt.HTMLEncode(evalResult.Explanation || "");
    const metricsHtml = buildEvalResultMetricsHtml(evalResult);
    const dialog = ECP.Dialog.ShowDialog("Eval Score", `
        <div class=agent-eval-result-dialog>
            <div class=ecp-body style="margin-bottom:12px">Judge score (1-100)</div>
            <input id=agentEvalScoreInput type=number min=1 max=100 value="${evalResult.Score}" style="width:100%;margin-bottom:12px">
            ${metricsHtml}
            <div class=ecp-body style="margin-bottom:6px">Explanation</div>
            <div class=ecp-bodysm style="white-space:pre-wrap">${explanation}</div>
        </div>`, {
        confirmButtonTitle: "Save Score",
        cancelButtonTitle: "Close",
        width: 520,
        confirmButtonAction: async (container) => {
            const scoreInput = container.querySelector("#agentEvalScoreInput");
            const score = Math.max(1, Math.min(100, parseInt(scoreInput ? scoreInput.value : evalResult.Score, 10) || evalResult.Score));
            await submitEvalScore({
                AIAgentMessageID: evalResult.AIAgentMessageID,
                EvalScore: score
            });
            ECP.Dialog.CloseDialog(dialog);
            ECP.HTML.Snackbar("Eval score saved.", "Success");
        }
    });

    return dialog;
}

async function handleEvalResult(data, thinkingMsg, runContext = null) {
    thinkingMsg.stopEvaluating();
    if (data.AIAgentMessageID) {
        thinkingMsg.aiAgentMessageID = data.AIAgentMessageID;
    }

    const runState = runContext && runContext.runState ? runContext.runState : null;
    if (!runState) {
        const evalResult = Object.assign({}, data);
        if (Number.isFinite(thinkingMsg && thinkingMsg.responseDurationMs)) {
            evalResult.DurationMs = thinkingMsg.responseDurationMs;
        }

        await showEvalResultDialog(evalResult);
        return;
    }

    const parsedScore = Number(data.Score);
    runState.score = Number.isFinite(parsedScore) ? parsedScore : null;
    runState.explanation = EC_Fmt.Null2EmptyStr(data.Explanation);
    runState.inputTokens = normalizeTokenCount(data ? data.InputTokens : null);
    runState.outputTokens = normalizeTokenCount(data ? data.OutputTokens : null);
    runState.cachedTokens = normalizeTokenCount(data ? data.CachedTokens : null);
    runState.scoreSaveErrorMessage = "";
    runState.evalResultReceived = true;

    if (data.AIAgentMessageID && Number.isFinite(runState.score)) {
        try {
            await submitEvalScore({
                AIAgentMessageID: data.AIAgentMessageID,
                EvalScore: runState.score
            });
        } catch (error) {
            runState.scoreSaveErrorMessage = error && error.message ? error.message : "Eval score could not be saved.";
            if (reliabilitySession && !reliabilitySession.hasShownSaveWarning) {
                reliabilitySession.hasShownSaveWarning = true;
                ECP.HTML.Snackbar("One or more reliability eval scores could not be saved. Review the results dialog for details.", "Warning");
            }
        }
    }

    if (!Number.isFinite(runState.score)) {
        markReliabilityRunFailure(runState, "Run completed without a numeric judge score.");
        return;
    }

    updateReliabilityRunPromptHints(runState);
    markReliabilityRunComplete(runState);
}

// Normalize a token count from an SSE/eval payload: numeric values clamp to a whole number >= 0,
// anything non-numeric becomes null (meaning "not reported")
function normalizeTokenCount(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? Math.max(0, Math.round(parsed)) : null;
}

// "Input 1,234, Output 56, Cached 789" — empty string when no counts were reported
function formatTokenUsageText(inputTokens, outputTokens, cachedTokens) {
    if (inputTokens === null && outputTokens === null && cachedTokens === null) {
        return "";
    }

    return `Input ${EC_Fmt.ScreenFmt(inputTokens || 0, "Integer")}, Output ${EC_Fmt.ScreenFmt(outputTokens || 0, "Integer")}, Cached ${EC_Fmt.ScreenFmt(cachedTokens || 0, "Integer")}`;
}

function buildEvalResultMetricsHtml(evalResult) {
    const metrics = [];
    const durationMs = Number(evalResult && (evalResult.durationMs ?? evalResult.DurationMs));
    if (Number.isFinite(durationMs)) {
        metrics.push(`Time: ${EC_Fmt.HTMLEncode(`${EC_Fmt.ScreenFmt(Math.max(0, durationMs) / 1000, "Decimal", 2)}s`)}`);
    }

    const tokenUsageText = formatTokenUsageText(
        normalizeTokenCount(evalResult && (evalResult.inputTokens ?? evalResult.InputTokens)),
        normalizeTokenCount(evalResult && (evalResult.outputTokens ?? evalResult.OutputTokens)),
        normalizeTokenCount(evalResult && (evalResult.cachedTokens ?? evalResult.CachedTokens))
    );
    if (tokenUsageText) {
        metrics.push(`Tokens: ${EC_Fmt.HTMLEncode(tokenUsageText)}`);
    }

    if (metrics.length === 0) {
        return "";
    }

    return `<div class=ecp-bodysm style="margin-bottom:12px">${metrics.map(metric => `<div>${metric}</div>`).join("")}</div>`;
}

function updateSaveSkillBarVisibility() {
    syncInputActionsMenuState();
}

function canSaveConversationAsSkill() {
    const chatPanel = ChatPanel.getCurrentPanel();
    if (!chatPanel) {
        return false;
    }

    const conversationId = chatPanel.element.getAttribute("ConversationID");
    return !EC_Fmt.isNull(conversationId) && !activeAIRequestState.isProcessing;
}

function setAgentPlanFirst(enabled, options = {}) {
    AgentSettings.planFirst = !!enabled;

    if (options.syncSettingsDialog && AI_DOM.planFirstCheckbox) {
        AI_DOM.planFirstCheckbox.checked = AgentSettings.planFirst;
    }

    syncInputActionsMenuState();

    if (options.showToast) {
        ECP.HTML.Snackbar(`Plan first ${AgentSettings.planFirst ? "enabled" : "disabled"}.`, "Information");
    }
}

// EC-24893: MCP connectors (per-chat on/off)
// External MCP servers linked to the current agent, as returned by AIAgent_GetInfo (AIAgentMCPServerID, Name,
// Description, AuthType, ConnectionStatus). Switching a connector off is remembered per agent for 24 hours,
// the same way the Google Search toggle is; only connected connectors that are still linked reach the server.
const MCPConnectorsState = {
    aiAgentID: "",
    servers: [],
    disabledIDs: new Set()
};

const MCP_DISABLED_STATE_EXPIRY_MS = 24 * 60 * 60 * 1000;
const MCP_AUTH_TYPE_OAUTH = 2;
const MCP_CONNECTION_STATUS_CONNECTED = 1;
const MCP_CONNECTION_STATUS_REFRESH_REQUIRED = 2;
const MCP_CONNECTION_STATUS_ERROR = 3;

function getMCPDisabledStateKey(aiAgentID) {
    return `${Distributor}_${UserID}_mcp_disabled_${aiAgentID}`;
}

function saveMCPDisabledState(aiAgentID, disabledIDs) {
    try {
        const entry = { value: Array.from(disabledIDs), expiry: Date.now() + MCP_DISABLED_STATE_EXPIRY_MS };
        localStorage.setItem(getMCPDisabledStateKey(aiAgentID), JSON.stringify(entry));
    } catch {
        // localStorage may be unavailable; state stays in-memory only
    }
}

function loadMCPDisabledState(aiAgentID) {
    try {
        const raw = localStorage.getItem(getMCPDisabledStateKey(aiAgentID));
        if (!raw) return [];
        const entry = JSON.parse(raw);
        if (!entry || Date.now() > entry.expiry || !Array.isArray(entry.value)) {
            localStorage.removeItem(getMCPDisabledStateKey(aiAgentID));
            return [];
        }
        return entry.value.map(Number).filter(id => id > 0);
    } catch {
        return [];
    }
}

// Header and open servers need no per-user connection; an OAuth server is usable only while the caller's token row is Connected
function isMCPServerConnected(server) {
    return Number(server.AuthType) !== MCP_AUTH_TYPE_OAUTH || Number(server.ConnectionStatus) === MCP_CONNECTION_STATUS_CONNECTED;
}

function initMCPConnectorsForAgent(aiAgentID, mcpServers) {
    MCPConnectorsState.aiAgentID = EC_Fmt.isNull(aiAgentID) ? "" : String(aiAgentID);
    MCPConnectorsState.servers = Array.isArray(mcpServers) ? mcpServers : [];
    MCPConnectorsState.disabledIDs = new Set(MCPConnectorsState.aiAgentID === "" ? [] : loadMCPDisabledState(MCPConnectorsState.aiAgentID));
    syncMCPConnectorsMenuState();
}

function setMCPServerEnabled(aiAgentID, serverID, enabled) {
    const id = Number(serverID);
    if (enabled) {
        MCPConnectorsState.disabledIDs.delete(id);
    } else {
        MCPConnectorsState.disabledIDs.add(id);
    }
    if (!EC_Fmt.isNull(aiAgentID)) {
        saveMCPDisabledState(aiAgentID, MCPConnectorsState.disabledIDs);
    }
    syncMCPConnectorsMenuState();
}

// Only IDs still linked to the agent AND connected are sent, so a stale switch never reaches the server
function getDisabledMCPServerIDs() {
    return MCPConnectorsState.servers
        .filter(server => isMCPServerConnected(server) && MCPConnectorsState.disabledIDs.has(Number(server.AIAgentMCPServerID)))
        .map(server => Number(server.AIAgentMCPServerID));
}

function getMCPConnectorsSummary() {
    const servers = MCPConnectorsState.servers;
    if (servers.length === 0) {
        return "";
    }
    let on = 0;
    let off = 0;
    let notConnected = 0;
    servers.forEach((server) => {
        if (!isMCPServerConnected(server)) {
            notConnected++;
        } else if (MCPConnectorsState.disabledIDs.has(Number(server.AIAgentMCPServerID))) {
            off++;
        } else {
            on++;
        }
    });
    let summary = `${on} on, ${off} off`;
    if (notConnected > 0) {
        summary += ` \u00b7 ${notConnected} not connected`;
    }
    return summary;
}

// Own sync function on purpose: syncInputActionsMenuState() is sliced verbatim by AgentUI.GoogleSearch.test.ts
function syncMCPConnectorsMenuState() {
    const item = AI_DOM.mcpConnectorsItem;
    if (!item) {
        return;
    }
    if (MCPConnectorsState.servers.length === 0) {
        item.classList.add("hidden");
        return;
    }
    item.classList.remove("hidden");
    const stateText = AI_DOM.mcpConnectorsStateText;
    if (stateText) {
        stateText.textContent = getMCPConnectorsSummary();
    }
}

function getMCPConnectorStatusLabel(server) {
    if (Number(server.AuthType) !== MCP_AUTH_TYPE_OAUTH) {
        return "";
    }
    switch (Number(server.ConnectionStatus)) {
        case MCP_CONNECTION_STATUS_CONNECTED:
            return "Connected";
        case MCP_CONNECTION_STATUS_REFRESH_REQUIRED:
            return "Reconnect required";
        case MCP_CONNECTION_STATUS_ERROR:
            return "Connection error";
        default:
            return "Not connected";
    }
}

// Switches are frozen while a turn is running or an approval is pending: toggling mid-approval would leave the
// resume without the tool it is about to execute.
function canToggleMCPConnectors() {
    return !activeAIRequestState.isProcessing && pendingToolApprovals.size === 0;
}

function buildMCPConnectorsDialogHTML(servers, disabledIDs, switchesDisabled) {
    if (servers.length === 0) {
        return "<div class=ecp-bodysm>No connectors are linked to this agent.</div>";
    }

    let html = "<div class=ecp-bodysm style=\"margin-bottom:12px\">External tools this agent may use in this chat. Switch a connector off to keep its tools out of the conversation.</div>";
    if (switchesDisabled) {
        html += "<div class=ecp-bodysm style=\"margin-bottom:12px\">Connectors can be switched while no request is running.</div>";
    }
    html += "<ecp-list>";
    servers.forEach((server) => {
        const id = Number(server.AIAgentMCPServerID);
        const isOAuth = Number(server.AuthType) === MCP_AUTH_TYPE_OAUTH;
        const status = Number(server.ConnectionStatus);
        const name = EC_Fmt.HTMLEncode(server.Name || "");
        const description = EC_Fmt.HTMLEncode(server.Description || "");
        const statusLabel = EC_Fmt.HTMLEncode(getMCPConnectorStatusLabel(server));

        let controls = "";
        if (isMCPServerConnected(server)) {
            controls += `<ecp-switch class=mcp-connector-switch data-mcp-server-id=${id} size=small${disabledIDs.has(id) ? "" : " checked"}${switchesDisabled ? " disabled" : ""}></ecp-switch>`;
            if (isOAuth) {
                controls += `<ecp-btn class=mcp-connector-disconnect data-mcp-server-id=${id} type=ghost>Disconnect</ecp-btn>`;
            }
        } else if (isOAuth) {
            if (status === MCP_CONNECTION_STATUS_REFRESH_REQUIRED || status === MCP_CONNECTION_STATUS_ERROR) {
                controls += "<span class=\"ecp-bodysm mcp-connector-attention\">Needs attention</span>";
            }
            controls += `<ecp-btn class=mcp-connector-connect data-mcp-server-id=${id} type=primary>${status === 0 ? "Connect" : "Reconnect"}</ecp-btn>`;
        }

        const subtitle = [description, statusLabel].filter(part => !EC_Fmt.isNull(part)).join(" \u00b7 ");
        html += `<ecp-list-item data-mcp-server-id=${id}>
 <ecp-list-item-content>
  <ecp-list-item-title>${name}</ecp-list-item-title>${subtitle ? `
  <ecp-list-item-subtitle>${subtitle}</ecp-list-item-subtitle>` : ""}
 </ecp-list-item-content>
 <div class=mcp-connector-controls style="display:flex;align-items:center;gap:8px">${controls}</div>
</ecp-list-item>`;
    });
    html += "</ecp-list>";
    return html;
}

function renderMCPConnectorsDialog(dialog) {
    const content = dialog ? dialog.querySelector(".ecp-dialog-content") : null;
    if (content) {
        content.innerHTML = buildMCPConnectorsDialogHTML(MCPConnectorsState.servers, MCPConnectorsState.disabledIDs, !canToggleMCPConnectors());
    }
}

async function refreshMCPConnectors(aiAgentID, dialog) {
    invalidateAgentInfoCache(aiAgentID);
    const agentData = await GetAgentInfo(aiAgentID);
    initMCPConnectorsForAgent(aiAgentID, agentData && Array.isArray(agentData.MCPServers) ? agentData.MCPServers : []);
    if (dialog && document.body.contains(dialog)) {
        renderMCPConnectorsDialog(dialog);
    }
}

async function disconnectMCPServer(aiAgentID, serverID, dialog) {
    const req = new ECP.EC_Request("AIAgent_DisconnectMCPServer");
    req.SetReturnType(ECP.EC_ReturnType.Json);
    req.AddRequestVariable("AIAgentMCPServerID", String(serverID), ECP.EC_Verb.Post);
    await req.Submit();
    ECP.HTML.Snackbar("Connector disconnected.", "Info");
    await refreshMCPConnectors(aiAgentID, dialog);
}

// The OAuth popup ends on our own OAuth page, which posts {type:"ecp-mcp-connected"} back to this window and closes.
// A popup closed by hand still refreshes (closed poll), so a completed connect never goes unnoticed.
function isMCPConnectMessage(event) {
    return event.origin === window.location.origin && !!event.data && event.data.type === "ecp-mcp-connected";
}

function openMCPConnectPopup(aiAgentID, serverID, dialog) {
    const popup = window.open(
        `OAuth.aspx?Action=ConnectMCP&Method=MCP&AIAgentMCPServerID=${encodeURIComponent(serverID)}&EncompassID=${encodeURIComponent(Distributor)}`,
        "MCPConnect",
        "popup=yes,width=580,height=600,left=200,top=100"
    );
    if (!popup) {
        ECP.HTML.Snackbar("Please allow popups for this site to connect.", "Warning");
        return;
    }

    let finished = false;
    let closedPoll = null;
    const finish = async (message, success) => {
        if (finished) {
            return;
        }
        finished = true;
        window.removeEventListener("message", onMessage);
        clearInterval(closedPoll);
        await refreshMCPConnectors(aiAgentID, dialog);
        if (!EC_Fmt.isNull(message)) {
            ECP.HTML.Snackbar(message, success ? "Success" : "Error");
        }
    };
    function onMessage(event) {
        if (!isMCPConnectMessage(event)) {
            return;
        }
        finish(event.data.Message, event.data.Success === true);
    }
    window.addEventListener("message", onMessage);
    closedPoll = setInterval(() => {
        if (popup.closed) {
            finish("", true);
        }
    }, 500);
}

function showMCPConnectorsDialog(requestedAIAgentID = "") {
    const aiAgentID = EC_Fmt.isNull(requestedAIAgentID) ? MCPConnectorsState.aiAgentID : String(requestedAIAgentID);
    if (EC_Fmt.isNull(aiAgentID)) {
        ECP.HTML.Snackbar("Select an agent to manage its connectors.", "Info");
        return null;
    }

    const dialog = ECP.Dialog.ShowDialog("Connectors", buildMCPConnectorsDialogHTML(MCPConnectorsState.servers, MCPConnectorsState.disabledIDs, !canToggleMCPConnectors()), {
        confirmButtonTitle: "Done",
        width: 560,
        confirmButtonAction: () => {
            ECP.Dialog.CloseDialog(dialog);
        }
    });

    dialog.addEventListener("click", (event) => {
        // ecp-switch flips its own checked state on click before this bubbles up, so read the new value
        const switchEl = event.target.closest(".mcp-connector-switch");
        if (switchEl) {
            if (!switchEl.disabled) {
                setMCPServerEnabled(aiAgentID, switchEl.getAttribute("data-mcp-server-id"), switchEl.checked);
            }
            return;
        }
        const connectBtn = event.target.closest(".mcp-connector-connect");
        if (connectBtn) {
            openMCPConnectPopup(aiAgentID, connectBtn.getAttribute("data-mcp-server-id"), dialog);
            return;
        }
        const disconnectBtn = event.target.closest(".mcp-connector-disconnect");
        if (disconnectBtn) {
            disconnectMCPServer(aiAgentID, disconnectBtn.getAttribute("data-mcp-server-id"), dialog);
        }
    });

    return dialog;
}

// EC-29098: Session-based Google Search toggle
let currentAgentGoogleSearchPermitted = false;

const GOOGLE_SEARCH_STATE_EXPIRY_MS = 24 * 60 * 60 * 1000;

function getGoogleSearchStateKey(aiAgentID) {
    return `${Distributor}_${UserID}_google_search_${aiAgentID}`;
}

function saveGoogleSearchState(aiAgentID, enabled) {
    try {
        const entry = { value: !!enabled, expiry: Date.now() + GOOGLE_SEARCH_STATE_EXPIRY_MS };
        localStorage.setItem(getGoogleSearchStateKey(aiAgentID), JSON.stringify(entry));
    } catch {
        // localStorage may be unavailable; state stays in-memory only
    }
}

function loadGoogleSearchState(aiAgentID) {
    try {
        const raw = localStorage.getItem(getGoogleSearchStateKey(aiAgentID));
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (!entry || Date.now() > entry.expiry) {
            localStorage.removeItem(getGoogleSearchStateKey(aiAgentID));
            return null;
        }
        return entry.value;
    } catch {
        return null;
    }
}

function setGoogleSearchEnabled(aiAgentID, enabled, options = {}) {
    AgentSettings.googleSearch = !!enabled;
    if (!EC_Fmt.isNull(aiAgentID)) {
        saveGoogleSearchState(aiAgentID, enabled);
    }
    syncInputActionsMenuState();
    if (options.showToast) {
        ECP.HTML.Snackbar(`Google Search ${AgentSettings.googleSearch ? "enabled" : "disabled"}.`, "Information");
    }
}

function initGoogleSearchForAgent(aiAgentID, agentGoogleSearchPermitted, defaultEnabled) {
    currentAgentGoogleSearchPermitted = !!agentGoogleSearchPermitted;
    if (!agentGoogleSearchPermitted) {
        AgentSettings.googleSearch = false;
        syncInputActionsMenuState();
        return;
    }
    const stored = loadGoogleSearchState(aiAgentID);
    AgentSettings.googleSearch = stored !== null ? stored : !!defaultEnabled;
    syncInputActionsMenuState();
}

function getGoogleSearchEnabled() {
    return AgentSettings.googleSearch;
}

function syncInputActionsMenuState() {
    const planFirstStateText = AI_DOM.planFirstStateText;
    if (planFirstStateText) {
        planFirstStateText.innerHTML = `Currently <b>${AgentSettings.planFirst ? "on" : "off"}</b>`;
    }

    syncEvalMenuState();

    const saveAsSkillItem = AI_DOM.saveAsSkillItem;
    if (saveAsSkillItem) {
        const canSave = canSaveConversationAsSkill() && !_saveSkillInProgress;
        saveAsSkillItem.style.opacity = canSave ? "" : "0.5";
        saveAsSkillItem.style.pointerEvents = canSave ? "" : "none";
    }

    const googleSearchToggleItem = AI_DOM.googleSearchToggleItem;
    if (googleSearchToggleItem) {
        if (currentAgentGoogleSearchPermitted) {
            googleSearchToggleItem.classList.remove("hidden");
            const googleSearchStateText = AI_DOM.googleSearchStateText;
            if (googleSearchStateText) {
                googleSearchStateText.innerHTML = `Currently <b>${AgentSettings.googleSearch ? "on" : "off"}</b>`;
            }
        } else {
            googleSearchToggleItem.classList.add("hidden");
        }
    }
}

let _saveSkillInProgress = false;

const AGENT_EVAL_PROMPT_PREVIEW_MAX_LENGTH = 500;

function getAgentEvalPromptPreview(prompt) {
    const promptText = typeof prompt === "string" ? prompt : "";
    if (promptText.length <= AGENT_EVAL_PROMPT_PREVIEW_MAX_LENGTH) {
        return promptText;
    }

    return `${promptText.slice(0, AGENT_EVAL_PROMPT_PREVIEW_MAX_LENGTH)}...`;
}

function hasPromptPlaceholders(promptText) {
    return typeof promptText === "string" && PROMPT_PLACEHOLDER_REGEX.test(promptText);
}

function setPendingEvalRequest(options = {}) {
    PendingEvalRequest.aiAgentID = options.aiAgentID ? String(options.aiAgentID) : "";
    PendingEvalRequest.aiAgentEvalID = options.AIAgentEvalID || 0;
    PendingEvalRequest.evalAIModelID = options.EvalAIModelID || 0;
    PendingEvalRequest.startNewConversation = options.startNewConversation === true;
}

function clearPendingEvalRequest() {
    PendingEvalRequest.aiAgentID = "";
    PendingEvalRequest.aiAgentEvalID = 0;
    PendingEvalRequest.evalAIModelID = 0;
    PendingEvalRequest.startNewConversation = false;
}

function getPendingEvalRequest() {
    if (PendingEvalRequest.aiAgentEvalID <= 0) {
        return null;
    }

    return {
        aiAgentID: PendingEvalRequest.aiAgentID,
        AIAgentEvalID: PendingEvalRequest.aiAgentEvalID,
        EvalAIModelID: PendingEvalRequest.evalAIModelID,
        startNewConversation: PendingEvalRequest.startNewConversation
    };
}

function stageEvalPromptForEditing(promptText, evalOptions) {
    const input = AI_DOM.chatInput;
    if (!input) {
        return;
    }

    input.value = promptText;
    autoResizeChatInput();
    setPendingEvalRequest(evalOptions);
    input.focus();

    const placeholderMatch = typeof promptText === "string" ? promptText.match(PROMPT_PLACEHOLDER_REGEX) : null;
    if (placeholderMatch && typeof input.setSelectionRange === "function") {
        const startIndex = promptText.indexOf(placeholderMatch[0]);
        if (startIndex >= 0) {
            input.setSelectionRange(startIndex, startIndex + placeholderMatch[0].length);
        }
    }
}

function buildAgentEvalDialogHTML(evalData) {
    const evals = Array.isArray(evalData.Evals) ? evalData.Evals : [];
    const models = Array.isArray(evalData.Models) ? evalData.Models : [];
    const defaultAIModelID = EC_Fmt.Null2ZeroInt(evalData.DefaultAIModelID);
    let html = "";

    if (evalData.CanOverrideModel && AgentCanOverrideEvalModel && models.length > 0) {
        let modelOptions = "<ecp-select-option value=\"\">Use agent default model</ecp-select-option>";
        for (let i = 0; i < models.length; i++) {
            const model = models[i];
            const selectedAttr = model.AIModelID === defaultAIModelID ? " selected" : "";
            modelOptions += `<ecp-select-option value="${model.AIModelID}"${selectedAttr}>${EC_Fmt.HTMLEncode(model.Model)}</ecp-select-option>`;
        }

        html += `
            <div class=agent-eval-model-wrap style="margin-bottom:12px">
                <div class=ecp-bodysm style="margin-bottom:6px">Model override</div>
                <ecp-select id=agentEvalModelSelect>${modelOptions}</ecp-select>
            </div>`;
    }

    html += `
        <div class=agent-eval-reliability-toggle-wrap>
            <label class=agent-eval-reliability-toggle>
                <input type=checkbox id=agentReliabilityModeToggle>
                <span>Reliability Test (3 parallel runs)</span>
            </label>
        </div>`;

    if (evals.length === 0) {
        html += "<div class=ecp-bodysm>No evals found for this agent.</div>";
        return html;
    }

    html += "<ecp-list type=clickable>";
    for (let i = 0; i < evals.length; i++) {
        const evalItem = evals[i];
        const promptText = typeof evalItem.Prompt === "string" ? evalItem.Prompt : "";
        const idealOutputText = typeof evalItem.IdealOutput === "string" ? evalItem.IdealOutput : "";
        const promptPreview = getAgentEvalPromptPreview(promptText);
        html += `
            <ecp-list-item class=agent-eval-run-btn data-eval-id="${evalItem.ID}">
                <ecp-list-item-content>
                    <ecp-list-item-title class=agent-eval-prompt-preview><b>${EC_Fmt.HTMLEncode(promptPreview)}</b></ecp-list-item-title>
                    <ecp-list-item-subtitle style="display:block;width:100%;min-width:0">
                        <div class=agent-eval-subtitle-wrap style="display:block;width:100%;min-width:0;max-width:100%">
                            <button
                                type=button
                                class=agent-eval-expand-btn
                                data-eval-id="${evalItem.ID}"
                                aria-expanded=false
                                style="display:inline-flex;align-items:center;gap:6px;margin-top:6px;padding:0;border:none;background:none;color:var(--primary-80);font:inherit;font-weight:var(--semibold-weight);cursor:pointer"
                            ><span class="agent-eval-expand-icon ews-icon-caretdown" aria-hidden=true style="display:inline-block;font-size:12px;transition:transform 150ms ease;transform:rotate(0deg)"></span><span class=agent-eval-expand-label>Show prompt and ideal output</span></button>
                            <div
                                class=agent-eval-details
                                data-eval-id="${evalItem.ID}"
                                hidden
                                style="width:100%;min-width:0;max-width:100%;box-sizing:border-box;margin-top:8px;padding:10px 12px;border:1px solid var(--border);border-radius:6px;background:var(--layer-1);max-height:220px;overflow:auto;overflow-x:hidden"
                            >
                                <div style="margin-bottom:10px"><div class=ecp-bodysm style="font-weight:var(--semibold-weight);margin-bottom:4px">Prompt</div><div class=agent-eval-full-prompt style="white-space:pre-wrap;overflow-wrap:anywhere;word-break:break-word">${EC_Fmt.HTMLEncode(promptText)}</div></div>
                                <div><div class=ecp-bodysm style="font-weight:var(--semibold-weight);margin-bottom:4px">Ideal Output</div><div class=agent-eval-ideal-output style="white-space:pre-wrap;overflow-wrap:anywhere;word-break:break-word">${EC_Fmt.HTMLEncode(idealOutputText)}</div></div>
                            </div>
                        </div>
                    </ecp-list-item-subtitle>
                </ecp-list-item-content>
            </ecp-list-item>`;
    }
    html += "</ecp-list>";

    return html;
}

function buildAddAgentEvalDialogHTML(aiAgentID = "") {
    const normalizedAgentID = EC_Fmt.Null2ZeroInt(aiAgentID);
    const valueAttr = normalizedAgentID > 0 ? ` value="${normalizedAgentID}"` : "";

    return `
        <div class=agent-add-eval-dialog>
            <div class=ecp-bodysm style="margin-bottom:6px">AI Agent</div>
            <ecp-auto-complete
                id=agentEvalAIAgentID
                name=agentEvalAIAgentID
                inputName=agentEvalAIAgentID
                reftable=AIAgents
                reffield=AIAgentID
                reffielddisplay=AgentName
                datatype="ECP.DataType._Integer"
                refFieldDisplayDataType="ECP.DataType._Text"
                limitToRefList=true${valueAttr}
            ></ecp-auto-complete>
            <div class=ecp-bodysm style="margin:12px 0 6px">Prompt</div>
            <textarea id=agentEvalPromptInput maxlength=4000 style="width:100%;min-height:120px;box-sizing:border-box;resize:vertical"></textarea>
            <div class=ecp-bodysm style="margin:12px 0 6px">Ideal Result</div>
            <textarea id=agentEvalIdealOutputInput maxlength=4000 style="width:100%;min-height:120px;box-sizing:border-box;resize:vertical"></textarea>
        </div>`;
}

async function showAddAgentEvalDialog(defaultAIAgentID = "", onSaved = null) {
    const dialog = ECP.Dialog.ShowDialog("Add Eval", buildAddAgentEvalDialogHTML(defaultAIAgentID), {
        confirmButtonTitle: "Save",
        cancelButtonTitle: "Cancel",
        width: 620,
        confirmButtonAction: async (container) => {
            const aiAgentInput = container.querySelector("#agentEvalAIAgentID");
            const promptInput = container.querySelector("#agentEvalPromptInput");
            const idealOutputInput = container.querySelector("#agentEvalIdealOutputInput");
            const selectedAIAgentID = EC_Fmt.Null2ZeroInt(aiAgentInput ? aiAgentInput.curValue || aiAgentInput.value : 0);
            const prompt = promptInput ? String(promptInput.value || "").trim() : "";
            const idealOutput = idealOutputInput ? String(idealOutputInput.value || "").trim() : "";

            if (selectedAIAgentID <= 0) {
                ECP.HTML.Snackbar("Please select an AI agent.", "Warning");
                return;
            }

            if (prompt.length === 0) {
                ECP.HTML.Snackbar("Prompt is required.", "Warning");
                return;
            }

            if (idealOutput.length === 0) {
                ECP.HTML.Snackbar("Ideal result is required.", "Warning");
                return;
            }

            try {
                const tableEdit = new ECP.EC_TableEdit("AIAgentEvals");
                tableEdit.AddRecord();
                tableEdit.UpdateRecord("AIAgentID", String(selectedAIAgentID));
                tableEdit.UpdateRecord("Prompt", prompt);
                tableEdit.UpdateRecord("IdealOutput", idealOutput);

                let result = await tableEdit.SaveRecord();
                if (typeof result === "string") {
                    result = JSON.parse(result);
                }

                if (result && result.Status && result.Status !== "Success") {
                    ECP.HTML.Snackbar(result.Message || "Unable to add eval.", "Error");
                    return;
                }

                ECP.Dialog.CloseDialog(dialog);
                ECP.HTML.Snackbar("Eval added.", "Success");

                if (typeof onSaved === "function") {
                    await onSaved(String(selectedAIAgentID));
                }
            } catch (error) {
                ECP.HTML.Snackbar(`Error: ${error.message || "Unknown error"}`, "Error");
            }
        }
    });

    return dialog;
}

async function showAgentEvalsDialog(requestedAIAgentID = "") {
    const aiAgentID = EC_Fmt.Null2ZeroInt(requestedAIAgentID) > 0 ? EC_Fmt.Null2ZeroInt(requestedAIAgentID) : getSelectedAgentID();
    if (aiAgentID <= 0) {
        return null;
    }

    const req = new ECP.EC_Request("AIAgent_GetEvals");
    req.SetReturnType(ECP.EC_ReturnType.Json);
    req.AddRequestVariable("AIAgentID", String(aiAgentID));
    const evalData = await req.Submit();
    const dialog = ECP.Dialog.ShowDialog("Evals", buildAgentEvalDialogHTML(evalData), {
        confirmButtonTitle: "Add Eval",
        cancelButtonTitle: "Close",
        width: 620,
        confirmButtonAction: async () => {
            ECP.Dialog.CloseDialog(dialog);
            await showAddAgentEvalDialog(String(aiAgentID), async (savedAIAgentID) => {
                await showAgentEvalsDialog(savedAIAgentID);
            });
        }
    });

    const reliabilityToggle = dialog.querySelector("#agentReliabilityModeToggle");
    if (reliabilityToggle) {
        reliabilityToggle.checked = false;
    }

    dialog.querySelectorAll(".agent-eval-expand-btn").forEach((button) => {
        button.addEventListener("click", (event) => {
            event.stopPropagation();

            const evalID = button.getAttribute("data-eval-id");
            const details = evalID ? dialog.querySelector(`.agent-eval-details[data-eval-id="${evalID}"]`) : null;
            const expandLabel = button.querySelector(".agent-eval-expand-label");
            const expandIcon = button.querySelector(".agent-eval-expand-icon");
            if (!details) {
                return;
            }

            const isExpanded = !details.hasAttribute("hidden");
            if (isExpanded) {
                details.setAttribute("hidden", "");
                button.setAttribute("aria-expanded", "false");
                if (expandLabel) {
                    expandLabel.textContent = "Show prompt and ideal output";
                }
                if (expandIcon) {
                    expandIcon.style.transform = "rotate(0deg)";
                }
                return;
            }

            details.removeAttribute("hidden");
            button.setAttribute("aria-expanded", "true");
            if (expandLabel) {
                expandLabel.textContent = "Hide prompt and ideal output";
            }
            if (expandIcon) {
                expandIcon.style.transform = "rotate(180deg)";
            }
        });
    });

    dialog.querySelectorAll(".agent-eval-details").forEach((details) => {
        details.addEventListener("click", (event) => {
            event.stopPropagation();
        });
    });

    dialog.querySelectorAll(".agent-eval-run-btn").forEach((button) => {
        button.addEventListener("click", async () => {
            const evalID = parseInt(button.getAttribute("data-eval-id"), 10);
            const evalItem = (evalData.Evals || []).find(item => item.ID === evalID);
            if (!evalItem) {
                return;
            }

            const runInReliabilityMode = !!(reliabilityToggle && reliabilityToggle.checked);

            const modelSelect = dialog.querySelector("#agentEvalModelSelect");
            const overrideModelID = modelSelect && modelSelect.value ? parseInt(modelSelect.value, 10) : 0;
            const evalOptions = {
                aiAgentID: String(aiAgentID),
                AIAgentEvalID: evalID,
                EvalAIModelID: overrideModelID,
                startNewConversation: true
            };
            ECP.Dialog.CloseDialog(dialog);
            resetReliabilityUI();

            if (runInReliabilityMode) {
                enterReliabilityModeForEval(evalItem, evalItem.Prompt, evalOptions);
                return;
            }

            if (hasPromptPlaceholders(evalItem.Prompt)) {
                stageEvalPromptForEditing(evalItem.Prompt, evalOptions);
                return;
            }

            await sendMessage({
                content: evalItem.Prompt,
                ...evalOptions
            });
        });
    });

    return dialog;
}

function getScheduledPromptAgentName(agents, aiAgentID) {
    const agentList = Array.isArray(agents) ? agents : [];
    const targetAIAgentID = EC_Fmt.Null2ZeroInt(aiAgentID);

    for (let i = 0; i < agentList.length; i++) {
        if (EC_Fmt.Null2ZeroInt(agentList[i].AIAgentID) === targetAIAgentID) {
            return agentList[i].Name || agentList[i].AgentName || "";
        }
    }

    return "";
}

function buildScheduledPromptManagerDialogHTML(prompts, agents, selectedAIAgentID) {
    const promptList = Array.isArray(prompts) ? prompts : [];
    const agentList = Array.isArray(agents) ? agents : [];
    let html = `
        <div class=scheduled-prompt-manager-dialog style="display:flex;flex-direction:column;gap:12px">
            <div style="display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap">
                <div class=ecp-bodysm style="color:var(--text-secondary)">Manage recurring prompts and review their outputs.</div>
                <ecp-btn id=scheduledPromptAddBtn type=primary icon=ews-icon-add>New Scheduled Prompt</ecp-btn>
            </div>`;

    if (promptList.length === 0) {
        html += `<div class=ecp-bodysm style="padding:12px 0;color:var(--text-secondary)">No scheduled prompts found${EC_Fmt.Null2ZeroInt(selectedAIAgentID) > 0 ? " for the selected agent" : ""}.</div></div>`;
        return html;
    }

    html += `
        <table class="Table NoPadding scheduled-prompt-manager-table" style="width:100%">
            <thead>
                <tr>
                    <th class="Parent" data-sort="agent">Agent</th>
                    <th class="Parent" data-sort="prompt">Prompt preview</th>
                    <th class="Parent" data-sort="active">Active</th>
                    <th class="Parent" data-sort="frequency">Frequency</th>
                    <th class="Parent" data-sort="lastRun">Last run</th>
                    <th class="Parent" data-sort="nextRun">Next run</th>
                    <th class="Parent" data-sort="deliveryMethod">Delivery method</th>
                    <th class="Parent" data-sort="actions">Actions</th>
                </tr>
            </thead>
            <tbody>`;

    for (let i = 0; i < promptList.length; i++) {
        const prompt = promptList[i];
        const promptPreviewRaw = EC_Fmt.NullChk(prompt.Prompt, "").replace(/\s+/g, " ").trim();
        const promptPreview = promptPreviewRaw.length > 60 ? `${promptPreviewRaw.slice(0, 60)}...` : promptPreviewRaw;
        const agentName = EC_Fmt.NullChk(prompt.AgentName, getScheduledPromptAgentName(agentList, prompt.AIAgentID));
        const runAsName = EC_Fmt.NullChk(prompt.RunAsName, "System");
        const frequency = EC_Fmt.Null2ZeroInt(prompt.Frequency);
        let frequencyLabel = "Unknown";
        if (frequency === 1) {
            frequencyLabel = "Daily";
        } else if (frequency === 2) {
            frequencyLabel = "Weekly";
        } else if (frequency === 3) {
            frequencyLabel = "Monthly";
        } else if (frequency === 4) {
            frequencyLabel = "Hourly";
        } else if (frequency === 5) {
            frequencyLabel = "Every 15 minutes";
        }
        const frequencyDetail = formatScheduledPromptFrequency(prompt);
        const lastRunValue = EC_Fmt.NullChk(prompt.LastSuccessTime, "")
            || EC_Fmt.NullChk(prompt.LastStartTime, "")
            || EC_Fmt.NullChk(prompt.LastFailTime, "")
            || EC_Fmt.NullChk(prompt.LastRunTime, "");
        const lastRunDisplay = lastRunValue.length > 0 ? formatScheduledPromptTime(lastRunValue) : "No runs";
        const nextRunValue = EC_Fmt.NullChk(prompt.NextRunTime, "");
        const nextRunDisplay = nextRunValue.length > 0 ? formatScheduledPromptTime(nextRunValue) : "—";
        const deliveryMethod = EC_Fmt.Null2ZeroInt(prompt.DeliveryMethod);
        let deliveryMethodLabel = "Default";
        if (deliveryMethod === 1) {
            deliveryMethodLabel = "eChat";
        } else if (deliveryMethod === 2) {
            deliveryMethodLabel = "Email";
        } else if (deliveryMethod === 3) {
            deliveryMethodLabel = "Text Message";
        }
        html += `
                <tr data-scheduled-prompt-id="${prompt.AIAgentsScheduledPromptID}">
                    <td>
                        <div class=scheduled-prompt-agent-name>${EC_Fmt.HTMLEncode(agentName)}</div>
                        <div class=scheduled-prompt-agent-runas>Run as: ${EC_Fmt.HTMLEncode(runAsName)}</div>
                    </td>
                    <td>
                        <div class=scheduled-prompt-preview title="${EC_Fmt.HTMLEncode(promptPreviewRaw)}">&ldquo;${EC_Fmt.HTMLEncode(promptPreview)}&rdquo;</div>
                    </td>
                    <td style="text-align:center">
                        <ecp-switch size=small disabled${prompt.Active ? " checked" : ""}></ecp-switch>
                    </td>
                    <td>
                        <div class=scheduled-prompt-frequency-label>${EC_Fmt.HTMLEncode(frequencyLabel)}</div>
                        <div class=scheduled-prompt-frequency-detail>${EC_Fmt.HTMLEncode(frequencyDetail)}</div>
                    </td>
                    <td>
                        <div class=scheduled-prompt-last-run>${EC_Fmt.HTMLEncode(lastRunDisplay)}</div>
                    </td>
                    <td>
                        <div class=scheduled-prompt-last-run>${EC_Fmt.HTMLEncode(nextRunDisplay)}</div>
                    </td>
                    <td>
                        <div class=scheduled-prompt-last-run>${EC_Fmt.HTMLEncode(deliveryMethodLabel)}</div>
                    </td>
                    <td style="text-align:center">
                        <div class=scheduled-prompt-row-actions>
                            <ecp-btn type=ghost icon=ews-icon-run data-scheduled-prompt-action=run data-scheduled-prompt-id="${prompt.AIAgentsScheduledPromptID}" title="Run now"></ecp-btn>
                            <ecp-btn type=ghost icon=ews-icon-edit data-scheduled-prompt-action=edit data-scheduled-prompt-id="${prompt.AIAgentsScheduledPromptID}" title="Edit"></ecp-btn>
                            <ecp-btn type=ghost icon=ews-icon-delete data-scheduled-prompt-action=delete data-scheduled-prompt-id="${prompt.AIAgentsScheduledPromptID}" title="Delete"></ecp-btn>
                        </div>
                    </td>
                </tr>`;
    }

    html += `
            </tbody>
        </table>
    </div>`;
    return html;
}

// Run-as is always the current user; editing it is not currently supported, so the input stays disabled
function buildScheduledPromptImpersonateUserAutoCompleteHTML() {
    const impersonateUserID = typeof UserID !== "undefined" ? EC_Fmt.Null2ZeroInt(UserID) : 0;
    const impersonateUserName = typeof UserName !== "undefined" ? UserName : "";
    const valueAttr = impersonateUserID > 0 ? ` value="${impersonateUserID}"` : "";
    const displayAttr = !EC_Fmt.isNull(impersonateUserName) ? ` curDisplayValue="${EC_Fmt.HTMLEncode(impersonateUserName)}"` : "";

    return `<ecp-auto-complete
        id=scheduledPromptImpersonateUserInput
        name=ImpersonateUserID
        inputName=ImpersonateUserID
        reftable=Users
        reffield=UserID
        reffielddisplay=UserName
        datatype="ECP.DataType._Integer"
        refFieldDisplayDataType="ECP.DataType._Text"
        limitToRefList=true${valueAttr}${displayAttr} disabled=true
    ></ecp-auto-complete>`;
}

// The Prompt and Schedule sections are identical for new and existing scheduled prompts
function buildScheduledPromptEditorSharedSectionsHTML(promptData) {
    const frequency = EC_Fmt.Null2ZeroInt(promptData.Frequency) > 0 ? EC_Fmt.Null2ZeroInt(promptData.Frequency) : 1;
    const usesTimeOfDay = scheduledPromptFrequencyUsesTimeOfDay(frequency);
    const deliveryMethod = [0, 1, 2, 3].includes(EC_Fmt.Null2ZeroInt(promptData.DeliveryMethod)) ? EC_Fmt.Null2ZeroInt(promptData.DeliveryMethod) : 0;
    const timeOfDay = formatScheduledPromptTimeOfDay(promptData.TimeOfDay || "08:00");
    const dayOfWeek = EC_Fmt.Null2ZeroInt(promptData.DayOfWeek) > 0 ? EC_Fmt.Null2ZeroInt(promptData.DayOfWeek) : 2;
    const dayOfMonth = EC_Fmt.Null2ZeroInt(promptData.DayOfMonth) > 0 ? EC_Fmt.Null2ZeroInt(promptData.DayOfMonth) : 1;
    const dayOfMonthOptions = buildDayOfMonthSelect("scheduledPromptDayOfMonthInput", dayOfMonth);
    const nextRunTimeValue = EC_Fmt.NullChk(promptData.NextRunTime, "");

    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let dayOfWeekOptions = "";
    for (let day = 1; day <= 7; day++) {
        dayOfWeekOptions += `<ecp-select-option value="${day}"${day === dayOfWeek ? " selected" : ""}>${dayNames[day - 1]}</ecp-select-option>`;
    }

    return `
            <div style="margin:0 0 16px">
                <div class=ecp-bodysm style="color:var(--text-secondary);margin-bottom:8px">Prompt</div>
                <ecp-input id=scheduledPromptPromptInput type=textarea rows=5 style="width:100%" placeholder="Enter the prompt to execute on schedule..."></ecp-input>
            </div>
            <div>
                <div class=ecp-bodysm style="color:var(--text-secondary);margin-bottom:8px">Schedule</div>
                <table style="width:100%;border-collapse:collapse"><tr>
                    <td style="padding:4px 12px 4px 0;vertical-align:top;width:50%">
                        <div style="color:var(--text-secondary);margin-bottom:6px">Frequency</div>
                        <ecp-select id=scheduledPromptFrequencyInput value="${frequency}" style="width:100%">
                            <ecp-select-option value="1"${frequency === 1 ? " selected" : ""}>Daily</ecp-select-option>
                            <ecp-select-option value="2"${frequency === 2 ? " selected" : ""}>Weekly</ecp-select-option>
                            <ecp-select-option value="3"${frequency === 3 ? " selected" : ""}>Monthly</ecp-select-option>
                            <ecp-select-option value="4"${frequency === 4 ? " selected" : ""}>Hourly</ecp-select-option>
                            <ecp-select-option value="5"${frequency === 5 ? " selected" : ""}>Every 15 minutes</ecp-select-option>
                        </ecp-select>
                    </td>
                    <td id=scheduledPromptTimeOfDayWrap${usesTimeOfDay ? "" : " class=hidden"} style="padding:4px 0 4px 0;vertical-align:top;width:50%">
                        <div style="color:var(--text-secondary);margin-bottom:6px">Time of day</div>
                        <ecp-input id=scheduledPromptTimeOfDayInput type=time value="${timeOfDay}" style="width:100%"></ecp-input>
                    </td>
                </tr></table>
                <table style="width:100%;border-collapse:collapse;margin-top:8px"><tr>
                    <td id=scheduledPromptDayOfWeekWrap${frequency === 2 ? "" : " class=hidden"} style="padding:4px 12px 4px 0;vertical-align:top;width:50%">
                        <div style="color:var(--text-secondary);margin-bottom:6px">Day of week</div>
                        <ecp-select id=scheduledPromptDayOfWeekInput value="${dayOfWeek}" style="width:100%">${dayOfWeekOptions}</ecp-select>
                    </td>
                    <td id=scheduledPromptDayOfMonthWrap${frequency === 3 ? "" : " class=hidden"} style="padding:4px 0;vertical-align:top;width:50%">
                        <div style="color:var(--text-secondary);margin-bottom:6px">Day of month</div>
                        ${dayOfMonthOptions}
                    </td>
                </tr></table>
                <table style="width:100%;border-collapse:collapse;margin-top:8px"><tr>
                    <td style="padding:4px 12px 4px 0;vertical-align:top;width:50%">
                        <div style="color:var(--text-secondary);margin-bottom:6px">Delivery method</div>
                        <ecp-select id=scheduledPromptDeliveryMethodInput value="${deliveryMethod}" style="width:100%">
                            <ecp-select-option value="0"${deliveryMethod === 0 ? " selected" : ""}>Default</ecp-select-option>
                            <ecp-select-option value="1"${deliveryMethod === 1 ? " selected" : ""}>eChat</ecp-select-option>
                            <ecp-select-option value="2"${deliveryMethod === 2 ? " selected" : ""}>Email</ecp-select-option>
                            <ecp-select-option value="3"${deliveryMethod === 3 ? " selected" : ""}>Text Message</ecp-select-option>
                        </ecp-select>
                    </td>
                    <td style="padding:4px 0;vertical-align:top;width:50%">
                        <div style="color:var(--text-secondary);margin-bottom:6px">Next run</div>
                        <ecp-input id=scheduledPromptNextRunTimeInput type=datetime pickertype=single subtabvalue=Custom value="${nextRunTimeValue}" style="width:100%"></ecp-input>
                    </td>
                </tr></table>
            </div>`;
}

function buildScheduledPromptEditorDialogHTML(prompt, agents) {
    const promptData = prompt || {};
    const isNewPrompt = EC_Fmt.Null2ZeroInt(promptData.AIAgentsScheduledPromptID) <= 0;
    const impersonateUserInput = buildScheduledPromptImpersonateUserAutoCompleteHTML();
    const sharedSections = buildScheduledPromptEditorSharedSectionsHTML(promptData);

    if (!isNewPrompt) {
        const agentName = EC_Fmt.NullChk(promptData.AgentName, getScheduledPromptAgentName(agents, promptData.AIAgentID));
        return `
        <div class=scheduled-prompt-editor style="color:var(--text)">
            <input type=hidden id=scheduledPromptAgentInput value="${EC_Fmt.Null2ZeroInt(promptData.AIAgentID)}">
            <div style="margin:0 0 16px">
                <div class=ecp-bodysm style="color:var(--text-secondary);margin-bottom:8px">Agent information</div>
                <table style="width:100%;border-collapse:collapse"><tr>
                    <td style="padding:4px 12px 4px 0;vertical-align:top;width:33%">
                        <div style="font-weight:600;color:var(--text-secondary);margin-bottom:6px">Agent</div>
                        <div>${EC_Fmt.HTMLEncode(agentName || `Agent #${EC_Fmt.Null2ZeroInt(promptData.AIAgentID)}`)}</div>
                    </td>
                    <td style="padding:4px 12px 4px 0;vertical-align:top;width:33%">
                        <div style="color:var(--text-secondary);margin-bottom:6px">Run as</div>
                        ${impersonateUserInput}
                    </td>
                    <td style="padding:4px 0;vertical-align:top;width:33%">
                        <div style="color:var(--text-secondary);margin-bottom:6px">Status</div>
                        <div style="display:flex;align-items:center;gap:8px">
                            <ecp-switch id=scheduledPromptActiveInput size=small${promptData.Active === false ? "" : " checked"}></ecp-switch>
                            <span style="color:var(--text-secondary)">${promptData.Active === false ? "Inactive" : "Active"}</span>
                        </div>
                    </td>
                </tr></table>
            </div>
            ${sharedSections}
        </div>`;
    }

    const agentList = Array.isArray(agents) ? agents : [];
    const selectedAIAgentID = EC_Fmt.Null2ZeroInt(promptData.AIAgentID) > 0 ? EC_Fmt.Null2ZeroInt(promptData.AIAgentID) : getSelectedAgentID();
    let agentOptions = "";
    for (let i = 0; i < agentList.length; i++) {
        const agent = agentList[i];
        const agentID = EC_Fmt.Null2ZeroInt(agent.AIAgentID);
        const selectedAttr = agentID === selectedAIAgentID ? " selected" : "";
        agentOptions += `<ecp-select-option value="${agentID}"${selectedAttr}>${EC_Fmt.HTMLEncode(agent.Name || agent.AgentName || "")}</ecp-select-option>`;
    }

    return `
        <div class=scheduled-prompt-editor style="color:var(--text)">
            <div style="margin:0 0 16px">
                <div class=ecp-bodysm style="color:var(--text-secondary);margin-bottom:8px">Agent information</div>
                <table style="width:100%;border-collapse:collapse"><tr>
                    <td style="padding:4px 12px 4px 0;vertical-align:top;width:50%">
                        <div style="font-weight:600;color:var(--text-secondary);margin-bottom:6px">Agent</div>
                        <ecp-select id=scheduledPromptAgentInput style="width:100%">${agentOptions}</ecp-select>
                    </td>
                    <td style="padding:4px 0;vertical-align:top;width:50%">
                        <div style="color:var(--text-secondary);margin-bottom:6px">Run as (user)</div>
                        ${impersonateUserInput}
                    </td>
                </tr></table>
            </div>
            ${sharedSections}
        </div>`;
}

function syncScheduledPromptFrequencyFields(container) {
    const frequencyInput = container.querySelector("#scheduledPromptFrequencyInput");
    const dayOfWeekWrap = container.querySelector("#scheduledPromptDayOfWeekWrap");
    const dayOfMonthWrap = container.querySelector("#scheduledPromptDayOfMonthWrap");
    const timeOfDayWrap = container.querySelector("#scheduledPromptTimeOfDayWrap");
    const frequency = frequencyInput ? EC_Fmt.Null2ZeroInt(frequencyInput.value) : 1;

    if (timeOfDayWrap) {
        timeOfDayWrap.classList.toggle("hidden", !scheduledPromptFrequencyUsesTimeOfDay(frequency));
    }

    if (dayOfWeekWrap) {
        dayOfWeekWrap.classList.toggle("hidden", frequency !== 2);
    }

    if (dayOfMonthWrap) {
        dayOfMonthWrap.classList.toggle("hidden", frequency !== 3);
    }
}

async function showScheduledPromptEditorDialog(prompt, agents, onSaved) {
    const promptData = prompt || {};
    const isNewPrompt = EC_Fmt.Null2ZeroInt(promptData.AIAgentsScheduledPromptID) <= 0;
    const editTitleName = EC_Fmt.NullChk(promptData.AgentName, getScheduledPromptAgentName(agents, promptData.AIAgentID));
    const dialog = ECP.Dialog.ShowDialog(isNewPrompt ? "Create new scheduled prompt" : `Edit: ${editTitleName || "Scheduled prompt"}`, buildScheduledPromptEditorDialogHTML(promptData, agents), {
        width: isNewPrompt ? 620 : 720,
        barPosition: "top",
        confirmButtonTitle: isNewPrompt ? "Create prompt" : "Save",
        cancelButtonTitle: "Cancel",
        confirmButtonAction: async (container) => {
            const agentInput = container.querySelector("#scheduledPromptAgentInput");
            const frequencyInput = container.querySelector("#scheduledPromptFrequencyInput");
            const timeOfDayInput = container.querySelector("#scheduledPromptTimeOfDayInput");
            const promptInput = container.querySelector("#scheduledPromptPromptInput");
            const activeInput = container.querySelector("#scheduledPromptActiveInput");
            const dayOfWeekInput = container.querySelector("#scheduledPromptDayOfWeekInput");
            const dayOfMonthInput = container.querySelector("#scheduledPromptDayOfMonthInput");
            const nextRunTimeInput = container.querySelector("#scheduledPromptNextRunTimeInput");
            const deliveryMethodInput = container.querySelector("#scheduledPromptDeliveryMethodInput");
            const aiAgentID = EC_Fmt.Null2ZeroInt(agentInput ? agentInput.value : 0);
            const frequency = EC_Fmt.Null2ZeroInt(frequencyInput ? frequencyInput.value : 0);
            const usesTimeOfDay = scheduledPromptFrequencyUsesTimeOfDay(frequency);
            const timeOfDay = timeOfDayInput ? String(timeOfDayInput.value || "").trim() : "";
            const scheduledPromptText = promptInput ? String(promptInput.value || "").trim() : "";
            const active = activeInput ? activeInput.checked : true;
            const impersonateUserID = typeof UserID !== "undefined" ? EC_Fmt.Null2ZeroInt(UserID) : 0;
            const dayOfWeek = frequency === 2 && dayOfWeekInput ? EC_Fmt.Null2ZeroInt(dayOfWeekInput.value) : 0;
            const dayOfMonth = frequency === 3 && dayOfMonthInput ? EC_Fmt.Null2ZeroInt(dayOfMonthInput.value) : 0;
            const nextRunTime = nextRunTimeInput ? String(nextRunTimeInput.value || "").trim() : "";
            const deliveryMethod = deliveryMethodInput ? EC_Fmt.Null2ZeroInt(deliveryMethodInput.value) : 0;

            if (aiAgentID <= 0) {
                ECP.HTML.Snackbar("Please select an AI agent.", "Warning");
                return;
            }

            if (impersonateUserID <= 0) {
                ECP.HTML.Snackbar("Unable to resolve the current user.", "Warning");
                return;
            }

            if (frequency <= 0) {
                ECP.HTML.Snackbar("Please choose a frequency.", "Warning");
                return;
            }

            if (usesTimeOfDay && timeOfDay.length === 0) {
                ECP.HTML.Snackbar("Please choose a time of day.", "Warning");
                return;
            }

            if (scheduledPromptText.length === 0) {
                ECP.HTML.Snackbar("Prompt is required.", "Warning");
                return;
            }

            if (![0, 1, 2, 3].includes(deliveryMethod)) {
                ECP.HTML.Snackbar("Please choose a valid delivery method.", "Warning");
                return;
            }

            const req = new ECP.EC_Request("AIAgent_SaveScheduledPrompt");
            req.SetReturnType(ECP.EC_ReturnType.Json);
            req.AddRequestVariable("AIAgentsScheduledPromptID", String(EC_Fmt.Null2ZeroInt(promptData.AIAgentsScheduledPromptID)), ECP.EC_Verb.Post);
            req.AddRequestVariable("AIAgentID", String(aiAgentID), ECP.EC_Verb.Post);
            req.AddRequestVariable("ImpersonateUserID", String(impersonateUserID), ECP.EC_Verb.Post);
            req.AddRequestVariable("Prompt", scheduledPromptText, ECP.EC_Verb.Post);
            req.AddRequestVariable("Active", active ? "true" : "false", ECP.EC_Verb.Post);
            req.AddRequestVariable("Frequency", String(frequency), ECP.EC_Verb.Post);
            req.AddRequestVariable("DeliveryMethod", String(deliveryMethod), ECP.EC_Verb.Post);
            if (usesTimeOfDay) {
                req.AddRequestVariable("TimeOfDay", timeOfDay, ECP.EC_Verb.Post);
            }
            if (dayOfWeek > 0) {
                req.AddRequestVariable("DayOfWeek", String(dayOfWeek), ECP.EC_Verb.Post);
            }
            if (dayOfMonth > 0) {
                req.AddRequestVariable("DayOfMonth", String(dayOfMonth), ECP.EC_Verb.Post);
            }
            if (nextRunTime.length > 0) {
                req.AddRequestVariable("NextRunTime", nextRunTime, ECP.EC_Verb.Post);
            }

            const result = await req.Submit();
            if (!result || result.success !== true) {
                ECP.HTML.Snackbar((result && result.Error) || "Unable to save scheduled prompt.", "Error");
                return;
            }

            ECP.Dialog.CloseDialog(dialog);
            ECP.HTML.Snackbar("Scheduled prompt saved.", "Success");
            if (typeof onSaved === "function") {
                await onSaved();
            }
        }
    });

    const frequencyInput = dialog.querySelector("#scheduledPromptFrequencyInput");
    if (frequencyInput) {
        frequencyInput.addEventListener("change", () => syncScheduledPromptFrequencyFields(dialog));
    }
    syncScheduledPromptFrequencyFields(dialog);

    const promptInput = dialog.querySelector("#scheduledPromptPromptInput");
    if (promptInput) {
        promptInput.value = promptData.Prompt || "";
    }

    return dialog;
}

async function showScheduledPromptsDialog() {
    const req = new ECP.EC_Request("AIAgent_GetScheduledPrompts");
    req.SetReturnType(ECP.EC_ReturnType.Json);
    const data = await req.Submit();
    const prompts = Array.isArray(data && data.prompts) ? data.prompts : [];
    const agents = Array.isArray(data && data.agents) ? data.agents : [];
    const selectedAIAgentID = getSelectedAgentID();
    const currentUserID = typeof UserID !== "undefined" ? EC_Fmt.Null2ZeroInt(UserID) : 0;
    const currentUserPrompts = currentUserID > 0 ? prompts.filter(item => EC_Fmt.Null2ZeroInt(item.ImpersonateUserID) === currentUserID) : [];
    const filteredPrompts = selectedAIAgentID > 0 ? currentUserPrompts.filter(item => EC_Fmt.Null2ZeroInt(item.AIAgentID) === selectedAIAgentID) : currentUserPrompts;
    const dialog = ECP.Dialog.ShowDialog("Scheduled prompts", buildScheduledPromptManagerDialogHTML(filteredPrompts, agents, selectedAIAgentID), {
        width: 980,
        height: 640,
        confirmButtonTitle: "Close"
    });

    const addButton = dialog.querySelector("#scheduledPromptAddBtn");
    if (addButton) {
        addButton.addEventListener("click", async () => {
            await showScheduledPromptEditorDialog(selectedAIAgentID > 0 ? { AIAgentID: selectedAIAgentID, Active: true } : { Active: true }, agents, async () => {
                ECP.Dialog.CloseDialog(dialog);
                await showScheduledPromptsDialog();
            });
        });
    }

    dialog.querySelectorAll("[data-scheduled-prompt-action]").forEach((button) => {
        button.addEventListener("click", async (event) => {
            event.stopPropagation();
            const promptID = EC_Fmt.Null2ZeroInt(button.getAttribute("data-scheduled-prompt-id"));
            const action = button.getAttribute("data-scheduled-prompt-action");
            const prompt = filteredPrompts.find(item => EC_Fmt.Null2ZeroInt(item.AIAgentsScheduledPromptID) === promptID);

            if (!prompt) {
                return;
            }

            if (action === "run") {
                ECP.HTML.Snackbar("Scheduled prompt running in background.", "Information");
                const runReq = new ECP.EC_Request("AIAgent_RunScheduledPrompt");
                runReq.SetReturnType(ECP.EC_ReturnType.Json);
                runReq.AddRequestVariable("AIAgentsScheduledPromptID", String(promptID));
                await runReq.Submit();
                await loadScheduledPromptExecutions(true);
                return;
            }

            if (action === "delete") {
                const promptName = EC_Fmt.HTMLEncode(prompt.Prompt || "this scheduled prompt");
                const actionDialog = ECP.Dialog.ShowDialog("Delete scheduled prompt", `Delete <strong>${promptName}</strong>?`, {
                    barPosition: "top",
                    cancelButtonTitle: "Cancel",
                    confirmButtonTitle: "Delete",
                    cancelButtonAction: () => {
                        ECP.Dialog.CloseDialog(actionDialog);
                    },
                    confirmButtonAction: async () => {
                        ECP.Dialog.CloseDialog(actionDialog);
                        const deleteReq = new ECP.EC_Request("AIAgent_DeleteScheduledPrompt");
                        deleteReq.SetReturnType(ECP.EC_ReturnType.Json);
                        deleteReq.AddRequestVariable("AIAgentsScheduledPromptID", String(promptID), ECP.EC_Verb.Post);
                        await deleteReq.Submit();
                        ECP.HTML.Snackbar("Scheduled prompt deleted.", "Success");
                        ECP.Dialog.CloseDialog(dialog);
                        await showScheduledPromptsDialog();
                    }
                });
                return;
            }

            if (action === "edit") {
                await showScheduledPromptEditorDialog(prompt, agents, async () => {
                    ECP.Dialog.CloseDialog(dialog);
                    await showScheduledPromptsDialog();
                });
            }
        });
    });

    return dialog;
}

async function saveWorkflowAsSkill() {
    if (_saveSkillInProgress) return;

    const chatPanel = ChatPanel.getCurrentPanel();
    if (!chatPanel) return;

    const conversationId = chatPanel.element.getAttribute("ConversationID");
    if (EC_Fmt.isNull(conversationId)) {
        ECP.HTML.Snackbar("No active conversation to save as skill.", "Warning");
        return;
    }

    _saveSkillInProgress = true;
    syncInputActionsMenuState();

    ECP.Dialog.ShowLoading("Analyzing conversation for skills\u2026");
    try {
        const req = new ECP.EC_Request("AIAgent_GenerateSkillProposal");
        req.AddRequestVariable("ConversationID", conversationId);
        req.SetReturnType(ECP.EC_ReturnType.Json);
        const result = await req.Submit();
        ECP.Dialog.HideLoading();

        if (!result.Success) {
            ECP.HTML.Snackbar(result.ErrorMessage || "Failed to generate skill proposal.", "Error");
            return;
        }

        if (!result.ProposedSkills || result.ProposedSkills.length === 0) {
            ECP.HTML.Snackbar(result.Summary || "No skills identified from this conversation.", "Information");
            return;
        }

        await showSkillProposalDialog(result);
    } catch (err) {
        ECP.Dialog.HideLoading();
        ECP.HTML.Snackbar(`Error: ${err.message || "Unknown error"}`, "Error");
    } finally {
        _saveSkillInProgress = false;
        syncInputActionsMenuState();
    }
}

async function showSkillProposalDialog(proposal) {
    const multipleSkills = proposal.ProposedSkills.length > 1;
    let skillListHTML = "";
    for (let i = 0; i < proposal.ProposedSkills.length; i++) {
        const skill = proposal.ProposedSkills[i];
        const typeBadge = skill.Type === "new"
            ? `<span class="skill-type-badge skill-type-new">New</span>`
            : `<span class="skill-type-badge skill-type-update">Update</span>`;
        skillListHTML += `
            <div class="skill-proposal-item">
                <label class="skill-proposal-check">
                    <input type="checkbox" ${multipleSkills ? "" : "checked "}data-skill-index="${i}">
                    ${typeBadge}
                    <strong>${EC_Fmt.HTMLEncode(skill.SkillName)}</strong>
                </label>
                <div class="skill-proposal-content">${EC_Fmt.HTMLEncode(skill.SkillContent)}</div>
                ${skill.Evidence ? `<div class="skill-proposal-evidence"><em>Evidence:</em> ${EC_Fmt.HTMLEncode(skill.Evidence)}</div>` : ""}
            </div>`;
    }

    const dialogHTML = `
        <div class="skill-proposal-dialog-body">
            <p class="skill-proposal-summary">${EC_Fmt.HTMLEncode(proposal.Summary)}</p>
            <div class="skill-proposal-list">${skillListHTML}</div>
        </div>`;

    const confirmed = await new Promise((resolve) => {
        ECP.Dialog.ShowDialog("Save Workflow as Skill", dialogHTML, {
            confirmButtonTitle: "Save Selected Skills",
            cancelButtonTitle: "Cancel",
            width: 600,
            confirmButtonAction: (container) => {
                const checkboxes = container.querySelectorAll("input[type=checkbox][data-skill-index]");
                const indexes = [];
                checkboxes.forEach((cb) => {
                    if (cb.checked) indexes.push(cb.getAttribute("data-skill-index"));
                });
                if (indexes.length === 0) {
                    ECP.HTML.Snackbar("Please select at least one skill to save.", "Warning");
                    return false;
                }
                container.remove();
                resolve(indexes);
            },
            cancelButtonAction: () => resolve(null)
        });
    });

    if (!confirmed || confirmed.length === 0) {
        if (confirmed && confirmed.length === 0) {
            ECP.HTML.Snackbar("No skills selected.", "Information");
        }
        return;
    }

    const confirmedIndexes = confirmed;

    try {
        const req = new ECP.EC_Request("AIAgent_ConfirmSkillProposal");
        req.AddRequestVariable("ProposalID", proposal.ProposalID);
        req.AddRequestVariable("ConfirmedSkillIndexes", confirmedIndexes.join(","));
        req.SetReturnType(ECP.EC_ReturnType.Json);
        const confirmResult = await req.Submit();

        if (!confirmResult.Success) {
            ECP.HTML.Snackbar(confirmResult.ErrorMessage || "Failed to save skills.", "Error");
            return;
        }

        const names = confirmResult.SkillNames || [];
        const msg = `Saved ${confirmResult.SkillsAdded} new and ${confirmResult.SkillsUpdated} updated skill(s)${names.length > 0 ? `: ${names.join(", ")}` : ""}.`;
        ECP.HTML.Snackbar(msg, "Success");
    } catch (err) {
        ECP.HTML.Snackbar(`Error saving skills: ${err.message || "Unknown error"}`, "Error");
    }
}

function handleConversationInfo(data, chatPanel, aiAgentID) {
    chatPanel.id = data.ConversationID;
    chatPanel.element.setAttribute("ConversationID", data.ConversationID);
    chatPanel.element.removeAttribute("temporary");
    ConversationTabManager.updateTabWithConversationInfo(
        data.ConversationID,
        aiAgentID,
        data.ConversationTitle
    );
    updateSaveSkillBarVisibility();
}

async function showAgentPromptIfNeeded() {
    await LoadPromptTemplates();

    // Active skill belongs to the previously selected agent — reset and warm the new agent's skill list
    clearActiveSkill();
    closeSkillCommandMenu();
    if (getSelectedAgentID() > 0) {
        loadAgentSkills(getSelectedAgentID());
    }

    const chatPanel = ChatPanel.getCurrentPanel();
    if (!chatPanel) return;

    const aiAgentID = document.getElementById("aiagentInput").value;

    // Always update Google Search toggle when agent changes, even in non-temporary panels
    if (EC_Fmt.isNull(aiAgentID)) {
        initGoogleSearchForAgent("", false, false);
        initMCPConnectorsForAgent("", []);
    } else {
        const agentData = await GetAgentInfo(aiAgentID);
        const permitted = agentData && !EC_Fmt.isNull(agentData.EnableWebSearch);
        initGoogleSearchForAgent(aiAgentID, permitted, permitted);
        // EC-24893: connectors the user can switch on/off for this chat
        initMCPConnectorsForAgent(aiAgentID, agentData && Array.isArray(agentData.MCPServers) ? agentData.MCPServers : []);
    }

    const isTemporary = chatPanel.element.hasAttribute("temporary");
    if (!isTemporary) return;

    chatPanel.clear();

    if (EC_Fmt.isNull(aiAgentID)) {
        chatPanel.addMessage("assistant", AUTO_ROUTING_WELCOME_MESSAGE, new Date().toISOString());
        return;
    }

    const promptMsg = await GetPromptMessage();
    if (!EC_Fmt.isNull(promptMsg)) {
        chatPanel.addMessage("assistant", promptMsg, new Date().toISOString());
    }
}

async function onAgentSelectionChanged() {
    // Switching agents starts a fresh session (same reset as "New chat"),
    // keeping the newly selected agent selected in the auto-complete.
    const aiAgentInputEl = document.getElementById("aiagentInput");
    const selectedAgentID = aiAgentInputEl ? aiAgentInputEl.value : "";
    const draftText = AI_DOM.chatInput ? AI_DOM.chatInput.value : "";
    const draftFiles = FileUploadState.stagedFiles;
    await newChat(selectedAgentID);

    // Carry the unsent draft over to the new agent's conversation
    if (!EC_Fmt.isNull(draftText) && AI_DOM.chatInput) {
        AI_DOM.chatInput.value = draftText;
        autoResizeChatInput();
    }

    // EC-32599: staged attachments travel with the draft text
    if (draftFiles.length > 0) {
        FileUploadState.stagedFiles = draftFiles;
        renderStagingArea();
    }

    if (ScheduledPromptsState.activeSidebarTab === "scheduled-prompts") {
        await loadScheduledPromptExecutions(true);
    }
}

async function newChat(aiAgentID = "") {
    stopVoiceInput();
    cancelActiveRequest();
    resetReliabilityUI();
    closeMarkdownTableCalculators();
    clearPendingEvalRequest();
    clearStagingArea();
    ConversationTabManager.clearSelection();
    const NewDefaultPanel = new ChatPanel("");
    NewDefaultPanel.show();

    const input = AI_DOM.chatInput;
    if (input) {
        input.value = "";
        autoResizeChatInput();
    }

    clearActiveSkill();
    closeSkillCommandMenu();
    SetSelectedAgent(aiAgentID);
    NewDefaultPanel.clear();
    updateSaveSkillBarVisibility();
    resetPromptPanelForNewConversation();

    if (isDrawerAgentLayout()) {
        CloseSidebar();
    }

    await showAgentPromptIfNeeded();
}

async function sendMessage(messageOptions = null) {
    const input = AI_DOM.chatInput;
    if (!input) {
        return;
    }

    await stopVoiceInput({ waitForFinalResult: true });

    // EC-25393: mid-run, typed text is queued into that turn. Programmatic sends (evals, the queue's own
    // re-send) always go through as normal turns.
    if (!messageOptions && canQueueInterjection()) {
        const queuedText = input.value.trim();
        if (EC_Fmt.isNull(queuedText)) {
            ECP.Dialog.Alert("Please enter a message");
            return;
        }

        if (await queueInterjection(queuedText)) {
            input.value = "";
            clearActiveSkill();
            closeSkillCommandMenu();
            syncQueueButtonEnabled();
        }
        input.focus();
        return;
    }

    input.blur();
    let text = input.value;
    if (messageOptions) {
        text = messageOptions.content == null ? "" : String(messageOptions.content);
    }
    const hasFiles = !messageOptions && FileUploadState.stagedFiles.length > 0;
    const aiAgentInput = document.getElementById("aiagentInput");
    const aiAgentValue = aiAgentInput ? aiAgentInput.value : "";
    const pendingEvalRequest = !messageOptions ? getPendingEvalRequest() : null;
    if (pendingEvalRequest && !EC_Fmt.isNull(aiAgentValue) && String(aiAgentValue) !== pendingEvalRequest.aiAgentID) {
        clearPendingEvalRequest();
    }

    const usablePendingEvalRequest = pendingEvalRequest && (EC_Fmt.isNull(aiAgentValue) || String(aiAgentValue) === pendingEvalRequest.aiAgentID)
        ? pendingEvalRequest
        : null;
    const effectiveMessageOptions = messageOptions || usablePendingEvalRequest;
    let AI_AGENT_ID = effectiveMessageOptions && effectiveMessageOptions.aiAgentID ? effectiveMessageOptions.aiAgentID : aiAgentValue;

    // Skill slash commands only apply to messages typed by the user
    let activeSkillForSend = null;
    if (!messageOptions) {
        const skillResolution = resolveActiveSkillForSend(text, aiAgentValue);
        activeSkillForSend = skillResolution.skill;
        text = skillResolution.text;
    }

    if (EC_Fmt.isNull(text) && !hasFiles && !activeSkillForSend) {
        ECP.Dialog.Alert("Please enter a message or attach a file");
        return;
    }

    if (!EC_Fmt.isNull(text) && hasPromptPlaceholders(text)) {
        ECP.Dialog.Alert("Please replace the placeholders [...] in your prompt before sending.");
        return;
    }

    if (hasFiles && getTotalStagedTokens() > FileUploadState.maxTotalTokens) {
        ECP.HTML.Snackbar(`Total file size exceeds the ${formatMaxTotalTokensLabel()} token limit. Remove some files before sending.`, "Error");
        return;
    }

    if (EC_Fmt.Null2ZeroInt(AI_AGENT_ID) <= 0) {
        if (EC_Fmt.isNull(text)) {
            ECP.HTML.Snackbar("Select an agent to continue", "Warning");
            return;
        }

        setInputState(false);
        try {
            AI_AGENT_ID = await AutoSelectAgentForPrompt(text);
        } catch (error) {
            setInputState(true);
            input.focus();
            ECP.HTML.Snackbar(error.message || "Unable to auto-select an agent", "Error");
            return;
        }

        if (EC_Fmt.Null2ZeroInt(AI_AGENT_ID) <= 0) {
            setInputState(true);
            input.focus();
            ECP.HTML.Snackbar("Select an agent to continue", "Warning");
            return;
        }
    }

    // EC-32435: a new turn abandons any tool approval the user left unanswered
    dismissPendingToolApprovals();

    const isExecutePlanPrompt = !EC_Fmt.isNull(text) && text.trim().toLowerCase() === "execute the plan";
    if (!isExecutePlanPrompt) {
        dismissPendingPlanApproval();
    }

    if (effectiveMessageOptions && effectiveMessageOptions.startNewConversation) {
        cancelActiveRequest();
        closeMarkdownTableCalculators();
        clearStagingArea();
        ConversationTabManager.clearSelection();
        const newDefaultPanel = new ChatPanel("");
        newDefaultPanel.show();
    } else {
        closeMarkdownTableCalculators();
    }
    setInputState(false);
    const chatPanel = ChatPanel.getCurrentPanel();
    if (!chatPanel) {
        setInputState(true);
        ECP.Dialog.Alert("No active chat panel found");
        return;
    }

    // Default prompt when a skill is invoked with no extra text
    const promptText = activeSkillForSend && EC_Fmt.isNull(text) ? `Run the "${activeSkillForSend.name}" skill.` : (text || "");
    let displayText = EC_Fmt.isNull(text) ? "(Files attached)" : text;
    if (activeSkillForSend) {
        displayText = `/${activeSkillForSend.slug}${EC_Fmt.isNull(text) ? "" : ` ${text}`}`;
    }

    if (EC_Fmt.isNull(chatPanel.element.getAttribute("ConversationID"))) {
        ConversationTabManager.createTemporaryTab(activeSkillForSend ? displayText : (text || "File upload"), AI_AGENT_ID);
        chatPanel.element.setAttribute("AIAgentID", AI_AGENT_ID);
        chatPanel.show();
        setPromptPanelCollapsed(true);
    }

    // Upload staged files before sending the message
    let uploadedFiles = [];
    let FileDocumentIDArr = [];
    if (hasFiles) {
        try {
            FileUploadState.isUploading = true;
            renderStagingArea();
            uploadedFiles = await uploadStagedFiles();
            FileDocumentIDArr = uploadedFiles.map(f => f.documentId);
        } catch (err) {
            FileUploadState.isUploading = false;
            renderStagingArea();
            setInputState(true);
            ECP.HTML.Snackbar(`File upload failed: ${err.message || "Unknown error"}`, "Error");
            return;
        }
        FileUploadState.isUploading = false;
        renderStagingArea();
    }

    const userMsg = chatPanel.addMessage("user", displayText, new Date().toISOString());
    if (uploadedFiles.length > 0) {
        userMsg.showFileAttachments(uploadedFiles);
    }
    if (!messageOptions) {
        input.value = "";
        autoResizeChatInput();
        clearStagingArea();
        clearActiveSkill();
        closeSkillCommandMenu();
        clearPromptPanelFilter();
    }

    if (!messageOptions && effectiveMessageOptions && effectiveMessageOptions.AIAgentEvalID) {
        clearPendingEvalRequest();
    }

    const thinkingMsg = chatPanel.addMessage("assistant", "", new Date().toISOString());
    thinkingMsg.aiAgentEvalID = effectiveMessageOptions ? effectiveMessageOptions.AIAgentEvalID || 0 : 0;
    thinkingMsg.evalAIModelID = effectiveMessageOptions ? effectiveMessageOptions.EvalAIModelID || 0 : 0;
    thinkingMsg.responseStartedAtMs = Date.now();
    thinkingMsg.responseDurationMs = null;
    thinkingMsg.startThinking();

    // Initialize active request state for cancellation support
    initializeAgentActiveRequest(thinkingMsg, chatPanel);

    await ReceiveServerSentEvents(thinkingMsg, {
        content: promptText,
        forcePlanFirst: WaitingForApprovePlanFirst,
        executePlan: false,
        FileDocumentIDArr,
        AIAgentSkillID: activeSkillForSend ? activeSkillForSend.id : 0,
        AIAgentEvalID: effectiveMessageOptions ? effectiveMessageOptions.AIAgentEvalID : 0,
        EvalAIModelID: effectiveMessageOptions ? effectiveMessageOptions.EvalAIModelID : 0
    }, chatPanel);

    // Note: setInputState and button visibility are now handled in finalizeActiveRequest()
    // or cancelActiveRequest() depending on how the request ends
    input.focus();

    EC_Fmt.SetLocalStorageValue(`${Distributor}_${UserID}_conversationid`, chatPanel.element.getAttribute("ConversationID"));
}

function setInputState(enabled) {
    const input = AI_DOM.chatInput;
    const sendBtn = AI_DOM.sendBtn;
    const voiceInputBtn = AI_DOM.voiceInputBtn;
    const inputActionsBtn = AI_DOM.inputActionsBtn;

    if (!sendBtn) {
        return;
    }

    if (!enabled) {
        stopVoiceInput();
    }

    sendBtn.disabled = !enabled;
    delete sendBtn.dataset.queueEmpty;
    if (voiceInputBtn) {
        voiceInputBtn.disabled = !enabled;
    }
    if (inputActionsBtn) {
        inputActionsBtn.disabled = !enabled;
    }
    if (!enabled && input) {
        input.blur();
    }

    syncVoiceInputButtonState();
}

function getFileExtension(file) {
    return `.${file.name.split(".").pop().toLowerCase()}`;
}

function isImageFile(file) {
    return FileUploadState.imageExtensions.includes(getFileExtension(file));
}

function validateFile(file) {
    const ext = getFileExtension(file);
    if (!FileUploadState.allowedExtensions.includes(ext)) {
        return { valid: false, error: `Unsupported file type: ${ext}. Supported: ${FileUploadState.allowedExtensions.join(", ")}` };
    }
    if (file.size > FileUploadState.maxFileSize) {
        return { valid: false, error: `File "${file.name}" exceeds the 5 MB size limit.` };
    }
    return { valid: true };
}

function estimateFileTokens(file) {
    if (isImageFile(file)) {
        return FileUploadState.imageTokenEstimate;
    }
    return Math.ceil(file.size / FileUploadState.charsPerToken);
}

function getTotalStagedTokens() {
    let total = 0;
    FileUploadState.stagedFiles.forEach((sf) => {
        total += estimateFileTokens(sf.file);
    });
    return total;
}

function validateTotalTokens(newFile) {
    const currentTokens = getTotalStagedTokens();
    const newTokens = estimateFileTokens(newFile);
    return (currentTokens + newTokens) <= FileUploadState.maxTotalTokens;
}

function formatMaxTotalTokensLabel() {
    return `${Math.round(FileUploadState.maxTotalTokens / 1000)}k`;
}

function addFileToStaging(file) {
    FileUploadState.stagedFiles.push({ file, id: EC_Fmt.Guid() });
    renderStagingArea();
}

function removeFileFromStaging(id) {
    FileUploadState.stagedFiles = FileUploadState.stagedFiles.filter(sf => sf.id !== id);
    renderStagingArea();
}

function clearStagingArea() {
    FileUploadState.stagedFiles = [];
    renderStagingArea();
}

function renderStagingArea() {
    const area = AI_DOM.fileStagingArea;
    if (!area) {
        return;
    }

    if (FileUploadState.stagedFiles.length === 0) {
        area.innerHTML = "";
        area.classList.add("hidden");
        return;
    }

    area.classList.remove("hidden");
    let html = "";
    FileUploadState.stagedFiles.forEach((sf) => {
        const name = EC_Fmt.HTMLEncode(sf.file.name);
        const size = EC_Fmt.FileSizeConvert(sf.file.size);
        const icon = isImageFile(sf.file) ? "ews-icon-image" : "ews-icon-document";
        html += `<span class="file-chip" data-file-id="${sf.id}">`;
        html += `<i class="file-chip-icon ${icon}"></i>`;
        html += `<span class="file-chip-name" title="${name}">${name}</span>`;
        html += `<span class="file-chip-size">${size}</span>`;
        html += `<i class="file-chip-remove ews-icon-close" data-remove-id="${sf.id}"></i>`;
        html += `</span>`;
    });

    const totalTokens = getTotalStagedTokens();
    const tokenStr = EC_Fmt.FormatNumber(String(totalTokens), 0, 0, true);
    const maxStr = EC_Fmt.FormatNumber(String(FileUploadState.maxTotalTokens), 0, 0, true);
    const overLimit = totalTokens > FileUploadState.maxTotalTokens;
    html += `<span class="file-token-summary${overLimit ? " over-limit" : ""}">~${tokenStr} / ${maxStr} tokens</span>`;
    if (FileUploadState.isUploading) {
        html += `<span class="file-uploading-indicator"><i class="ews-icon-circlehalfdashed"></i>Uploading files...</span>`;
    }

    area.innerHTML = html;

    area.querySelectorAll(".file-chip-remove").forEach((btn) => {
        btn.addEventListener("click", (e) => {
            removeFileFromStaging(e.target.getAttribute("data-remove-id"));
        });
    });
}

async function uploadStagedFiles() {
    const results = [];
    for (let i = 0; i < FileUploadState.stagedFiles.length; i++) {
        const sf = FileUploadState.stagedFiles[i];
        const req = new ECP.EC_Request("AIAgent_UploadFile");
        req.AddFile(sf.file.name, sf.file);
        const response = await req.Submit();
        if (response && response.DocumentID) {
            results.push({ documentId: response.DocumentID, fileName: response.FileName || sf.file.name, fileSize: sf.file.size });
        } else if (response && response.Error) {
            throw new Error(response.Error);
        } else {
            throw new Error(`Failed to upload file: ${sf.file.name}`);
        }
    }
    return results;
}

// EC-25393: mirrors BC_AIAgentInterjection.MaxQueuedPerTurn
const MAX_QUEUED_INTERJECTIONS = 5;
const QUEUED_INTERJECTION_NOTE = "Queued \u2014 the agent will pick this up at its next step";
const UNDELIVERED_INTERJECTION_NOTE = "Not delivered \u2014 send it again to continue";
// Short forms for the timeline, where surrounding rows give the context
const QUEUED_INTERJECTION_STATE = "queued\u2026";
const DELIVERED_INTERJECTION_STATE = "picked up mid-run";
const UNDELIVERED_INTERJECTION_STATE = "not delivered";

/**
 * EC-25393: True when typed text should be queued into the running turn. Reliability runs fan out with no single
 * turn to interject into, and a run parked on a plan approval already has its own input path.
 */
function canQueueInterjection() {
    return activeAIRequestState.isProcessing
        && !activeAIRequestState.isReliabilityMode
        && !WaitingForApprovePlanFirst
        && !EC_Fmt.isNull(activeAIRequestState.conversationID);
}

function getUndeliveredInterjections() {
    return activeAIRequestState.queuedInterjections.filter(entry => !entry.delivered);
}

/** EC-25393: Renders before the request, so a slow round trip never looks like the message was dropped. */
async function queueInterjection(text) {
    const chatPanel = activeAIRequestState.chatPanel || ChatPanel.getCurrentPanel();
    if (!chatPanel) {
        return false;
    }

    if (getUndeliveredInterjections().length >= MAX_QUEUED_INTERJECTIONS) {
        ECP.HTML.Snackbar(`You can queue up to ${MAX_QUEUED_INTERJECTIONS} messages while the agent is running.`, "Warning");
        return false;
    }

    // EC-25393: render into the timeline where it was sent — a trailing bubble reads as a follow-up question
    // asked after the answer, the opposite of what happened. The bubble is only a fallback.
    const thinkingMsg = activeAIRequestState.thinkingMsg;
    const timelineItem = thinkingMsg ? thinkingMsg.addInterjection(text, QUEUED_INTERJECTION_STATE) : null;
    let messageEl = null;
    if (!timelineItem) {
        messageEl = chatPanel.addMessage("user", text, new Date().toISOString());
        messageEl.markQueuedInterjection(null, QUEUED_INTERJECTION_NOTE);
    }
    const entry = {
        sequence: null, text, thinkingMsg, timelineItem, messageEl, delivered: false
    };
    activeAIRequestState.queuedInterjections.push(entry);
    chatPanel.scrollToBottom();

    try {
        const myRequest = new ECP.EC_Request("AIAgent_QueueMessage");
        // Registered POST-only, and AddRequestVariable defaults to GET. 4000 chars of user text is not a query string.
        myRequest.AddRequestVariable("ConversationID", activeAIRequestState.conversationID, ECP.EC_Verb.Post);
        myRequest.AddRequestVariable("Message", text, ECP.EC_Verb.Post);
        const result = await myRequest.Submit();
        if (result && result.Error) {
            throw new Error(result.Error);
        }
        entry.sequence = EC_Fmt.Null2ZeroInt(result && result.InterjectionSequence);
    } catch (error) {
        const queueIndex = activeAIRequestState.queuedInterjections.indexOf(entry);
        if (queueIndex >= 0) {
            activeAIRequestState.queuedInterjections.splice(queueIndex, 1);
        }
        if (timelineItem && thinkingMsg) {
            thinkingMsg.removeInterjection(timelineItem);
        }
        if (messageEl) {
            messageEl.remove();
        }
        ECP.HTML.Snackbar(`Could not queue that message: ${error.message || "Unknown error"}`, "Error");
        return false;
    }

    // The pickup can be announced before this response lands, so reconcile rather than assume it is waiting.
    applyDeliveredInterjections();
    return true;
}

function markInterjectionsDelivered(sequences) {
    if (!Array.isArray(sequences)) {
        return;
    }

    sequences.forEach(sequence => activeAIRequestState.deliveredInterjectionSequences.add(EC_Fmt.Null2ZeroInt(sequence)));
    applyDeliveredInterjections();
}

function applyDeliveredInterjections() {
    activeAIRequestState.queuedInterjections.forEach((entry) => {
        if (entry.delivered || !entry.sequence) {
            return;
        }
        if (!activeAIRequestState.deliveredInterjectionSequences.has(entry.sequence)) {
            return;
        }
        entry.delivered = true;
        if (entry.timelineItem) {
            entry.thinkingMsg.setInterjectionState(entry.timelineItem, DELIVERED_INTERJECTION_STATE);
        } else if (entry.messageEl) {
            entry.messageEl.clearQueuedInterjection();
        }
    });
}

/** EC-25393: Empties the queue and hands back whatever the agent never reached. */
function settleQueuedInterjections() {
    const undelivered = getUndeliveredInterjections();
    activeAIRequestState.queuedInterjections = [];
    activeAIRequestState.deliveredInterjectionSequences = new Set();
    return undelivered;
}

/**
 * EC-25393: The run stopped on something the user must act on (approval, plan, clarification, error, cancel), so
 * the message is not promoted into a turn behind their back — it stays put, marked as never delivered.
 */
function abandonQueuedInterjections() {
    settleQueuedInterjections().forEach((entry) => {
        if (entry.timelineItem) {
            entry.thinkingMsg.setInterjectionState(entry.timelineItem, UNDELIVERED_INTERJECTION_STATE);
        } else if (entry.messageEl) {
            entry.messageEl.markQueuedInterjection(entry.sequence, UNDELIVERED_INTERJECTION_NOTE);
        }
    });
}

/**
 * EC-25393: The run finished before reaching the message, so it becomes the next turn. The provisional rendering
 * is removed first, so the re-send renders it once as an ordinary message.
 */
async function resendQueuedInterjections() {
    const undelivered = settleQueuedInterjections();
    if (undelivered.length === 0) {
        return;
    }

    undelivered.forEach((entry) => {
        if (entry.timelineItem) {
            entry.thinkingMsg.removeInterjection(entry.timelineItem);
        } else if (entry.messageEl) {
            entry.messageEl.remove();
        }
    });
    await sendMessage({ content: undelivered.map(entry => entry.text).join("\n\n") });
}

/**
 * EC-25393: Queue stays disabled until something is typed. The reason is marked on the button so the mic can stay
 * live through it — dictating is one of the ways an empty composer gets filled.
 */
function syncQueueButtonEnabled() {
    const sendBtn = AI_DOM.sendBtn;
    if (!sendBtn) {
        return;
    }

    if (!activeAIRequestState.isProcessing || activeAIRequestState.isReliabilityMode) {
        delete sendBtn.dataset.queueEmpty;
        return;
    }

    const input = AI_DOM.chatInput;
    const hasText = !!input && !EC_Fmt.isNull(input.value.trim());
    sendBtn.disabled = !hasText;
    if (hasText) {
        delete sendBtn.dataset.queueEmpty;
    } else {
        sendBtn.dataset.queueEmpty = "true";
    }
    syncVoiceInputButtonState();
}

/**
 * Updates the UI to show either Send or Stop button based on processing state.
 * @param {boolean} isProcessing - Whether a request is currently being processed
 */
function updateButtonVisibility(isProcessing) {
    const sendBtn = AI_DOM.sendBtn;
    const stopBtn = AI_DOM.stopBtn;

    if (!sendBtn || !stopBtn) {
        return;
    }

    stopBtn.classList.toggle("hidden", !isProcessing);

    // EC-25393: the composer stays live mid-run, so Send becomes Queue beside Stop. Reliability runs have no
    // queue, so they keep the old lock-out.
    const queueMode = isProcessing && !activeAIRequestState.isReliabilityMode;
    sendBtn.classList.toggle("hidden", isProcessing && !queueMode);
    sendBtn.setAttribute("icon", queueMode ? "ews-icon-circlehalfdashed" : "ews-icon-arrowup");
    syncComposerButtonLabels();
    if (queueMode) {
        syncQueueButtonEnabled();
    } else if (sendBtn.dataset.queueEmpty === "true") {
        // Leaving the run must not strand Send disabled on the queue's empty-input rule.
        delete sendBtn.dataset.queueEmpty;
        sendBtn.disabled = false;
    }
}

/**
 * Cancels the active request (SSE stream or fetch) and resets the UI.
 * Called when user clicks the Stop button.
 */
function cancelActiveRequest() {
    if (!activeAIRequestState.isProcessing) return;

    const input = AI_DOM.chatInput;

    if (activeAIRequestState.isReliabilityMode) {
        stopReliabilitySessionRuns({ skipFinalize: true });
        clearActiveAIRequestState();
        updateButtonVisibility(false);
        if (reliabilitySession && reliabilitySession.hasSent) {
            setReliabilityMainInputLocked(true);
            setInputState(false);
        } else {
            setReliabilityMainInputLocked(false);
            setInputState(true);
        }
        updateReliabilitySessionSendState();
        if (input && (!reliabilitySession || !reliabilitySession.hasSent)) {
            input.focus();
        }
        return;
    }

    // Abort fetch request if active
    if (activeAIRequestState.abortController) {
        activeAIRequestState.abortController.abort();
        activeAIRequestState.abortController = null;
    }

    // Update the thinking message to show cancellation
    if (activeAIRequestState.thinkingMsg) {
        activeAIRequestState.thinkingMsg.stopThinking();
        activeAIRequestState.thinkingMsg.markToolsComplete();

        // Check if there's any content already displayed
        const currentContent = activeAIRequestState.thinkingMsg.rawContent || "";
        if (currentContent.trim()) {
            // Append cancellation notice to existing content
            activeAIRequestState.thinkingMsg.updateContent(`${currentContent}\n\n*— Request cancelled by user*`);
        } else {
            // No content yet, just show cancellation message
            activeAIRequestState.thinkingMsg.updateContent("*Request cancelled by user*");
        }
    }

    // Reset active request state
    activeAIRequestState.isProcessing = false;
    activeAIRequestState.thinkingMsg = null;
    activeAIRequestState.chatPanel = null;
    activeAIRequestState.conversationID = null;

    // EC-25393: the user stopped the run, so a queued message is not silently promoted into a new turn
    abandonQueuedInterjections();

    // Reset UI
    updateButtonVisibility(false);
    setInputState(true);
    if (input) {
        input.focus();
    }
}

/**
 * Sets up the active request state before making a request.
 * @param {Object} thinkingMsg - The thinking message element
 * @param {Object} chatPanel - The chat panel
 */
function initializeAgentActiveRequest(thinkingMsg, chatPanel) {
    activeAIRequestState.isProcessing = true;
    activeAIRequestState.thinkingMsg = thinkingMsg;
    activeAIRequestState.chatPanel = chatPanel;
    activeAIRequestState.abortController = null;
    // EC-25393: an approval/plan/clarification resume re-arms this state, orphaning anything left queued.
    abandonQueuedInterjections();
    // EC-25393: a resumed turn keeps its conversation, so seed from the panel; run_started confirms or supplies it.
    activeAIRequestState.conversationID = chatPanel && chatPanel.element ? chatPanel.element.getAttribute("ConversationID") : null;
    activeAIRequestState.queuedInterjections = [];
    activeAIRequestState.deliveredInterjectionSequences = new Set();
    updateButtonVisibility(true);
}

// EC-30403: Browser tab title indicator when an agent finishes while the tab is in the background
function getAgentNotificationStateKey() {
    return `${Distributor}_${UserID}_ai_tab_notifications`;
}

function loadAgentNotificationPreference() {
    try {
        const raw = localStorage.getItem(getAgentNotificationStateKey());
        if (raw !== null) {
            AgentSettings.tabNotifications = raw === "true";
        }
    } catch {
        // localStorage may be unavailable; keep the in-memory default
    }
}

function saveAgentNotificationPreference() {
    try {
        localStorage.setItem(getAgentNotificationStateKey(), AgentSettings.tabNotifications ? "true" : "false");
    } catch {
        // localStorage may be unavailable; state stays in-memory only
    }
}

function setTabNotificationsEnabled(enabled) {
    AgentSettings.tabNotifications = !!enabled;
    saveAgentNotificationPreference();
}

function getActiveConversationTitle(chatPanel) {
    const conversationId = chatPanel && chatPanel.id ? chatPanel.id : null;
    let tab = conversationId ? ConversationTabManager.getTab(conversationId) : null;
    if (!tab) {
        tab = ConversationTabManager.getTempTab();
    }
    if (tab) {
        const titleEl = tab.querySelector(".chat-title");
        if (titleEl && titleEl.textContent && titleEl.textContent.trim()) {
            return titleEl.textContent.trim();
        }
    }
    return null;
}

let agentTabFlashTitle = null;

function flashAgentTab(conversationTitle) {
    if (agentTabFlashTitle === null) {
        agentTabFlashTitle = document.title;
    }
    document.title = conversationTitle ? `✅ ${conversationTitle}` : "✅ Agent finished";
}

function clearAgentTabFlash() {
    if (agentTabFlashTitle === null) {
        return;
    }
    document.title = agentTabFlashTitle;
    agentTabFlashTitle = null;
}

function initAgentTabFlashClearing() {
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
            clearAgentTabFlash();
        }
    });
    window.addEventListener("focus", clearAgentTabFlash);
}

function maybeNotifyAgentComplete(chatPanel) {
    if (!AgentSettings.tabNotifications) {
        return;
    }
    // Only notify when the user is not actively looking at this tab already
    if (document.visibilityState === "visible") {
        return;
    }

    flashAgentTab(getActiveConversationTitle(chatPanel));
}

/**
 * Cleans up the active request state after completion.
 */
function finalizeAgentActiveRequest() {
    maybeNotifyAgentComplete(activeAIRequestState.chatPanel);
    activeAIRequestState.isProcessing = false;
    activeAIRequestState.abortController = null;
    activeAIRequestState.thinkingMsg = null;
    activeAIRequestState.chatPanel = null;
    // EC-25393: queued entries are settled by the stream itself, once it knows how the run ended
    activeAIRequestState.conversationID = null;
    updateButtonVisibility(false);
    updateSaveSkillBarVisibility();
}

async function getAgentUserApproveType() {
    try {
        const myRequest = new ECP.EC_Request("AIAgent_GetUserApproveType");
        const result = await myRequest.Submit();
        return result.UserApproveType;
    } catch (error) {
        return 0;
    }
}

async function getAgentToolApprovalSettings() {
    const myRequest = new ECP.EC_Request("AIAgent_GetToolApprovalSettings");
    return myRequest.Submit();
}

async function setAgentUserApproveType(userApproveType, toolName = "") {
    const myRequest = new ECP.EC_Request("AIAgent_SetUserApproveType");
    myRequest.AddRequestVariable("UserApproveType", userApproveType);
    myRequest.AddRequestVariable("ToolName", toolName || "");
    const result = await myRequest.Submit();
    AgentUserApproveType = EC_Fmt.Null2ZeroInt(result && result.UserApproveType);
    updateUserApproveTips();

    // EC-31344: keep the cached bootstrap static data in step so navigations don't
    // reflect a stale approval preference.
    const cachedStatic = readAgentCache("static");
    if (cachedStatic) {
        cachedStatic.UserApproveType = AgentUserApproveType;
        writeAgentCache("static", cachedStatic);
    }

    return AgentUserApproveType;
}

// EC-29677: the toggle is a plain user setting, written with the shared SetUserSetting command (no command of its
// own). It is applied on Save rather than on click, and the cached bootstrap is kept in step the same way the
// approval preference is. Whether a profile exists comes from the dialog-open read below.
const MATCH_MY_VOICE_SETTING_NAME = "AIAgent_MatchMyVoice";
let matchMyVoiceHasProfile = false;

// Keeps the in-memory setting and the cached bootstrap on the same value, so a navigation does not resurrect
// the previous one.
function applyMatchMyVoiceSetting(enabled) {
    AgentSettings.matchMyVoice = !!enabled;

    const cachedStatic = readAgentCache("static");
    if (cachedStatic) {
        cachedStatic.MatchMyVoice = AgentSettings.matchMyVoice;
        writeAgentCache("static", cachedStatic);
    }

    return AgentSettings.matchMyVoice;
}

async function setAgentMatchMyVoice(enabled) {
    const myRequest = new ECP.EC_Request("SetUserSetting");
    // SetUserSetting answers with an empty (non-JSON) body, and EC_Request rejects with "Invalid JSON" on the
    // default Json return type — which read as a failed save even though the setting had been stored.
    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
    myRequest.AddRequestVariable("SettingName", MATCH_MY_VOICE_SETTING_NAME);
    myRequest.AddRequestVariable("SettingValue", enabled ? "true" : "false");
    await myRequest.Submit();
    applyMatchMyVoiceSetting(enabled);

    if (AgentSettings.matchMyVoice && !matchMyVoiceHasProfile) {
        ECP.HTML.Snackbar("Match my voice is on. Your writing style profile will be created from your sent emails the first time the agent writes one.", "Information");
    }

    return AgentSettings.matchMyVoice;
}

// Shows the user whether a style profile exists yet, and what it says, when the settings dialog opens.
async function refreshMatchMyVoiceProfileState() {
    const stateText = AI_DOM.matchMyVoiceProfileState;
    if (!stateText) {
        return;
    }

    let result;
    try {
        result = await new ECP.EC_Request("AIAgent_GetWritingStyleProfile").Submit();
    } catch (error) {
        return;
    }

    if (!result || result.Permitted === false) {
        const row = document.getElementById("matchMyVoiceRow");
        if (row) {
            row.classList.add("hidden");
        }
        return;
    }

    matchMyVoiceHasProfile = !!result.HasProfile;

    // This read is the authority on the switch, not the cached bootstrap: an entry written before the setting
    // existed (or by an older session) shows the switch off while the setting is on, and Save only writes when the
    // switch changed, so the wrong state would otherwise stick until the cache expired.
    applyMatchMyVoiceSetting(result.MatchMyVoice);
    if (AI_DOM.matchMyVoiceCheckbox) {
        AI_DOM.matchMyVoiceCheckbox.checked = AgentSettings.matchMyVoice;
    }

    if (result.HasProfile) {
        stateText.textContent = `Your saved style: ${result.StyleProfile}`;
    } else if (result.MailboxConnected) {
        stateText.textContent = "No style profile yet — it will be generated from your sent emails when it is first needed. You can also generate it now from the My Profile page.";
    } else {
        stateText.textContent = "No style profile yet — connect a Gmail or Outlook mailbox on the My Profile page, or paste a writing sample there, to create one.";
    }
}

async function saveAgentToolApprovalSettings(tableEditTables, tableAddTables, tableChangeRequestTables, tableAddRequestTables, approvedTools) {
    const myRequest = new ECP.EC_Request("AIAgent_SaveToolApprovalSettings");
    myRequest.AddRequestVariable("TableEditTables", tableEditTables || "");
    myRequest.AddRequestVariable("TableAddTables", tableAddTables || "");
    myRequest.AddRequestVariable("TableChangeRequestTables", tableChangeRequestTables || "");
    myRequest.AddRequestVariable("TableAddRequestTables", tableAddRequestTables || "");
    myRequest.AddRequestVariable("ApprovedTools", approvedTools || "");
    return myRequest.Submit();
}

async function setAgentTableToolApproveType(toolName, tableName, userApproveType) {
    const myRequest = new ECP.EC_Request("AIAgent_SetTableToolApproveType");
    myRequest.AddRequestVariable("ToolName", toolName || "");
    myRequest.AddRequestVariable("TableName", tableName || "");
    myRequest.AddRequestVariable("UserApproveType", userApproveType);
    return myRequest.Submit();
}

function updateUserApproveTips() {
    let tips = "";
    let buttonTitle = "";
    switch (AgentUserApproveType) {
        case 0:
            break;
        case 1:
            tips = "Auto-approval is enabled for this session.";
            buttonTitle = "End session auto-approval";
            break;
        // Case 2 (Always allow) does not show a tip
    }

    if (tips) {
        AI_DOM.chatContent.classList.add("show-tips");
        document.getElementById("autoApprovalTips").textContent = tips;
        document.getElementById("cancelAutoApprovalBtn").textContent = buttonTitle;
    } else {
        AI_DOM.chatContent.classList.remove("show-tips");
    }
}

function WriteAIAgentsPanel() {
    const handle = document.createElement("div");
    handle.id = "ecp-ai-panel-handle";

    function onPanelResizeStart(e) {
        e.preventDefault();
        const panel = document.getElementById("ecp-ai-sidepanel");
        const bodyWrap = document.querySelector(".body-wrap");

        if (!panel || !handle) {
            return;
        }

        handle.classList.add("dragging");
        if (bodyWrap) {
            bodyWrap.classList.add("ecp-ai-no-transition");
        }
        panel.style.transition = "none";

        function onMouseMove(moveEvent) {
            const newWidth = ClampAIPanelWidth(window.innerWidth - moveEvent.clientX);
            ApplyAIPanelWidth(panel, newWidth);
        }

        function onMouseUp() {
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
            SaveAIPanelWidthPercent(panel._width);
            handle.classList.remove("dragging");
            if (bodyWrap) {
                bodyWrap.classList.remove("ecp-ai-no-transition");
            }
            panel.style.transition = "";
        }

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
    }

    handle.addEventListener("mousedown", onPanelResizeStart);

    const host = document.createElement("div");
    host.id = "ecp-ai-sidepanel-host";

    const panel = document.createElement("div");
    panel.id = "ecp-ai-sidepanel";
    panel._width = GetPersistedAIPanelWidth();
    panel._mounted = false;
    panel.appendChild(handle);
    panel.appendChild(host);
    document.body.appendChild(panel);
    ApplyAIPanelWidth(panel, panel._width);
    return panel;
}

async function EnsurePanelMounted(panel) {
    if (!panel) {
        return;
    }

    if (panel._mounted) {
        await ResumeConversationIfNeeded(GetSavedConversationID());
        return;
    }

    if (panel._mountPromise) {
        await panel._mountPromise;
        return;
    }

    const host = panel.querySelector("#ecp-ai-sidepanel-host");
    if (!host) {
        return;
    }

    ECP.Dialog.ShowLoading("Loading...", panel);
    await ECP.Tools.AsyncAnimationFrame();

    panel._mountPromise = MountAgentUI(host, {
        mode: "sidepanel",
        onClosePanel() {
            closeAIPanel(panel);
        },
        resumeConversationId: GetSavedConversationID()
    });

    try {
        await panel._mountPromise;
        panel._mounted = true;
    } finally {
        panel._mountPromise = null;
        ECP.Dialog.HideLoading();
    }
}

function openAIPanel(panel, animate = true) {
    panel._open = true;
    const bodyWrap = document.querySelector(".body-wrap");

    if (!animate) {
        panel.style.transition = "none";
        if (bodyWrap) {
            bodyWrap.style.transition = "none";
        }
    }

    panel.classList.add("ecp-ai-panel-open");
    ApplyAIPanelWidth(panel);
    EC_Fmt.SetLocalStorageValue(AI_PANEL_LS_KEY(), true);

    if (!animate) {
        requestAnimationFrame(() => {
            panel.style.transition = "";
            if (bodyWrap) {
                bodyWrap.style.transition = "";
            }
        });
    }
}

function closeAIPanel(panel) {
    panel._open = false;
    panel.classList.remove("ecp-ai-panel-open");
    const bodyWrap = document.querySelector(".body-wrap");
    if (bodyWrap) {
        bodyWrap.style.marginRight = "0px";
    }
    EC_Fmt.SetLocalStorageValue(AI_PANEL_LS_KEY(), false);
}

function InitializeGlobalAIAgentPanel() {
    if (typeof EWS === "undefined" || typeof EWS.Ready !== "function") {
        return;
    }

    window.addEventListener("resize", () => {
        const aiPanel = document.getElementById("ecp-ai-sidepanel");
        if (!aiPanel) {
            return;
        }

        ApplyAIPanelWidth(aiPanel);
    });

    EWS.Ready(() => {
        if (typeof UserType !== "undefined" && UserType === "Guest") {
            return;
        }

        requestIdleCallback(() => {
            const ecpAgentButton = document.getElementById("encompassAgentIcon");
            const pageHeader = document.querySelector("#Header .Inner");

            if (!ecpAgentButton || !pageHeader || (typeof IsImpersonateUser !== "undefined" && IsImpersonateUser)) {
                return;
            }

            if (EC_Fmt.GetLocalStorageValue(AI_PANEL_LS_KEY()) === true) {
                const aiPanel = WriteAIAgentsPanel();
                openAIPanel(aiPanel, false);
                EnsurePanelMounted(aiPanel);
            }

            ecpAgentButton.addEventListener("click", async () => {
                let aiPanel = document.getElementById("ecp-ai-sidepanel");
                if (!aiPanel) {
                    aiPanel = WriteAIAgentsPanel();
                }

                if (aiPanel._open) {
                    closeAIPanel(aiPanel);
                    return;
                }

                openAIPanel(aiPanel);
                await EnsurePanelMounted(aiPanel);
            });
        });

        document.addEventListener("visibilitychange", async () => {
            if (document.visibilityState === "visible") {
                const aiPanel = document.getElementById("ecp-ai-sidepanel");
                if (aiPanel && aiPanel._open && aiPanel._mounted) {
                    await ResumeConversationIfNeeded(GetSavedConversationID());
                }
            }
        });
    });
}

async function BootstrapAgentUI() {
    if (typeof describe !== "undefined") {
        return;
    }

    loadAgentNotificationPreference();
    initAgentTabFlashClearing();

    const standaloneHost = document.getElementById("AgentUIRoot") || document.querySelector("[data-ecp-ai-agent-host]");
    if (standaloneHost) {
        const resumeConversationId = GetResumeConversationIDFromURL() || GetSavedConversationID();
        await MountAgentUI(standaloneHost, {
            mode: "standalone",
            resumeConversationId
        });
        return;
    }

    InitializeGlobalAIAgentPanel();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { BootstrapAgentUI(); }, { once: true });
} else {
    BootstrapAgentUI();
}
